export const pokemonDB = [
    {
        id: 1,
        name: 'Bulbasaur',
        frontSpriteSrc: './img/pokemon/front/001_bulbasaur_front.png',
        backSpriteSrc: './img/pokemon/back/001_bulbasaur_back.png',
        baseStats: {
            maxHp: 45,
            attack: 49,
            defense: 49,
            specialAttack: 65,
            specialDefense: 65,
            speed: 45,
        },
        moveSet: {
            1: ['growl', 'tackle'],
            3: ['vine_whip'],
            6: ['growth'],
            9: ['leech_seed'],
            12: ['razor_leaf', 'absorb'],
            15: ['poison_powder', 'sleep_powder'],
            20: ['razor_leaf'],
            25: ['sweet_scent'],
            32: ['growth'],
            39: ['synthesis'],
            46: ['solar_beam'],
        },
        moveSetTMHM: ['cut', 'rock_smash', 'strength', 'flash'],
        evolution: {
            level: 14,
            id: 2,
        },
    },
    {
        id: 2,
        name: 'Ivysaur',
        frontSpriteSrc: './img/pokemon/front/002_ivysaur_front.png',
        backSpriteSrc: './img/pokemon/back/002_ivysaur_back.png',
        evolution: {
            level: null,
            id: null,
        },
    },
    {
        id: 3,
        name: 'Venusaur',
        frontSpriteSrc: './img/pokemon/front/003_venusaur_front.png',
        backSpriteSrc: './img/pokemon/back/003_venusaur_back.png',
        evolutionId: null,
        evolution: {
            level: null,
            id: null,
        },
    },
    {
        id: 4,
        name: 'Charmander',
        frontSpriteSrc: './img/pokemon/front/004_charmander_front.png',
        backSpriteSrc: './img/pokemon/back/004_charmander_back.png',
        evolutionId: 5,
    },
    {
        id: 5,
        name: 'Charmeleon',
        frontSpriteSrc: './img/pokemon/front/005_charmeleon_front.png',
        backSpriteSrc: './img/pokemon/back/005_charmeleon_back.png',
        evolutionId: 6,
    },
    {
        id: 6,
        name: 'Charizard',
        frontSpriteSrc: './img/pokemon/front/006_charizard_front.png',
        backSpriteSrc: './img/pokemon/back/006_charizard_back.png',
        evolutionId: null,
    },
    {
        id: 7,
        name: 'Squirtle',
        frontSpriteSrc: './img/pokemon/front/007_squirtle_front.png',
        backSpriteSrc: './img/pokemon/back/007_squirtle_back.png',
        baseStats: {
            maxHp: 44,
            attack: 48,
            defense: 65,
            specialAttack: 50,
            specialDefense: 64,
            speed: 43,
        },
        evolution: {
            level: 16,
            id: 8,
        },
    },
    {
        id: 8,
        name: 'Wartortle',
        frontSpriteSrc: './img/pokemon/front/008_wartortle_front.png',
        backSpriteSrc: './img/pokemon/back/008_wartortle_back.png',
        evolutionId: 9,
    },
    {
        id: 9,
        name: 'Blastoise',
        frontSpriteSrc: './img/pokemon/front/009_blastoise_front.png',
        backSpriteSrc: './img/pokemon/back/009_blastoise_back.png',
        evolutionId: null,
    },
    {
        id: 10,
        name: 'Caterpie',
        frontSpriteSrc: './img/pokemon/front/010_caterpie_front.png',
        backSpriteSrc: './img/pokemon/back/010_caterpie_back.png',
    },
    {
        id: 11,
        name: 'Metapod',
        frontSpriteSrc: './img/pokemon/front/011_metapod_front.png',
        backSpriteSrc: './img/pokemon/back/011_metapod_back.png',
    },
    {
        id: 12,
        name: 'Butterfree',
        frontSpriteSrc: './img/pokemon/front/012_butterfree_front.png',
        backSpriteSrc: './img/pokemon/back/012_butterfree_back.png',
    },
    {
        id: 13,
        name: 'Weedle',
        frontSpriteSrc: './img/pokemon/front/013_weedle_front.png',
        backSpriteSrc: './img/pokemon/back/013_weedle_back.png',
    },
    {
        id: 14,
        name: 'Kakuna',
        frontSpriteSrc: './img/pokemon/front/014_kakuna_front.png',
        backSpriteSrc: './img/pokemon/back/014_kakuna_back.png',
    },
    {
        id: 15,
        name: 'Beedrill',
        frontSpriteSrc: './img/pokemon/front/015_beedrill_front.png',
        backSpriteSrc: './img/pokemon/back/015_beedrill_back.png',
    },
    {
        id: 16,
        name: 'Pidgey',
        frontSpriteSrc: './img/pokemon/front/016_pidgey_front.png',
        backSpriteSrc: './img/pokemon/back/016_pidgey_back.png',
        baseStats: {
            maxHp: 40,
            attack: 45,
            defense: 40,
            specialAttack: 35,
            specialDefense: 35,
            speed: 56,
        },
        evolution: {
            level: 18,
            id: 17,
        },
    },
    {
        id: 17,
        name: 'Pidgeotto',
        frontSpriteSrc: './img/pokemon/front/017_pidgeotto_front.png',
        backSpriteSrc: './img/pokemon/back/017_pidgeotto_back.png',
    },
    {
        id: 18,
        name: 'Pidgeot',
        frontSpriteSrc: './img/pokemon/front/018_pidgeot_front.png',
        backSpriteSrc: './img/pokemon/back/018_pidgeot_back.png',
    },
    {
        id: 19,
        name: 'Rattata',
        frontSpriteSrc: './img/pokemon/front/019_rattata_front.png',
        backSpriteSrc: './img/pokemon/back/019_rattata_back.png',
        baseStats: {
            maxHp: 30,
            attack: 56,
            defense: 35,
            specialAttack: 25,
            specialDefense: 35,
            speed: 72,
        },
        evolution: {
            level: 20,
            id: 20,
        },
    },
    {
        id: 20,
        name: 'Raticate',
        frontSpriteSrc: './img/pokemon/front/020_raticate_front.png',
        backSpriteSrc: './img/pokemon/back/020_raticate_back.png',
    },
    {
        id: 21,
        name: 'Spearow',
        frontSpriteSrc: './img/pokemon/front/021_spearow_front.png',
        backSpriteSrc: './img/pokemon/back/021_spearow_back.png',
        baseStats: {
            maxHp: 40,
            attack: 60,
            defense: 30,
            specialAttack: 31,
            specialDefense: 31,
            speed: 70,
        },
        evolution: {
            level: 20,
            id: 22,
        },
    },
    {
        id: 22,
        name: 'Fearow',
        frontSpriteSrc: './img/pokemon/front/022_fearow_front.png',
        backSpriteSrc: './img/pokemon/back/022_fearow_back.png',
    },
    {
        id: 23,
        name: 'Ekans',
        frontSpriteSrc: './img/pokemon/front/023_ekans_front.png',
        backSpriteSrc: './img/pokemon/back/023_ekans_back.png',
        baseStats: {
            maxHp: 35,
            attack: 60,
            defense: 44,
            specialAttack: 40,
            specialDefense: 54,
            speed: 55,
        },
        evolution: {
            level: 21,
            id: 24,
        },
    },
    {
        id: 24,
        name: 'Arbok',
        frontSpriteSrc: './img/pokemon/front/024_arbok_front.png',
        backSpriteSrc: './img/pokemon/back/024_arbok_back.png',
    },
    {
        id: 25,
        name: 'Pikachu',
        frontSpriteSrc: './img/pokemon/front/025_pikachu_front.png',
        backSpriteSrc: './img/pokemon/back/025_pikachu_back.png',
    },
    {
        id: 26,
        name: 'Raichu',
        frontSpriteSrc: './img/pokemon/front/026_raichu_front.png',
        backSpriteSrc: './img/pokemon/back/026_raichu_back.png',
    },
    {
        id: 27,
        name: 'Sandshrew',
        frontSpriteSrc: './img/pokemon/front/027_sandshrew_front.png',
        backSpriteSrc: './img/pokemon/back/027_sandshrew_back.png',
    },
    {
        id: 28,
        name: 'Sandslash',
        frontSpriteSrc: './img/pokemon/front/028_sandslash_front.png',
        backSpriteSrc: './img/pokemon/back/028_sandslash_back.png',
    },
    {
        id: 29,
        name: 'Nidoran\u2640',
        frontSpriteSrc: './img/pokemon/front/029_nidoran\u2640_front.png',
        backSpriteSrc: './img/pokemon/back/029_nidoran\u2640_back.png',
    },
    {
        id: 30,
        name: 'Nidorina',
        frontSpriteSrc: './img/pokemon/front/030_nidorina_front.png',
        backSpriteSrc: './img/pokemon/back/030_nidorina_back.png',
    },
    {
        id: 31,
        name: 'Nidoqueen',
        frontSpriteSrc: './img/pokemon/front/031_nidoqueen_front.png',
        backSpriteSrc: './img/pokemon/back/031_nidoqueen_back.png',
    },
    {
        id: 32,
        name: 'Nidoran\u2642',
        frontSpriteSrc: './img/pokemon/front/032_nidoran\u2642_front.png',
        backSpriteSrc: './img/pokemon/back/032_nidoran\u2642_back.png',
    },
    {
        id: 33,
        name: 'Nidorino',
        frontSpriteSrc: './img/pokemon/front/033_nidorino_front.png',
        backSpriteSrc: './img/pokemon/back/033_nidorino_back.png',
    },
    {
        id: 34,
        name: 'Nidoking',
        frontSpriteSrc: './img/pokemon/front/034_nidoking_front.png',
        backSpriteSrc: './img/pokemon/back/034_nidoking_back.png',
    },
    {
        id: 35,
        name: 'Clefairy',
        frontSpriteSrc: './img/pokemon/front/035_clefairy_front.png',
        backSpriteSrc: './img/pokemon/back/035_clefairy_back.png',
    },
    {
        id: 36,
        name: 'Clefable',
        frontSpriteSrc: './img/pokemon/front/036_clefable_front.png',
        backSpriteSrc: './img/pokemon/back/036_clefable_back.png',
    },
    {
        id: 37,
        name: 'Vulpix',
        frontSpriteSrc: './img/pokemon/front/037_vulpix_front.png',
        backSpriteSrc: './img/pokemon/back/037_vulpix_back.png',
    },
    {
        id: 38,
        name: 'Ninetales',
        frontSpriteSrc: './img/pokemon/front/038_ninetales_front.png',
        backSpriteSrc: './img/pokemon/back/038_ninetales_back.png',
    },
    {
        id: 39,
        name: 'Jigglypuff',
        frontSpriteSrc: './img/pokemon/front/039_jigglypuff_front.png',
        backSpriteSrc: './img/pokemon/back/039_jigglypuff_back.png',
    },
    {
        id: 40,
        name: 'Wigglytuff',
        frontSpriteSrc: './img/pokemon/front/040_wigglytuff_front.png',
        backSpriteSrc: './img/pokemon/back/040_wigglytuff_back.png',
    },
    {
        id: 41,
        name: 'Zubat',
        frontSpriteSrc: './img/pokemon/front/041_zubat_front.png',
        backSpriteSrc: './img/pokemon/back/041_zubat_back.png',
    },
    {
        id: 42,
        name: 'Golbat',
        frontSpriteSrc: './img/pokemon/front/042_golbat_front.png',
        backSpriteSrc: './img/pokemon/back/042_golbat_back.png',
    },
    {
        id: 43,
        name: 'Oddish',
        frontSpriteSrc: './img/pokemon/front/043_oddish_front.png',
        backSpriteSrc: './img/pokemon/back/043_oddish_back.png',
    },
    {
        id: 44,
        name: 'Gloom',
        frontSpriteSrc: './img/pokemon/front/044_gloom_front.png',
        backSpriteSrc: './img/pokemon/back/044_gloom_back.png',
    },
    {
        id: 45,
        name: 'Vileplume',
        frontSpriteSrc: './img/pokemon/front/045_vileplume_front.png',
        backSpriteSrc: './img/pokemon/back/045_vileplume_back.png',
    },
    {
        id: 46,
        name: 'Paras',
        frontSpriteSrc: './img/pokemon/front/046_paras_front.png',
        backSpriteSrc: './img/pokemon/back/046_paras_back.png',
    },
    {
        id: 47,
        name: 'Parasect',
        frontSpriteSrc: './img/pokemon/front/047_parasect_front.png',
        backSpriteSrc: './img/pokemon/back/047_parasect_back.png',
    },
    {
        id: 48,
        name: 'Venonat',
        frontSpriteSrc: './img/pokemon/front/048_venonat_front.png',
        backSpriteSrc: './img/pokemon/back/048_venonat_back.png',
    },
    {
        id: 49,
        name: 'Venomoth',
        frontSpriteSrc: './img/pokemon/front/049_venomoth_front.png',
        backSpriteSrc: './img/pokemon/back/049_venomoth_back.png',
    },
    {
        id: 50,
        name: 'Diglett',
        frontSpriteSrc: './img/pokemon/front/050_diglett_front.png',
        backSpriteSrc: './img/pokemon/back/050_diglett_back.png',
    },
    {
        id: 51,
        name: 'Dugtrio',
        frontSpriteSrc: './img/pokemon/front/051_dugtrio_front.png',
        backSpriteSrc: './img/pokemon/back/051_dugtrio_back.png',
    },
    {
        id: 52,
        name: 'Meowth',
        frontSpriteSrc: './img/pokemon/front/052_meowth_front.png',
        backSpriteSrc: './img/pokemon/back/052_meowth_back.png',
    },
    {
        id: 53,
        name: 'Persian',
        frontSpriteSrc: './img/pokemon/front/053_persian_front.png',
        backSpriteSrc: './img/pokemon/back/053_persian_back.png',
    },
    {
        id: 54,
        name: 'Psyduck',
        frontSpriteSrc: './img/pokemon/front/054_psyduck_front.png',
        backSpriteSrc: './img/pokemon/back/054_psyduck_back.png',
    },
    {
        id: 55,
        name: 'Golduck',
        frontSpriteSrc: './img/pokemon/front/055_golduck_front.png',
        backSpriteSrc: './img/pokemon/back/055_golduck_back.png',
    },
    {
        id: 56,
        name: 'Mankey',
        frontSpriteSrc: './img/pokemon/front/056_mankey_front.png',
        backSpriteSrc: './img/pokemon/back/056_mankey_back.png',
    },
    {
        id: 57,
        name: 'Primeape',
        frontSpriteSrc: './img/pokemon/front/057_primeape_front.png',
        backSpriteSrc: './img/pokemon/back/057_primeape_back.png',
    },
    {
        id: 58,
        name: 'Growlithe',
        frontSpriteSrc: './img/pokemon/front/058_growlithe_front.png',
        backSpriteSrc: './img/pokemon/back/058_growlithe_back.png',
    },
    {
        id: 59,
        name: 'Arcanine',
        frontSpriteSrc: './img/pokemon/front/059_arcanine_front.png',
        backSpriteSrc: './img/pokemon/back/059_arcanine_back.png',
    },
    {
        id: 60,
        name: 'Poliwag',
        frontSpriteSrc: './img/pokemon/front/060_poliwag_front.png',
        backSpriteSrc: './img/pokemon/back/060_poliwag_back.png',
    },
    {
        id: 61,
        name: 'Poliwhirl',
        frontSpriteSrc: './img/pokemon/front/061_poliwhirl_front.png',
        backSpriteSrc: './img/pokemon/back/061_poliwhirl_back.png',
    },
    {
        id: 62,
        name: 'Poliwrath',
        frontSpriteSrc: './img/pokemon/front/062_poliwrath_front.png',
        backSpriteSrc: './img/pokemon/back/062_poliwrath_back.png',
    },
    {
        id: 63,
        name: 'Abra',
        frontSpriteSrc: './img/pokemon/front/063_abra_front.png',
        backSpriteSrc: './img/pokemon/back/063_abra_back.png',
    },
    {
        id: 64,
        name: 'Kadabra',
        frontSpriteSrc: './img/pokemon/front/064_kadabra_front.png',
        backSpriteSrc: './img/pokemon/back/064_kadabra_back.png',
    },
    {
        id: 65,
        name: 'Alakazam',
        frontSpriteSrc: './img/pokemon/front/065_alakazam_front.png',
        backSpriteSrc: './img/pokemon/back/065_alakazam_back.png',
    },
    {
        id: 66,
        name: 'Machop',
        frontSpriteSrc: './img/pokemon/front/066_machop_front.png',
        backSpriteSrc: './img/pokemon/back/066_machop_back.png',
    },
    {
        id: 67,
        name: 'Machoke',
        frontSpriteSrc: './img/pokemon/front/067_machoke_front.png',
        backSpriteSrc: './img/pokemon/back/067_machoke_back.png',
    },
    {
        id: 68,
        name: 'Machamp',
        frontSpriteSrc: './img/pokemon/front/068_machamp_front.png',
        backSpriteSrc: './img/pokemon/back/068_machamp_back.png',
    },
    {
        id: 69,
        name: 'Bellsprout',
        frontSpriteSrc: './img/pokemon/front/069_bellsprout_front.png',
        backSpriteSrc: './img/pokemon/back/069_bellsprout_back.png',
    },
    {
        id: 70,
        name: 'Weepinbell',
        frontSpriteSrc: './img/pokemon/front/070_weepinbell_front.png',
        backSpriteSrc: './img/pokemon/back/070_weepinbell_back.png',
    },
    {
        id: 71,
        name: 'Victreebel',
        frontSpriteSrc: './img/pokemon/front/071_victreebel_front.png',
        backSpriteSrc: './img/pokemon/back/071_victreebel_back.png',
    },
    {
        id: 72,
        name: 'Tentacool',
        frontSpriteSrc: './img/pokemon/front/072_tentacool_front.png',
        backSpriteSrc: './img/pokemon/back/072_tentacool_back.png',
    },
    {
        id: 73,
        name: 'Tentacruel',
        frontSpriteSrc: './img/pokemon/front/073_tentacruel_front.png',
        backSpriteSrc: './img/pokemon/back/073_tentacruel_back.png',
    },
    {
        id: 74,
        name: 'Geodude',
        frontSpriteSrc: './img/pokemon/front/074_geodude_front.png',
        backSpriteSrc: './img/pokemon/back/074_geodude_back.png',
    },
    {
        id: 75,
        name: 'Graveler',
        frontSpriteSrc: './img/pokemon/front/075_graveler_front.png',
        backSpriteSrc: './img/pokemon/back/075_graveler_back.png',
    },
    {
        id: 76,
        name: 'Golem',
        frontSpriteSrc: './img/pokemon/front/076_golem_front.png',
        backSpriteSrc: './img/pokemon/back/076_golem_back.png',
    },
    {
        id: 77,
        name: 'Ponyta',
        frontSpriteSrc: './img/pokemon/front/077_ponyta_front.png',
        backSpriteSrc: './img/pokemon/back/077_ponyta_back.png',
    },
    {
        id: 78,
        name: 'Rapidash',
        frontSpriteSrc: './img/pokemon/front/078_rapidash_front.png',
        backSpriteSrc: './img/pokemon/back/078_rapidash_back.png',
    },
    {
        id: 79,
        name: 'Slowpoke',
        frontSpriteSrc: './img/pokemon/front/079_slowpoke_front.png',
        backSpriteSrc: './img/pokemon/back/079_slowpoke_back.png',
    },
    {
        id: 80,
        name: 'Slowbro',
        frontSpriteSrc: './img/pokemon/front/080_slowbro_front.png',
        backSpriteSrc: './img/pokemon/back/080_slowbro_back.png',
    },
    {
        id: 81,
        name: 'Magnemite',
        frontSpriteSrc: './img/pokemon/front/081_magnemite_front.png',
        backSpriteSrc: './img/pokemon/back/081_magnemite_back.png',
    },
    {
        id: 82,
        name: 'Magneton',
        frontSpriteSrc: './img/pokemon/front/082_magneton_front.png',
        backSpriteSrc: './img/pokemon/back/082_magneton_back.png',
    },
    {
        id: 83,
        name: "Farfetch'd",
        frontSpriteSrc: "./img/pokemon/front/083_farfetch'd_front.png",
        backSpriteSrc: "./img/pokemon/back/083_farfetch'd_back.png",
    },
    {
        id: 84,
        name: 'Doduo',
        frontSpriteSrc: './img/pokemon/front/084_doduo_front.png',
        backSpriteSrc: './img/pokemon/back/084_doduo_back.png',
    },
    {
        id: 85,
        name: 'Dodrio',
        frontSpriteSrc: './img/pokemon/front/085_dodrio_front.png',
        backSpriteSrc: './img/pokemon/back/085_dodrio_back.png',
    },
    {
        id: 86,
        name: 'Seel',
        frontSpriteSrc: './img/pokemon/front/086_seel_front.png',
        backSpriteSrc: './img/pokemon/back/086_seel_back.png',
    },
    {
        id: 87,
        name: 'Dewgong',
        frontSpriteSrc: './img/pokemon/front/087_dewgong_front.png',
        backSpriteSrc: './img/pokemon/back/087_dewgong_back.png',
    },
    {
        id: 88,
        name: 'Grimer',
        frontSpriteSrc: './img/pokemon/front/088_grimer_front.png',
        backSpriteSrc: './img/pokemon/back/088_grimer_back.png',
    },
    {
        id: 89,
        name: 'Muk',
        frontSpriteSrc: './img/pokemon/front/089_muk_front.png',
        backSpriteSrc: './img/pokemon/back/089_muk_back.png',
    },
    {
        id: 90,
        name: 'Shellder',
        frontSpriteSrc: './img/pokemon/front/090_shellder_front.png',
        backSpriteSrc: './img/pokemon/back/090_shellder_back.png',
    },
    {
        id: 91,
        name: 'Cloyster',
        frontSpriteSrc: './img/pokemon/front/091_cloyster_front.png',
        backSpriteSrc: './img/pokemon/back/091_cloyster_back.png',
    },
    {
        id: 92,
        name: 'Gastly',
        frontSpriteSrc: './img/pokemon/front/092_gastly_front.png',
        backSpriteSrc: './img/pokemon/back/092_gastly_back.png',
    },
    {
        id: 93,
        name: 'Haunter',
        frontSpriteSrc: './img/pokemon/front/093_haunter_front.png',
        backSpriteSrc: './img/pokemon/back/093_haunter_back.png',
    },
    {
        id: 94,
        name: 'Gengar',
        frontSpriteSrc: './img/pokemon/front/094_gengar_front.png',
        backSpriteSrc: './img/pokemon/back/094_gengar_back.png',
    },
    {
        id: 95,
        name: 'Onix',
        frontSpriteSrc: './img/pokemon/front/095_onix_front.png',
        backSpriteSrc: './img/pokemon/back/095_onix_back.png',
    },
    {
        id: 96,
        name: 'Drowzee',
        frontSpriteSrc: './img/pokemon/front/096_drowzee_front.png',
        backSpriteSrc: './img/pokemon/back/096_drowzee_back.png',
    },
    {
        id: 97,
        name: 'Hypno',
        frontSpriteSrc: './img/pokemon/front/097_hypno_front.png',
        backSpriteSrc: './img/pokemon/back/097_hypno_back.png',
    },
    {
        id: 98,
        name: 'Krabby',
        frontSpriteSrc: './img/pokemon/front/098_krabby_front.png',
        backSpriteSrc: './img/pokemon/back/098_krabby_back.png',
    },
    {
        id: 99,
        name: 'Kingler',
        frontSpriteSrc: './img/pokemon/front/099_kingler_front.png',
        backSpriteSrc: './img/pokemon/back/099_kingler_back.png',
    },
    {
        id: 100,
        name: 'Voltorb',
        frontSpriteSrc: './img/pokemon/front/100_voltorb_front.png',
        backSpriteSrc: './img/pokemon/back/100_voltorb_back.png',
    },
    {
        id: 101,
        name: 'Electrode',
        frontSpriteSrc: './img/pokemon/front/101_electrode_front.png',
        backSpriteSrc: './img/pokemon/back/101_electrode_back.png',
    },
    {
        id: 102,
        name: 'Exeggcute',
        frontSpriteSrc: './img/pokemon/front/102_exeggcute_front.png',
        backSpriteSrc: './img/pokemon/back/102_exeggcute_back.png',
    },
    {
        id: 103,
        name: 'Exeggutor',
        frontSpriteSrc: './img/pokemon/front/103_exeggutor_front.png',
        backSpriteSrc: './img/pokemon/back/103_exeggutor_back.png',
    },
    {
        id: 104,
        name: 'Cubone',
        frontSpriteSrc: './img/pokemon/front/104_cubone_front.png',
        backSpriteSrc: './img/pokemon/back/104_cubone_back.png',
    },
    {
        id: 105,
        name: 'Marowak',
        frontSpriteSrc: './img/pokemon/front/105_marowak_front.png',
        backSpriteSrc: './img/pokemon/back/105_marowak_back.png',
    },
    {
        id: 106,
        name: 'Hitmonlee',
        frontSpriteSrc: './img/pokemon/front/106_hitmonlee_front.png',
        backSpriteSrc: './img/pokemon/back/106_hitmonlee_back.png',
    },
    {
        id: 107,
        name: 'Hitmonchan',
        frontSpriteSrc: './img/pokemon/front/107_hitmonchan_front.png',
        backSpriteSrc: './img/pokemon/back/107_hitmonchan_back.png',
    },
    {
        id: 108,
        name: 'Lickitung',
        frontSpriteSrc: './img/pokemon/front/108_lickitung_front.png',
        backSpriteSrc: './img/pokemon/back/108_lickitung_back.png',
    },
    {
        id: 109,
        name: 'Koffing',
        frontSpriteSrc: './img/pokemon/front/109_koffing_front.png',
        backSpriteSrc: './img/pokemon/back/109_koffing_back.png',
    },
    {
        id: 110,
        name: 'Weezing',
        frontSpriteSrc: './img/pokemon/front/110_weezing_front.png',
        backSpriteSrc: './img/pokemon/back/110_weezing_back.png',
    },
    {
        id: 111,
        name: 'Rhyhorn',
        frontSpriteSrc: './img/pokemon/front/111_rhyhorn_front.png',
        backSpriteSrc: './img/pokemon/back/111_rhyhorn_back.png',
    },
    {
        id: 112,
        name: 'Rhydon',
        frontSpriteSrc: './img/pokemon/front/112_rhydon_front.png',
        backSpriteSrc: './img/pokemon/back/112_rhydon_back.png',
    },
    {
        id: 113,
        name: 'Chansey',
        frontSpriteSrc: './img/pokemon/front/113_chansey_front.png',
        backSpriteSrc: './img/pokemon/back/113_chansey_back.png',
    },
    {
        id: 114,
        name: 'Tangela',
        frontSpriteSrc: './img/pokemon/front/114_tangela_front.png',
        backSpriteSrc: './img/pokemon/back/114_tangela_back.png',
    },
    {
        id: 115,
        name: 'Kangaskhan',
        frontSpriteSrc: './img/pokemon/front/115_kangaskhan_front.png',
        backSpriteSrc: './img/pokemon/back/115_kangaskhan_back.png',
    },
    {
        id: 116,
        name: 'Horsea',
        frontSpriteSrc: './img/pokemon/front/116_horsea_front.png',
        backSpriteSrc: './img/pokemon/back/116_horsea_back.png',
    },
    {
        id: 117,
        name: 'Seadra',
        frontSpriteSrc: './img/pokemon/front/117_seadra_front.png',
        backSpriteSrc: './img/pokemon/back/117_seadra_back.png',
    },
    {
        id: 118,
        name: 'Goldeen',
        frontSpriteSrc: './img/pokemon/front/118_goldeen_front.png',
        backSpriteSrc: './img/pokemon/back/118_goldeen_back.png',
    },
    {
        id: 119,
        name: 'Seaking',
        frontSpriteSrc: './img/pokemon/front/119_seaking_front.png',
        backSpriteSrc: './img/pokemon/back/119_seaking_back.png',
    },
    {
        id: 120,
        name: 'Staryu',
        frontSpriteSrc: './img/pokemon/front/120_staryu_front.png',
        backSpriteSrc: './img/pokemon/back/120_staryu_back.png',
    },
    {
        id: 121,
        name: 'Starmie',
        frontSpriteSrc: './img/pokemon/front/121_starmie_front.png',
        backSpriteSrc: './img/pokemon/back/121_starmie_back.png',
    },
    {
        id: 122,
        name: 'Mr._mime',
        frontSpriteSrc: './img/pokemon/front/122_mr._mime_front.png',
        backSpriteSrc: './img/pokemon/back/122_mr._mime_back.png',
    },
    {
        id: 123,
        name: 'Scyther',
        frontSpriteSrc: './img/pokemon/front/123_scyther_front.png',
        backSpriteSrc: './img/pokemon/back/123_scyther_back.png',
    },
    {
        id: 124,
        name: 'Jynx',
        frontSpriteSrc: './img/pokemon/front/124_jynx_front.png',
        backSpriteSrc: './img/pokemon/back/124_jynx_back.png',
    },
    {
        id: 125,
        name: 'Electabuzz',
        frontSpriteSrc: './img/pokemon/front/125_electabuzz_front.png',
        backSpriteSrc: './img/pokemon/back/125_electabuzz_back.png',
    },
    {
        id: 126,
        name: 'Magmar',
        frontSpriteSrc: './img/pokemon/front/126_magmar_front.png',
        backSpriteSrc: './img/pokemon/back/126_magmar_back.png',
    },
    {
        id: 127,
        name: 'Pinsir',
        frontSpriteSrc: './img/pokemon/front/127_pinsir_front.png',
        backSpriteSrc: './img/pokemon/back/127_pinsir_back.png',
    },
    {
        id: 128,
        name: 'Tauros',
        frontSpriteSrc: './img/pokemon/front/128_tauros_front.png',
        backSpriteSrc: './img/pokemon/back/128_tauros_back.png',
    },
    {
        id: 129,
        name: 'Magikarp',
        frontSpriteSrc: './img/pokemon/front/129_magikarp_front.png',
        backSpriteSrc: './img/pokemon/back/129_magikarp_back.png',
    },
    {
        id: 130,
        name: 'Gyarados',
        frontSpriteSrc: './img/pokemon/front/130_gyarados_front.png',
        backSpriteSrc: './img/pokemon/back/130_gyarados_back.png',
    },
    {
        id: 131,
        name: 'Lapras',
        frontSpriteSrc: './img/pokemon/front/131_lapras_front.png',
        backSpriteSrc: './img/pokemon/back/131_lapras_back.png',
    },
    {
        id: 132,
        name: 'Ditto',
        frontSpriteSrc: './img/pokemon/front/132_ditto_front.png',
        backSpriteSrc: './img/pokemon/back/132_ditto_back.png',
    },
    {
        id: 133,
        name: 'Eevee',
        frontSpriteSrc: './img/pokemon/front/133_eevee_front.png',
        backSpriteSrc: './img/pokemon/back/133_eevee_back.png',
    },
    {
        id: 134,
        name: 'Vaporeon',
        frontSpriteSrc: './img/pokemon/front/134_vaporeon_front.png',
        backSpriteSrc: './img/pokemon/back/134_vaporeon_back.png',
    },
    {
        id: 135,
        name: 'Jolteon',
        frontSpriteSrc: './img/pokemon/front/135_jolteon_front.png',
        backSpriteSrc: './img/pokemon/back/135_jolteon_back.png',
    },
    {
        id: 136,
        name: 'Flareon',
        frontSpriteSrc: './img/pokemon/front/136_flareon_front.png',
        backSpriteSrc: './img/pokemon/back/136_flareon_back.png',
    },
    {
        id: 137,
        name: 'Porygon',
        frontSpriteSrc: './img/pokemon/front/137_porygon_front.png',
        backSpriteSrc: './img/pokemon/back/137_porygon_back.png',
    },
    {
        id: 138,
        name: 'Omanyte',
        frontSpriteSrc: './img/pokemon/front/138_omanyte_front.png',
        backSpriteSrc: './img/pokemon/back/138_omanyte_back.png',
    },
    {
        id: 139,
        name: 'Omastar',
        frontSpriteSrc: './img/pokemon/front/139_omastar_front.png',
        backSpriteSrc: './img/pokemon/back/139_omastar_back.png',
    },
    {
        id: 140,
        name: 'Kabuto',
        frontSpriteSrc: './img/pokemon/front/140_kabuto_front.png',
        backSpriteSrc: './img/pokemon/back/140_kabuto_back.png',
    },
    {
        id: 141,
        name: 'Kabutops',
        frontSpriteSrc: './img/pokemon/front/141_kabutops_front.png',
        backSpriteSrc: './img/pokemon/back/141_kabutops_back.png',
    },
    {
        id: 142,
        name: 'Aerodactyl',
        frontSpriteSrc: './img/pokemon/front/142_aerodactyl_front.png',
        backSpriteSrc: './img/pokemon/back/142_aerodactyl_back.png',
    },
    {
        id: 143,
        name: 'Snorlax',
        frontSpriteSrc: './img/pokemon/front/143_snorlax_front.png',
        backSpriteSrc: './img/pokemon/back/143_snorlax_back.png',
    },
    {
        id: 144,
        name: 'Articuno',
        frontSpriteSrc: './img/pokemon/front/144_articuno_front.png',
        backSpriteSrc: './img/pokemon/back/144_articuno_back.png',
    },
    {
        id: 145,
        name: 'Zapdos',
        frontSpriteSrc: './img/pokemon/front/145_zapdos_front.png',
        backSpriteSrc: './img/pokemon/back/145_zapdos_back.png',
    },
    {
        id: 146,
        name: 'Moltres',
        frontSpriteSrc: './img/pokemon/front/146_moltres_front.png',
        backSpriteSrc: './img/pokemon/back/146_moltres_back.png',
    },
    {
        id: 147,
        name: 'Dratini',
        frontSpriteSrc: './img/pokemon/front/147_dratini_front.png',
        backSpriteSrc: './img/pokemon/back/147_dratini_back.png',
    },
    {
        id: 148,
        name: 'Dragonair',
        frontSpriteSrc: './img/pokemon/front/148_dragonair_front.png',
        backSpriteSrc: './img/pokemon/back/148_dragonair_back.png',
    },
    {
        id: 149,
        name: 'Dragonite',
        frontSpriteSrc: './img/pokemon/front/149_dragonite_front.png',
        backSpriteSrc: './img/pokemon/back/149_dragonite_back.png',
    },
    {
        id: 150,
        name: 'Mewtwo',
        frontSpriteSrc: './img/pokemon/front/150_mewtwo_front.png',
        backSpriteSrc: './img/pokemon/back/150_mewtwo_back.png',
    },
    {
        id: 151,
        name: 'Mew',
        frontSpriteSrc: './img/pokemon/front/151_mew_front.png',
        backSpriteSrc: './img/pokemon/back/151_mew_back.png',
    },
    {
        id: 152,
        name: 'Chikorita',
        frontSpriteSrc: './img/pokemon/front/152_chikorita_front.png',
        backSpriteSrc: './img/pokemon/back/152_chikorita_back.png',
        baseStats: {
            maxHp: 45,
            attack: 49,
            defense: 65,
            specialAttack: 49,
            specialDefense: 65,
            speed: 45,
        },
        evolution: {
            level: 16,
            id: 153,
        },
    },
    {
        id: 153,
        name: 'Bayleef',
        frontSpriteSrc: './img/pokemon/front/153_bayleef_front.png',
        backSpriteSrc: './img/pokemon/back/153_bayleef_back.png',
    },
    {
        id: 154,
        name: 'Meganium',
        frontSpriteSrc: './img/pokemon/front/154_meganium_front.png',
        backSpriteSrc: './img/pokemon/back/154_meganium_back.png',
    },
    {
        id: 155,
        name: 'Cyndaquil',
        frontSpriteSrc: './img/pokemon/front/155_cyndaquil_front.png',
        backSpriteSrc: './img/pokemon/back/155_cyndaquil_back.png',
    },
    {
        id: 156,
        name: 'Quilava',
        frontSpriteSrc: './img/pokemon/front/156_quilava_front.png',
        backSpriteSrc: './img/pokemon/back/156_quilava_back.png',
    },
    {
        id: 157,
        name: 'Typhlosion',
        frontSpriteSrc: './img/pokemon/front/157_typhlosion_front.png',
        backSpriteSrc: './img/pokemon/back/157_typhlosion_back.png',
    },
    {
        id: 158,
        name: 'Totodile',
        frontSpriteSrc: './img/pokemon/front/158_totodile_front.png',
        backSpriteSrc: './img/pokemon/back/158_totodile_back.png',
    },
    {
        id: 159,
        name: 'Croconaw',
        frontSpriteSrc: './img/pokemon/front/159_croconaw_front.png',
        backSpriteSrc: './img/pokemon/back/159_croconaw_back.png',
    },
    {
        id: 160,
        name: 'Feraligatr',
        frontSpriteSrc: './img/pokemon/front/160_feraligatr_front.png',
        backSpriteSrc: './img/pokemon/back/160_feraligatr_back.png',
    },
    {
        id: 161,
        name: 'Sentret',
        frontSpriteSrc: './img/pokemon/front/161_sentret_front.png',
        backSpriteSrc: './img/pokemon/back/161_sentret_back.png',
        baseStats: {
            maxHp: 35,
            attack: 46,
            defense: 34,
            specialAttack: 35,
            specialDefense: 45,
            speed: 20,
        },
        evolution: {
            level: 23,
            id: 162,
        },
    },
    {
        id: 162,
        name: 'Furret',
        frontSpriteSrc: './img/pokemon/front/162_furret_front.png',
        backSpriteSrc: './img/pokemon/back/162_furret_back.png',
    },
    {
        id: 163,
        name: 'Hoothoot',
        frontSpriteSrc: './img/pokemon/front/163_hoothoot_front.png',
        backSpriteSrc: './img/pokemon/back/163_hoothoot_back.png',
    },
    {
        id: 164,
        name: 'Noctowl',
        frontSpriteSrc: './img/pokemon/front/164_noctowl_front.png',
        backSpriteSrc: './img/pokemon/back/164_noctowl_back.png',
    },
    {
        id: 165,
        name: 'Ledyba',
        frontSpriteSrc: './img/pokemon/front/165_ledyba_front.png',
        backSpriteSrc: './img/pokemon/back/165_ledyba_back.png',
    },
    {
        id: 166,
        name: 'Ledian',
        frontSpriteSrc: './img/pokemon/front/166_ledian_front.png',
        backSpriteSrc: './img/pokemon/back/166_ledian_back.png',
    },
    {
        id: 167,
        name: 'Spinarak',
        frontSpriteSrc: './img/pokemon/front/167_spinarak_front.png',
        backSpriteSrc: './img/pokemon/back/167_spinarak_back.png',
        baseStats: {
            maxHp: 40,
            attack: 60,
            defense: 40,
            specialAttack: 40,
            specialDefense: 40,
            speed: 30,
        },
        moveSet: {
            1: ['poison_sting', 'string_shot'],
            6: ['scary_face'],
            11: ['constrict'],
            17: ['night_shade'],
            23: ['leech_life'],
            30: ['fury_swipes'],
            37: ['spider_web'],
            45: ['agility'],
            53: ['psychic'],
        },
        moveSetTMHM: ['flash'],
        evolution: {
            level: 16,
            id: 168,
        },
    },
    {
        id: 168,
        name: 'Ariados',
        frontSpriteSrc: './img/pokemon/front/168_ariados_front.png',
        backSpriteSrc: './img/pokemon/back/168_ariados_back.png',
    },
    {
        id: 169,
        name: 'Crobat',
        frontSpriteSrc: './img/pokemon/front/169_crobat_front.png',
        backSpriteSrc: './img/pokemon/back/169_crobat_back.png',
    },
    {
        id: 170,
        name: 'Chinchou',
        frontSpriteSrc: './img/pokemon/front/170_chinchou_front.png',
        backSpriteSrc: './img/pokemon/back/170_chinchou_back.png',
    },
    {
        id: 171,
        name: 'Lanturn',
        frontSpriteSrc: './img/pokemon/front/171_lanturn_front.png',
        backSpriteSrc: './img/pokemon/back/171_lanturn_back.png',
    },
    {
        id: 172,
        name: 'Pichu',
        frontSpriteSrc: './img/pokemon/front/172_pichu_front.png',
        backSpriteSrc: './img/pokemon/back/172_pichu_back.png',
    },
    {
        id: 173,
        name: 'Cleffa',
        frontSpriteSrc: './img/pokemon/front/173_cleffa_front.png',
        backSpriteSrc: './img/pokemon/back/173_cleffa_back.png',
    },
    {
        id: 174,
        name: 'Igglybuff',
        frontSpriteSrc: './img/pokemon/front/174_igglybuff_front.png',
        backSpriteSrc: './img/pokemon/back/174_igglybuff_back.png',
    },
    {
        id: 175,
        name: 'Togepi',
        frontSpriteSrc: './img/pokemon/front/175_togepi_front.png',
        backSpriteSrc: './img/pokemon/back/175_togepi_back.png',
    },
    {
        id: 176,
        name: 'Togetic',
        frontSpriteSrc: './img/pokemon/front/176_togetic_front.png',
        backSpriteSrc: './img/pokemon/back/176_togetic_back.png',
    },
    {
        id: 177,
        name: 'Natu',
        frontSpriteSrc: './img/pokemon/front/177_natu_front.png',
        backSpriteSrc: './img/pokemon/back/177_natu_back.png',
    },
    {
        id: 178,
        name: 'Xatu',
        frontSpriteSrc: './img/pokemon/front/178_xatu_front.png',
        backSpriteSrc: './img/pokemon/back/178_xatu_back.png',
    },
    {
        id: 179,
        name: 'Mareep',
        frontSpriteSrc: './img/pokemon/front/179_mareep_front.png',
        backSpriteSrc: './img/pokemon/back/179_mareep_back.png',
        baseStats: {
            maxHp: 55,
            attack: 40,
            defense: 40,
            specialAttack: 65,
            specialDefense: 45,
            speed: 35,
        },
        moveSet: {
            1: ['growl', 'tackle'],
            9: ['thundershock'],
            16: ['thunder_wave'],
            23: ['cotton_spore'],
            30: ['light_screen'],
            37: ['thunder'],
        },
        moveSetTMHM: ['cut', 'flash'],
        evolution: {
            level: 15,
            id: 180,
        },
    },
    {
        id: 180,
        name: 'Flaaffy',
        frontSpriteSrc: './img/pokemon/front/180_flaaffy_front.png',
        backSpriteSrc: './img/pokemon/back/180_flaaffy_back.png',
        moveSet: {
            1: ['growl', 'tackle', 'thunder_shock'],
            9: ['thunder_shock'],
            18: ['thunder_wave'],
            27: ['cotton_spore'],
            36: ['light_screen'],
            45: ['thunder'],
        },
        evolution: {
            level: 30,
            id: 181,
        },
    },
    {
        id: 181,
        name: 'Ampharos',
        frontSpriteSrc: './img/pokemon/front/181_ampharos_front.png',
        backSpriteSrc: './img/pokemon/back/181_ampharos_back.png',
    },
    {
        id: 182,
        name: 'Bellossom',
        frontSpriteSrc: './img/pokemon/front/182_bellossom_front.png',
        backSpriteSrc: './img/pokemon/back/182_bellossom_back.png',
    },
    {
        id: 183,
        name: 'Marill',
        frontSpriteSrc: './img/pokemon/front/183_marill_front.png',
        backSpriteSrc: './img/pokemon/back/183_marill_back.png',
    },
    {
        id: 184,
        name: 'Azumarill',
        frontSpriteSrc: './img/pokemon/front/184_azumarill_front.png',
        backSpriteSrc: './img/pokemon/back/184_azumarill_back.png',
    },
    {
        id: 185,
        name: 'Sudowoodo',
        frontSpriteSrc: './img/pokemon/front/185_sudowoodo_front.png',
        backSpriteSrc: './img/pokemon/back/185_sudowoodo_back.png',
    },
    {
        id: 186,
        name: 'Politoed',
        frontSpriteSrc: './img/pokemon/front/186_politoed_front.png',
        backSpriteSrc: './img/pokemon/back/186_politoed_back.png',
    },
    {
        id: 187,
        name: 'Hoppip',
        frontSpriteSrc: './img/pokemon/front/187_hoppip_front.png',
        backSpriteSrc: './img/pokemon/back/187_hoppip_back.png',
    },
    {
        id: 188,
        name: 'Skiploom',
        frontSpriteSrc: './img/pokemon/front/188_skiploom_front.png',
        backSpriteSrc: './img/pokemon/back/188_skiploom_back.png',
    },
    {
        id: 189,
        name: 'Jumpluff',
        frontSpriteSrc: './img/pokemon/front/189_jumpluff_front.png',
        backSpriteSrc: './img/pokemon/back/189_jumpluff_back.png',
    },
    {
        id: 190,
        name: 'Aipom',
        frontSpriteSrc: './img/pokemon/front/190_aipom_front.png',
        backSpriteSrc: './img/pokemon/back/190_aipom_back.png',
    },
    {
        id: 191,
        name: 'Sunkern',
        frontSpriteSrc: './img/pokemon/front/191_sunkern_front.png',
        backSpriteSrc: './img/pokemon/back/191_sunkern_back.png',
    },
    {
        id: 192,
        name: 'Sunflora',
        frontSpriteSrc: './img/pokemon/front/192_sunflora_front.png',
        backSpriteSrc: './img/pokemon/back/192_sunflora_back.png',
    },
    {
        id: 193,
        name: 'Yanma',
        frontSpriteSrc: './img/pokemon/front/193_yanma_front.png',
        backSpriteSrc: './img/pokemon/back/193_yanma_back.png',
        baseStats: {
            maxHp: 65,
            attack: 65,
            defense: 45,
            specialAttack: 75,
            specialDefense: 45,
            speed: 95,
        },
        moveSet: {
            1: ['poison_sting', 'string_shot'],
            7: ['quick_attack'],
            13: ['double_team'],
            19: ['sonic_boom'],
            25: ['detect'],
            31: ['supersonic'],
            37: ['uproar'],
            43: ['wing_attack'],
            49: ['screech'],
        },
        moveSetTMHM: ['flash'],
        evolution: {
            id: null,
            level: null,
        },
    },
    {
        id: 194,
        name: 'Wooper',
        frontSpriteSrc: './img/pokemon/front/194_wooper_front.png',
        backSpriteSrc: './img/pokemon/back/194_wooper_back.png',
    },
    {
        id: 195,
        name: 'Quagsire',
        frontSpriteSrc: './img/pokemon/front/195_quagsire_front.png',
        backSpriteSrc: './img/pokemon/back/195_quagsire_back.png',
    },
    {
        id: 196,
        name: 'Espeon',
        frontSpriteSrc: './img/pokemon/front/196_espeon_front.png',
        backSpriteSrc: './img/pokemon/back/196_espeon_back.png',
    },
    {
        id: 197,
        name: 'Umbreon',
        frontSpriteSrc: './img/pokemon/front/197_umbreon_front.png',
        backSpriteSrc: './img/pokemon/back/197_umbreon_back.png',
    },
    {
        id: 198,
        name: 'Murkrow',
        frontSpriteSrc: './img/pokemon/front/198_murkrow_front.png',
        backSpriteSrc: './img/pokemon/back/198_murkrow_back.png',
    },
    {
        id: 199,
        name: 'Slowking',
        frontSpriteSrc: './img/pokemon/front/199_slowking_front.png',
        backSpriteSrc: './img/pokemon/back/199_slowking_back.png',
    },
    {
        id: 200,
        name: 'Misdreavus',
        frontSpriteSrc: './img/pokemon/front/200_misdreavus_front.png',
        backSpriteSrc: './img/pokemon/back/200_misdreavus_back.png',
    },
    {
        id: 201,
        name: 'Unown',
        frontSpriteSrc: './img/pokemon/front/201_unown_front.png',
        backSpriteSrc: './img/pokemon/back/201_unown_back.png',
    },
    {
        id: 202,
        name: 'Wobbuffet',
        frontSpriteSrc: './img/pokemon/front/202_wobbuffet_front.png',
        backSpriteSrc: './img/pokemon/back/202_wobbuffet_back.png',
    },
    {
        id: 203,
        name: 'Girafarig',
        frontSpriteSrc: './img/pokemon/front/203_girafarig_front.png',
        backSpriteSrc: './img/pokemon/back/203_girafarig_back.png',
    },
    {
        id: 204,
        name: 'Pineco',
        frontSpriteSrc: './img/pokemon/front/204_pineco_front.png',
        backSpriteSrc: './img/pokemon/back/204_pineco_back.png',
    },
    {
        id: 205,
        name: 'Forretress',
        frontSpriteSrc: './img/pokemon/front/205_forretress_front.png',
        backSpriteSrc: './img/pokemon/back/205_forretress_back.png',
    },
    {
        id: 206,
        name: 'Dunsparce',
        frontSpriteSrc: './img/pokemon/front/206_dunsparce_front.png',
        backSpriteSrc: './img/pokemon/back/206_dunsparce_back.png',
    },
    {
        id: 207,
        name: 'Gligar',
        frontSpriteSrc: './img/pokemon/front/207_gligar_front.png',
        backSpriteSrc: './img/pokemon/back/207_gligar_back.png',
    },
    {
        id: 208,
        name: 'Steelix',
        frontSpriteSrc: './img/pokemon/front/208_steelix_front.png',
        backSpriteSrc: './img/pokemon/back/208_steelix_back.png',
    },
    {
        id: 209,
        name: 'Snubbull',
        frontSpriteSrc: './img/pokemon/front/209_snubbull_front.png',
        backSpriteSrc: './img/pokemon/back/209_snubbull_back.png',
    },
    {
        id: 210,
        name: 'Granbull',
        frontSpriteSrc: './img/pokemon/front/210_granbull_front.png',
        backSpriteSrc: './img/pokemon/back/210_granbull_back.png',
    },
    {
        id: 211,
        name: 'Qwilfish',
        frontSpriteSrc: './img/pokemon/front/211_qwilfish_front.png',
        backSpriteSrc: './img/pokemon/back/211_qwilfish_back.png',
    },
    {
        id: 212,
        name: 'Scizor',
        frontSpriteSrc: './img/pokemon/front/212_scizor_front.png',
        backSpriteSrc: './img/pokemon/back/212_scizor_back.png',
    },
    {
        id: 213,
        name: 'Shuckle',
        frontSpriteSrc: './img/pokemon/front/213_shuckle_front.png',
        backSpriteSrc: './img/pokemon/back/213_shuckle_back.png',
    },
    {
        id: 214,
        name: 'Heracross',
        frontSpriteSrc: './img/pokemon/front/214_heracross_front.png',
        backSpriteSrc: './img/pokemon/back/214_heracross_back.png',
    },
    {
        id: 215,
        name: 'Sneasel',
        frontSpriteSrc: './img/pokemon/front/215_sneasel_front.png',
        backSpriteSrc: './img/pokemon/back/215_sneasel_back.png',
    },
    {
        id: 216,
        name: 'Teddiursa',
        frontSpriteSrc: './img/pokemon/front/216_teddiursa_front.png',
        backSpriteSrc: './img/pokemon/back/216_teddiursa_back.png',
    },
    {
        id: 217,
        name: 'Ursaring',
        frontSpriteSrc: './img/pokemon/front/217_ursaring_front.png',
        backSpriteSrc: './img/pokemon/back/217_ursaring_back.png',
    },
    {
        id: 218,
        name: 'Slugma',
        frontSpriteSrc: './img/pokemon/front/218_slugma_front.png',
        backSpriteSrc: './img/pokemon/back/218_slugma_back.png',
    },
    {
        id: 219,
        name: 'Magcargo',
        frontSpriteSrc: './img/pokemon/front/219_magcargo_front.png',
        backSpriteSrc: './img/pokemon/back/219_magcargo_back.png',
    },
    {
        id: 220,
        name: 'Swinub',
        frontSpriteSrc: './img/pokemon/front/220_swinub_front.png',
        backSpriteSrc: './img/pokemon/back/220_swinub_back.png',
    },
    {
        id: 221,
        name: 'Piloswine',
        frontSpriteSrc: './img/pokemon/front/221_piloswine_front.png',
        backSpriteSrc: './img/pokemon/back/221_piloswine_back.png',
    },
    {
        id: 222,
        name: 'Corsola',
        frontSpriteSrc: './img/pokemon/front/222_corsola_front.png',
        backSpriteSrc: './img/pokemon/back/222_corsola_back.png',
    },
    {
        id: 223,
        name: 'Remoraid',
        frontSpriteSrc: './img/pokemon/front/223_remoraid_front.png',
        backSpriteSrc: './img/pokemon/back/223_remoraid_back.png',
    },
    {
        id: 224,
        name: 'Octillery',
        frontSpriteSrc: './img/pokemon/front/224_octillery_front.png',
        backSpriteSrc: './img/pokemon/back/224_octillery_back.png',
    },
    {
        id: 225,
        name: 'Delibird',
        frontSpriteSrc: './img/pokemon/front/225_delibird_front.png',
        backSpriteSrc: './img/pokemon/back/225_delibird_back.png',
    },
    {
        id: 226,
        name: 'Mantine',
        frontSpriteSrc: './img/pokemon/front/226_mantine_front.png',
        backSpriteSrc: './img/pokemon/back/226_mantine_back.png',
    },
    {
        id: 227,
        name: 'Skarmory',
        frontSpriteSrc: './img/pokemon/front/227_skarmory_front.png',
        backSpriteSrc: './img/pokemon/back/227_skarmory_back.png',
    },
    {
        id: 228,
        name: 'Houndour',
        frontSpriteSrc: './img/pokemon/front/228_houndour_front.png',
        backSpriteSrc: './img/pokemon/back/228_houndour_back.png',
    },
    {
        id: 229,
        name: 'Houndoom',
        frontSpriteSrc: './img/pokemon/front/229_houndoom_front.png',
        backSpriteSrc: './img/pokemon/back/229_houndoom_back.png',
    },
    {
        id: 230,
        name: 'Kingdra',
        frontSpriteSrc: './img/pokemon/front/230_kingdra_front.png',
        backSpriteSrc: './img/pokemon/back/230_kingdra_back.png',
    },
    {
        id: 231,
        name: 'Phanpy',
        frontSpriteSrc: './img/pokemon/front/231_phanpy_front.png',
        backSpriteSrc: './img/pokemon/back/231_phanpy_back.png',
    },
    {
        id: 232,
        name: 'Donphan',
        frontSpriteSrc: './img/pokemon/front/232_donphan_front.png',
        backSpriteSrc: './img/pokemon/back/232_donphan_back.png',
    },
    {
        id: 233,
        name: 'Porygon2',
        frontSpriteSrc: './img/pokemon/front/233_porygon2_front.png',
        backSpriteSrc: './img/pokemon/back/233_porygon2_back.png',
    },
    {
        id: 234,
        name: 'Stantler',
        frontSpriteSrc: './img/pokemon/front/234_stantler_front.png',
        backSpriteSrc: './img/pokemon/back/234_stantler_back.png',
    },
    {
        id: 235,
        name: 'Smeargle',
        frontSpriteSrc: './img/pokemon/front/235_smeargle_front.png',
        backSpriteSrc: './img/pokemon/back/235_smeargle_back.png',
    },
    {
        id: 236,
        name: 'Tyrogue',
        frontSpriteSrc: './img/pokemon/front/236_tyrogue_front.png',
        backSpriteSrc: './img/pokemon/back/236_tyrogue_back.png',
    },
    {
        id: 237,
        name: 'Hitmontop',
        frontSpriteSrc: './img/pokemon/front/237_hitmontop_front.png',
        backSpriteSrc: './img/pokemon/back/237_hitmontop_back.png',
    },
    {
        id: 238,
        name: 'Smoochum',
        frontSpriteSrc: './img/pokemon/front/238_smoochum_front.png',
        backSpriteSrc: './img/pokemon/back/238_smoochum_back.png',
    },
    {
        id: 239,
        name: 'Elekid',
        frontSpriteSrc: './img/pokemon/front/239_elekid_front.png',
        backSpriteSrc: './img/pokemon/back/239_elekid_back.png',
    },
    {
        id: 240,
        name: 'Magby',
        frontSpriteSrc: './img/pokemon/front/240_magby_front.png',
        backSpriteSrc: './img/pokemon/back/240_magby_back.png',
    },
    {
        id: 241,
        name: 'Miltank',
        frontSpriteSrc: './img/pokemon/front/241_miltank_front.png',
        backSpriteSrc: './img/pokemon/back/241_miltank_back.png',
    },
    {
        id: 242,
        name: 'Blissey',
        frontSpriteSrc: './img/pokemon/front/242_blissey_front.png',
        backSpriteSrc: './img/pokemon/back/242_blissey_back.png',
    },
    {
        id: 243,
        name: 'Raikou',
        frontSpriteSrc: './img/pokemon/front/243_raikou_front.png',
        backSpriteSrc: './img/pokemon/back/243_raikou_back.png',
    },
    {
        id: 244,
        name: 'Entei',
        frontSpriteSrc: './img/pokemon/front/244_entei_front.png',
        backSpriteSrc: './img/pokemon/back/244_entei_back.png',
    },
    {
        id: 245,
        name: 'Suicune',
        frontSpriteSrc: './img/pokemon/front/245_suicune_front.png',
        backSpriteSrc: './img/pokemon/back/245_suicune_back.png',
    },
    {
        id: 246,
        name: 'Larvitar',
        frontSpriteSrc: './img/pokemon/front/246_larvitar_front.png',
        backSpriteSrc: './img/pokemon/back/246_larvitar_back.png',
    },
    {
        id: 247,
        name: 'Pupitar',
        frontSpriteSrc: './img/pokemon/front/247_pupitar_front.png',
        backSpriteSrc: './img/pokemon/back/247_pupitar_back.png',
    },
    {
        id: 248,
        name: 'Tyranitar',
        frontSpriteSrc: './img/pokemon/front/248_tyranitar_front.png',
        backSpriteSrc: './img/pokemon/back/248_tyranitar_back.png',
    },
    {
        id: 249,
        name: 'Lugia',
        frontSpriteSrc: './img/pokemon/front/249_lugia_front.png',
        backSpriteSrc: './img/pokemon/back/249_lugia_back.png',
    },
    {
        id: 250,
        name: 'Ho-oh',
        frontSpriteSrc: './img/pokemon/front/250_ho-oh_front.png',
        backSpriteSrc: './img/pokemon/back/250_ho-oh_back.png',
    },
    {
        id: 251,
        name: 'Celebi',
        frontSpriteSrc: './img/pokemon/front/251_celebi_front.png',
        backSpriteSrc: './img/pokemon/back/251_celebi_back.png',
    },
    {
        id: 252,
        name: 'Treecko',
        frontSpriteSrc: './img/pokemon/front/252_treecko_front.png',
        backSpriteSrc: './img/pokemon/back/252_treecko_back.png',
        baseStats: {
            maxHp: 40,
            attack: 45,
            defense: 35,
            specialAttack: 65,
            specialDefense: 55,
            speed: 70,
        },
        evolution: {
            id: 253,
            level: 16,
        },
    },
    {
        id: 253,
        name: 'Grovyle',
        frontSpriteSrc: './img/pokemon/front/253_grovyle_front.png',
        backSpriteSrc: './img/pokemon/back/253_grovyle_back.png',
    },
    {
        id: 254,
        name: 'Sceptile',
        frontSpriteSrc: './img/pokemon/front/254_sceptile_front.png',
        backSpriteSrc: './img/pokemon/back/254_sceptile_back.png',
    },
    {
        id: 255,
        name: 'Torchic',
        frontSpriteSrc: './img/pokemon/front/255_torchic_front.png',
        backSpriteSrc: './img/pokemon/back/255_torchic_back.png',
        baseStats: {
            maxHp: 45,
            attack: 60,
            defense: 40,
            specialAttack: 70,
            specialDefense: 50,
            speed: 45,
        },
        evolution: {
            level: 16,
            id: 16,
        },
    },
    {
        id: 256,
        name: 'Combusken',
        frontSpriteSrc: './img/pokemon/front/256_combusken_front.png',
        backSpriteSrc: './img/pokemon/back/256_combusken_back.png',
    },
    {
        id: 257,
        name: 'Blaziken',
        frontSpriteSrc: './img/pokemon/front/257_blaziken_front.png',
        backSpriteSrc: './img/pokemon/back/257_blaziken_back.png',
    },
    {
        id: 258,
        name: 'Mudkip',
        frontSpriteSrc: './img/pokemon/front/258_mudkip_front.png',
        backSpriteSrc: './img/pokemon/back/258_mudkip_back.png',
        baseStats: {
            maxHp: 50,
            attack: 70,
            defense: 50,
            specialAttack: 50,
            specialDefense: 50,
            speed: 40,
        },
        evolution: {
            level: 16,
            id: 259,
        },
    },
    {
        id: 259,
        name: 'Marshtomp',
        frontSpriteSrc: './img/pokemon/front/259_marshtomp_front.png',
        backSpriteSrc: './img/pokemon/back/259_marshtomp_back.png',
    },
    {
        id: 260,
        name: 'Swampert',
        frontSpriteSrc: './img/pokemon/front/260_swampert_front.png',
        backSpriteSrc: './img/pokemon/back/260_swampert_back.png',
    },
    {
        id: 261,
        name: 'Poochyena',
        frontSpriteSrc: './img/pokemon/front/261_poochyena_front.png',
        backSpriteSrc: './img/pokemon/back/261_poochyena_back.png',
        baseStats: {
            maxHp: 35,
            attack: 55,
            defense: 35,
            specialAttack: 30,
            specialDefense: 30,
            speed: 35,
        },
        evolution: {
            id: 262,
            level: 20,
        },
    },
    {
        id: 262,
        name: 'Mightyena',
        frontSpriteSrc: './img/pokemon/front/262_mightyena_front.png',
        backSpriteSrc: './img/pokemon/back/262_mightyena_back.png',
    },
    {
        id: 263,
        name: 'Zigzagoon',
        frontSpriteSrc: './img/pokemon/front/263_zigzagoon_front.png',
        backSpriteSrc: './img/pokemon/back/263_zigzagoon_back.png',
        baseStats: {
            maxHp: 38,
            attack: 30,
            defense: 41,
            specialAttack: 30,
            specialDefense: 41,
            speed: 60,
        },
        evolution: {
            id: 264,
            level: 22,
        },
    },
    {
        id: 264,
        name: 'Linoone',
        frontSpriteSrc: './img/pokemon/front/264_linoone_front.png',
        backSpriteSrc: './img/pokemon/back/264_linoone_back.png',
    },
    {
        id: 265,
        name: 'Wurmple',
        frontSpriteSrc: './img/pokemon/front/265_wurmple_front.png',
        backSpriteSrc: './img/pokemon/back/265_wurmple_back.png',
    },
    {
        id: 266,
        name: 'Silcoon',
        frontSpriteSrc: './img/pokemon/front/266_silcoon_front.png',
        backSpriteSrc: './img/pokemon/back/266_silcoon_back.png',
    },
    {
        id: 267,
        name: 'Beautifly',
        frontSpriteSrc: './img/pokemon/front/267_beautifly_front.png',
        backSpriteSrc: './img/pokemon/back/267_beautifly_back.png',
    },
    {
        id: 268,
        name: 'Cascoon',
        frontSpriteSrc: './img/pokemon/front/268_cascoon_front.png',
        backSpriteSrc: './img/pokemon/back/268_cascoon_back.png',
    },
    {
        id: 269,
        name: 'Dustox',
        frontSpriteSrc: './img/pokemon/front/269_dustox_front.png',
        backSpriteSrc: './img/pokemon/back/269_dustox_back.png',
    },
    {
        id: 270,
        name: 'Lotad',
        frontSpriteSrc: './img/pokemon/front/270_lotad_front.png',
        backSpriteSrc: './img/pokemon/back/270_lotad_back.png',
    },
    {
        id: 271,
        name: 'Lombre',
        frontSpriteSrc: './img/pokemon/front/271_lombre_front.png',
        backSpriteSrc: './img/pokemon/back/271_lombre_back.png',
    },
    {
        id: 272,
        name: 'Ludicolo',
        frontSpriteSrc: './img/pokemon/front/272_ludicolo_front.png',
        backSpriteSrc: './img/pokemon/back/272_ludicolo_back.png',
    },
    {
        id: 273,
        name: 'Seedot',
        frontSpriteSrc: './img/pokemon/front/273_seedot_front.png',
        backSpriteSrc: './img/pokemon/back/273_seedot_back.png',
    },
    {
        id: 274,
        name: 'Nuzleaf',
        frontSpriteSrc: './img/pokemon/front/274_nuzleaf_front.png',
        backSpriteSrc: './img/pokemon/back/274_nuzleaf_back.png',
    },
    {
        id: 275,
        name: 'Shiftry',
        frontSpriteSrc: './img/pokemon/front/275_shiftry_front.png',
        backSpriteSrc: './img/pokemon/back/275_shiftry_back.png',
    },
    {
        id: 276,
        name: 'Taillow',
        frontSpriteSrc: './img/pokemon/front/276_taillow_front.png',
        backSpriteSrc: './img/pokemon/back/276_taillow_back.png',
    },
    {
        id: 277,
        name: 'Swellow',
        frontSpriteSrc: './img/pokemon/front/277_swellow_front.png',
        backSpriteSrc: './img/pokemon/back/277_swellow_back.png',
    },
    {
        id: 278,
        name: 'Wingull',
        frontSpriteSrc: './img/pokemon/front/278_wingull_front.png',
        backSpriteSrc: './img/pokemon/back/278_wingull_back.png',
    },
    {
        id: 279,
        name: 'Pelipper',
        frontSpriteSrc: './img/pokemon/front/279_pelipper_front.png',
        backSpriteSrc: './img/pokemon/back/279_pelipper_back.png',
    },
    {
        id: 280,
        name: 'Ralts',
        frontSpriteSrc: './img/pokemon/front/280_ralts_front.png',
        backSpriteSrc: './img/pokemon/back/280_ralts_back.png',
    },
    {
        id: 281,
        name: 'Kirlia',
        frontSpriteSrc: './img/pokemon/front/281_kirlia_front.png',
        backSpriteSrc: './img/pokemon/back/281_kirlia_back.png',
    },
    {
        id: 282,
        name: 'Gardevoir',
        frontSpriteSrc: './img/pokemon/front/282_gardevoir_front.png',
        backSpriteSrc: './img/pokemon/back/282_gardevoir_back.png',
    },
    {
        id: 283,
        name: 'Surskit',
        frontSpriteSrc: './img/pokemon/front/283_surskit_front.png',
        backSpriteSrc: './img/pokemon/back/283_surskit_back.png',
    },
    {
        id: 284,
        name: 'Masquerain',
        frontSpriteSrc: './img/pokemon/front/284_masquerain_front.png',
        backSpriteSrc: './img/pokemon/back/284_masquerain_back.png',
    },
    {
        id: 285,
        name: 'Shroomish',
        frontSpriteSrc: './img/pokemon/front/285_shroomish_front.png',
        backSpriteSrc: './img/pokemon/back/285_shroomish_back.png',
    },
    {
        id: 286,
        name: 'Breloom',
        frontSpriteSrc: './img/pokemon/front/286_breloom_front.png',
        backSpriteSrc: './img/pokemon/back/286_breloom_back.png',
    },
    {
        id: 287,
        name: 'Slakoth',
        frontSpriteSrc: './img/pokemon/front/287_slakoth_front.png',
        backSpriteSrc: './img/pokemon/back/287_slakoth_back.png',
    },
    {
        id: 288,
        name: 'Vigoroth',
        frontSpriteSrc: './img/pokemon/front/288_vigoroth_front.png',
        backSpriteSrc: './img/pokemon/back/288_vigoroth_back.png',
    },
    {
        id: 289,
        name: 'Slaking',
        frontSpriteSrc: './img/pokemon/front/289_slaking_front.png',
        backSpriteSrc: './img/pokemon/back/289_slaking_back.png',
    },
    {
        id: 290,
        name: 'Nincada',
        frontSpriteSrc: './img/pokemon/front/290_nincada_front.png',
        backSpriteSrc: './img/pokemon/back/290_nincada_back.png',
    },
    {
        id: 291,
        name: 'Ninjask',
        frontSpriteSrc: './img/pokemon/front/291_ninjask_front.png',
        backSpriteSrc: './img/pokemon/back/291_ninjask_back.png',
    },
    {
        id: 292,
        name: 'Shedinja',
        frontSpriteSrc: './img/pokemon/front/292_shedinja_front.png',
        backSpriteSrc: './img/pokemon/back/292_shedinja_back.png',
    },
    {
        id: 293,
        name: 'Whismur',
        frontSpriteSrc: './img/pokemon/front/293_whismur_front.png',
        backSpriteSrc: './img/pokemon/back/293_whismur_back.png',
    },
    {
        id: 294,
        name: 'Loudred',
        frontSpriteSrc: './img/pokemon/front/294_loudred_front.png',
        backSpriteSrc: './img/pokemon/back/294_loudred_back.png',
    },
    {
        id: 295,
        name: 'Exploud',
        frontSpriteSrc: './img/pokemon/front/295_exploud_front.png',
        backSpriteSrc: './img/pokemon/back/295_exploud_back.png',
    },
    {
        id: 296,
        name: 'Makuhita',
        frontSpriteSrc: './img/pokemon/front/296_makuhita_front.png',
        backSpriteSrc: './img/pokemon/back/296_makuhita_back.png',
    },
    {
        id: 297,
        name: 'Hariyama',
        frontSpriteSrc: './img/pokemon/front/297_hariyama_front.png',
        backSpriteSrc: './img/pokemon/back/297_hariyama_back.png',
    },
    {
        id: 298,
        name: 'Azurill',
        frontSpriteSrc: './img/pokemon/front/298_azurill_front.png',
        backSpriteSrc: './img/pokemon/back/298_azurill_back.png',
    },
    {
        id: 299,
        name: 'Nosepass',
        frontSpriteSrc: './img/pokemon/front/299_nosepass_front.png',
        backSpriteSrc: './img/pokemon/back/299_nosepass_back.png',
    },
    {
        id: 300,
        name: 'Skitty',
        frontSpriteSrc: './img/pokemon/front/300_skitty_front.png',
        backSpriteSrc: './img/pokemon/back/300_skitty_back.png',
    },
    {
        id: 301,
        name: 'Delcatty',
        frontSpriteSrc: './img/pokemon/front/301_delcatty_front.png',
        backSpriteSrc: './img/pokemon/back/301_delcatty_back.png',
    },
    {
        id: 302,
        name: 'Sableye',
        frontSpriteSrc: './img/pokemon/front/302_sableye_front.png',
        backSpriteSrc: './img/pokemon/back/302_sableye_back.png',
    },
    {
        id: 303,
        name: 'Mawile',
        frontSpriteSrc: './img/pokemon/front/303_mawile_front.png',
        backSpriteSrc: './img/pokemon/back/303_mawile_back.png',
    },
    {
        id: 304,
        name: 'Aron',
        frontSpriteSrc: './img/pokemon/front/304_aron_front.png',
        backSpriteSrc: './img/pokemon/back/304_aron_back.png',
    },
    {
        id: 305,
        name: 'Lairon',
        frontSpriteSrc: './img/pokemon/front/305_lairon_front.png',
        backSpriteSrc: './img/pokemon/back/305_lairon_back.png',
    },
    {
        id: 306,
        name: 'Aggron',
        frontSpriteSrc: './img/pokemon/front/306_aggron_front.png',
        backSpriteSrc: './img/pokemon/back/306_aggron_back.png',
    },
    {
        id: 307,
        name: 'Meditite',
        frontSpriteSrc: './img/pokemon/front/307_meditite_front.png',
        backSpriteSrc: './img/pokemon/back/307_meditite_back.png',
    },
    {
        id: 308,
        name: 'Medicham',
        frontSpriteSrc: './img/pokemon/front/308_medicham_front.png',
        backSpriteSrc: './img/pokemon/back/308_medicham_back.png',
    },
    {
        id: 309,
        name: 'Electrike',
        frontSpriteSrc: './img/pokemon/front/309_electrike_front.png',
        backSpriteSrc: './img/pokemon/back/309_electrike_back.png',
    },
    {
        id: 310,
        name: 'Manectric',
        frontSpriteSrc: './img/pokemon/front/310_manectric_front.png',
        backSpriteSrc: './img/pokemon/back/310_manectric_back.png',
    },
    {
        id: 311,
        name: 'Plusle',
        frontSpriteSrc: './img/pokemon/front/311_plusle_front.png',
        backSpriteSrc: './img/pokemon/back/311_plusle_back.png',
    },
    {
        id: 312,
        name: 'Minun',
        frontSpriteSrc: './img/pokemon/front/312_minun_front.png',
        backSpriteSrc: './img/pokemon/back/312_minun_back.png',
    },
    {
        id: 313,
        name: 'Volbeat',
        frontSpriteSrc: './img/pokemon/front/313_volbeat_front.png',
        backSpriteSrc: './img/pokemon/back/313_volbeat_back.png',
    },
    {
        id: 314,
        name: 'Illumise',
        frontSpriteSrc: './img/pokemon/front/314_illumise_front.png',
        backSpriteSrc: './img/pokemon/back/314_illumise_back.png',
    },
    {
        id: 315,
        name: 'Roselia',
        frontSpriteSrc: './img/pokemon/front/315_roselia_front.png',
        backSpriteSrc: './img/pokemon/back/315_roselia_back.png',
    },
    {
        id: 316,
        name: 'Gulpin',
        frontSpriteSrc: './img/pokemon/front/316_gulpin_front.png',
        backSpriteSrc: './img/pokemon/back/316_gulpin_back.png',
    },
    {
        id: 317,
        name: 'Swalot',
        frontSpriteSrc: './img/pokemon/front/317_swalot_front.png',
        backSpriteSrc: './img/pokemon/back/317_swalot_back.png',
    },
    {
        id: 318,
        name: 'Carvanha',
        frontSpriteSrc: './img/pokemon/front/318_carvanha_front.png',
        backSpriteSrc: './img/pokemon/back/318_carvanha_back.png',
    },
    {
        id: 319,
        name: 'Sharpedo',
        frontSpriteSrc: './img/pokemon/front/319_sharpedo_front.png',
        backSpriteSrc: './img/pokemon/back/319_sharpedo_back.png',
    },
    {
        id: 320,
        name: 'Wailmer',
        frontSpriteSrc: './img/pokemon/front/320_wailmer_front.png',
        backSpriteSrc: './img/pokemon/back/320_wailmer_back.png',
    },
    {
        id: 321,
        name: 'Wailord',
        frontSpriteSrc: './img/pokemon/front/321_wailord_front.png',
        backSpriteSrc: './img/pokemon/back/321_wailord_back.png',
    },
    {
        id: 322,
        name: 'Numel',
        frontSpriteSrc: './img/pokemon/front/322_numel_front.png',
        backSpriteSrc: './img/pokemon/back/322_numel_back.png',
    },
    {
        id: 323,
        name: 'Camerupt',
        frontSpriteSrc: './img/pokemon/front/323_camerupt_front.png',
        backSpriteSrc: './img/pokemon/back/323_camerupt_back.png',
    },
    {
        id: 324,
        name: 'Torkoal',
        frontSpriteSrc: './img/pokemon/front/324_torkoal_front.png',
        backSpriteSrc: './img/pokemon/back/324_torkoal_back.png',
    },
    {
        id: 325,
        name: 'Spoink',
        frontSpriteSrc: './img/pokemon/front/325_spoink_front.png',
        backSpriteSrc: './img/pokemon/back/325_spoink_back.png',
    },
    {
        id: 326,
        name: 'Grumpig',
        frontSpriteSrc: './img/pokemon/front/326_grumpig_front.png',
        backSpriteSrc: './img/pokemon/back/326_grumpig_back.png',
    },
    {
        id: 327,
        name: 'Spinda',
        frontSpriteSrc: './img/pokemon/front/327_spinda_front.png',
        backSpriteSrc: './img/pokemon/back/327_spinda_back.png',
    },
    {
        id: 328,
        name: 'Trapinch',
        frontSpriteSrc: './img/pokemon/front/328_trapinch_front.png',
        backSpriteSrc: './img/pokemon/back/328_trapinch_back.png',
    },
    {
        id: 329,
        name: 'Vibrava',
        frontSpriteSrc: './img/pokemon/front/329_vibrava_front.png',
        backSpriteSrc: './img/pokemon/back/329_vibrava_back.png',
    },
    {
        id: 330,
        name: 'Flygon',
        frontSpriteSrc: './img/pokemon/front/330_flygon_front.png',
        backSpriteSrc: './img/pokemon/back/330_flygon_back.png',
    },
    {
        id: 331,
        name: 'Cacnea',
        frontSpriteSrc: './img/pokemon/front/331_cacnea_front.png',
        backSpriteSrc: './img/pokemon/back/331_cacnea_back.png',
    },
    {
        id: 332,
        name: 'Cacturne',
        frontSpriteSrc: './img/pokemon/front/332_cacturne_front.png',
        backSpriteSrc: './img/pokemon/back/332_cacturne_back.png',
    },
    {
        id: 333,
        name: 'Swablu',
        frontSpriteSrc: './img/pokemon/front/333_swablu_front.png',
        backSpriteSrc: './img/pokemon/back/333_swablu_back.png',
    },
    {
        id: 334,
        name: 'Altaria',
        frontSpriteSrc: './img/pokemon/front/334_altaria_front.png',
        backSpriteSrc: './img/pokemon/back/334_altaria_back.png',
    },
    {
        id: 335,
        name: 'Zangoose',
        frontSpriteSrc: './img/pokemon/front/335_zangoose_front.png',
        backSpriteSrc: './img/pokemon/back/335_zangoose_back.png',
    },
    {
        id: 336,
        name: 'Seviper',
        frontSpriteSrc: './img/pokemon/front/336_seviper_front.png',
        backSpriteSrc: './img/pokemon/back/336_seviper_back.png',
    },
    {
        id: 337,
        name: 'Lunatone',
        frontSpriteSrc: './img/pokemon/front/337_lunatone_front.png',
        backSpriteSrc: './img/pokemon/back/337_lunatone_back.png',
    },
    {
        id: 338,
        name: 'Solrock',
        frontSpriteSrc: './img/pokemon/front/338_solrock_front.png',
        backSpriteSrc: './img/pokemon/back/338_solrock_back.png',
    },
    {
        id: 339,
        name: 'Barboach',
        frontSpriteSrc: './img/pokemon/front/339_barboach_front.png',
        backSpriteSrc: './img/pokemon/back/339_barboach_back.png',
    },
    {
        id: 340,
        name: 'Whiscash',
        frontSpriteSrc: './img/pokemon/front/340_whiscash_front.png',
        backSpriteSrc: './img/pokemon/back/340_whiscash_back.png',
    },
    {
        id: 341,
        name: 'Corphish',
        frontSpriteSrc: './img/pokemon/front/341_corphish_front.png',
        backSpriteSrc: './img/pokemon/back/341_corphish_back.png',
    },
    {
        id: 342,
        name: 'Crawdaunt',
        frontSpriteSrc: './img/pokemon/front/342_crawdaunt_front.png',
        backSpriteSrc: './img/pokemon/back/342_crawdaunt_back.png',
    },
    {
        id: 343,
        name: 'Baltoy',
        frontSpriteSrc: './img/pokemon/front/343_baltoy_front.png',
        backSpriteSrc: './img/pokemon/back/343_baltoy_back.png',
    },
    {
        id: 344,
        name: 'Claydol',
        frontSpriteSrc: './img/pokemon/front/344_claydol_front.png',
        backSpriteSrc: './img/pokemon/back/344_claydol_back.png',
    },
    {
        id: 345,
        name: 'Lileep',
        frontSpriteSrc: './img/pokemon/front/345_lileep_front.png',
        backSpriteSrc: './img/pokemon/back/345_lileep_back.png',
    },
    {
        id: 346,
        name: 'Cradily',
        frontSpriteSrc: './img/pokemon/front/346_cradily_front.png',
        backSpriteSrc: './img/pokemon/back/346_cradily_back.png',
    },
    {
        id: 347,
        name: 'Anorith',
        frontSpriteSrc: './img/pokemon/front/347_anorith_front.png',
        backSpriteSrc: './img/pokemon/back/347_anorith_back.png',
    },
    {
        id: 348,
        name: 'Armaldo',
        frontSpriteSrc: './img/pokemon/front/348_armaldo_front.png',
        backSpriteSrc: './img/pokemon/back/348_armaldo_back.png',
    },
    {
        id: 349,
        name: 'Feebas',
        frontSpriteSrc: './img/pokemon/front/349_feebas_front.png',
        backSpriteSrc: './img/pokemon/back/349_feebas_back.png',
    },
    {
        id: 350,
        name: 'Milotic',
        frontSpriteSrc: './img/pokemon/front/350_milotic_front.png',
        backSpriteSrc: './img/pokemon/back/350_milotic_back.png',
    },
    {
        id: 351,
        name: 'Castform',
        frontSpriteSrc: './img/pokemon/front/351_castform_front.png',
        backSpriteSrc: './img/pokemon/back/351_castform_back.png',
    },
    {
        id: 352,
        name: 'Kecleon',
        frontSpriteSrc: './img/pokemon/front/352_kecleon_front.png',
        backSpriteSrc: './img/pokemon/back/352_kecleon_back.png',
    },
    {
        id: 353,
        name: 'Shuppet',
        frontSpriteSrc: './img/pokemon/front/353_shuppet_front.png',
        backSpriteSrc: './img/pokemon/back/353_shuppet_back.png',
    },
    {
        id: 354,
        name: 'Banette',
        frontSpriteSrc: './img/pokemon/front/354_banette_front.png',
        backSpriteSrc: './img/pokemon/back/354_banette_back.png',
    },
    {
        id: 355,
        name: 'Duskull',
        frontSpriteSrc: './img/pokemon/front/355_duskull_front.png',
        backSpriteSrc: './img/pokemon/back/355_duskull_back.png',
    },
    {
        id: 356,
        name: 'Dusclops',
        frontSpriteSrc: './img/pokemon/front/356_dusclops_front.png',
        backSpriteSrc: './img/pokemon/back/356_dusclops_back.png',
    },
    {
        id: 357,
        name: 'Tropius',
        frontSpriteSrc: './img/pokemon/front/357_tropius_front.png',
        backSpriteSrc: './img/pokemon/back/357_tropius_back.png',
    },
    {
        id: 358,
        name: 'Chimecho',
        frontSpriteSrc: './img/pokemon/front/358_chimecho_front.png',
        backSpriteSrc: './img/pokemon/back/358_chimecho_back.png',
    },
    {
        id: 359,
        name: 'Absol',
        frontSpriteSrc: './img/pokemon/front/359_absol_front.png',
        backSpriteSrc: './img/pokemon/back/359_absol_back.png',
    },
    {
        id: 360,
        name: 'Wynaut',
        frontSpriteSrc: './img/pokemon/front/360_wynaut_front.png',
        backSpriteSrc: './img/pokemon/back/360_wynaut_back.png',
    },
    {
        id: 361,
        name: 'Snorunt',
        frontSpriteSrc: './img/pokemon/front/361_snorunt_front.png',
        backSpriteSrc: './img/pokemon/back/361_snorunt_back.png',
    },
    {
        id: 362,
        name: 'Glalie',
        frontSpriteSrc: './img/pokemon/front/362_glalie_front.png',
        backSpriteSrc: './img/pokemon/back/362_glalie_back.png',
    },
    {
        id: 363,
        name: 'Spheal',
        frontSpriteSrc: './img/pokemon/front/363_spheal_front.png',
        backSpriteSrc: './img/pokemon/back/363_spheal_back.png',
    },
    {
        id: 364,
        name: 'Sealeo',
        frontSpriteSrc: './img/pokemon/front/364_sealeo_front.png',
        backSpriteSrc: './img/pokemon/back/364_sealeo_back.png',
    },
    {
        id: 365,
        name: 'Walrein',
        frontSpriteSrc: './img/pokemon/front/365_walrein_front.png',
        backSpriteSrc: './img/pokemon/back/365_walrein_back.png',
    },
    {
        id: 366,
        name: 'Clamperl',
        frontSpriteSrc: './img/pokemon/front/366_clamperl_front.png',
        backSpriteSrc: './img/pokemon/back/366_clamperl_back.png',
    },
    {
        id: 367,
        name: 'Huntail',
        frontSpriteSrc: './img/pokemon/front/367_huntail_front.png',
        backSpriteSrc: './img/pokemon/back/367_huntail_back.png',
    },
    {
        id: 368,
        name: 'Gorebyss',
        frontSpriteSrc: './img/pokemon/front/368_gorebyss_front.png',
        backSpriteSrc: './img/pokemon/back/368_gorebyss_back.png',
    },
    {
        id: 369,
        name: 'Relicanth',
        frontSpriteSrc: './img/pokemon/front/369_relicanth_front.png',
        backSpriteSrc: './img/pokemon/back/369_relicanth_back.png',
    },
    {
        id: 370,
        name: 'Luvdisc',
        frontSpriteSrc: './img/pokemon/front/370_luvdisc_front.png',
        backSpriteSrc: './img/pokemon/back/370_luvdisc_back.png',
    },
    {
        id: 371,
        name: 'Bagon',
        frontSpriteSrc: './img/pokemon/front/371_bagon_front.png',
        backSpriteSrc: './img/pokemon/back/371_bagon_back.png',
    },
    {
        id: 372,
        name: 'Shelgon',
        frontSpriteSrc: './img/pokemon/front/372_shelgon_front.png',
        backSpriteSrc: './img/pokemon/back/372_shelgon_back.png',
    },
    {
        id: 373,
        name: 'Salamence',
        frontSpriteSrc: './img/pokemon/front/373_salamence_front.png',
        backSpriteSrc: './img/pokemon/back/373_salamence_back.png',
    },
    {
        id: 374,
        name: 'Beldum',
        frontSpriteSrc: './img/pokemon/front/374_beldum_front.png',
        backSpriteSrc: './img/pokemon/back/374_beldum_back.png',
    },
    {
        id: 375,
        name: 'Metang',
        frontSpriteSrc: './img/pokemon/front/375_metang_front.png',
        backSpriteSrc: './img/pokemon/back/375_metang_back.png',
    },
    {
        id: 376,
        name: 'Metagross',
        frontSpriteSrc: './img/pokemon/front/376_metagross_front.png',
        backSpriteSrc: './img/pokemon/back/376_metagross_back.png',
    },
    {
        id: 377,
        name: 'Regirock',
        frontSpriteSrc: './img/pokemon/front/377_regirock_front.png',
        backSpriteSrc: './img/pokemon/back/377_regirock_back.png',
    },
    {
        id: 378,
        name: 'Regice',
        frontSpriteSrc: './img/pokemon/front/378_regice_front.png',
        backSpriteSrc: './img/pokemon/back/378_regice_back.png',
    },
    {
        id: 379,
        name: 'Registeel',
        frontSpriteSrc: './img/pokemon/front/379_registeel_front.png',
        backSpriteSrc: './img/pokemon/back/379_registeel_back.png',
    },
    {
        id: 380,
        name: 'Latias',
        frontSpriteSrc: './img/pokemon/front/380_latias_front.png',
        backSpriteSrc: './img/pokemon/back/380_latias_back.png',
    },
    {
        id: 381,
        name: 'Latios',
        frontSpriteSrc: './img/pokemon/front/381_latios_front.png',
        backSpriteSrc: './img/pokemon/back/381_latios_back.png',
    },
    {
        id: 382,
        name: 'Kyogre',
        frontSpriteSrc: './img/pokemon/front/382_kyogre_front.png',
        backSpriteSrc: './img/pokemon/back/382_kyogre_back.png',
    },
    {
        id: 383,
        name: 'Groudon',
        frontSpriteSrc: './img/pokemon/front/383_groudon_front.png',
        backSpriteSrc: './img/pokemon/back/383_groudon_back.png',
    },
    {
        id: 384,
        name: 'Rayquaza',
        frontSpriteSrc: './img/pokemon/front/384_rayquaza_front.png',
        backSpriteSrc: './img/pokemon/back/384_rayquaza_back.png',
    },
    {
        id: 385,
        name: 'Jirachi',
        frontSpriteSrc: './img/pokemon/front/385_jirachi_front.png',
        backSpriteSrc: './img/pokemon/back/385_jirachi_back.png',
    },
    {
        id: 386,
        name: 'Deoxys',
        frontSpriteSrc: './img/pokemon/front/386_deoxys_front.png',
        backSpriteSrc: './img/pokemon/back/386_deoxys_back.png',
    },
    {
        id: 387,
        name: 'Lucy',
    },
    {
        id: 388,
        name: 'Kokeko',
    },
];

export const genderDB = {
    // Generation 1 (1-151)
    1: { male: 0.875, female: 0.125 }, // Bulbasaur
    2: { male: 0.875, female: 0.125 }, // Ivysaur
    3: { male: 0.875, female: 0.125 }, // Venusaur
    4: { male: 0.875, female: 0.125 }, // Charmander
    5: { male: 0.875, female: 0.125 }, // Charmeleon
    6: { male: 0.875, female: 0.125 }, // Charizard
    7: { male: 0.875, female: 0.125 }, // Squirtle
    8: { male: 0.875, female: 0.125 }, // Wartortle
    9: { male: 0.875, female: 0.125 }, // Blastoise
    10: { male: 0.5, female: 0.5 }, // Caterpie
    11: { male: 0.5, female: 0.5 }, // Metapod
    12: { male: 0.5, female: 0.5 }, // Butterfree
    13: { male: 0.5, female: 0.5 }, // Weedle
    14: { male: 0.5, female: 0.5 }, // Kakuna
    15: { male: 0.5, female: 0.5 }, // Beedrill
    16: { male: 0.5, female: 0.5 }, // Pidgey
    17: { male: 0.5, female: 0.5 }, // Pidgeotto
    18: { male: 0.5, female: 0.5 }, // Pidgeot
    19: { male: 0.5, female: 0.5 }, // Rattata
    20: { male: 0.5, female: 0.5 }, // Raticate
    21: { male: 0.5, female: 0.5 }, // Spearow
    22: { male: 0.5, female: 0.5 }, // Fearow
    23: { male: 0.5, female: 0.5 }, // Ekans
    24: { male: 0.5, female: 0.5 }, // Arbok
    25: { male: 0.5, female: 0.5 }, // Pikachu
    26: { male: 0.5, female: 0.5 }, // Raichu
    27: { male: 0.5, female: 0.5 }, // Sandshrew
    28: { male: 0.5, female: 0.5 }, // Sandslash
    29: { male: 0, female: 1 }, // Nidoran♀
    30: { male: 0, female: 1 }, // Nidorina
    31: { male: 0, female: 1 }, // Nidoqueen
    32: { male: 1, female: 0 }, // Nidoran♂
    33: { male: 1, female: 0 }, // Nidorino
    34: { male: 1, female: 0 }, // Nidoking
    35: { male: 0.25, female: 0.75 }, // Clefairy
    36: { male: 0.25, female: 0.75 }, // Clefable
    37: { male: 0.25, female: 0.75 }, // Vulpix
    38: { male: 0.25, female: 0.75 }, // Ninetales
    39: { male: 0.25, female: 0.75 }, // Jigglypuff
    40: { male: 0.25, female: 0.75 }, // Wigglytuff
    41: { male: 0.5, female: 0.5 }, // Zubat
    42: { male: 0.5, female: 0.5 }, // Golbat
    43: { male: 0.5, female: 0.5 }, // Oddish
    44: { male: 0.5, female: 0.5 }, // Gloom
    45: { male: 0.5, female: 0.5 }, // Vileplume
    46: { male: 0.5, female: 0.5 }, // Paras
    47: { male: 0.5, female: 0.5 }, // Parasect
    48: { male: 0.5, female: 0.5 }, // Venonat
    49: { male: 0.5, female: 0.5 }, // Venomoth
    50: { male: 0.5, female: 0.5 }, // Diglett
    51: { male: 0.5, female: 0.5 }, // Dugtrio
    52: { male: 0.5, female: 0.5 }, // Meowth
    53: { male: 0.5, female: 0.5 }, // Persian
    54: { male: 0.5, female: 0.5 }, // Psyduck
    55: { male: 0.5, female: 0.5 }, // Golduck
    56: { male: 0.5, female: 0.5 }, // Mankey
    57: { male: 0.5, female: 0.5 }, // Primeape
    58: { male: 0.75, female: 0.25 }, // Growlithe
    59: { male: 0.75, female: 0.25 }, // Arcanine
    60: { male: 0.5, female: 0.5 }, // Poliwag
    61: { male: 0.5, female: 0.5 }, // Poliwhirl
    62: { male: 0.5, female: 0.5 }, // Poliwrath
    63: { male: 0.75, female: 0.25 }, // Abra
    64: { male: 0.75, female: 0.25 }, // Kadabra
    65: { male: 0.75, female: 0.25 }, // Alakazam
    66: { male: 0.75, female: 0.25 }, // Machop
    67: { male: 0.75, female: 0.25 }, // Machoke
    68: { male: 0.75, female: 0.25 }, // Machamp
    69: { male: 0.5, female: 0.5 }, // Bellsprout
    70: { male: 0.5, female: 0.5 }, // Weepinbell
    71: { male: 0.5, female: 0.5 }, // Victreebel
    72: { male: 0.5, female: 0.5 }, // Tentacool
    73: { male: 0.5, female: 0.5 }, // Tentacruel
    74: { male: 0.5, female: 0.5 }, // Geodude
    75: { male: 0.5, female: 0.5 }, // Graveler
    76: { male: 0.5, female: 0.5 }, // Golem
    77: { male: 0.5, female: 0.5 }, // Ponyta
    78: { male: 0.5, female: 0.5 }, // Rapidash
    79: { male: 0.5, female: 0.5 }, // Slowpoke
    80: { male: 0.5, female: 0.5 }, // Slowbro
    81: { male: 0, female: 0 }, // Magnemite
    82: { male: 0, female: 0 }, // Magneton
    83: { male: 0.5, female: 0.5 }, // Farfetch'd
    84: { male: 0.5, female: 0.5 }, // Doduo
    85: { male: 0.5, female: 0.5 }, // Dodrio
    86: { male: 0.5, female: 0.5 }, // Seel
    87: { male: 0.5, female: 0.5 }, // Dewgong
    88: { male: 0.5, female: 0.5 }, // Grimer
    89: { male: 0.5, female: 0.5 }, // Muk
    90: { male: 0.5, female: 0.5 }, // Shellder
    91: { male: 0.5, female: 0.5 }, // Cloyster
    92: { male: 0.5, female: 0.5 }, // Gastly
    93: { male: 0.5, female: 0.5 }, // Haunter
    94: { male: 0.5, female: 0.5 }, // Gengar
    95: { male: 0.5, female: 0.5 }, // Onix
    96: { male: 0.5, female: 0.5 }, // Drowzee
    97: { male: 0.5, female: 0.5 }, // Hypno
    98: { male: 0.5, female: 0.5 }, // Krabby
    99: { male: 0.5, female: 0.5 }, // Kingler
    100: { male: 0, female: 0 }, // Voltorb
    101: { male: 0, female: 0 }, // Electrode
    102: { male: 0.5, female: 0.5 }, // Exeggcute
    103: { male: 0.5, female: 0.5 }, // Exeggutor
    104: { male: 0.5, female: 0.5 }, // Cubone
    105: { male: 0.5, female: 0.5 }, // Marowak
    106: { male: 1, female: 0 }, // Hitmonlee
    107: { male: 1, female: 0 }, // Hitmonchan
    108: { male: 0.5, female: 0.5 }, // Lickitung
    109: { male: 0.5, female: 0.5 }, // Koffing
    110: { male: 0.5, female: 0.5 }, // Weezing
    111: { male: 0.5, female: 0.5 }, // Rhyhorn
    112: { male: 0.5, female: 0.5 }, // Rhydon
    113: { male: 0, female: 1 }, // Chansey
    114: { male: 0.5, female: 0.5 }, // Tangela
    115: { male: 0, female: 1 }, // Kangaskhan
    116: { male: 0.5, female: 0.5 }, // Horsea
    117: { male: 0.5, female: 0.5 }, // Seadra
    118: { male: 0.5, female: 0.5 }, // Goldeen
    119: { male: 0.5, female: 0.5 }, // Seaking
    120: { male: 0, female: 0 }, // Staryu
    121: { male: 0, female: 0 }, // Starmie
    122: { male: 0.5, female: 0.5 }, // Mr. Mime
    123: { male: 0.5, female: 0.5 }, // Scyther
    124: { male: 0, female: 1 }, // Jynx
    125: { male: 0.75, female: 0.25 }, // Electabuzz
    126: { male: 0.75, female: 0.25 }, // Magmar
    127: { male: 0.5, female: 0.5 }, // Pinsir
    128: { male: 1, female: 0 }, // Tauros
    129: { male: 0.5, female: 0.5 }, // Magikarp
    130: { male: 0.5, female: 0.5 }, // Gyarados
    131: { male: 0.5, female: 0.5 }, // Lapras
    132: { male: 0, female: 0 }, // Ditto
    133: { male: 0.875, female: 0.125 }, // Eevee
    134: { male: 0.875, female: 0.125 }, // Vaporeon
    135: { male: 0.875, female: 0.125 }, // Jolteon
    136: { male: 0.875, female: 0.125 }, // Flareon
    137: { male: 0, female: 0 }, // Porygon
    138: { male: 0.875, female: 0.125 }, // Omanyte
    139: { male: 0.875, female: 0.125 }, // Omastar
    140: { male: 0.875, female: 0.125 }, // Kabuto
    141: { male: 0.875, female: 0.125 }, // Kabutops
    142: { male: 0.875, female: 0.125 }, // Aerodactyl
    143: { male: 0.875, female: 0.125 }, // Snorlax
    144: { male: 0, female: 0 }, // Articuno
    145: { male: 0, female: 0 }, // Zapdos
    146: { male: 0, female: 0 }, // Moltres
    147: { male: 0.5, female: 0.5 }, // Dratini
    148: { male: 0.5, female: 0.5 }, // Dragonair
    149: { male: 0.5, female: 0.5 }, // Dragonite
    150: { male: 0, female: 0 }, // Mewtwo
    151: { male: 0, female: 0 }, // Mew

    // Generation 2 (152-251)
    152: { male: 0.875, female: 0.125 }, // Chikorita
    153: { male: 0.875, female: 0.125 }, // Bayleef
    154: { male: 0.875, female: 0.125 }, // Meganium
    155: { male: 0.875, female: 0.125 }, // Cyndaquil
    156: { male: 0.875, female: 0.125 }, // Quilava
    157: { male: 0.875, female: 0.125 }, // Typhlosion
    158: { male: 0.875, female: 0.125 }, // Totodile
    159: { male: 0.875, female: 0.125 }, // Croconaw
    160: { male: 0.875, female: 0.125 }, // Feraligatr
    161: { male: 0.5, female: 0.5 }, // Sentret
    162: { male: 0.5, female: 0.5 }, // Furret
    163: { male: 0.5, female: 0.5 }, // Hoothoot
    164: { male: 0.5, female: 0.5 }, // Noctowl
    165: { male: 0.5, female: 0.5 }, // Ledyba
    166: { male: 0.5, female: 0.5 }, // Ledian
    167: { male: 0.5, female: 0.5 }, // Spinarak
    168: { male: 0.5, female: 0.5 }, // Ariados
    169: { male: 0.5, female: 0.5 }, // Crobat
    170: { male: 0.5, female: 0.5 }, // Chinchou
    171: { male: 0.5, female: 0.5 }, // Lanturn
    172: { male: 0.5, female: 0.5 }, // Pichu
    173: { male: 0.25, female: 0.75 }, // Cleffa
    174: { male: 0.25, female: 0.75 }, // Igglybuff
    175: { male: 0.875, female: 0.125 }, // Togepi
    176: { male: 0.875, female: 0.125 }, // Togetic
    177: { male: 0.5, female: 0.5 }, // Natu
    178: { male: 0.5, female: 0.5 }, // Xatu
    179: { male: 0.5, female: 0.5 }, // Mareep
    180: { male: 0.5, female: 0.5 }, // Flaaffy
    181: { male: 0.5, female: 0.5 }, // Ampharos
    182: { male: 0.5, female: 0.5 }, // Bellossom
    183: { male: 0.5, female: 0.5 }, // Marill
    184: { male: 0.5, female: 0.5 }, // Azumarill
    185: { male: 0.5, female: 0.5 }, // Sudowoodo
    186: { male: 0.5, female: 0.5 }, // Politoed
    187: { male: 0.5, female: 0.5 }, // Hoppip
    188: { male: 0.5, female: 0.5 }, // Skiploom
    189: { male: 0.5, female: 0.5 }, // Jumpluff
    190: { male: 0.5, female: 0.5 }, // Aipom
    191: { male: 0.5, female: 0.5 }, // Sunkern
    192: { male: 0.5, female: 0.5 }, // Sunflora
    193: { male: 0.5, female: 0.5 }, // Yanma
    194: { male: 0.5, female: 0.5 }, // Wooper
    195: { male: 0.5, female: 0.5 }, // Quagsire
    196: { male: 0.875, female: 0.125 }, // Espeon
    197: { male: 0.875, female: 0.125 }, // Umbreon
    198: { male: 0.5, female: 0.5 }, // Murkrow
    199: { male: 0.5, female: 0.5 }, // Slowking
    200: { male: 0.5, female: 0.5 }, // Misdreavus
    201: { male: 0, female: 0 }, // Unown
    202: { male: 0.5, female: 0.5 }, // Wobbuffet
    203: { male: 0.5, female: 0.5 }, // Girafarig
    204: { male: 0.5, female: 0.5 }, // Pineco
    205: { male: 0.5, female: 0.5 }, // Forretress
    206: { male: 0.5, female: 0.5 }, // Dunsparce
    207: { male: 0.5, female: 0.5 }, // Gligar
    208: { male: 0.5, female: 0.5 }, // Steelix
    209: { male: 0.25, female: 0.75 }, // Snubbull
    210: { male: 0.25, female: 0.75 }, // Granbull
    211: { male: 0.5, female: 0.5 }, // Qwilfish
    212: { male: 0.5, female: 0.5 }, // Scizor
    213: { male: 0.5, female: 0.5 }, // Shuckle
    214: { male: 0.5, female: 0.5 }, // Heracross
    215: { male: 0.5, female: 0.5 }, // Sneasel
    216: { male: 0.5, female: 0.5 }, // Teddiursa
    217: { male: 0.5, female: 0.5 }, // Ursaring
    218: { male: 0.5, female: 0.5 }, // Slugma
    219: { male: 0.5, female: 0.5 }, // Magcargo
    220: { male: 0.5, female: 0.5 }, // Swinub
    221: { male: 0.5, female: 0.5 }, // Piloswine
    222: { male: 0.25, female: 0.75 }, // Corsola
    223: { male: 0.5, female: 0.5 }, // Remoraid
    224: { male: 0.5, female: 0.5 }, // Octillery
    225: { male: 0.5, female: 0.5 }, // Delibird
    226: { male: 0.5, female: 0.5 }, // Mantine
    227: { male: 0.5, female: 0.5 }, // Skarmory
    228: { male: 0.5, female: 0.5 }, // Houndour
    229: { male: 0.5, female: 0.5 }, // Houndoom
    230: { male: 0.5, female: 0.5 }, // Kingdra
    231: { male: 0.5, female: 0.5 }, // Phanpy
    232: { male: 0.5, female: 0.5 }, // Donphan
    233: { male: 0, female: 0 }, // Porygon2
    234: { male: 0.5, female: 0.5 }, // Stantler
    235: { male: 0.5, female: 0.5 }, // Smeargle
    236: { male: 1, female: 0 }, // Tyrogue
    237: { male: 1, female: 0 }, // Hitmontop
    238: { male: 0, female: 1 }, // Smoochum
    239: { male: 0.75, female: 0.25 }, // Elekid
    240: { male: 0.75, female: 0.25 }, // Magby
    241: { male: 0, female: 1 }, // Miltank
    242: { male: 0, female: 1 }, // Blissey
    243: { male: 0, female: 0 }, // Raikou
    244: { male: 0, female: 0 }, // Entei
    245: { male: 0, female: 0 }, // Suicune
    246: { male: 0.5, female: 0.5 }, // Larvitar
    247: { male: 0.5, female: 0.5 }, // Pupitar
    248: { male: 0.5, female: 0.5 }, // Tyranitar
    249: { male: 0, female: 0 }, // Lugia
    250: { male: 0, female: 0 }, // Ho-Oh
    251: { male: 0, female: 0 }, // Celebi

    // Generation 3 (252-386)
    252: { male: 0.875, female: 0.125 }, // Treecko
    253: { male: 0.875, female: 0.125 }, // Grovyle
    254: { male: 0.875, female: 0.125 }, // Sceptile
    255: { male: 0.875, female: 0.125 }, // Torchic
    256: { male: 0.875, female: 0.125 }, // Combusken
    257: { male: 0.875, female: 0.125 }, // Blaziken
    258: { male: 0.875, female: 0.125 }, // Mudkip
    259: { male: 0.875, female: 0.125 }, // Marshtomp
    260: { male: 0.875, female: 0.125 }, // Swampert
    261: { male: 0.5, female: 0.5 }, // Poochyena
    262: { male: 0.5, female: 0.5 }, // Mightyena
    263: { male: 0.5, female: 0.5 }, // Zigzagoon
    264: { male: 0.5, female: 0.5 }, // Linoone
    265: { male: 0.5, female: 0.5 }, // Wurmple
    266: { male: 0.5, female: 0.5 }, // Silcoon
    267: { male: 0.5, female: 0.5 }, // Beautifly
    268: { male: 0.5, female: 0.5 }, // Cascoon
    269: { male: 0.5, female: 0.5 }, // Dustox
    270: { male: 0.5, female: 0.5 }, // Lotad
    271: { male: 0.5, female: 0.5 }, // Lombre
    272: { male: 0.5, female: 0.5 }, // Ludicolo
    273: { male: 0.5, female: 0.5 }, // Seedot
    274: { male: 0.5, female: 0.5 }, // Nuzleaf
    275: { male: 0.5, female: 0.5 }, // Shiftry
    276: { male: 0.5, female: 0.5 }, // Taillow
    277: { male: 0.5, female: 0.5 }, // Swellow
    278: { male: 0.5, female: 0.5 }, // Wingull
    279: { male: 0.5, female: 0.5 }, // Pelipper
    280: { male: 0.5, female: 0.5 }, // Ralts
    281: { male: 0.5, female: 0.5 }, // Kirlia
    282: { male: 0.5, female: 0.5 }, // Gardevoir
    283: { male: 0.5, female: 0.5 }, // Surskit
    284: { male: 0.5, female: 0.5 }, // Masquerain
    285: { male: 0.5, female: 0.5 }, // Shroomish
    286: { male: 0.5, female: 0.5 }, // Breloom
    287: { male: 0.5, female: 0.5 }, // Slakoth
    288: { male: 0.5, female: 0.5 }, // Vigoroth
    289: { male: 0.5, female: 0.5 }, // Slaking
    290: { male: 0.5, female: 0.5 }, // Nincada
    291: { male: 0.5, female: 0.5 }, // Ninjask
    292: { male: 0, female: 0 }, // Shedinja
    293: { male: 0.5, female: 0.5 }, // Whismur
    294: { male: 0.5, female: 0.5 }, // Loudred
    295: { male: 0.5, female: 0.5 }, // Exploud
    296: { male: 0.5, female: 0.5 }, // Makuhita
    297: { male: 0.5, female: 0.5 }, // Hariyama
    298: { male: 0.25, female: 0.75 }, // Azurill
    299: { male: 0.5, female: 0.5 }, // Nosepass
    300: { male: 0.5, female: 0.5 }, // Skitty
    301: { male: 0.5, female: 0.5 }, // Delcatty
    302: { male: 0.5, female: 0.5 }, // Sableye
    303: { male: 0.5, female: 0.5 }, // Mawile
    304: { male: 0.5, female: 0.5 }, // Aron
    305: { male: 0.5, female: 0.5 }, // Lairon
    306: { male: 0.5, female: 0.5 }, // Aggron
    307: { male: 0.5, female: 0.5 }, // Meditite
    308: { male: 0.5, female: 0.5 }, // Medicham
    309: { male: 0.5, female: 0.5 }, // Electrike
    310: { male: 0.5, female: 0.5 }, // Manectric
    311: { male: 0.5, female: 0.5 }, // Plusle
    312: { male: 0.5, female: 0.5 }, // Minun
    313: { male: 1, female: 0 }, // Volbeat
    314: { male: 0, female: 1 }, // Illumise
    315: { male: 0.5, female: 0.5 }, // Roselia
    316: { male: 0.5, female: 0.5 }, // Gulpin
    317: { male: 0.5, female: 0.5 }, // Swalot
    318: { male: 0.5, female: 0.5 }, // Carvanha
    319: { male: 0.5, female: 0.5 }, // Sharpedo
    320: { male: 0.5, female: 0.5 }, // Wailmer
    321: { male: 0.5, female: 0.5 }, // Wailord
    322: { male: 0.5, female: 0.5 }, // Numel
    323: { male: 0.5, female: 0.5 }, // Camerupt
    324: { male: 0.5, female: 0.5 }, // Torkoal
    325: { male: 0.5, female: 0.5 }, // Spoink
    326: { male: 0.5, female: 0.5 }, // Grumpig
    327: { male: 0.5, female: 0.5 }, // Spinda
    328: { male: 0.5, female: 0.5 }, // Trapinch
    329: { male: 0.5, female: 0.5 }, // Vibrava
    330: { male: 0.5, female: 0.5 }, // Flygon
    331: { male: 0.5, female: 0.5 }, // Cacnea
    332: { male: 0.5, female: 0.5 }, // Cacturne
    333: { male: 0.5, female: 0.5 }, // Swablu
    334: { male: 0.5, female: 0.5 }, // Altaria
    335: { male: 0.5, female: 0.5 }, // Zangoose
    336: { male: 0.5, female: 0.5 }, // Seviper
    337: { male: 0, female: 0 }, // Lunatone
    338: { male: 0, female: 0 }, // Solrock
    339: { male: 0.5, female: 0.5 }, // Barboach
    340: { male: 0.5, female: 0.5 }, // Whiscash
    341: { male: 0.5, female: 0.5 }, // Corphish
    342: { male: 0.5, female: 0.5 }, // Crawdaunt
    343: { male: 0, female: 0 }, // Baltoy
    344: { male: 0, female: 0 }, // Claydol
    345: { male: 0.875, female: 0.125 }, // Lileep
    346: { male: 0.875, female: 0.125 }, // Cradily
    347: { male: 0.875, female: 0.125 }, // Anorith
    348: { male: 0.875, female: 0.125 }, // Armaldo
    349: { male: 0.5, female: 0.5 }, // Feebas
    350: { male: 0.5, female: 0.5 }, // Milotic
    351: { male: 0.5, female: 0.5 }, // Castform
    352: { male: 0.5, female: 0.5 }, // Kecleon
    353: { male: 0.5, female: 0.5 }, // Shuppet
    354: { male: 0.5, female: 0.5 }, // Banette
    355: { male: 0.5, female: 0.5 }, // Duskull
    356: { male: 0.5, female: 0.5 }, // Dusclops
    357: { male: 0.5, female: 0.5 }, // Tropius
    358: { male: 0.5, female: 0.5 }, // Chimecho
    359: { male: 0.5, female: 0.5 }, // Absol
    360: { male: 0.5, female: 0.5 }, // Wynaut
    361: { male: 0.5, female: 0.5 }, // Snorunt
    362: { male: 0.5, female: 0.5 }, // Glalie
    363: { male: 0.5, female: 0.5 }, // Spheal
    364: { male: 0.5, female: 0.5 }, // Sealeo
    365: { male: 0.5, female: 0.5 }, // Walrein
    366: { male: 0.5, female: 0.5 }, // Clamperl
    367: { male: 0.5, female: 0.5 }, // Huntail
    368: { male: 0.5, female: 0.5 }, // Gorebyss
    369: { male: 0.875, female: 0.125 }, // Relicanth
    370: { male: 0.5, female: 0.5 }, // Luvdisc
    371: { male: 0.5, female: 0.5 }, // Bagon
    372: { male: 0.5, female: 0.5 }, // Shelgon
    373: { male: 0.5, female: 0.5 }, // Salamence
    374: { male: 0, female: 0 }, // Beldum
    375: { male: 0, female: 0 }, // Metang
    376: { male: 0, female: 0 }, // Metagross
    377: { male: 0, female: 0 }, // Regirock
    378: { male: 0, female: 0 }, // Regice
    379: { male: 0, female: 0 }, // Registeel
    380: { male: 0, female: 0 }, // Latias
    381: { male: 0, female: 0 }, // Latios
    382: { male: 0, female: 0 }, // Kyogre
    383: { male: 0, female: 0 }, // Groudon
    384: { male: 0, female: 0 }, // Rayquaza
    385: { male: 0, female: 0 }, // Jirachi
    386: { male: 0, female: 0 }, // Deoxys
    387: { male: 0, female: 1 }, // Lucy
    388: { male: 0.5, female: 0.5 }, // Guanpalo
};

export const catchRateDB = {
    1: {
        id: '001',
        catch_rate: 45,
    },
    2: {
        id: '002',
        catch_rate: 45,
    },
    3: {
        id: '003',
        catch_rate: 45,
    },
    4: {
        id: '004',
        catch_rate: 45,
    },
    5: {
        id: '005',
        catch_rate: 45,
    },
    6: {
        id: '006',
        catch_rate: 45,
    },
    7: {
        id: '007',
        catch_rate: 45,
    },
    8: {
        id: '008',
        catch_rate: 45,
    },
    9: {
        id: '009',
        catch_rate: 45,
    },
    10: {
        id: '010',
        catch_rate: 255,
    },
    11: {
        id: '011',
        catch_rate: 120,
    },
    12: {
        id: '012',
        catch_rate: 45,
    },
    13: {
        id: '013',
        catch_rate: 255,
    },
    14: {
        id: '014',
        catch_rate: 120,
    },
    15: {
        id: '015',
        catch_rate: 45,
    },
    16: {
        id: '016',
        catch_rate: 255,
    },
    17: {
        id: '017',
        catch_rate: 120,
    },
    18: {
        id: '018',
        catch_rate: 45,
    },
    19: {
        id: '019',
        catch_rate: 255,
    },
    20: {
        id: '020',
        catch_rate: 127,
    },
    21: {
        id: '021',
        catch_rate: 255,
    },
    22: {
        id: '022',
        catch_rate: 90,
    },
    23: {
        id: '023',
        catch_rate: 255,
    },
    24: {
        id: '024',
        catch_rate: 90,
    },
    25: {
        id: '025',
        catch_rate: 255,
    },
    26: {
        id: '026',
        catch_rate: 75,
    },
    27: {
        id: '027',
        catch_rate: 255,
    },
    28: {
        id: '028',
        catch_rate: 90,
    },
    29: {
        id: '029',
        catch_rate: 235,
    },
    30: {
        id: '030',
        catch_rate: 120,
    },
    31: {
        id: '031',
        catch_rate: 45,
    },
    32: {
        id: '032',
        catch_rate: 235,
    },
    33: {
        id: '033',
        catch_rate: 120,
    },
    34: {
        id: '034',
        catch_rate: 45,
    },
    35: {
        id: '035',
        catch_rate: 150,
    },
    36: {
        id: '036',
        catch_rate: 25,
    },
    37: {
        id: '037',
        catch_rate: 190,
    },
    38: {
        id: '038',
        catch_rate: 75,
    },
    39: {
        id: '039',
        catch_rate: 170,
    },
    40: {
        id: '040',
        catch_rate: 50,
    },
    41: {
        id: '041',
        catch_rate: 255,
    },
    42: {
        id: '042',
        catch_rate: 90,
    },
    43: {
        id: '043',
        catch_rate: 255,
    },
    44: {
        id: '044',
        catch_rate: 120,
    },
    45: {
        id: '045',
        catch_rate: 45,
    },
    46: {
        id: '046',
        catch_rate: 190,
    },
    47: {
        id: '047',
        catch_rate: 75,
    },
    48: {
        id: '048',
        catch_rate: 190,
    },
    49: {
        id: '049',
        catch_rate: 75,
    },
    50: {
        id: '050',
        catch_rate: 255,
    },
    51: {
        id: '051',
        catch_rate: 50,
    },
    52: {
        id: '052',
        catch_rate: 255,
    },
    53: {
        id: '053',
        catch_rate: 90,
    },
    54: {
        id: '054',
        catch_rate: 190,
    },
    55: {
        id: '055',
        catch_rate: 75,
    },
    56: {
        id: '056',
        catch_rate: 190,
    },
    57: {
        id: '057',
        catch_rate: 75,
    },
    58: {
        id: '058',
        catch_rate: 190,
    },
    59: {
        id: '059',
        catch_rate: 75,
    },
    60: {
        id: '060',
        catch_rate: 255,
    },
    61: {
        id: '061',
        catch_rate: 120,
    },
    62: {
        id: '062',
        catch_rate: 45,
    },
    63: {
        id: '063',
        catch_rate: 200,
    },
    64: {
        id: '064',
        catch_rate: 100,
    },
    65: {
        id: '065',
        catch_rate: 50,
    },
    66: {
        id: '066',
        catch_rate: 180,
    },
    67: {
        id: '067',
        catch_rate: 90,
    },
    68: {
        id: '068',
        catch_rate: 45,
    },
    69: {
        id: '069',
        catch_rate: 255,
    },
    70: {
        id: '070',
        catch_rate: 120,
    },
    71: {
        id: '071',
        catch_rate: 45,
    },
    72: {
        id: '072',
        catch_rate: 190,
    },
    73: {
        id: '073',
        catch_rate: 60,
    },
    74: {
        id: '074',
        catch_rate: 255,
    },
    75: {
        id: '075',
        catch_rate: 120,
    },
    76: {
        id: '076',
        catch_rate: 45,
    },
    77: {
        id: '077',
        catch_rate: 190,
    },
    78: {
        id: '078',
        catch_rate: 60,
    },
    79: {
        id: '079',
        catch_rate: 190,
    },
    80: {
        id: '080',
        catch_rate: 75,
    },
    81: {
        id: '081',
        catch_rate: 190,
    },
    82: {
        id: '082',
        catch_rate: 60,
    },
    83: {
        id: '083',
        catch_rate: 45,
    },
    84: {
        id: '084',
        catch_rate: 190,
    },
    85: {
        id: '085',
        catch_rate: 45,
    },
    86: {
        id: '086',
        catch_rate: 190,
    },
    87: {
        id: '087',
        catch_rate: 75,
    },
    88: {
        id: '088',
        catch_rate: 190,
    },
    89: {
        id: '089',
        catch_rate: 75,
    },
    90: {
        id: '090',
        catch_rate: 190,
    },
    91: {
        id: '091',
        catch_rate: 60,
    },
    92: {
        id: '092',
        catch_rate: 190,
    },
    93: {
        id: '093',
        catch_rate: 90,
    },
    94: {
        id: '094',
        catch_rate: 45,
    },
    95: {
        id: '095',
        catch_rate: 45,
    },
    96: {
        id: '096',
        catch_rate: 190,
    },
    97: {
        id: '097',
        catch_rate: 75,
    },
    98: {
        id: '098',
        catch_rate: 225,
    },
    99: {
        id: '099',
        catch_rate: 60,
    },
    100: {
        id: '100',
        catch_rate: 190,
    },
    101: {
        id: '101',
        catch_rate: 60,
    },
    102: {
        id: '102',
        catch_rate: 90,
    },
    103: {
        id: '103',
        catch_rate: 45,
    },
    104: {
        id: '104',
        catch_rate: 190,
    },
    105: {
        id: '105',
        catch_rate: 75,
    },
    106: {
        id: '106',
        catch_rate: 45,
    },
    107: {
        id: '107',
        catch_rate: 45,
    },
    108: {
        id: '108',
        catch_rate: 45,
    },
    109: {
        id: '109',
        catch_rate: 190,
    },
    110: {
        id: '110',
        catch_rate: 60,
    },
    111: {
        id: '111',
        catch_rate: 120,
    },
    112: {
        id: '112',
        catch_rate: 60,
    },
    113: {
        id: '113',
        catch_rate: 30,
    },
    114: {
        id: '114',
        catch_rate: 45,
    },
    115: {
        id: '115',
        catch_rate: 45,
    },
    116: {
        id: '116',
        catch_rate: 225,
    },
    117: {
        id: '117',
        catch_rate: 75,
    },
    118: {
        id: '118',
        catch_rate: 225,
    },
    119: {
        id: '119',
        catch_rate: 60,
    },
    120: {
        id: '120',
        catch_rate: 225,
    },
    121: {
        id: '121',
        catch_rate: 60,
    },
    122: {
        id: '122',
        catch_rate: 45,
    },
    123: {
        id: '123',
        catch_rate: 45,
    },
    124: {
        id: '124',
        catch_rate: 45,
    },
    125: {
        id: '125',
        catch_rate: 45,
    },
    126: {
        id: '126',
        catch_rate: 45,
    },
    127: {
        id: '127',
        catch_rate: 45,
    },
    128: {
        id: '128',
        catch_rate: 45,
    },
    129: {
        id: '129',
        catch_rate: 255,
    },
    130: {
        id: '130',
        catch_rate: 45,
    },
    131: {
        id: '131',
        catch_rate: 45,
    },
    132: {
        id: '132',
        catch_rate: 35,
    },
    133: {
        id: '133',
        catch_rate: 255,
    },
    134: {
        id: '134',
        catch_rate: 45,
    },
    135: {
        id: '135',
        catch_rate: 45,
    },
    136: {
        id: '136',
        catch_rate: 45,
    },
    137: {
        id: '137',
        catch_rate: 45,
    },
    138: {
        id: '138',
        catch_rate: 45,
    },
    139: {
        id: '139',
        catch_rate: 45,
    },
    140: {
        id: '140',
        catch_rate: 45,
    },
    141: {
        id: '141',
        catch_rate: 45,
    },
    142: {
        id: '142',
        catch_rate: 45,
    },
    143: {
        id: '143',
        catch_rate: 25,
    },
    144: {
        id: '144',
        catch_rate: 3,
    },
    145: {
        id: '145',
        catch_rate: 3,
    },
    146: {
        id: '146',
        catch_rate: 3,
    },
    147: {
        id: '147',
        catch_rate: 45,
    },
    148: {
        id: '148',
        catch_rate: 45,
    },
    149: {
        id: '149',
        catch_rate: 45,
    },
    150: {
        id: '150',
        catch_rate: 3,
    },
    151: {
        id: '151',
        catch_rate: 45,
    },
    152: {
        id: '152',
        catch_rate: 45,
    },
    153: {
        id: '153',
        catch_rate: 45,
    },
    154: {
        id: '154',
        catch_rate: 45,
    },
    155: {
        id: '155',
        catch_rate: 45,
    },
    156: {
        id: '156',
        catch_rate: 45,
    },
    157: {
        id: '157',
        catch_rate: 45,
    },
    158: {
        id: '158',
        catch_rate: 45,
    },
    159: {
        id: '159',
        catch_rate: 45,
    },
    160: {
        id: '160',
        catch_rate: 45,
    },
    161: {
        id: '161',
        catch_rate: 255,
    },
    162: {
        id: '162',
        catch_rate: 90,
    },
    163: {
        id: '163',
        catch_rate: 255,
    },
    164: {
        id: '164',
        catch_rate: 90,
    },
    165: {
        id: '165',
        catch_rate: 255,
    },
    166: {
        id: '166',
        catch_rate: 90,
    },
    167: {
        id: '167',
        catch_rate: 255,
    },
    168: {
        id: '168',
        catch_rate: 90,
    },
    169: {
        id: '169',
        catch_rate: 90,
    },
    170: {
        id: '170',
        catch_rate: 190,
    },
    171: {
        id: '171',
        catch_rate: 75,
    },
    172: {
        id: '172',
        catch_rate: 190,
    },
    173: {
        id: '173',
        catch_rate: 150,
    },
    174: {
        id: '174',
        catch_rate: 170,
    },
    175: {
        id: '175',
        catch_rate: 190,
    },
    176: {
        id: '176',
        catch_rate: 75,
    },
    177: {
        id: '177',
        catch_rate: 190,
    },
    178: {
        id: '178',
        catch_rate: 75,
    },
    179: {
        id: '179',
        catch_rate: 235,
    },
    180: {
        id: '180',
        catch_rate: 120,
    },
    181: {
        id: '181',
        catch_rate: 45,
    },
    182: {
        id: '182',
        catch_rate: 45,
    },
    183: {
        id: '183',
        catch_rate: 190,
    },
    184: {
        id: '184',
        catch_rate: 75,
    },
    185: {
        id: '185',
        catch_rate: 65,
    },
    186: {
        id: '186',
        catch_rate: 45,
    },
    187: {
        id: '187',
        catch_rate: 255,
    },
    188: {
        id: '188',
        catch_rate: 120,
    },
    189: {
        id: '189',
        catch_rate: 45,
    },
    190: {
        id: '190',
        catch_rate: 45,
    },
    191: {
        id: '191',
        catch_rate: 235,
    },
    192: {
        id: '192',
        catch_rate: 120,
    },
    193: {
        id: '193',
        catch_rate: 75,
    },
    194: {
        id: '194',
        catch_rate: 255,
    },
    195: {
        id: '195',
        catch_rate: 90,
    },
    196: {
        id: '196',
        catch_rate: 45,
    },
    197: {
        id: '197',
        catch_rate: 45,
    },
    198: {
        id: '198',
        catch_rate: 30,
    },
    199: {
        id: '199',
        catch_rate: 70,
    },
    200: {
        id: '200',
        catch_rate: 45,
    },
    201: {
        id: '201',
        catch_rate: 225,
    },
    202: {
        id: '202',
        catch_rate: 45,
    },
    203: {
        id: '203',
        catch_rate: 60,
    },
    204: {
        id: '204',
        catch_rate: 190,
    },
    205: {
        id: '205',
        catch_rate: 75,
    },
    206: {
        id: '206',
        catch_rate: 190,
    },
    207: {
        id: '207',
        catch_rate: 60,
    },
    208: {
        id: '208',
        catch_rate: 25,
    },
    209: {
        id: '209',
        catch_rate: 190,
    },
    210: {
        id: '210',
        catch_rate: 75,
    },
    211: {
        id: '211',
        catch_rate: 45,
    },
    212: {
        id: '212',
        catch_rate: 25,
    },
    213: {
        id: '213',
        catch_rate: 190,
    },
    214: {
        id: '214',
        catch_rate: 45,
    },
    215: {
        id: '215',
        catch_rate: 60,
    },
    216: {
        id: '216',
        catch_rate: 120,
    },
    217: {
        id: '217',
        catch_rate: 60,
    },
    218: {
        id: '218',
        catch_rate: 190,
    },
    219: {
        id: '219',
        catch_rate: 75,
    },
    220: {
        id: '220',
        catch_rate: 225,
    },
    221: {
        id: '221',
        catch_rate: 75,
    },
    222: {
        id: '222',
        catch_rate: 60,
    },
    223: {
        id: '223',
        catch_rate: 190,
    },
    224: {
        id: '224',
        catch_rate: 75,
    },
    225: {
        id: '225',
        catch_rate: 45,
    },
    226: {
        id: '226',
        catch_rate: 25,
    },
    227: {
        id: '227',
        catch_rate: 25,
    },
    228: {
        id: '228',
        catch_rate: 120,
    },
    229: {
        id: '229',
        catch_rate: 45,
    },
    230: {
        id: '230',
        catch_rate: 45,
    },
    231: {
        id: '231',
        catch_rate: 120,
    },
    232: {
        id: '232',
        catch_rate: 60,
    },
    233: {
        id: '233',
        catch_rate: 45,
    },
    234: {
        id: '234',
        catch_rate: 45,
    },
    235: {
        id: '235',
        catch_rate: 45,
    },
    236: {
        id: '236',
        catch_rate: 75,
    },
    237: {
        id: '237',
        catch_rate: 45,
    },
    238: {
        id: '238',
        catch_rate: 45,
    },
    239: {
        id: '239',
        catch_rate: 45,
    },
    240: {
        id: '240',
        catch_rate: 45,
    },
    241: {
        id: '241',
        catch_rate: 45,
    },
    242: {
        id: '242',
        catch_rate: 30,
    },
    243: {
        id: '243',
        catch_rate: 3,
    },
    244: {
        id: '244',
        catch_rate: 3,
    },
    245: {
        id: '245',
        catch_rate: 3,
    },
    246: {
        id: '246',
        catch_rate: 45,
    },
    247: {
        id: '247',
        catch_rate: 45,
    },
    248: {
        id: '248',
        catch_rate: 45,
    },
    249: {
        id: '249',
        catch_rate: 3,
    },
    250: {
        id: '250',
        catch_rate: 3,
    },
    251: {
        id: '251',
        catch_rate: 45,
    },
    252: {
        id: '252',
        catch_rate: 45,
    },
    253: {
        id: '253',
        catch_rate: 45,
    },
    254: {
        id: '254',
        catch_rate: 45,
    },
    255: {
        id: '255',
        catch_rate: 45,
    },
    256: {
        id: '256',
        catch_rate: 45,
    },
    257: {
        id: '257',
        catch_rate: 45,
    },
    258: {
        id: '258',
        catch_rate: 45,
    },
    259: {
        id: '259',
        catch_rate: 45,
    },
    260: {
        id: '260',
        catch_rate: 45,
    },
    261: {
        id: '261',
        catch_rate: 255,
    },
    262: {
        id: '262',
        catch_rate: 127,
    },
    263: {
        id: '263',
        catch_rate: 255,
    },
    264: {
        id: '264',
        catch_rate: 90,
    },
    265: {
        id: '265',
        catch_rate: 255,
    },
    266: {
        id: '266',
        catch_rate: 120,
    },
    267: {
        id: '267',
        catch_rate: 45,
    },
    268: {
        id: '268',
        catch_rate: 120,
    },
    269: {
        id: '269',
        catch_rate: 45,
    },
    270: {
        id: '270',
        catch_rate: 255,
    },
    271: {
        id: '271',
        catch_rate: 120,
    },
    272: {
        id: '272',
        catch_rate: 45,
    },
    273: {
        id: '273',
        catch_rate: 255,
    },
    274: {
        id: '274',
        catch_rate: 120,
    },
    275: {
        id: '275',
        catch_rate: 45,
    },
    276: {
        id: '276',
        catch_rate: 200,
    },
    277: {
        id: '277',
        catch_rate: 45,
    },
    278: {
        id: '278',
        catch_rate: 190,
    },
    279: {
        id: '279',
        catch_rate: 45,
    },
    280: {
        id: '280',
        catch_rate: 235,
    },
    281: {
        id: '281',
        catch_rate: 120,
    },
    282: {
        id: '282',
        catch_rate: 45,
    },
    283: {
        id: '283',
        catch_rate: 200,
    },
    284: {
        id: '284',
        catch_rate: 75,
    },
    285: {
        id: '285',
        catch_rate: 255,
    },
    286: {
        id: '286',
        catch_rate: 90,
    },
    287: {
        id: '287',
        catch_rate: 255,
    },
    288: {
        id: '288',
        catch_rate: 120,
    },
    289: {
        id: '289',
        catch_rate: 45,
    },
    290: {
        id: '290',
        catch_rate: 255,
    },
    291: {
        id: '291',
        catch_rate: 120,
    },
    292: {
        id: '292',
        catch_rate: 45,
    },
    293: {
        id: '293',
        catch_rate: 190,
    },
    294: {
        id: '294',
        catch_rate: 120,
    },
    295: {
        id: '295',
        catch_rate: 45,
    },
    296: {
        id: '296',
        catch_rate: 180,
    },
    297: {
        id: '297',
        catch_rate: 200,
    },
    298: {
        id: '298',
        catch_rate: 150,
    },
    299: {
        id: '299',
        catch_rate: 255,
    },
    300: {
        id: '300',
        catch_rate: 255,
    },
    301: {
        id: '301',
        catch_rate: 60,
    },
    302: {
        id: '302',
        catch_rate: 45,
    },
    303: {
        id: '303',
        catch_rate: 45,
    },
    304: {
        id: '304',
        catch_rate: 180,
    },
    305: {
        id: '305',
        catch_rate: 90,
    },
    306: {
        id: '306',
        catch_rate: 45,
    },
    307: {
        id: '307',
        catch_rate: 180,
    },
    308: {
        id: '308',
        catch_rate: 90,
    },
    309: {
        id: '309',
        catch_rate: 120,
    },
    310: {
        id: '310',
        catch_rate: 45,
    },
    311: {
        id: '311',
        catch_rate: 200,
    },
    312: {
        id: '312',
        catch_rate: 200,
    },
    313: {
        id: '313',
        catch_rate: 150,
    },
    314: {
        id: '314',
        catch_rate: 150,
    },
    315: {
        id: '315',
        catch_rate: 150,
    },
    316: {
        id: '316',
        catch_rate: 225,
    },
    317: {
        id: '317',
        catch_rate: 75,
    },
    318: {
        id: '318',
        catch_rate: 225,
    },
    319: {
        id: '319',
        catch_rate: 60,
    },
    320: {
        id: '320',
        catch_rate: 125,
    },
    321: {
        id: '321',
        catch_rate: 60,
    },
    322: {
        id: '322',
        catch_rate: 255,
    },
    323: {
        id: '323',
        catch_rate: 150,
    },
    324: {
        id: '324',
        catch_rate: 90,
    },
    325: {
        id: '325',
        catch_rate: 255,
    },
    326: {
        id: '326',
        catch_rate: 60,
    },
    327: {
        id: '327',
        catch_rate: 255,
    },
    328: {
        id: '328',
        catch_rate: 255,
    },
    329: {
        id: '329',
        catch_rate: 120,
    },
    330: {
        id: '330',
        catch_rate: 45,
    },
    331: {
        id: '331',
        catch_rate: 190,
    },
    332: {
        id: '332',
        catch_rate: 60,
    },
    333: {
        id: '333',
        catch_rate: 255,
    },
    334: {
        id: '334',
        catch_rate: 45,
    },
    335: {
        id: '335',
        catch_rate: 90,
    },
    336: {
        id: '336',
        catch_rate: 90,
    },
    337: {
        id: '337',
        catch_rate: 45,
    },
    338: {
        id: '338',
        catch_rate: 45,
    },
    339: {
        id: '339',
        catch_rate: 190,
    },
    340: {
        id: '340',
        catch_rate: 75,
    },
    341: {
        id: '341',
        catch_rate: 205,
    },
    342: {
        id: '342',
        catch_rate: 155,
    },
    343: {
        id: '343',
        catch_rate: 255,
    },
    344: {
        id: '344',
        catch_rate: 90,
    },
    345: {
        id: '345',
        catch_rate: 45,
    },
    346: {
        id: '346',
        catch_rate: 45,
    },
    347: {
        id: '347',
        catch_rate: 45,
    },
    348: {
        id: '348',
        catch_rate: 45,
    },
    349: {
        id: '349',
        catch_rate: 255,
    },
    350: {
        id: '350',
        catch_rate: 60,
    },
    351: {
        id: '351',
        catch_rate: 45,
    },
    352: {
        id: '352',
        catch_rate: 200,
    },
    353: {
        id: '353',
        catch_rate: 225,
    },
    354: {
        id: '354',
        catch_rate: 45,
    },
    355: {
        id: '355',
        catch_rate: 190,
    },
    356: {
        id: '356',
        catch_rate: 90,
    },
    357: {
        id: '357',
        catch_rate: 200,
    },
    358: {
        id: '358',
        catch_rate: 45,
    },
    359: {
        id: '359',
        catch_rate: 30,
    },
    360: {
        id: '360',
        catch_rate: 125,
    },
    361: {
        id: '361',
        catch_rate: 190,
    },
    362: {
        id: '362',
        catch_rate: 75,
    },
    363: {
        id: '363',
        catch_rate: 255,
    },
    364: {
        id: '364',
        catch_rate: 120,
    },
    365: {
        id: '365',
        catch_rate: 45,
    },
    366: {
        id: '366',
        catch_rate: 255,
    },
    367: {
        id: '367',
        catch_rate: 60,
    },
    368: {
        id: '368',
        catch_rate: 60,
    },
    369: {
        id: '369',
        catch_rate: 25,
    },
    370: {
        id: '370',
        catch_rate: 225,
    },
    371: {
        id: '371',
        catch_rate: 45,
    },
    372: {
        id: '372',
        catch_rate: 45,
    },
    373: {
        id: '373',
        catch_rate: 45,
    },
    374: {
        id: '374',
        catch_rate: 3,
    },
    375: {
        id: '375',
        catch_rate: 3,
    },
    376: {
        id: '376',
        catch_rate: 3,
    },
    377: {
        id: '377',
        catch_rate: 3,
    },
    378: {
        id: '378',
        catch_rate: 3,
    },
    379: {
        id: '379',
        catch_rate: 3,
    },
    380: {
        id: '380',
        catch_rate: 3,
    },
    381: {
        id: '381',
        catch_rate: 3,
    },
    382: {
        id: '382',
        catch_rate: 3,
    },
    383: {
        id: '383',
        catch_rate: 3,
    },
    384: {
        id: '384',
        catch_rate: 3,
    },
    385: {
        id: '385',
        catch_rate: 3,
    },
    386: {
        id: '386',
        catch_rate: 3,
    },
    387: {
        id: '387',
        catch_rate: 45,
    },
    388: {
        id: '388',
        catch_rate: 45,
    },
    389: {
        id: '389',
        catch_rate: 45,
    },
    390: {
        id: '390',
        catch_rate: 45,
    },
    391: {
        id: '391',
        catch_rate: 45,
    },
    392: {
        id: '392',
        catch_rate: 45,
    },
    393: {
        id: '393',
        catch_rate: 45,
    },
    394: {
        id: '394',
        catch_rate: 45,
    },
    395: {
        id: '395',
        catch_rate: 45,
    },
    396: {
        id: '396',
        catch_rate: 255,
    },
    397: {
        id: '397',
        catch_rate: 120,
    },
    398: {
        id: '398',
        catch_rate: 45,
    },
    399: {
        id: '399',
        catch_rate: 255,
    },
    400: {
        id: '400',
        catch_rate: 127,
    },
    401: {
        id: '401',
        catch_rate: 255,
    },
    402: {
        id: '402',
        catch_rate: 45,
    },
    403: {
        id: '403',
        catch_rate: 235,
    },
    404: {
        id: '404',
        catch_rate: 120,
    },
    405: {
        id: '405',
        catch_rate: 45,
    },
    406: {
        id: '406',
        catch_rate: 255,
    },
    407: {
        id: '407',
        catch_rate: 75,
    },
    408: {
        id: '408',
        catch_rate: 45,
    },
    409: {
        id: '409',
        catch_rate: 45,
    },
    410: {
        id: '410',
        catch_rate: 45,
    },
    411: {
        id: '411',
        catch_rate: 45,
    },
    412: {
        id: '412',
        catch_rate: 120,
    },
    413: {
        id: '413',
        catch_rate: 45,
    },
    414: {
        id: '414',
        catch_rate: 45,
    },
    415: {
        id: '415',
        catch_rate: 120,
    },
    416: {
        id: '416',
        catch_rate: 45,
    },
    417: {
        id: '417',
        catch_rate: 200,
    },
    418: {
        id: '418',
        catch_rate: 190,
    },
    419: {
        id: '419',
        catch_rate: 75,
    },
    420: {
        id: '420',
        catch_rate: 190,
    },
    421: {
        id: '421',
        catch_rate: 75,
    },
    422: {
        id: '422',
        catch_rate: 190,
    },
    423: {
        id: '423',
        catch_rate: 75,
    },
    424: {
        id: '424',
        catch_rate: 45,
    },
    425: {
        id: '425',
        catch_rate: 125,
    },
    426: {
        id: '426',
        catch_rate: 60,
    },
    427: {
        id: '427',
        catch_rate: 190,
    },
    428: {
        id: '428',
        catch_rate: 60,
    },
    429: {
        id: '429',
        catch_rate: 45,
    },
    430: {
        id: '430',
        catch_rate: 30,
    },
    431: {
        id: '431',
        catch_rate: 190,
    },
    432: {
        id: '432',
        catch_rate: 75,
    },
    433: {
        id: '433',
        catch_rate: 120,
    },
    434: {
        id: '434',
        catch_rate: 225,
    },
    435: {
        id: '435',
        catch_rate: 60,
    },
    436: {
        id: '436',
        catch_rate: 255,
    },
    437: {
        id: '437',
        catch_rate: 90,
    },
    438: {
        id: '438',
        catch_rate: 255,
    },
    439: {
        id: '439',
        catch_rate: 145,
    },
    440: {
        id: '440',
        catch_rate: 130,
    },
    441: {
        id: '441',
        catch_rate: 30,
    },
    442: {
        id: '442',
        catch_rate: 100,
    },
    443: {
        id: '443',
        catch_rate: 45,
    },
    444: {
        id: '444',
        catch_rate: 45,
    },
    445: {
        id: '445',
        catch_rate: 45,
    },
    446: {
        id: '446',
        catch_rate: 50,
    },
    447: {
        id: '447',
        catch_rate: 75,
    },
    448: {
        id: '448',
        catch_rate: 45,
    },
    449: {
        id: '449',
        catch_rate: 140,
    },
    450: {
        id: '450',
        catch_rate: 60,
    },
    451: {
        id: '451',
        catch_rate: 120,
    },
    452: {
        id: '452',
        catch_rate: 45,
    },
    453: {
        id: '453',
        catch_rate: 140,
    },
    454: {
        id: '454',
        catch_rate: 75,
    },
    455: {
        id: '455',
        catch_rate: 200,
    },
    456: {
        id: '456',
        catch_rate: 190,
    },
    457: {
        id: '457',
        catch_rate: 75,
    },
    458: {
        id: '458',
        catch_rate: 25,
    },
    459: {
        id: '459',
        catch_rate: 120,
    },
    460: {
        id: '460',
        catch_rate: 60,
    },
    461: {
        id: '461',
        catch_rate: 45,
    },
    462: {
        id: '462',
        catch_rate: 30,
    },
    463: {
        id: '463',
        catch_rate: 30,
    },
    464: {
        id: '464',
        catch_rate: 30,
    },
    465: {
        id: '465',
        catch_rate: 30,
    },
    466: {
        id: '466',
        catch_rate: 30,
    },
    467: {
        id: '467',
        catch_rate: 30,
    },
    468: {
        id: '468',
        catch_rate: 30,
    },
    469: {
        id: '469',
        catch_rate: 30,
    },
    470: {
        id: '470',
        catch_rate: 45,
    },
    471: {
        id: '471',
        catch_rate: 45,
    },
    472: {
        id: '472',
        catch_rate: 30,
    },
    473: {
        id: '473',
        catch_rate: 50,
    },
    474: {
        id: '474',
        catch_rate: 30,
    },
    475: {
        id: '475',
        catch_rate: 45,
    },
    476: {
        id: '476',
        catch_rate: 60,
    },
    477: {
        id: '477',
        catch_rate: 45,
    },
    478: {
        id: '478',
        catch_rate: 75,
    },
    479: {
        id: '479',
        catch_rate: 45,
    },
    480: {
        id: '480',
        catch_rate: 3,
    },
    481: {
        id: '481',
        catch_rate: 3,
    },
    482: {
        id: '482',
        catch_rate: 3,
    },
    483: {
        id: '483',
        catch_rate: 3,
    },
    484: {
        id: '484',
        catch_rate: 3,
    },
    485: {
        id: '485',
        catch_rate: 3,
    },
    486: {
        id: '486',
        catch_rate: 3,
    },
    487: {
        id: '487',
        catch_rate: 3,
    },
    488: {
        id: '488',
        catch_rate: 3,
    },
    489: {
        id: '489',
        catch_rate: 30,
    },
    490: {
        id: '490',
        catch_rate: 3,
    },
    491: {
        id: '491',
        catch_rate: 3,
    },
    492: {
        id: '492',
        catch_rate: 45,
    },
    493: {
        id: '493',
        catch_rate: 3,
    },
    494: {
        id: '494',
        catch_rate: 3,
    },
    495: {
        id: '495',
        catch_rate: 45,
    },
    496: {
        id: '496',
        catch_rate: 45,
    },
    497: {
        id: '497',
        catch_rate: 45,
    },
    498: {
        id: '498',
        catch_rate: 45,
    },
    499: {
        id: '499',
        catch_rate: 45,
    },
    500: {
        id: '500',
        catch_rate: 45,
    },
    501: {
        id: '501',
        catch_rate: 45,
    },
    502: {
        id: '502',
        catch_rate: 45,
    },
    503: {
        id: '503',
        catch_rate: 45,
    },
    504: {
        id: '504',
        catch_rate: 255,
    },
    505: {
        id: '505',
        catch_rate: 255,
    },
    506: {
        id: '506',
        catch_rate: 255,
    },
    507: {
        id: '507',
        catch_rate: 120,
    },
    508: {
        id: '508',
        catch_rate: 45,
    },
    509: {
        id: '509',
        catch_rate: 255,
    },
    510: {
        id: '510',
        catch_rate: 90,
    },
    511: {
        id: '511',
        catch_rate: 190,
    },
    512: {
        id: '512',
        catch_rate: 75,
    },
    513: {
        id: '513',
        catch_rate: 190,
    },
    514: {
        id: '514',
        catch_rate: 75,
    },
    515: {
        id: '515',
        catch_rate: 190,
    },
    516: {
        id: '516',
        catch_rate: 75,
    },
    517: {
        id: '517',
        catch_rate: 190,
    },
    518: {
        id: '518',
        catch_rate: 75,
    },
    519: {
        id: '519',
        catch_rate: 255,
    },
    520: {
        id: '520',
        catch_rate: 120,
    },
    521: {
        id: '521',
        catch_rate: 45,
    },
    522: {
        id: '522',
        catch_rate: 190,
    },
    523: {
        id: '523',
        catch_rate: 75,
    },
    524: {
        id: '524',
        catch_rate: 255,
    },
    525: {
        id: '525',
        catch_rate: 120,
    },
    526: {
        id: '526',
        catch_rate: 45,
    },
    527: {
        id: '527',
        catch_rate: 190,
    },
    528: {
        id: '528',
        catch_rate: 45,
    },
    529: {
        id: '529',
        catch_rate: 120,
    },
    530: {
        id: '530',
        catch_rate: 60,
    },
    531: {
        id: '531',
        catch_rate: 255,
    },
    532: {
        id: '532',
        catch_rate: 180,
    },
    533: {
        id: '533',
        catch_rate: 90,
    },
    534: {
        id: '534',
        catch_rate: 45,
    },
    535: {
        id: '535',
        catch_rate: 255,
    },
    536: {
        id: '536',
        catch_rate: 120,
    },
    537: {
        id: '537',
        catch_rate: 45,
    },
    538: {
        id: '538',
        catch_rate: 45,
    },
    539: {
        id: '539',
        catch_rate: 45,
    },
    540: {
        id: '540',
        catch_rate: 255,
    },
    541: {
        id: '541',
        catch_rate: 120,
    },
    542: {
        id: '542',
        catch_rate: 45,
    },
    543: {
        id: '543',
        catch_rate: 255,
    },
    544: {
        id: '544',
        catch_rate: 120,
    },
    545: {
        id: '545',
        catch_rate: 45,
    },
    546: {
        id: '546',
        catch_rate: 190,
    },
    547: {
        id: '547',
        catch_rate: 75,
    },
    548: {
        id: '548',
        catch_rate: 190,
    },
    549: {
        id: '549',
        catch_rate: 75,
    },
    550: {
        id: '550',
        catch_rate: 190,
    },
    551: {
        id: '551',
        catch_rate: 180,
    },
    552: {
        id: '552',
        catch_rate: 90,
    },
    553: {
        id: '553',
        catch_rate: 45,
    },
    554: {
        id: '554',
        catch_rate: 120,
    },
    555: {
        id: '555',
        catch_rate: 60,
    },
    556: {
        id: '556',
        catch_rate: 255,
    },
    557: {
        id: '557',
        catch_rate: 190,
    },
    558: {
        id: '558',
        catch_rate: 75,
    },
    559: {
        id: '559',
        catch_rate: 180,
    },
    560: {
        id: '560',
        catch_rate: 90,
    },
    561: {
        id: '561',
        catch_rate: 45,
    },
    562: {
        id: '562',
        catch_rate: 190,
    },
    563: {
        id: '563',
        catch_rate: 90,
    },
    564: {
        id: '564',
        catch_rate: 45,
    },
    565: {
        id: '565',
        catch_rate: 45,
    },
    566: {
        id: '566',
        catch_rate: 45,
    },
    567: {
        id: '567',
        catch_rate: 45,
    },
    568: {
        id: '568',
        catch_rate: 190,
    },
    569: {
        id: '569',
        catch_rate: 60,
    },
    570: {
        id: '570',
        catch_rate: 75,
    },
    571: {
        id: '571',
        catch_rate: 45,
    },
    572: {
        id: '572',
        catch_rate: 255,
    },
    573: {
        id: '573',
        catch_rate: 60,
    },
    574: {
        id: '574',
        catch_rate: 200,
    },
    575: {
        id: '575',
        catch_rate: 100,
    },
    576: {
        id: '576',
        catch_rate: 50,
    },
    577: {
        id: '577',
        catch_rate: 200,
    },
    578: {
        id: '578',
        catch_rate: 100,
    },
    579: {
        id: '579',
        catch_rate: 50,
    },
    580: {
        id: '580',
        catch_rate: 190,
    },
    581: {
        id: '581',
        catch_rate: 45,
    },
    582: {
        id: '582',
        catch_rate: 255,
    },
    583: {
        id: '583',
        catch_rate: 120,
    },
    584: {
        id: '584',
        catch_rate: 45,
    },
    585: {
        id: '585',
        catch_rate: 190,
    },
    586: {
        id: '586',
        catch_rate: 75,
    },
    587: {
        id: '587',
        catch_rate: 200,
    },
    588: {
        id: '588',
        catch_rate: 200,
    },
    589: {
        id: '589',
        catch_rate: 75,
    },
    590: {
        id: '590',
        catch_rate: 190,
    },
    591: {
        id: '591',
        catch_rate: 75,
    },
    592: {
        id: '592',
        catch_rate: 190,
    },
    593: {
        id: '593',
        catch_rate: 60,
    },
    594: {
        id: '594',
        catch_rate: 75,
    },
    595: {
        id: '595',
        catch_rate: 190,
    },
    596: {
        id: '596',
        catch_rate: 75,
    },
    597: {
        id: '597',
        catch_rate: 255,
    },
    598: {
        id: '598',
        catch_rate: 90,
    },
    599: {
        id: '599',
        catch_rate: 130,
    },
    600: {
        id: '600',
        catch_rate: 60,
    },
    601: {
        id: '601',
        catch_rate: 30,
    },
    602: {
        id: '602',
        catch_rate: 190,
    },
    603: {
        id: '603',
        catch_rate: 60,
    },
    604: {
        id: '604',
        catch_rate: 30,
    },
    605: {
        id: '605',
        catch_rate: 255,
    },
    606: {
        id: '606',
        catch_rate: 90,
    },
    607: {
        id: '607',
        catch_rate: 190,
    },
    608: {
        id: '608',
        catch_rate: 90,
    },
    609: {
        id: '609',
        catch_rate: 45,
    },
    610: {
        id: '610',
        catch_rate: 75,
    },
    611: {
        id: '611',
        catch_rate: 60,
    },
    612: {
        id: '612',
        catch_rate: 45,
    },
    613: {
        id: '613',
        catch_rate: 120,
    },
    614: {
        id: '614',
        catch_rate: 60,
    },
    615: {
        id: '615',
        catch_rate: 25,
    },
    616: {
        id: '616',
        catch_rate: 200,
    },
    617: {
        id: '617',
        catch_rate: 75,
    },
    618: {
        id: '618',
        catch_rate: 75,
    },
    619: {
        id: '619',
        catch_rate: 180,
    },
    620: {
        id: '620',
        catch_rate: 45,
    },
    621: {
        id: '621',
        catch_rate: 45,
    },
    622: {
        id: '622',
        catch_rate: 190,
    },
    623: {
        id: '623',
        catch_rate: 90,
    },
    624: {
        id: '624',
        catch_rate: 120,
    },
    625: {
        id: '625',
        catch_rate: 45,
    },
    626: {
        id: '626',
        catch_rate: 45,
    },
    627: {
        id: '627',
        catch_rate: 190,
    },
    628: {
        id: '628',
        catch_rate: 60,
    },
    629: {
        id: '629',
        catch_rate: 190,
    },
    630: {
        id: '630',
        catch_rate: 60,
    },
    631: {
        id: '631',
        catch_rate: 90,
    },
    632: {
        id: '632',
        catch_rate: 90,
    },
    633: {
        id: '633',
        catch_rate: 45,
    },
    634: {
        id: '634',
        catch_rate: 45,
    },
    635: {
        id: '635',
        catch_rate: 45,
    },
    636: {
        id: '636',
        catch_rate: 45,
    },
    637: {
        id: '637',
        catch_rate: 15,
    },
    638: {
        id: '638',
        catch_rate: 3,
    },
    639: {
        id: '639',
        catch_rate: 3,
    },
    640: {
        id: '640',
        catch_rate: 3,
    },
    641: {
        id: '641',
        catch_rate: 3,
    },
    642: {
        id: '642',
        catch_rate: 3,
    },
    643: {
        id: '643',
        catch_rate: 3,
    },
    644: {
        id: '644',
        catch_rate: 3,
    },
    645: {
        id: '645',
        catch_rate: 3,
    },
    646: {
        id: '646',
        catch_rate: 3,
    },
    647: {
        id: '647',
        catch_rate: 3,
    },
    648: {
        id: '648',
        catch_rate: 3,
    },
    649: {
        id: '649',
        catch_rate: 3,
    },
    650: {
        id: '650',
        catch_rate: 45,
    },
    651: {
        id: '651',
        catch_rate: 45,
    },
    652: {
        id: '652',
        catch_rate: 45,
    },
    653: {
        id: '653',
        catch_rate: 45,
    },
    654: {
        id: '654',
        catch_rate: 45,
    },
    655: {
        id: '655',
        catch_rate: 45,
    },
    656: {
        id: '656',
        catch_rate: 45,
    },
    657: {
        id: '657',
        catch_rate: 45,
    },
    658: {
        id: '658',
        catch_rate: 45,
    },
    659: {
        id: '659',
        catch_rate: 255,
    },
    660: {
        id: '660',
        catch_rate: 127,
    },
    661: {
        id: '661',
        catch_rate: 255,
    },
    662: {
        id: '662',
        catch_rate: 120,
    },
    663: {
        id: '663',
        catch_rate: 45,
    },
    664: {
        id: '664',
        catch_rate: 255,
    },
    665: {
        id: '665',
        catch_rate: 120,
    },
    666: {
        id: '666',
        catch_rate: 45,
    },
    667: {
        id: '667',
        catch_rate: 220,
    },
    668: {
        id: '668',
        catch_rate: 65,
    },
    669: {
        id: '669',
        catch_rate: 225,
    },
    670: {
        id: '670',
        catch_rate: 120,
    },
    671: {
        id: '671',
        catch_rate: 45,
    },
    672: {
        id: '672',
        catch_rate: 200,
    },
    673: {
        id: '673',
        catch_rate: 45,
    },
    674: {
        id: '674',
        catch_rate: 220,
    },
    675: {
        id: '675',
        catch_rate: 65,
    },
    676: {
        id: '676',
        catch_rate: 160,
    },
    677: {
        id: '677',
        catch_rate: 190,
    },
    678: {
        id: '678',
        catch_rate: 75,
    },
    679: {
        id: '679',
        catch_rate: 180,
    },
    680: {
        id: '680',
        catch_rate: 90,
    },
    681: {
        id: '681',
        catch_rate: 45,
    },
    682: {
        id: '682',
        catch_rate: 200,
    },
    683: {
        id: '683',
        catch_rate: 140,
    },
    684: {
        id: '684',
        catch_rate: 200,
    },
    685: {
        id: '685',
        catch_rate: 140,
    },
    686: {
        id: '686',
        catch_rate: 190,
    },
    687: {
        id: '687',
        catch_rate: 80,
    },
    688: {
        id: '688',
        catch_rate: 120,
    },
    689: {
        id: '689',
        catch_rate: 45,
    },
    690: {
        id: '690',
        catch_rate: 225,
    },
    691: {
        id: '691',
        catch_rate: 55,
    },
    692: {
        id: '692',
        catch_rate: 225,
    },
    693: {
        id: '693',
        catch_rate: 55,
    },
    694: {
        id: '694',
        catch_rate: 190,
    },
    695: {
        id: '695',
        catch_rate: 75,
    },
    696: {
        id: '696',
        catch_rate: 45,
    },
    697: {
        id: '697',
        catch_rate: 45,
    },
    698: {
        id: '698',
        catch_rate: 45,
    },
    699: {
        id: '699',
        catch_rate: 45,
    },
    700: {
        id: '700',
        catch_rate: 45,
    },
    701: {
        id: '701',
        catch_rate: 100,
    },
    702: {
        id: '702',
        catch_rate: 180,
    },
    703: {
        id: '703',
        catch_rate: 60,
    },
    704: {
        id: '704',
        catch_rate: 45,
    },
    705: {
        id: '705',
        catch_rate: 45,
    },
    706: {
        id: '706',
        catch_rate: 45,
    },
    707: {
        id: '707',
        catch_rate: 75,
    },
    708: {
        id: '708',
        catch_rate: 120,
    },
    709: {
        id: '709',
        catch_rate: 60,
    },
    710: {
        id: '710',
        catch_rate: 120,
    },
    711: {
        id: '711',
        catch_rate: 60,
    },
    712: {
        id: '712',
        catch_rate: 190,
    },
    713: {
        id: '713',
        catch_rate: 55,
    },
    714: {
        id: '714',
        catch_rate: 190,
    },
    715: {
        id: '715',
        catch_rate: 45,
    },
    716: {
        id: '716',
        catch_rate: 45,
    },
    717: {
        id: '717',
        catch_rate: 45,
    },
    718: {
        id: '718',
        catch_rate: 3,
    },
    719: {
        id: '719',
        catch_rate: 3,
    },
    720: {
        id: '720',
        catch_rate: 3,
    },
    721: {
        id: '721',
        catch_rate: 3,
    },
    722: {
        id: '722',
        catch_rate: 45,
    },
    723: {
        id: '723',
        catch_rate: 45,
    },
    724: {
        id: '724',
        catch_rate: 45,
    },
    725: {
        id: '725',
        catch_rate: 45,
    },
    726: {
        id: '726',
        catch_rate: 45,
    },
    727: {
        id: '727',
        catch_rate: 45,
    },
    728: {
        id: '728',
        catch_rate: 45,
    },
    729: {
        id: '729',
        catch_rate: 45,
    },
    730: {
        id: '730',
        catch_rate: 45,
    },
    731: {
        id: '731',
        catch_rate: 255,
    },
    732: {
        id: '732',
        catch_rate: 120,
    },
    733: {
        id: '733',
        catch_rate: 45,
    },
    734: {
        id: '734',
        catch_rate: 255,
    },
    735: {
        id: '735',
        catch_rate: 127,
    },
    736: {
        id: '736',
        catch_rate: 255,
    },
    737: {
        id: '737',
        catch_rate: 120,
    },
    738: {
        id: '738',
        catch_rate: 45,
    },
    739: {
        id: '739',
        catch_rate: 225,
    },
    740: {
        id: '740',
        catch_rate: 60,
    },
    741: {
        id: '741',
        catch_rate: 45,
    },
    742: {
        id: '742',
        catch_rate: 190,
    },
    743: {
        id: '743',
        catch_rate: 75,
    },
    744: {
        id: '744',
        catch_rate: 190,
    },
    745: {
        id: '745',
        catch_rate: 90,
    },
    746: {
        id: '746',
        catch_rate: 60,
    },
    747: {
        id: '747',
        catch_rate: 190,
    },
    748: {
        id: '748',
        catch_rate: 75,
    },
    749: {
        id: '749',
        catch_rate: 190,
    },
    750: {
        id: '750',
        catch_rate: 60,
    },
    751: {
        id: '751',
        catch_rate: 200,
    },
    752: {
        id: '752',
        catch_rate: 100,
    },
    753: {
        id: '753',
        catch_rate: 190,
    },
    754: {
        id: '754',
        catch_rate: 75,
    },
    755: {
        id: '755',
        catch_rate: 190,
    },
    756: {
        id: '756',
        catch_rate: 75,
    },
    757: {
        id: '757',
        catch_rate: 120,
    },
    758: {
        id: '758',
        catch_rate: 45,
    },
    759: {
        id: '759',
        catch_rate: 140,
    },
    760: {
        id: '760',
        catch_rate: 70,
    },
    761: {
        id: '761',
        catch_rate: 235,
    },
    762: {
        id: '762',
        catch_rate: 120,
    },
    763: {
        id: '763',
        catch_rate: 45,
    },
    764: {
        id: '764',
        catch_rate: 60,
    },
    765: {
        id: '765',
        catch_rate: 45,
    },
    766: {
        id: '766',
        catch_rate: 45,
    },
    767: {
        id: '767',
        catch_rate: 90,
    },
    768: {
        id: '768',
        catch_rate: 45,
    },
    769: {
        id: '769',
        catch_rate: 140,
    },
    770: {
        id: '770',
        catch_rate: 60,
    },
    771: {
        id: '771',
        catch_rate: 60,
    },
    772: {
        id: '772',
        catch_rate: 3,
    },
    773: {
        id: '773',
        catch_rate: 3,
    },
    774: {
        id: '774',
        catch_rate: 30,
    },
    775: {
        id: '775',
        catch_rate: 45,
    },
    776: {
        id: '776',
        catch_rate: 70,
    },
    777: {
        id: '777',
        catch_rate: 180,
    },
    778: {
        id: '778',
        catch_rate: 45,
    },
    779: {
        id: '779',
        catch_rate: 80,
    },
    780: {
        id: '780',
        catch_rate: 70,
    },
    781: {
        id: '781',
        catch_rate: 25,
    },
    782: {
        id: '782',
        catch_rate: 45,
    },
    783: {
        id: '783',
        catch_rate: 45,
    },
    784: {
        id: '784',
        catch_rate: 45,
    },
    785: {
        id: '785',
        catch_rate: 3,
    },
    786: {
        id: '786',
        catch_rate: 3,
    },
    787: {
        id: '787',
        catch_rate: 3,
    },
    788: {
        id: '788',
        catch_rate: 3,
    },
    789: {
        id: '789',
        catch_rate: 3,
    },
    790: {
        id: '790',
        catch_rate: 3,
    },
    791: {
        id: '791',
        catch_rate: 3,
    },
    792: {
        id: '792',
        catch_rate: 3,
    },
    793: {
        id: '793',
        catch_rate: 45,
    },
    794: {
        id: '794',
        catch_rate: 45,
    },
    795: {
        id: '795',
        catch_rate: 45,
    },
    796: {
        id: '796',
        catch_rate: 45,
    },
    797: {
        id: '797',
        catch_rate: 45,
    },
    798: {
        id: '798',
        catch_rate: 45,
    },
    799: {
        id: '799',
        catch_rate: 45,
    },
    800: {
        id: '800',
        catch_rate: 3,
    },
    801: {
        id: '801',
        catch_rate: 3,
    },
    802: {
        id: '802',
        catch_rate: 3,
    },
    803: {
        id: '803',
        catch_rate: 45,
    },
    804: {
        id: '804',
        catch_rate: 45,
    },
    805: {
        id: '805',
        catch_rate: 30,
    },
    806: {
        id: '806',
        catch_rate: 30,
    },
    807: {
        id: '807',
        catch_rate: 3,
    },
    808: {
        id: '808',
        catch_rate: 3,
    },
    809: {
        id: '809',
        catch_rate: 3,
    },
    810: {
        id: '810',
        catch_rate: 45,
    },
    811: {
        id: '811',
        catch_rate: 45,
    },
    812: {
        id: '812',
        catch_rate: 45,
    },
    813: {
        id: '813',
        catch_rate: 45,
    },
    814: {
        id: '814',
        catch_rate: 45,
    },
    815: {
        id: '815',
        catch_rate: 45,
    },
    816: {
        id: '816',
        catch_rate: 45,
    },
    817: {
        id: '817',
        catch_rate: 45,
    },
    818: {
        id: '818',
        catch_rate: 45,
    },
    819: {
        id: '819',
        catch_rate: 255,
    },
    820: {
        id: '820',
        catch_rate: 90,
    },
    821: {
        id: '821',
        catch_rate: 255,
    },
    822: {
        id: '822',
        catch_rate: 120,
    },
    823: {
        id: '823',
        catch_rate: 45,
    },
    824: {
        id: '824',
        catch_rate: 255,
    },
    825: {
        id: '825',
        catch_rate: 120,
    },
    826: {
        id: '826',
        catch_rate: 45,
    },
    827: {
        id: '827',
        catch_rate: 255,
    },
    828: {
        id: '828',
        catch_rate: 127,
    },
    829: {
        id: '829',
        catch_rate: 190,
    },
    830: {
        id: '830',
        catch_rate: 75,
    },
    831: {
        id: '831',
        catch_rate: 255,
    },
    832: {
        id: '832',
        catch_rate: 127,
    },
    833: {
        id: '833',
        catch_rate: 255,
    },
    834: {
        id: '834',
        catch_rate: 75,
    },
    835: {
        id: '835',
        catch_rate: 255,
    },
    836: {
        id: '836',
        catch_rate: 45,
    },
    837: {
        id: '837',
        catch_rate: 255,
    },
    838: {
        id: '838',
        catch_rate: 120,
    },
    839: {
        id: '839',
        catch_rate: 45,
    },
    840: {
        id: '840',
        catch_rate: 255,
    },
    841: {
        id: '841',
        catch_rate: 45,
    },
    842: {
        id: '842',
        catch_rate: 45,
    },
    843: {
        id: '843',
        catch_rate: 255,
    },
    844: {
        id: '844',
        catch_rate: 120,
    },
    845: {
        id: '845',
        catch_rate: 45,
    },
    846: {
        id: '846',
        catch_rate: 255,
    },
    847: {
        id: '847',
        catch_rate: 60,
    },
    848: {
        id: '848',
        catch_rate: 75,
    },
    849: {
        id: '849',
        catch_rate: 45,
    },
    850: {
        id: '850',
        catch_rate: 190,
    },
    851: {
        id: '851',
        catch_rate: 75,
    },
    852: {
        id: '852',
        catch_rate: 180,
    },
    853: {
        id: '853',
        catch_rate: 45,
    },
    854: {
        id: '854',
        catch_rate: 120,
    },
    855: {
        id: '855',
        catch_rate: 60,
    },
    856: {
        id: '856',
        catch_rate: 235,
    },
    857: {
        id: '857',
        catch_rate: 120,
    },
    858: {
        id: '858',
        catch_rate: 45,
    },
    859: {
        id: '859',
        catch_rate: 255,
    },
    860: {
        id: '860',
        catch_rate: 120,
    },
    861: {
        id: '861',
        catch_rate: 45,
    },
    862: {
        id: '862',
        catch_rate: 45,
    },
    863: {
        id: '863',
        catch_rate: 90,
    },
    864: {
        id: '864',
        catch_rate: 30,
    },
    865: {
        id: '865',
        catch_rate: 45,
    },
    866: {
        id: '866',
        catch_rate: 45,
    },
    867: {
        id: '867',
        catch_rate: 90,
    },
    868: {
        id: '868',
        catch_rate: 200,
    },
    869: {
        id: '869',
        catch_rate: 100,
    },
    870: {
        id: '870',
        catch_rate: 45,
    },
    871: {
        id: '871',
        catch_rate: 75,
    },
    872: {
        id: '872',
        catch_rate: 190,
    },
    873: {
        id: '873',
        catch_rate: 75,
    },
    874: {
        id: '874',
        catch_rate: 60,
    },
    875: {
        id: '875',
        catch_rate: 60,
    },
    876: {
        id: '876',
        catch_rate: 30,
    },
    877: {
        id: '877',
        catch_rate: 180,
    },
    878: {
        id: '878',
        catch_rate: 190,
    },
    879: {
        id: '879',
        catch_rate: 90,
    },
    880: {
        id: '880',
        catch_rate: 45,
    },
    881: {
        id: '881',
        catch_rate: 45,
    },
    882: {
        id: '882',
        catch_rate: 45,
    },
    883: {
        id: '883',
        catch_rate: 45,
    },
    884: {
        id: '884',
        catch_rate: 45,
    },
    885: {
        id: '885',
        catch_rate: 45,
    },
    886: {
        id: '886',
        catch_rate: 45,
    },
    887: {
        id: '887',
        catch_rate: 45,
    },
    888: {
        id: '888',
        catch_rate: 10,
    },
    889: {
        id: '889',
        catch_rate: 10,
    },
    890: {
        id: '890',
        catch_rate: 255,
    },
    891: {
        id: '891',
        catch_rate: 3,
    },
    892: {
        id: '892',
        catch_rate: 3,
    },
    893: {
        id: '893',
        catch_rate: 3,
    },
    894: {
        id: '894',
        catch_rate: 3,
    },
    895: {
        id: '895',
        catch_rate: 3,
    },
    896: {
        id: '896',
        catch_rate: 3,
    },
    897: {
        id: '897',
        catch_rate: 3,
    },
    898: {
        id: '898',
        catch_rate: 3,
    },
    899: {
        id: '899',
        catch_rate: 45,
    },
    900: {
        id: '900',
        catch_rate: 15,
    },
    901: {
        id: '901',
        catch_rate: 20,
    },
    902: {
        id: '902',
        catch_rate: 45,
    },
    903: {
        id: '903',
        catch_rate: 20,
    },
    904: {
        id: '904',
        catch_rate: 45,
    },
    905: {
        id: '905',
        catch_rate: 3,
    },
    906: {
        id: '906',
        catch_rate: 45,
    },
    907: {
        id: '907',
        catch_rate: 45,
    },
    908: {
        id: '908',
        catch_rate: 45,
    },
    909: {
        id: '909',
        catch_rate: 45,
    },
    910: {
        id: '910',
        catch_rate: 45,
    },
    911: {
        id: '911',
        catch_rate: 45,
    },
    912: {
        id: '912',
        catch_rate: 45,
    },
    913: {
        id: '913',
        catch_rate: 45,
    },
    914: {
        id: '914',
        catch_rate: 45,
    },
    915: {
        id: '915',
        catch_rate: 255,
    },
    916: {
        id: '916',
        catch_rate: 100,
    },
    917: {
        id: '917',
        catch_rate: 255,
    },
    918: {
        id: '918',
        catch_rate: 120,
    },
    919: {
        id: '919',
        catch_rate: 190,
    },
    920: {
        id: '920',
        catch_rate: 30,
    },
    921: {
        id: '921',
        catch_rate: 190,
    },
    922: {
        id: '922',
        catch_rate: 80,
    },
    923: {
        id: '923',
        catch_rate: 45,
    },
    924: {
        id: '924',
        catch_rate: 150,
    },
    925: {
        id: '925',
        catch_rate: 75,
    },
    926: {
        id: '926',
        catch_rate: 190,
    },
    927: {
        id: '927',
        catch_rate: 90,
    },
    928: {
        id: '928',
        catch_rate: 255,
    },
    929: {
        id: '929',
        catch_rate: 120,
    },
    930: {
        id: '930',
        catch_rate: 45,
    },
    931: {
        id: '931',
        catch_rate: 190,
    },
    932: {
        id: '932',
        catch_rate: 255,
    },
    933: {
        id: '933',
        catch_rate: 120,
    },
    934: {
        id: '934',
        catch_rate: 45,
    },
    935: {
        id: '935',
        catch_rate: 90,
    },
    936: {
        id: '936',
        catch_rate: 25,
    },
    937: {
        id: '937',
        catch_rate: 25,
    },
    938: {
        id: '938',
        catch_rate: 190,
    },
    939: {
        id: '939',
        catch_rate: 50,
    },
    940: {
        id: '940',
        catch_rate: 180,
    },
    941: {
        id: '941',
        catch_rate: 90,
    },
    942: {
        id: '942',
        catch_rate: 150,
    },
    943: {
        id: '943',
        catch_rate: 75,
    },
    944: {
        id: '944',
        catch_rate: 190,
    },
    945: {
        id: '945',
        catch_rate: 90,
    },
    946: {
        id: '946',
        catch_rate: 190,
    },
    947: {
        id: '947',
        catch_rate: 45,
    },
    948: {
        id: '948',
        catch_rate: 190,
    },
    949: {
        id: '949',
        catch_rate: 90,
    },
    950: {
        id: '950',
        catch_rate: 120,
    },
    951: {
        id: '951',
        catch_rate: 190,
    },
    952: {
        id: '952',
        catch_rate: 75,
    },
    953: {
        id: '953',
        catch_rate: 190,
    },
    954: {
        id: '954',
        catch_rate: 45,
    },
    955: {
        id: '955',
        catch_rate: 120,
    },
    956: {
        id: '956',
        catch_rate: 60,
    },
    957: {
        id: '957',
        catch_rate: 190,
    },
    958: {
        id: '958',
        catch_rate: 90,
    },
    959: {
        id: '959',
        catch_rate: 45,
    },
    960: {
        id: '960',
        catch_rate: 255,
    },
    961: {
        id: '961',
        catch_rate: 50,
    },
    962: {
        id: '962',
        catch_rate: 25,
    },
    963: {
        id: '963',
        catch_rate: 200,
    },
    964: {
        id: '964',
        catch_rate: 45,
    },
    965: {
        id: '965',
        catch_rate: 190,
    },
    966: {
        id: '966',
        catch_rate: 75,
    },
    967: {
        id: '967',
        catch_rate: 190,
    },
    968: {
        id: '968',
        catch_rate: 25,
    },
    969: {
        id: '969',
        catch_rate: 70,
    },
    970: {
        id: '970',
        catch_rate: 25,
    },
    971: {
        id: '971',
        catch_rate: 120,
    },
    972: {
        id: '972',
        catch_rate: 60,
    },
    973: {
        id: '973',
        catch_rate: 100,
    },
    974: {
        id: '974',
        catch_rate: 150,
    },
    975: {
        id: '975',
        catch_rate: 50,
    },
    976: {
        id: '976',
        catch_rate: 100,
    },
    977: {
        id: '977',
        catch_rate: 25,
    },
    978: {
        id: '978',
        catch_rate: 100,
    },
    979: {
        id: '979',
        catch_rate: 45,
    },
    980: {
        id: '980',
        catch_rate: 90,
    },
    981: {
        id: '981',
        catch_rate: 45,
    },
    982: {
        id: '982',
        catch_rate: 45,
    },
    983: {
        id: '983',
        catch_rate: 25,
    },
    984: {
        id: '984',
        catch_rate: 30,
    },
    985: {
        id: '985',
        catch_rate: 50,
    },
    986: {
        id: '986',
        catch_rate: 50,
    },
    987: {
        id: '987',
        catch_rate: 30,
    },
    988: {
        id: '988',
        catch_rate: 30,
    },
    989: {
        id: '989',
        catch_rate: 30,
    },
    990: {
        id: '990',
        catch_rate: 30,
    },
    991: {
        id: '991',
        catch_rate: 50,
    },
    992: {
        id: '992',
        catch_rate: 50,
    },
    993: {
        id: '993',
        catch_rate: 30,
    },
    994: {
        id: '994',
        catch_rate: 30,
    },
    995: {
        id: '995',
        catch_rate: 30,
    },
    996: {
        id: '996',
        catch_rate: 45,
    },
    997: {
        id: '997',
        catch_rate: 25,
    },
    998: {
        id: '998',
        catch_rate: 10,
    },
    999: {
        id: '999',
        catch_rate: 45,
    },
    1000: {
        id: '1000',
        catch_rate: 45,
    },
    1001: {
        id: '1001',
        catch_rate: 6,
    },
    1002: {
        id: '1002',
        catch_rate: 6,
    },
    1003: {
        id: '1003',
        catch_rate: 6,
    },
    1004: {
        id: '1004',
        catch_rate: 6,
    },
    1005: {
        id: '1005',
        catch_rate: 10,
    },
    1006: {
        id: '1006',
        catch_rate: 10,
    },
    1007: {
        id: '1007',
        catch_rate: 3,
    },
    1008: {
        id: '1008',
        catch_rate: 3,
    },
    1009: {
        id: '1009',
        catch_rate: 5,
    },
    1010: {
        id: '1010',
        catch_rate: 5,
    },
    1011: {
        id: '1011',
        catch_rate: 45,
    },
    1012: {
        id: '1012',
        catch_rate: 120,
    },
    1013: {
        id: '1013',
        catch_rate: 60,
    },
    1014: {
        id: '1014',
        catch_rate: 3,
    },
    1015: {
        id: '1015',
        catch_rate: 3,
    },
    1016: {
        id: '1016',
        catch_rate: 3,
    },
    1017: {
        id: '1017',
        catch_rate: 5,
    },
    1018: {
        id: '1018',
        catch_rate: 10,
    },
    1019: {
        id: '1019',
        catch_rate: 10,
    },
    1020: {
        id: '1020',
        catch_rate: 10,
    },
    1021: {
        id: '1021',
        catch_rate: 10,
    },
    1022: {
        id: '1022',
        catch_rate: 10,
    },
    1023: {
        id: '1023',
        catch_rate: 10,
    },
    1024: {
        id: '1024',
        catch_rate: 255,
    },
    1025: {
        id: '1025',
        catch_rate: 3,
    },
};

export const evDB = {
    1: {
        id: 1,
        evYield: {
            exp: 64,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 45,
            attack: 49,
            defense: 49,
            specialAttack: 65,
            specialDefense: 65,
            speed: 45,
        },
    },
    2: {
        id: 2,
        evYield: {
            exp: 141,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 62,
            defense: 63,
            specialAttack: 80,
            specialDefense: 80,
            speed: 60,
        },
    },
    3: {
        id: 3,
        evYield: {
            exp: 208,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 2,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 82,
            defense: 83,
            specialAttack: 100,
            specialDefense: 100,
            speed: 80,
        },
    },
    4: {
        id: 4,
        evYield: {
            exp: 65,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 39,
            attack: 52,
            defense: 43,
            specialAttack: 60,
            specialDefense: 50,
            speed: 65,
        },
    },
    5: {
        id: 5,
        evYield: {
            exp: 142,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 58,
            attack: 64,
            defense: 58,
            specialAttack: 80,
            specialDefense: 65,
            speed: 80,
        },
    },
    6: {
        id: 6,
        evYield: {
            exp: 209,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 3,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 78,
            attack: 84,
            defense: 78,
            specialAttack: 109,
            specialDefense: 85,
            speed: 100,
        },
    },
    7: {
        id: 7,
        evYield: {
            exp: 66,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 44,
            attack: 48,
            defense: 65,
            specialAttack: 50,
            specialDefense: 64,
            speed: 43,
        },
    },
    8: {
        id: 8,
        evYield: {
            exp: 143,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 59,
            attack: 63,
            defense: 80,
            specialAttack: 65,
            specialDefense: 80,
            speed: 58,
        },
    },
    9: {
        id: 9,
        evYield: {
            exp: 210,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 3,
            speed: 0,
        },
        baseStats: {
            maxHp: 79,
            attack: 83,
            defense: 100,
            specialAttack: 85,
            specialDefense: 105,
            speed: 78,
        },
    },
    10: {
        id: 10,
        evYield: {
            exp: 53,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 45,
            attack: 30,
            defense: 35,
            specialAttack: 20,
            specialDefense: 20,
            speed: 45,
        },
    },
    11: {
        id: 11,
        evYield: {
            exp: 72,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 20,
            defense: 55,
            specialAttack: 25,
            specialDefense: 25,
            speed: 30,
        },
    },
    12: {
        id: 12,
        evYield: {
            exp: 160,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 2,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 45,
            defense: 50,
            specialAttack: 80,
            specialDefense: 80,
            speed: 70,
        },
    },
    13: {
        id: 13,
        evYield: {
            exp: 52,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 40,
            attack: 35,
            defense: 30,
            specialAttack: 20,
            specialDefense: 20,
            speed: 50,
        },
    },
    14: {
        id: 14,
        evYield: {
            exp: 71,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 45,
            attack: 25,
            defense: 50,
            specialAttack: 25,
            specialDefense: 25,
            speed: 35,
        },
    },
    15: {
        id: 15,
        evYield: {
            exp: 159,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 80,
            defense: 40,
            specialAttack: 45,
            specialDefense: 80,
            speed: 75,
        },
    },
    16: {
        id: 16,
        evYield: {
            exp: 55,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 40,
            attack: 45,
            defense: 40,
            specialAttack: 35,
            specialDefense: 35,
            speed: 56,
        },
    },
    17: {
        id: 17,
        evYield: {
            exp: 113,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 63,
            attack: 60,
            defense: 55,
            specialAttack: 50,
            specialDefense: 50,
            speed: 71,
        },
    },
    18: {
        id: 18,
        evYield: {
            exp: 172,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 3,
        },
        baseStats: {
            maxHp: 83,
            attack: 80,
            defense: 75,
            specialAttack: 70,
            specialDefense: 70,
            speed: 91,
        },
    },
    19: {
        id: 19,
        evYield: {
            exp: 57,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 30,
            attack: 56,
            defense: 35,
            specialAttack: 25,
            specialDefense: 35,
            speed: 72,
        },
    },
    20: {
        id: 20,
        evYield: {
            exp: 116,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 55,
            attack: 81,
            defense: 60,
            specialAttack: 50,
            specialDefense: 70,
            speed: 97,
        },
    },
    21: {
        id: 21,
        evYield: {
            exp: 58,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 40,
            attack: 60,
            defense: 30,
            specialAttack: 31,
            specialDefense: 31,
            speed: 70,
        },
    },
    22: {
        id: 22,
        evYield: {
            exp: 162,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 65,
            attack: 90,
            defense: 65,
            specialAttack: 61,
            specialDefense: 61,
            speed: 100,
        },
    },
    23: {
        id: 23,
        evYield: {
            exp: 62,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 35,
            attack: 60,
            defense: 44,
            specialAttack: 40,
            specialDefense: 54,
            speed: 55,
        },
    },
    24: {
        id: 24,
        evYield: {
            exp: 147,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 85,
            defense: 69,
            specialAttack: 65,
            specialDefense: 79,
            speed: 80,
        },
    },
    25: {
        id: 25,
        evYield: {
            exp: 82,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 35,
            attack: 55,
            defense: 30,
            specialAttack: 50,
            specialDefense: 40,
            speed: 90,
        },
    },
    26: {
        id: 26,
        evYield: {
            exp: 122,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 3,
        },
        baseStats: {
            maxHp: 60,
            attack: 90,
            defense: 55,
            specialAttack: 90,
            specialDefense: 80,
            speed: 100,
        },
    },
    27: {
        id: 27,
        evYield: {
            exp: 93,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 75,
            defense: 85,
            specialAttack: 20,
            specialDefense: 30,
            speed: 40,
        },
    },
    28: {
        id: 28,
        evYield: {
            exp: 163,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 75,
            attack: 100,
            defense: 110,
            specialAttack: 45,
            specialDefense: 55,
            speed: 65,
        },
    },
    29: {
        id: 29,
        evYield: {
            exp: 59,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 55,
            attack: 47,
            defense: 52,
            specialAttack: 40,
            specialDefense: 40,
            speed: 41,
        },
    },
    30: {
        id: 30,
        evYield: {
            exp: 117,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 62,
            defense: 67,
            specialAttack: 55,
            specialDefense: 55,
            speed: 56,
        },
    },
    31: {
        id: 31,
        evYield: {
            exp: 194,
            hp: 3,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 90,
            attack: 82,
            defense: 87,
            specialAttack: 75,
            specialDefense: 85,
            speed: 76,
        },
    },
    32: {
        id: 32,
        evYield: {
            exp: 60,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 46,
            attack: 70,
            defense: 40,
            specialAttack: 40,
            specialDefense: 40,
            speed: 50,
        },
    },
    33: {
        id: 33,
        evYield: {
            exp: 118,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 61,
            attack: 85,
            defense: 57,
            specialAttack: 55,
            specialDefense: 55,
            speed: 65,
        },
    },
    34: {
        id: 34,
        evYield: {
            exp: 195,
            hp: 0,
            attack: 3,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 81,
            attack: 100,
            defense: 77,
            specialAttack: 85,
            specialDefense: 75,
            speed: 85,
        },
    },
    35: {
        id: 35,
        evYield: {
            exp: 68,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 45,
            defense: 48,
            specialAttack: 60,
            specialDefense: 65,
            speed: 35,
        },
    },
    36: {
        id: 36,
        evYield: {
            exp: 129,
            hp: 3,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 95,
            attack: 70,
            defense: 73,
            specialAttack: 85,
            specialDefense: 90,
            speed: 60,
        },
    },
    37: {
        id: 37,
        evYield: {
            exp: 63,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 38,
            attack: 41,
            defense: 40,
            specialAttack: 50,
            specialDefense: 65,
            speed: 65,
        },
    },
    38: {
        id: 38,
        evYield: {
            exp: 178,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 1,
            speed: 1,
        },
        baseStats: {
            maxHp: 73,
            attack: 76,
            defense: 75,
            specialAttack: 81,
            specialDefense: 100,
            speed: 100,
        },
    },
    39: {
        id: 39,
        evYield: {
            exp: 76,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 115,
            attack: 45,
            defense: 20,
            specialAttack: 45,
            specialDefense: 25,
            speed: 20,
        },
    },
    40: {
        id: 40,
        evYield: {
            exp: 109,
            hp: 3,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 140,
            attack: 70,
            defense: 45,
            specialAttack: 75,
            specialDefense: 50,
            speed: 45,
        },
    },
    41: {
        id: 41,
        evYield: {
            exp: 54,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 40,
            attack: 45,
            defense: 35,
            specialAttack: 30,
            specialDefense: 40,
            speed: 55,
        },
    },
    42: {
        id: 42,
        evYield: {
            exp: 171,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 75,
            attack: 80,
            defense: 70,
            specialAttack: 65,
            specialDefense: 75,
            speed: 90,
        },
    },
    43: {
        id: 43,
        evYield: {
            exp: 78,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 45,
            attack: 50,
            defense: 55,
            specialAttack: 75,
            specialDefense: 65,
            speed: 30,
        },
    },
    44: {
        id: 44,
        evYield: {
            exp: 132,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 2,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 65,
            defense: 70,
            specialAttack: 85,
            specialDefense: 75,
            speed: 40,
        },
    },
    45: {
        id: 45,
        evYield: {
            exp: 184,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 3,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 75,
            attack: 80,
            defense: 85,
            specialAttack: 100,
            specialDefense: 90,
            speed: 50,
        },
    },
    46: {
        id: 46,
        evYield: {
            exp: 70,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 35,
            attack: 70,
            defense: 55,
            specialAttack: 45,
            specialDefense: 55,
            speed: 25,
        },
    },
    47: {
        id: 47,
        evYield: {
            exp: 128,
            hp: 0,
            attack: 2,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 95,
            defense: 80,
            specialAttack: 60,
            specialDefense: 80,
            speed: 30,
        },
    },
    48: {
        id: 48,
        evYield: {
            exp: 75,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 55,
            defense: 50,
            specialAttack: 40,
            specialDefense: 55,
            speed: 45,
        },
    },
    49: {
        id: 49,
        evYield: {
            exp: 138,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 70,
            attack: 65,
            defense: 60,
            specialAttack: 90,
            specialDefense: 75,
            speed: 90,
        },
    },
    50: {
        id: 50,
        evYield: {
            exp: 81,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 10,
            attack: 55,
            defense: 25,
            specialAttack: 35,
            specialDefense: 45,
            speed: 95,
        },
    },
    51: {
        id: 51,
        evYield: {
            exp: 153,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 35,
            attack: 80,
            defense: 50,
            specialAttack: 50,
            specialDefense: 70,
            speed: 120,
        },
    },
    52: {
        id: 52,
        evYield: {
            exp: 69,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 40,
            attack: 45,
            defense: 35,
            specialAttack: 40,
            specialDefense: 40,
            speed: 90,
        },
    },
    53: {
        id: 53,
        evYield: {
            exp: 148,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 65,
            attack: 70,
            defense: 60,
            specialAttack: 65,
            specialDefense: 65,
            speed: 115,
        },
    },
    54: {
        id: 54,
        evYield: {
            exp: 80,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 52,
            defense: 48,
            specialAttack: 65,
            specialDefense: 50,
            speed: 55,
        },
    },
    55: {
        id: 55,
        evYield: {
            exp: 174,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 2,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 82,
            defense: 78,
            specialAttack: 95,
            specialDefense: 80,
            speed: 85,
        },
    },
    56: {
        id: 56,
        evYield: {
            exp: 74,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 40,
            attack: 80,
            defense: 35,
            specialAttack: 35,
            specialDefense: 45,
            speed: 70,
        },
    },
    57: {
        id: 57,
        evYield: {
            exp: 149,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 105,
            defense: 60,
            specialAttack: 60,
            specialDefense: 70,
            speed: 95,
        },
    },
    58: {
        id: 58,
        evYield: {
            exp: 91,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 55,
            attack: 70,
            defense: 45,
            specialAttack: 70,
            specialDefense: 50,
            speed: 60,
        },
    },
    59: {
        id: 59,
        evYield: {
            exp: 213,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 90,
            attack: 110,
            defense: 80,
            specialAttack: 100,
            specialDefense: 80,
            speed: 95,
        },
    },
    60: {
        id: 60,
        evYield: {
            exp: 77,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 40,
            attack: 50,
            defense: 40,
            specialAttack: 40,
            specialDefense: 40,
            speed: 90,
        },
    },
    61: {
        id: 61,
        evYield: {
            exp: 131,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 65,
            attack: 65,
            defense: 65,
            specialAttack: 50,
            specialDefense: 50,
            speed: 90,
        },
    },
    62: {
        id: 62,
        evYield: {
            exp: 185,
            hp: 0,
            attack: 0,
            defense: 3,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 90,
            attack: 85,
            defense: 95,
            specialAttack: 70,
            specialDefense: 90,
            speed: 70,
        },
    },
    63: {
        id: 63,
        evYield: {
            exp: 73,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 25,
            attack: 20,
            defense: 15,
            specialAttack: 105,
            specialDefense: 55,
            speed: 90,
        },
    },
    64: {
        id: 64,
        evYield: {
            exp: 145,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 2,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 40,
            attack: 35,
            defense: 30,
            specialAttack: 120,
            specialDefense: 70,
            speed: 105,
        },
    },
    65: {
        id: 65,
        evYield: {
            exp: 186,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 3,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 55,
            attack: 50,
            defense: 45,
            specialAttack: 135,
            specialDefense: 85,
            speed: 120,
        },
    },
    66: {
        id: 66,
        evYield: {
            exp: 88,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 80,
            defense: 50,
            specialAttack: 35,
            specialDefense: 35,
            speed: 35,
        },
    },
    67: {
        id: 67,
        evYield: {
            exp: 146,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 100,
            defense: 70,
            specialAttack: 50,
            specialDefense: 60,
            speed: 45,
        },
    },
    68: {
        id: 68,
        evYield: {
            exp: 193,
            hp: 0,
            attack: 3,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 90,
            attack: 130,
            defense: 80,
            specialAttack: 65,
            specialDefense: 85,
            speed: 55,
        },
    },
    69: {
        id: 69,
        evYield: {
            exp: 84,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 75,
            defense: 35,
            specialAttack: 70,
            specialDefense: 30,
            speed: 40,
        },
    },
    70: {
        id: 70,
        evYield: {
            exp: 151,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 90,
            defense: 50,
            specialAttack: 85,
            specialDefense: 45,
            speed: 55,
        },
    },
    71: {
        id: 71,
        evYield: {
            exp: 191,
            hp: 0,
            attack: 3,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 105,
            defense: 65,
            specialAttack: 100,
            specialDefense: 60,
            speed: 70,
        },
    },
    72: {
        id: 72,
        evYield: {
            exp: 105,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 40,
            attack: 40,
            defense: 35,
            specialAttack: 50,
            specialDefense: 100,
            speed: 70,
        },
    },
    73: {
        id: 73,
        evYield: {
            exp: 205,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 2,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 70,
            defense: 65,
            specialAttack: 80,
            specialDefense: 120,
            speed: 100,
        },
    },
    74: {
        id: 74,
        evYield: {
            exp: 86,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 40,
            attack: 80,
            defense: 100,
            specialAttack: 30,
            specialDefense: 30,
            speed: 20,
        },
    },
    75: {
        id: 75,
        evYield: {
            exp: 134,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 55,
            attack: 95,
            defense: 115,
            specialAttack: 45,
            specialDefense: 45,
            speed: 35,
        },
    },
    76: {
        id: 76,
        evYield: {
            exp: 177,
            hp: 0,
            attack: 0,
            defense: 3,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 110,
            defense: 130,
            specialAttack: 55,
            specialDefense: 65,
            speed: 45,
        },
    },
    77: {
        id: 77,
        evYield: {
            exp: 152,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 50,
            attack: 85,
            defense: 55,
            specialAttack: 65,
            specialDefense: 65,
            speed: 90,
        },
    },
    78: {
        id: 78,
        evYield: {
            exp: 192,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 65,
            attack: 100,
            defense: 70,
            specialAttack: 80,
            specialDefense: 80,
            speed: 105,
        },
    },
    79: {
        id: 79,
        evYield: {
            exp: 99,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 90,
            attack: 65,
            defense: 65,
            specialAttack: 40,
            specialDefense: 40,
            speed: 15,
        },
    },
    80: {
        id: 80,
        evYield: {
            exp: 164,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 95,
            attack: 75,
            defense: 110,
            specialAttack: 100,
            specialDefense: 80,
            speed: 30,
        },
    },
    81: {
        id: 81,
        evYield: {
            exp: 89,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 25,
            attack: 35,
            defense: 70,
            specialAttack: 95,
            specialDefense: 55,
            speed: 45,
        },
    },
    82: {
        id: 82,
        evYield: {
            exp: 161,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 2,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 60,
            defense: 95,
            specialAttack: 120,
            specialDefense: 70,
            speed: 70,
        },
    },
    83: {
        id: 83,
        evYield: {
            exp: 94,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 52,
            attack: 65,
            defense: 55,
            specialAttack: 58,
            specialDefense: 62,
            speed: 60,
        },
    },
    84: {
        id: 84,
        evYield: {
            exp: 96,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 35,
            attack: 85,
            defense: 45,
            specialAttack: 35,
            specialDefense: 35,
            speed: 75,
        },
    },
    85: {
        id: 85,
        evYield: {
            exp: 158,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 110,
            defense: 70,
            specialAttack: 60,
            specialDefense: 60,
            speed: 100,
        },
    },
    86: {
        id: 86,
        evYield: {
            exp: 100,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 45,
            defense: 55,
            specialAttack: 45,
            specialDefense: 70,
            speed: 45,
        },
    },
    87: {
        id: 87,
        evYield: {
            exp: 176,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 2,
            speed: 0,
        },
        baseStats: {
            maxHp: 90,
            attack: 70,
            defense: 80,
            specialAttack: 70,
            specialDefense: 95,
            speed: 70,
        },
    },
    88: {
        id: 88,
        evYield: {
            exp: 90,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 80,
            defense: 50,
            specialAttack: 40,
            specialDefense: 50,
            speed: 25,
        },
    },
    89: {
        id: 89,
        evYield: {
            exp: 157,
            hp: 1,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 105,
            attack: 105,
            defense: 75,
            specialAttack: 65,
            specialDefense: 100,
            speed: 50,
        },
    },
    90: {
        id: 90,
        evYield: {
            exp: 97,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 30,
            attack: 65,
            defense: 100,
            specialAttack: 45,
            specialDefense: 25,
            speed: 40,
        },
    },
    91: {
        id: 91,
        evYield: {
            exp: 203,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 95,
            defense: 180,
            specialAttack: 85,
            specialDefense: 45,
            speed: 70,
        },
    },
    92: {
        id: 92,
        evYield: {
            exp: 95,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 30,
            attack: 35,
            defense: 30,
            specialAttack: 100,
            specialDefense: 35,
            speed: 80,
        },
    },
    93: {
        id: 93,
        evYield: {
            exp: 126,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 2,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 45,
            attack: 50,
            defense: 45,
            specialAttack: 115,
            specialDefense: 55,
            speed: 95,
        },
    },
    94: {
        id: 94,
        evYield: {
            exp: 190,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 3,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 65,
            defense: 60,
            specialAttack: 130,
            specialDefense: 75,
            speed: 110,
        },
    },
    95: {
        id: 95,
        evYield: {
            exp: 108,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 35,
            attack: 45,
            defense: 160,
            specialAttack: 30,
            specialDefense: 45,
            speed: 70,
        },
    },
    96: {
        id: 96,
        evYield: {
            exp: 102,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 48,
            defense: 45,
            specialAttack: 43,
            specialDefense: 90,
            speed: 42,
        },
    },
    97: {
        id: 97,
        evYield: {
            exp: 165,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 2,
            speed: 0,
        },
        baseStats: {
            maxHp: 85,
            attack: 73,
            defense: 70,
            specialAttack: 73,
            specialDefense: 115,
            speed: 67,
        },
    },
    98: {
        id: 98,
        evYield: {
            exp: 115,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 30,
            attack: 105,
            defense: 90,
            specialAttack: 25,
            specialDefense: 25,
            speed: 50,
        },
    },
    99: {
        id: 99,
        evYield: {
            exp: 206,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 55,
            attack: 130,
            defense: 115,
            specialAttack: 50,
            specialDefense: 50,
            speed: 75,
        },
    },
    100: {
        id: 100,
        evYield: {
            exp: 103,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 40,
            attack: 30,
            defense: 50,
            specialAttack: 55,
            specialDefense: 55,
            speed: 100,
        },
    },
    101: {
        id: 101,
        evYield: {
            exp: 150,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 60,
            attack: 50,
            defense: 70,
            specialAttack: 80,
            specialDefense: 80,
            speed: 140,
        },
    },
    102: {
        id: 102,
        evYield: {
            exp: 98,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 40,
            defense: 80,
            specialAttack: 60,
            specialDefense: 45,
            speed: 40,
        },
    },
    103: {
        id: 103,
        evYield: {
            exp: 212,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 2,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 95,
            attack: 95,
            defense: 85,
            specialAttack: 125,
            specialDefense: 65,
            speed: 55,
        },
    },
    104: {
        id: 104,
        evYield: {
            exp: 87,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 50,
            defense: 95,
            specialAttack: 40,
            specialDefense: 50,
            speed: 35,
        },
    },
    105: {
        id: 105,
        evYield: {
            exp: 124,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 80,
            defense: 110,
            specialAttack: 50,
            specialDefense: 80,
            speed: 45,
        },
    },
    106: {
        id: 106,
        evYield: {
            exp: 139,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 120,
            defense: 53,
            specialAttack: 35,
            specialDefense: 110,
            speed: 87,
        },
    },
    107: {
        id: 107,
        evYield: {
            exp: 140,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 2,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 105,
            defense: 79,
            specialAttack: 35,
            specialDefense: 110,
            speed: 76,
        },
    },
    108: {
        id: 108,
        evYield: {
            exp: 127,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 90,
            attack: 55,
            defense: 75,
            specialAttack: 60,
            specialDefense: 75,
            speed: 30,
        },
    },
    109: {
        id: 109,
        evYield: {
            exp: 114,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 40,
            attack: 65,
            defense: 95,
            specialAttack: 60,
            specialDefense: 45,
            speed: 35,
        },
    },
    110: {
        id: 110,
        evYield: {
            exp: 173,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 90,
            defense: 120,
            specialAttack: 85,
            specialDefense: 70,
            speed: 60,
        },
    },
    111: {
        id: 111,
        evYield: {
            exp: 135,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 85,
            defense: 95,
            specialAttack: 30,
            specialDefense: 30,
            speed: 25,
        },
    },
    112: {
        id: 112,
        evYield: {
            exp: 204,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 105,
            attack: 130,
            defense: 120,
            specialAttack: 45,
            specialDefense: 45,
            speed: 40,
        },
    },
    113: {
        id: 113,
        evYield: {
            exp: 255,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 250,
            attack: 5,
            defense: 5,
            specialAttack: 35,
            specialDefense: 105,
            speed: 50,
        },
    },
    114: {
        id: 114,
        evYield: {
            exp: 166,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 55,
            defense: 115,
            specialAttack: 100,
            specialDefense: 40,
            speed: 60,
        },
    },
    115: {
        id: 115,
        evYield: {
            exp: 175,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 105,
            attack: 95,
            defense: 80,
            specialAttack: 40,
            specialDefense: 80,
            speed: 90,
        },
    },
    116: {
        id: 116,
        evYield: {
            exp: 83,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 30,
            attack: 40,
            defense: 70,
            specialAttack: 70,
            specialDefense: 25,
            speed: 60,
        },
    },
    117: {
        id: 117,
        evYield: {
            exp: 155,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 55,
            attack: 65,
            defense: 95,
            specialAttack: 95,
            specialDefense: 45,
            speed: 85,
        },
    },
    118: {
        id: 118,
        evYield: {
            exp: 111,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 45,
            attack: 67,
            defense: 60,
            specialAttack: 35,
            specialDefense: 50,
            speed: 63,
        },
    },
    119: {
        id: 119,
        evYield: {
            exp: 170,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 92,
            defense: 65,
            specialAttack: 65,
            specialDefense: 80,
            speed: 68,
        },
    },
    120: {
        id: 120,
        evYield: {
            exp: 106,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 30,
            attack: 45,
            defense: 55,
            specialAttack: 70,
            specialDefense: 55,
            speed: 85,
        },
    },
    121: {
        id: 121,
        evYield: {
            exp: 207,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 60,
            attack: 75,
            defense: 85,
            specialAttack: 100,
            specialDefense: 85,
            speed: 115,
        },
    },
    122: {
        id: 122,
        evYield: {
            exp: 136,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 2,
            speed: 0,
        },
        baseStats: {
            maxHp: 40,
            attack: 45,
            defense: 65,
            specialAttack: 100,
            specialDefense: 120,
            speed: 90,
        },
    },
    123: {
        id: 123,
        evYield: {
            exp: 187,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 110,
            defense: 80,
            specialAttack: 55,
            specialDefense: 80,
            speed: 105,
        },
    },
    124: {
        id: 124,
        evYield: {
            exp: 137,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 2,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 50,
            defense: 35,
            specialAttack: 115,
            specialDefense: 95,
            speed: 95,
        },
    },
    125: {
        id: 125,
        evYield: {
            exp: 156,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 65,
            attack: 83,
            defense: 57,
            specialAttack: 95,
            specialDefense: 85,
            speed: 105,
        },
    },
    126: {
        id: 126,
        evYield: {
            exp: 167,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 2,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 95,
            defense: 57,
            specialAttack: 100,
            specialDefense: 85,
            speed: 93,
        },
    },
    127: {
        id: 127,
        evYield: {
            exp: 200,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 125,
            defense: 100,
            specialAttack: 55,
            specialDefense: 70,
            speed: 85,
        },
    },
    128: {
        id: 128,
        evYield: {
            exp: 211,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 75,
            attack: 100,
            defense: 95,
            specialAttack: 40,
            specialDefense: 70,
            speed: 110,
        },
    },
    129: {
        id: 129,
        evYield: {
            exp: 20,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 20,
            attack: 10,
            defense: 55,
            specialAttack: 15,
            specialDefense: 20,
            speed: 80,
        },
    },
    130: {
        id: 130,
        evYield: {
            exp: 214,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 95,
            attack: 125,
            defense: 79,
            specialAttack: 60,
            specialDefense: 100,
            speed: 81,
        },
    },
    131: {
        id: 131,
        evYield: {
            exp: 219,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 130,
            attack: 85,
            defense: 80,
            specialAttack: 85,
            specialDefense: 95,
            speed: 60,
        },
    },
    132: {
        id: 132,
        evYield: {
            exp: 61,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 48,
            attack: 48,
            defense: 48,
            specialAttack: 48,
            specialDefense: 48,
            speed: 48,
        },
    },
    133: {
        id: 133,
        evYield: {
            exp: 92,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 55,
            attack: 55,
            defense: 50,
            specialAttack: 45,
            specialDefense: 65,
            speed: 55,
        },
    },
    134: {
        id: 134,
        evYield: {
            exp: 196,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 130,
            attack: 65,
            defense: 60,
            specialAttack: 110,
            specialDefense: 95,
            speed: 65,
        },
    },
    135: {
        id: 135,
        evYield: {
            exp: 197,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 65,
            attack: 65,
            defense: 60,
            specialAttack: 110,
            specialDefense: 95,
            speed: 130,
        },
    },
    136: {
        id: 136,
        evYield: {
            exp: 198,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 130,
            defense: 60,
            specialAttack: 95,
            specialDefense: 110,
            speed: 65,
        },
    },
    137: {
        id: 137,
        evYield: {
            exp: 130,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 60,
            defense: 70,
            specialAttack: 85,
            specialDefense: 75,
            speed: 40,
        },
    },
    138: {
        id: 138,
        evYield: {
            exp: 120,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 35,
            attack: 40,
            defense: 100,
            specialAttack: 90,
            specialDefense: 55,
            speed: 35,
        },
    },
    139: {
        id: 139,
        evYield: {
            exp: 199,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 60,
            defense: 125,
            specialAttack: 115,
            specialDefense: 70,
            speed: 55,
        },
    },
    140: {
        id: 140,
        evYield: {
            exp: 119,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 30,
            attack: 80,
            defense: 90,
            specialAttack: 55,
            specialDefense: 45,
            speed: 55,
        },
    },
    141: {
        id: 141,
        evYield: {
            exp: 201,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 115,
            defense: 105,
            specialAttack: 65,
            specialDefense: 70,
            speed: 80,
        },
    },
    142: {
        id: 142,
        evYield: {
            exp: 202,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 80,
            attack: 105,
            defense: 65,
            specialAttack: 60,
            specialDefense: 75,
            speed: 130,
        },
    },
    143: {
        id: 143,
        evYield: {
            exp: 154,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 160,
            attack: 110,
            defense: 65,
            specialAttack: 65,
            specialDefense: 110,
            speed: 30,
        },
    },
    144: {
        id: 144,
        evYield: {
            exp: 215,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 3,
            speed: 0,
        },
        baseStats: {
            maxHp: 90,
            attack: 85,
            defense: 100,
            specialAttack: 95,
            specialDefense: 125,
            speed: 85,
        },
    },
    145: {
        id: 145,
        evYield: {
            exp: 216,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 3,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 90,
            attack: 90,
            defense: 85,
            specialAttack: 125,
            specialDefense: 90,
            speed: 100,
        },
    },
    146: {
        id: 146,
        evYield: {
            exp: 217,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 3,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 90,
            attack: 100,
            defense: 90,
            specialAttack: 125,
            specialDefense: 85,
            speed: 90,
        },
    },
    147: {
        id: 147,
        evYield: {
            exp: 67,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 41,
            attack: 64,
            defense: 45,
            specialAttack: 50,
            specialDefense: 50,
            speed: 50,
        },
    },
    148: {
        id: 148,
        evYield: {
            exp: 144,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 61,
            attack: 84,
            defense: 65,
            specialAttack: 70,
            specialDefense: 70,
            speed: 70,
        },
    },
    149: {
        id: 149,
        evYield: {
            exp: 218,
            hp: 0,
            attack: 3,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 91,
            attack: 134,
            defense: 95,
            specialAttack: 100,
            specialDefense: 100,
            speed: 80,
        },
    },
    150: {
        id: 150,
        evYield: {
            exp: 220,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 3,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 106,
            attack: 110,
            defense: 90,
            specialAttack: 154,
            specialDefense: 90,
            speed: 130,
        },
    },
    151: {
        id: 151,
        evYield: {
            exp: 64,
            hp: 3,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 100,
            attack: 100,
            defense: 100,
            specialAttack: 100,
            specialDefense: 100,
            speed: 100,
        },
    },
    152: {
        id: 152,
        evYield: {
            exp: 64,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 45,
            attack: 49,
            defense: 65,
            specialAttack: 49,
            specialDefense: 65,
            speed: 45,
        },
    },
    153: {
        id: 153,
        evYield: {
            exp: 141,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 62,
            defense: 80,
            specialAttack: 63,
            specialDefense: 80,
            speed: 60,
        },
    },
    154: {
        id: 154,
        evYield: {
            exp: 208,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 2,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 82,
            defense: 100,
            specialAttack: 83,
            specialDefense: 100,
            speed: 80,
        },
    },
    155: {
        id: 155,
        evYield: {
            exp: 65,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 39,
            attack: 52,
            defense: 43,
            specialAttack: 60,
            specialDefense: 50,
            speed: 65,
        },
    },
    156: {
        id: 156,
        evYield: {
            exp: 142,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 58,
            attack: 64,
            defense: 58,
            specialAttack: 80,
            specialDefense: 65,
            speed: 80,
        },
    },
    157: {
        id: 157,
        evYield: {
            exp: 209,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 3,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 78,
            attack: 84,
            defense: 78,
            specialAttack: 109,
            specialDefense: 85,
            speed: 100,
        },
    },
    158: {
        id: 158,
        evYield: {
            exp: 66,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 65,
            defense: 64,
            specialAttack: 44,
            specialDefense: 48,
            speed: 43,
        },
    },
    159: {
        id: 159,
        evYield: {
            exp: 143,
            hp: 0,
            attack: 1,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 80,
            defense: 80,
            specialAttack: 59,
            specialDefense: 63,
            speed: 58,
        },
    },
    160: {
        id: 160,
        evYield: {
            exp: 210,
            hp: 0,
            attack: 2,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 85,
            attack: 105,
            defense: 100,
            specialAttack: 79,
            specialDefense: 83,
            speed: 78,
        },
    },
    161: {
        id: 161,
        evYield: {
            exp: 57,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 35,
            attack: 46,
            defense: 34,
            specialAttack: 35,
            specialDefense: 45,
            speed: 20,
        },
    },
    162: {
        id: 162,
        evYield: {
            exp: 116,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 85,
            attack: 76,
            defense: 64,
            specialAttack: 45,
            specialDefense: 55,
            speed: 90,
        },
    },
    163: {
        id: 163,
        evYield: {
            exp: 58,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 30,
            defense: 30,
            specialAttack: 36,
            specialDefense: 56,
            speed: 50,
        },
    },
    164: {
        id: 164,
        evYield: {
            exp: 162,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 100,
            attack: 50,
            defense: 50,
            specialAttack: 76,
            specialDefense: 96,
            speed: 70,
        },
    },
    165: {
        id: 165,
        evYield: {
            exp: 54,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 40,
            attack: 20,
            defense: 30,
            specialAttack: 40,
            specialDefense: 80,
            speed: 55,
        },
    },
    166: {
        id: 166,
        evYield: {
            exp: 134,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 2,
            speed: 0,
        },
        baseStats: {
            maxHp: 55,
            attack: 35,
            defense: 50,
            specialAttack: 55,
            specialDefense: 110,
            speed: 85,
        },
    },
    167: {
        id: 167,
        evYield: {
            exp: 54,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 40,
            attack: 60,
            defense: 40,
            specialAttack: 40,
            specialDefense: 40,
            speed: 30,
        },
    },
    168: {
        id: 168,
        evYield: {
            exp: 134,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 90,
            defense: 70,
            specialAttack: 60,
            specialDefense: 60,
            speed: 40,
        },
    },
    169: {
        id: 169,
        evYield: {
            exp: 204,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 3,
        },
        baseStats: {
            maxHp: 85,
            attack: 90,
            defense: 80,
            specialAttack: 70,
            specialDefense: 80,
            speed: 130,
        },
    },
    170: {
        id: 170,
        evYield: {
            exp: 90,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 75,
            attack: 38,
            defense: 38,
            specialAttack: 56,
            specialDefense: 56,
            speed: 67,
        },
    },
    171: {
        id: 171,
        evYield: {
            exp: 156,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 125,
            attack: 58,
            defense: 58,
            specialAttack: 76,
            specialDefense: 76,
            speed: 67,
        },
    },
    172: {
        id: 172,
        evYield: {
            exp: 42,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 20,
            attack: 40,
            defense: 15,
            specialAttack: 35,
            specialDefense: 35,
            speed: 60,
        },
    },
    173: {
        id: 173,
        evYield: {
            exp: 37,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 25,
            defense: 28,
            specialAttack: 45,
            specialDefense: 55,
            speed: 15,
        },
    },
    174: {
        id: 174,
        evYield: {
            exp: 39,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 90,
            attack: 30,
            defense: 15,
            specialAttack: 40,
            specialDefense: 20,
            speed: 15,
        },
    },
    175: {
        id: 175,
        evYield: {
            exp: 74,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 35,
            attack: 20,
            defense: 65,
            specialAttack: 40,
            specialDefense: 65,
            speed: 20,
        },
    },
    176: {
        id: 176,
        evYield: {
            exp: 114,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 2,
            speed: 0,
        },
        baseStats: {
            maxHp: 55,
            attack: 40,
            defense: 85,
            specialAttack: 80,
            specialDefense: 105,
            speed: 40,
        },
    },
    177: {
        id: 177,
        evYield: {
            exp: 73,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 40,
            attack: 50,
            defense: 45,
            specialAttack: 70,
            specialDefense: 45,
            speed: 70,
        },
    },
    178: {
        id: 178,
        evYield: {
            exp: 171,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 65,
            attack: 75,
            defense: 70,
            specialAttack: 95,
            specialDefense: 70,
            speed: 95,
        },
    },
    179: {
        id: 179,
        evYield: {
            exp: 59,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 55,
            attack: 40,
            defense: 40,
            specialAttack: 65,
            specialDefense: 45,
            speed: 35,
        },
    },
    180: {
        id: 180,
        evYield: {
            exp: 117,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 2,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 55,
            defense: 55,
            specialAttack: 80,
            specialDefense: 60,
            speed: 45,
        },
    },
    181: {
        id: 181,
        evYield: {
            exp: 194,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 3,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 90,
            attack: 75,
            defense: 75,
            specialAttack: 115,
            specialDefense: 90,
            speed: 55,
        },
    },
    182: {
        id: 182,
        evYield: {
            exp: 184,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 3,
            speed: 0,
        },
        baseStats: {
            maxHp: 75,
            attack: 80,
            defense: 85,
            specialAttack: 90,
            specialDefense: 100,
            speed: 50,
        },
    },
    183: {
        id: 183,
        evYield: {
            exp: 58,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 20,
            defense: 50,
            specialAttack: 20,
            specialDefense: 50,
            speed: 40,
        },
    },
    184: {
        id: 184,
        evYield: {
            exp: 153,
            hp: 3,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 100,
            attack: 50,
            defense: 80,
            specialAttack: 50,
            specialDefense: 80,
            speed: 50,
        },
    },
    185: {
        id: 185,
        evYield: {
            exp: 135,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 100,
            defense: 115,
            specialAttack: 30,
            specialDefense: 65,
            speed: 30,
        },
    },
    186: {
        id: 186,
        evYield: {
            exp: 185,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 3,
            speed: 0,
        },
        baseStats: {
            maxHp: 90,
            attack: 75,
            defense: 75,
            specialAttack: 90,
            specialDefense: 100,
            speed: 70,
        },
    },
    187: {
        id: 187,
        evYield: {
            exp: 74,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 35,
            attack: 35,
            defense: 40,
            specialAttack: 35,
            specialDefense: 55,
            speed: 50,
        },
    },
    188: {
        id: 188,
        evYield: {
            exp: 136,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 55,
            attack: 45,
            defense: 50,
            specialAttack: 45,
            specialDefense: 65,
            speed: 80,
        },
    },
    189: {
        id: 189,
        evYield: {
            exp: 176,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 3,
        },
        baseStats: {
            maxHp: 75,
            attack: 55,
            defense: 70,
            specialAttack: 55,
            specialDefense: 85,
            speed: 110,
        },
    },
    190: {
        id: 190,
        evYield: {
            exp: 94,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 55,
            attack: 70,
            defense: 55,
            specialAttack: 40,
            specialDefense: 55,
            speed: 85,
        },
    },
    191: {
        id: 191,
        evYield: {
            exp: 52,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 30,
            attack: 30,
            defense: 30,
            specialAttack: 30,
            specialDefense: 30,
            speed: 30,
        },
    },
    192: {
        id: 192,
        evYield: {
            exp: 146,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 2,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 75,
            attack: 75,
            defense: 55,
            specialAttack: 105,
            specialDefense: 85,
            speed: 30,
        },
    },
    193: {
        id: 193,
        evYield: {
            exp: 147,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 65,
            attack: 65,
            defense: 45,
            specialAttack: 75,
            specialDefense: 45,
            speed: 95,
        },
    },
    194: {
        id: 194,
        evYield: {
            exp: 52,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 55,
            attack: 45,
            defense: 45,
            specialAttack: 25,
            specialDefense: 25,
            speed: 15,
        },
    },
    195: {
        id: 195,
        evYield: {
            exp: 137,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 95,
            attack: 85,
            defense: 85,
            specialAttack: 65,
            specialDefense: 65,
            speed: 35,
        },
    },
    196: {
        id: 196,
        evYield: {
            exp: 197,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 2,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 65,
            defense: 60,
            specialAttack: 130,
            specialDefense: 95,
            speed: 110,
        },
    },
    197: {
        id: 197,
        evYield: {
            exp: 197,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 2,
            speed: 0,
        },
        baseStats: {
            maxHp: 95,
            attack: 65,
            defense: 110,
            specialAttack: 60,
            specialDefense: 130,
            speed: 65,
        },
    },
    198: {
        id: 198,
        evYield: {
            exp: 107,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 60,
            attack: 85,
            defense: 42,
            specialAttack: 85,
            specialDefense: 42,
            speed: 91,
        },
    },
    199: {
        id: 199,
        evYield: {
            exp: 164,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 3,
            speed: 0,
        },
        baseStats: {
            maxHp: 95,
            attack: 75,
            defense: 80,
            specialAttack: 100,
            specialDefense: 110,
            speed: 30,
        },
    },
    200: {
        id: 200,
        evYield: {
            exp: 147,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 60,
            defense: 60,
            specialAttack: 85,
            specialDefense: 85,
            speed: 85,
        },
    },
    201: {
        id: 201,
        evYield: {
            exp: 61,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 48,
            attack: 72,
            defense: 48,
            specialAttack: 72,
            specialDefense: 48,
            speed: 48,
        },
    },
    202: {
        id: 202,
        evYield: {
            exp: 177,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 190,
            attack: 33,
            defense: 58,
            specialAttack: 33,
            specialDefense: 58,
            speed: 33,
        },
    },
    203: {
        id: 203,
        evYield: {
            exp: 149,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 2,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 80,
            defense: 65,
            specialAttack: 90,
            specialDefense: 65,
            speed: 85,
        },
    },
    204: {
        id: 204,
        evYield: {
            exp: 60,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 65,
            defense: 90,
            specialAttack: 35,
            specialDefense: 35,
            speed: 15,
        },
    },
    205: {
        id: 205,
        evYield: {
            exp: 118,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 75,
            attack: 90,
            defense: 140,
            specialAttack: 60,
            specialDefense: 60,
            speed: 40,
        },
    },
    206: {
        id: 206,
        evYield: {
            exp: 75,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 100,
            attack: 70,
            defense: 70,
            specialAttack: 65,
            specialDefense: 65,
            speed: 45,
        },
    },
    207: {
        id: 207,
        evYield: {
            exp: 108,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 75,
            defense: 105,
            specialAttack: 35,
            specialDefense: 65,
            speed: 85,
        },
    },
    208: {
        id: 208,
        evYield: {
            exp: 196,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 75,
            attack: 85,
            defense: 200,
            specialAttack: 55,
            specialDefense: 65,
            speed: 30,
        },
    },
    209: {
        id: 209,
        evYield: {
            exp: 63,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 80,
            defense: 50,
            specialAttack: 40,
            specialDefense: 40,
            speed: 30,
        },
    },
    210: {
        id: 210,
        evYield: {
            exp: 178,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 90,
            attack: 120,
            defense: 75,
            specialAttack: 60,
            specialDefense: 60,
            speed: 45,
        },
    },
    211: {
        id: 211,
        evYield: {
            exp: 100,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 95,
            defense: 75,
            specialAttack: 55,
            specialDefense: 55,
            speed: 85,
        },
    },
    212: {
        id: 212,
        evYield: {
            exp: 200,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 130,
            defense: 100,
            specialAttack: 55,
            specialDefense: 80,
            speed: 65,
        },
    },
    213: {
        id: 213,
        evYield: {
            exp: 80,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 20,
            attack: 10,
            defense: 230,
            specialAttack: 10,
            specialDefense: 230,
            speed: 5,
        },
    },
    214: {
        id: 214,
        evYield: {
            exp: 200,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 125,
            defense: 75,
            specialAttack: 40,
            specialDefense: 95,
            speed: 85,
        },
    },
    215: {
        id: 215,
        evYield: {
            exp: 132,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 55,
            attack: 95,
            defense: 55,
            specialAttack: 35,
            specialDefense: 75,
            speed: 115,
        },
    },
    216: {
        id: 216,
        evYield: {
            exp: 124,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 80,
            defense: 50,
            specialAttack: 50,
            specialDefense: 50,
            speed: 40,
        },
    },
    217: {
        id: 217,
        evYield: {
            exp: 189,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 90,
            attack: 130,
            defense: 75,
            specialAttack: 75,
            specialDefense: 75,
            speed: 55,
        },
    },
    218: {
        id: 218,
        evYield: {
            exp: 78,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 40,
            attack: 40,
            defense: 40,
            specialAttack: 70,
            specialDefense: 40,
            speed: 20,
        },
    },
    219: {
        id: 219,
        evYield: {
            exp: 154,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 50,
            defense: 120,
            specialAttack: 80,
            specialDefense: 80,
            speed: 30,
        },
    },
    220: {
        id: 220,
        evYield: {
            exp: 78,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 50,
            defense: 40,
            specialAttack: 30,
            specialDefense: 30,
            speed: 50,
        },
    },
    221: {
        id: 221,
        evYield: {
            exp: 160,
            hp: 1,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 100,
            attack: 100,
            defense: 80,
            specialAttack: 60,
            specialDefense: 60,
            speed: 50,
        },
    },
    222: {
        id: 222,
        evYield: {
            exp: 113,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 55,
            attack: 55,
            defense: 85,
            specialAttack: 65,
            specialDefense: 85,
            speed: 35,
        },
    },
    223: {
        id: 223,
        evYield: {
            exp: 78,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 35,
            attack: 65,
            defense: 35,
            specialAttack: 65,
            specialDefense: 35,
            speed: 65,
        },
    },
    224: {
        id: 224,
        evYield: {
            exp: 164,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 75,
            attack: 105,
            defense: 75,
            specialAttack: 105,
            specialDefense: 75,
            speed: 45,
        },
    },
    225: {
        id: 225,
        evYield: {
            exp: 183,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 45,
            attack: 55,
            defense: 45,
            specialAttack: 65,
            specialDefense: 45,
            speed: 75,
        },
    },
    226: {
        id: 226,
        evYield: {
            exp: 168,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 2,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 40,
            defense: 70,
            specialAttack: 80,
            specialDefense: 140,
            speed: 70,
        },
    },
    227: {
        id: 227,
        evYield: {
            exp: 168,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 80,
            defense: 140,
            specialAttack: 40,
            specialDefense: 70,
            speed: 70,
        },
    },
    228: {
        id: 228,
        evYield: {
            exp: 114,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 45,
            attack: 60,
            defense: 30,
            specialAttack: 80,
            specialDefense: 50,
            speed: 65,
        },
    },
    229: {
        id: 229,
        evYield: {
            exp: 204,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 2,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 75,
            attack: 90,
            defense: 50,
            specialAttack: 110,
            specialDefense: 80,
            speed: 95,
        },
    },
    230: {
        id: 230,
        evYield: {
            exp: 207,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 1,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 75,
            attack: 95,
            defense: 95,
            specialAttack: 95,
            specialDefense: 95,
            speed: 85,
        },
    },
    231: {
        id: 231,
        evYield: {
            exp: 124,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 90,
            attack: 60,
            defense: 60,
            specialAttack: 40,
            specialDefense: 40,
            speed: 40,
        },
    },
    232: {
        id: 232,
        evYield: {
            exp: 189,
            hp: 0,
            attack: 1,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 90,
            attack: 120,
            defense: 120,
            specialAttack: 60,
            specialDefense: 60,
            speed: 50,
        },
    },
    233: {
        id: 233,
        evYield: {
            exp: 180,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 2,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 85,
            attack: 80,
            defense: 90,
            specialAttack: 105,
            specialDefense: 95,
            speed: 60,
        },
    },
    234: {
        id: 234,
        evYield: {
            exp: 165,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 73,
            attack: 95,
            defense: 62,
            specialAttack: 85,
            specialDefense: 65,
            speed: 85,
        },
    },
    235: {
        id: 235,
        evYield: {
            exp: 106,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 55,
            attack: 20,
            defense: 35,
            specialAttack: 20,
            specialDefense: 45,
            speed: 75,
        },
    },
    236: {
        id: 236,
        evYield: {
            exp: 91,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 35,
            attack: 35,
            defense: 35,
            specialAttack: 35,
            specialDefense: 35,
            speed: 35,
        },
    },
    237: {
        id: 237,
        evYield: {
            exp: 138,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 2,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 95,
            defense: 95,
            specialAttack: 35,
            specialDefense: 110,
            speed: 70,
        },
    },
    238: {
        id: 238,
        evYield: {
            exp: 87,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 45,
            attack: 30,
            defense: 15,
            specialAttack: 85,
            specialDefense: 65,
            speed: 65,
        },
    },
    239: {
        id: 239,
        evYield: {
            exp: 106,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 45,
            attack: 63,
            defense: 37,
            specialAttack: 65,
            specialDefense: 55,
            speed: 95,
        },
    },
    240: {
        id: 240,
        evYield: {
            exp: 117,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 45,
            attack: 75,
            defense: 37,
            specialAttack: 70,
            specialDefense: 55,
            speed: 83,
        },
    },
    241: {
        id: 241,
        evYield: {
            exp: 200,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 95,
            attack: 80,
            defense: 105,
            specialAttack: 40,
            specialDefense: 70,
            speed: 100,
        },
    },
    242: {
        id: 242,
        evYield: {
            exp: 255,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 255,
            attack: 10,
            defense: 10,
            specialAttack: 75,
            specialDefense: 135,
            speed: 55,
        },
    },
    243: {
        id: 243,
        evYield: {
            exp: 216,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 90,
            attack: 85,
            defense: 75,
            specialAttack: 115,
            specialDefense: 100,
            speed: 115,
        },
    },
    244: {
        id: 244,
        evYield: {
            exp: 217,
            hp: 1,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 115,
            attack: 115,
            defense: 85,
            specialAttack: 90,
            specialDefense: 75,
            speed: 100,
        },
    },
    245: {
        id: 245,
        evYield: {
            exp: 215,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 2,
            speed: 0,
        },
        baseStats: {
            maxHp: 100,
            attack: 75,
            defense: 115,
            specialAttack: 90,
            specialDefense: 115,
            speed: 85,
        },
    },
    246: {
        id: 246,
        evYield: {
            exp: 67,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 64,
            defense: 50,
            specialAttack: 45,
            specialDefense: 50,
            speed: 41,
        },
    },
    247: {
        id: 247,
        evYield: {
            exp: 144,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 84,
            defense: 70,
            specialAttack: 65,
            specialDefense: 70,
            speed: 51,
        },
    },
    248: {
        id: 248,
        evYield: {
            exp: 218,
            hp: 0,
            attack: 3,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 100,
            attack: 134,
            defense: 110,
            specialAttack: 95,
            specialDefense: 100,
            speed: 61,
        },
    },
    249: {
        id: 249,
        evYield: {
            exp: 220,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 3,
            speed: 0,
        },
        baseStats: {
            maxHp: 106,
            attack: 90,
            defense: 130,
            specialAttack: 90,
            specialDefense: 154,
            speed: 110,
        },
    },
    250: {
        id: 250,
        evYield: {
            exp: 220,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 3,
            speed: 0,
        },
        baseStats: {
            maxHp: 106,
            attack: 130,
            defense: 90,
            specialAttack: 110,
            specialDefense: 154,
            speed: 90,
        },
    },
    251: {
        id: 251,
        evYield: {
            exp: 64,
            hp: 3,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 100,
            attack: 100,
            defense: 100,
            specialAttack: 100,
            specialDefense: 100,
            speed: 100,
        },
    },
    252: {
        id: 252,
        evYield: {
            exp: 65,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 40,
            attack: 45,
            defense: 35,
            specialAttack: 65,
            specialDefense: 55,
            speed: 70,
        },
    },
    253: {
        id: 253,
        evYield: {
            exp: 141,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 50,
            attack: 65,
            defense: 45,
            specialAttack: 85,
            specialDefense: 65,
            speed: 95,
        },
    },
    254: {
        id: 254,
        evYield: {
            exp: 208,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 3,
        },
        baseStats: {
            maxHp: 70,
            attack: 85,
            defense: 65,
            specialAttack: 105,
            specialDefense: 85,
            speed: 120,
        },
    },
    255: {
        id: 255,
        evYield: {
            exp: 65,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 45,
            attack: 60,
            defense: 40,
            specialAttack: 70,
            specialDefense: 50,
            speed: 45,
        },
    },
    256: {
        id: 256,
        evYield: {
            exp: 142,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 85,
            defense: 60,
            specialAttack: 85,
            specialDefense: 60,
            speed: 55,
        },
    },
    257: {
        id: 257,
        evYield: {
            exp: 209,
            hp: 0,
            attack: 3,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 120,
            defense: 70,
            specialAttack: 110,
            specialDefense: 70,
            speed: 80,
        },
    },
    258: {
        id: 258,
        evYield: {
            exp: 65,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 70,
            defense: 50,
            specialAttack: 50,
            specialDefense: 50,
            speed: 40,
        },
    },
    259: {
        id: 259,
        evYield: {
            exp: 143,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 85,
            defense: 70,
            specialAttack: 60,
            specialDefense: 70,
            speed: 50,
        },
    },
    260: {
        id: 260,
        evYield: {
            exp: 210,
            hp: 0,
            attack: 3,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 100,
            attack: 110,
            defense: 90,
            specialAttack: 85,
            specialDefense: 90,
            speed: 60,
        },
    },
    261: {
        id: 261,
        evYield: {
            exp: 55,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 35,
            attack: 55,
            defense: 35,
            specialAttack: 30,
            specialDefense: 30,
            speed: 35,
        },
    },
    262: {
        id: 262,
        evYield: {
            exp: 128,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 90,
            defense: 70,
            specialAttack: 60,
            specialDefense: 60,
            speed: 70,
        },
    },
    263: {
        id: 263,
        evYield: {
            exp: 60,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 38,
            attack: 30,
            defense: 41,
            specialAttack: 30,
            specialDefense: 41,
            speed: 60,
        },
    },
    264: {
        id: 264,
        evYield: {
            exp: 128,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 78,
            attack: 70,
            defense: 61,
            specialAttack: 50,
            specialDefense: 61,
            speed: 100,
        },
    },
    265: {
        id: 265,
        evYield: {
            exp: 54,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 45,
            attack: 45,
            defense: 35,
            specialAttack: 20,
            specialDefense: 30,
            speed: 20,
        },
    },
    266: {
        id: 266,
        evYield: {
            exp: 71,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 35,
            defense: 55,
            specialAttack: 25,
            specialDefense: 25,
            speed: 15,
        },
    },
    267: {
        id: 267,
        evYield: {
            exp: 161,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 3,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 70,
            defense: 50,
            specialAttack: 90,
            specialDefense: 50,
            speed: 65,
        },
    },
    268: {
        id: 268,
        evYield: {
            exp: 72,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 35,
            defense: 55,
            specialAttack: 25,
            specialDefense: 25,
            speed: 15,
        },
    },
    269: {
        id: 269,
        evYield: {
            exp: 160,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 3,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 50,
            defense: 70,
            specialAttack: 50,
            specialDefense: 90,
            speed: 65,
        },
    },
    270: {
        id: 270,
        evYield: {
            exp: 74,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 40,
            attack: 30,
            defense: 30,
            specialAttack: 40,
            specialDefense: 50,
            speed: 30,
        },
    },
    271: {
        id: 271,
        evYield: {
            exp: 141,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 2,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 50,
            defense: 50,
            specialAttack: 60,
            specialDefense: 70,
            speed: 50,
        },
    },
    272: {
        id: 272,
        evYield: {
            exp: 181,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 3,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 70,
            defense: 70,
            specialAttack: 90,
            specialDefense: 100,
            speed: 70,
        },
    },
    273: {
        id: 273,
        evYield: {
            exp: 74,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 40,
            attack: 40,
            defense: 50,
            specialAttack: 30,
            specialDefense: 30,
            speed: 30,
        },
    },
    274: {
        id: 274,
        evYield: {
            exp: 141,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 70,
            defense: 40,
            specialAttack: 60,
            specialDefense: 40,
            speed: 60,
        },
    },
    275: {
        id: 275,
        evYield: {
            exp: 181,
            hp: 0,
            attack: 3,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 90,
            attack: 100,
            defense: 60,
            specialAttack: 90,
            specialDefense: 60,
            speed: 80,
        },
    },
    276: {
        id: 276,
        evYield: {
            exp: 59,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 40,
            attack: 55,
            defense: 30,
            specialAttack: 30,
            specialDefense: 30,
            speed: 85,
        },
    },
    277: {
        id: 277,
        evYield: {
            exp: 162,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 60,
            attack: 85,
            defense: 60,
            specialAttack: 50,
            specialDefense: 50,
            speed: 125,
        },
    },
    278: {
        id: 278,
        evYield: {
            exp: 64,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 40,
            attack: 30,
            defense: 30,
            specialAttack: 55,
            specialDefense: 30,
            speed: 85,
        },
    },
    279: {
        id: 279,
        evYield: {
            exp: 164,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 50,
            defense: 100,
            specialAttack: 85,
            specialDefense: 70,
            speed: 65,
        },
    },
    280: {
        id: 280,
        evYield: {
            exp: 70,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 28,
            attack: 25,
            defense: 25,
            specialAttack: 45,
            specialDefense: 35,
            speed: 40,
        },
    },
    281: {
        id: 281,
        evYield: {
            exp: 140,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 2,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 38,
            attack: 35,
            defense: 35,
            specialAttack: 65,
            specialDefense: 55,
            speed: 50,
        },
    },
    282: {
        id: 282,
        evYield: {
            exp: 208,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 3,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 68,
            attack: 65,
            defense: 65,
            specialAttack: 125,
            specialDefense: 115,
            speed: 80,
        },
    },
    283: {
        id: 283,
        evYield: {
            exp: 63,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 40,
            attack: 30,
            defense: 32,
            specialAttack: 50,
            specialDefense: 52,
            speed: 65,
        },
    },
    284: {
        id: 284,
        evYield: {
            exp: 128,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 60,
            defense: 62,
            specialAttack: 80,
            specialDefense: 82,
            speed: 60,
        },
    },
    285: {
        id: 285,
        evYield: {
            exp: 65,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 40,
            defense: 60,
            specialAttack: 40,
            specialDefense: 60,
            speed: 35,
        },
    },
    286: {
        id: 286,
        evYield: {
            exp: 165,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 130,
            defense: 80,
            specialAttack: 60,
            specialDefense: 60,
            speed: 70,
        },
    },
    287: {
        id: 287,
        evYield: {
            exp: 83,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 60,
            defense: 60,
            specialAttack: 35,
            specialDefense: 35,
            speed: 30,
        },
    },
    288: {
        id: 288,
        evYield: {
            exp: 126,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 80,
            attack: 80,
            defense: 80,
            specialAttack: 55,
            specialDefense: 55,
            speed: 90,
        },
    },
    289: {
        id: 289,
        evYield: {
            exp: 210,
            hp: 3,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 150,
            attack: 160,
            defense: 100,
            specialAttack: 95,
            specialDefense: 65,
            speed: 100,
        },
    },
    290: {
        id: 290,
        evYield: {
            exp: 65,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 31,
            attack: 45,
            defense: 90,
            specialAttack: 30,
            specialDefense: 30,
            speed: 40,
        },
    },
    291: {
        id: 291,
        evYield: {
            exp: 155,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 61,
            attack: 90,
            defense: 45,
            specialAttack: 50,
            specialDefense: 50,
            speed: 160,
        },
    },
    292: {
        id: 292,
        evYield: {
            exp: 95,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 1,
            attack: 90,
            defense: 45,
            specialAttack: 30,
            specialDefense: 30,
            speed: 40,
        },
    },
    293: {
        id: 293,
        evYield: {
            exp: 68,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 64,
            attack: 51,
            defense: 23,
            specialAttack: 51,
            specialDefense: 23,
            speed: 28,
        },
    },
    294: {
        id: 294,
        evYield: {
            exp: 126,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 84,
            attack: 71,
            defense: 43,
            specialAttack: 71,
            specialDefense: 43,
            speed: 48,
        },
    },
    295: {
        id: 295,
        evYield: {
            exp: 184,
            hp: 3,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 104,
            attack: 91,
            defense: 63,
            specialAttack: 91,
            specialDefense: 63,
            speed: 68,
        },
    },
    296: {
        id: 296,
        evYield: {
            exp: 87,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 72,
            attack: 60,
            defense: 30,
            specialAttack: 20,
            specialDefense: 30,
            speed: 25,
        },
    },
    297: {
        id: 297,
        evYield: {
            exp: 184,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 144,
            attack: 120,
            defense: 60,
            specialAttack: 40,
            specialDefense: 60,
            speed: 50,
        },
    },
    298: {
        id: 298,
        evYield: {
            exp: 33,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 20,
            defense: 40,
            specialAttack: 20,
            specialDefense: 40,
            speed: 20,
        },
    },
    299: {
        id: 299,
        evYield: {
            exp: 108,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 30,
            attack: 45,
            defense: 135,
            specialAttack: 45,
            specialDefense: 90,
            speed: 30,
        },
    },
    300: {
        id: 300,
        evYield: {
            exp: 65,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 50,
            attack: 45,
            defense: 45,
            specialAttack: 35,
            specialDefense: 35,
            speed: 50,
        },
    },
    301: {
        id: 301,
        evYield: {
            exp: 138,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 70,
            attack: 65,
            defense: 65,
            specialAttack: 55,
            specialDefense: 55,
            speed: 70,
        },
    },
    302: {
        id: 302,
        evYield: {
            exp: 98,
            hp: 0,
            attack: 1,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 75,
            defense: 75,
            specialAttack: 65,
            specialDefense: 65,
            speed: 50,
        },
    },
    303: {
        id: 303,
        evYield: {
            exp: 98,
            hp: 0,
            attack: 1,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 85,
            defense: 85,
            specialAttack: 55,
            specialDefense: 55,
            speed: 50,
        },
    },
    304: {
        id: 304,
        evYield: {
            exp: 96,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 70,
            defense: 100,
            specialAttack: 40,
            specialDefense: 40,
            speed: 30,
        },
    },
    305: {
        id: 305,
        evYield: {
            exp: 152,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 90,
            defense: 140,
            specialAttack: 50,
            specialDefense: 50,
            speed: 40,
        },
    },
    306: {
        id: 306,
        evYield: {
            exp: 205,
            hp: 0,
            attack: 0,
            defense: 3,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 110,
            defense: 180,
            specialAttack: 60,
            specialDefense: 60,
            speed: 50,
        },
    },
    307: {
        id: 307,
        evYield: {
            exp: 91,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 30,
            attack: 40,
            defense: 55,
            specialAttack: 40,
            specialDefense: 55,
            speed: 60,
        },
    },
    308: {
        id: 308,
        evYield: {
            exp: 153,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 60,
            attack: 60,
            defense: 75,
            specialAttack: 60,
            specialDefense: 75,
            speed: 80,
        },
    },
    309: {
        id: 309,
        evYield: {
            exp: 104,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 40,
            attack: 45,
            defense: 40,
            specialAttack: 65,
            specialDefense: 40,
            speed: 65,
        },
    },
    310: {
        id: 310,
        evYield: {
            exp: 168,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 70,
            attack: 75,
            defense: 60,
            specialAttack: 105,
            specialDefense: 60,
            speed: 105,
        },
    },
    311: {
        id: 311,
        evYield: {
            exp: 120,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 60,
            attack: 50,
            defense: 40,
            specialAttack: 85,
            specialDefense: 75,
            speed: 95,
        },
    },
    312: {
        id: 312,
        evYield: {
            exp: 120,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 60,
            attack: 40,
            defense: 50,
            specialAttack: 75,
            specialDefense: 85,
            speed: 95,
        },
    },
    313: {
        id: 313,
        evYield: {
            exp: 146,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 65,
            attack: 73,
            defense: 55,
            specialAttack: 47,
            specialDefense: 75,
            speed: 85,
        },
    },
    314: {
        id: 314,
        evYield: {
            exp: 146,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 65,
            attack: 47,
            defense: 55,
            specialAttack: 73,
            specialDefense: 75,
            speed: 85,
        },
    },
    315: {
        id: 315,
        evYield: {
            exp: 152,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 60,
            defense: 45,
            specialAttack: 100,
            specialDefense: 80,
            speed: 65,
        },
    },
    316: {
        id: 316,
        evYield: {
            exp: 75,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 43,
            defense: 53,
            specialAttack: 43,
            specialDefense: 53,
            speed: 40,
        },
    },
    317: {
        id: 317,
        evYield: {
            exp: 168,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 100,
            attack: 73,
            defense: 83,
            specialAttack: 73,
            specialDefense: 83,
            speed: 55,
        },
    },
    318: {
        id: 318,
        evYield: {
            exp: 88,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 45,
            attack: 90,
            defense: 20,
            specialAttack: 65,
            specialDefense: 20,
            speed: 65,
        },
    },
    319: {
        id: 319,
        evYield: {
            exp: 175,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 120,
            defense: 40,
            specialAttack: 95,
            specialDefense: 40,
            speed: 95,
        },
    },
    320: {
        id: 320,
        evYield: {
            exp: 137,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 130,
            attack: 70,
            defense: 35,
            specialAttack: 70,
            specialDefense: 35,
            speed: 60,
        },
    },
    321: {
        id: 321,
        evYield: {
            exp: 206,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 170,
            attack: 90,
            defense: 45,
            specialAttack: 90,
            specialDefense: 45,
            speed: 60,
        },
    },
    322: {
        id: 322,
        evYield: {
            exp: 88,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 60,
            defense: 40,
            specialAttack: 65,
            specialDefense: 45,
            speed: 35,
        },
    },
    323: {
        id: 323,
        evYield: {
            exp: 175,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 100,
            defense: 70,
            specialAttack: 105,
            specialDefense: 75,
            speed: 40,
        },
    },
    324: {
        id: 324,
        evYield: {
            exp: 161,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 85,
            defense: 140,
            specialAttack: 85,
            specialDefense: 70,
            speed: 20,
        },
    },
    325: {
        id: 325,
        evYield: {
            exp: 89,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 25,
            defense: 35,
            specialAttack: 70,
            specialDefense: 80,
            speed: 60,
        },
    },
    326: {
        id: 326,
        evYield: {
            exp: 164,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 2,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 45,
            defense: 65,
            specialAttack: 90,
            specialDefense: 110,
            speed: 80,
        },
    },
    327: {
        id: 327,
        evYield: {
            exp: 85,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 60,
            defense: 60,
            specialAttack: 60,
            specialDefense: 60,
            speed: 60,
        },
    },
    328: {
        id: 328,
        evYield: {
            exp: 73,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 45,
            attack: 100,
            defense: 45,
            specialAttack: 45,
            specialDefense: 45,
            speed: 10,
        },
    },
    329: {
        id: 329,
        evYield: {
            exp: 126,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 50,
            attack: 70,
            defense: 50,
            specialAttack: 50,
            specialDefense: 50,
            speed: 70,
        },
    },
    330: {
        id: 330,
        evYield: {
            exp: 197,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 2,
        },
        baseStats: {
            maxHp: 80,
            attack: 100,
            defense: 80,
            specialAttack: 80,
            specialDefense: 80,
            speed: 100,
        },
    },
    331: {
        id: 331,
        evYield: {
            exp: 97,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 85,
            defense: 40,
            specialAttack: 85,
            specialDefense: 40,
            speed: 35,
        },
    },
    332: {
        id: 332,
        evYield: {
            exp: 177,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 115,
            defense: 60,
            specialAttack: 115,
            specialDefense: 60,
            speed: 55,
        },
    },
    333: {
        id: 333,
        evYield: {
            exp: 74,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 45,
            attack: 40,
            defense: 60,
            specialAttack: 40,
            specialDefense: 75,
            speed: 50,
        },
    },
    334: {
        id: 334,
        evYield: {
            exp: 188,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 2,
            speed: 0,
        },
        baseStats: {
            maxHp: 75,
            attack: 70,
            defense: 90,
            specialAttack: 70,
            specialDefense: 105,
            speed: 80,
        },
    },
    335: {
        id: 335,
        evYield: {
            exp: 165,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 73,
            attack: 115,
            defense: 60,
            specialAttack: 60,
            specialDefense: 60,
            speed: 90,
        },
    },
    336: {
        id: 336,
        evYield: {
            exp: 165,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 73,
            attack: 100,
            defense: 60,
            specialAttack: 100,
            specialDefense: 60,
            speed: 65,
        },
    },
    337: {
        id: 337,
        evYield: {
            exp: 150,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 2,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 55,
            defense: 65,
            specialAttack: 95,
            specialDefense: 85,
            speed: 70,
        },
    },
    338: {
        id: 338,
        evYield: {
            exp: 150,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 95,
            defense: 85,
            specialAttack: 55,
            specialDefense: 65,
            speed: 70,
        },
    },
    339: {
        id: 339,
        evYield: {
            exp: 92,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 48,
            defense: 43,
            specialAttack: 46,
            specialDefense: 41,
            speed: 60,
        },
    },
    340: {
        id: 340,
        evYield: {
            exp: 158,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 110,
            attack: 78,
            defense: 73,
            specialAttack: 76,
            specialDefense: 71,
            speed: 60,
        },
    },
    341: {
        id: 341,
        evYield: {
            exp: 111,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 43,
            attack: 80,
            defense: 65,
            specialAttack: 50,
            specialDefense: 35,
            speed: 35,
        },
    },
    342: {
        id: 342,
        evYield: {
            exp: 161,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 63,
            attack: 120,
            defense: 85,
            specialAttack: 90,
            specialDefense: 55,
            speed: 55,
        },
    },
    343: {
        id: 343,
        evYield: {
            exp: 58,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 40,
            attack: 40,
            defense: 55,
            specialAttack: 40,
            specialDefense: 70,
            speed: 55,
        },
    },
    344: {
        id: 344,
        evYield: {
            exp: 189,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 2,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 70,
            defense: 105,
            specialAttack: 70,
            specialDefense: 120,
            speed: 75,
        },
    },
    345: {
        id: 345,
        evYield: {
            exp: 121,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 66,
            attack: 41,
            defense: 77,
            specialAttack: 61,
            specialDefense: 87,
            speed: 23,
        },
    },
    346: {
        id: 346,
        evYield: {
            exp: 201,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 2,
            speed: 0,
        },
        baseStats: {
            maxHp: 86,
            attack: 81,
            defense: 97,
            specialAttack: 81,
            specialDefense: 107,
            speed: 43,
        },
    },
    347: {
        id: 347,
        evYield: {
            exp: 119,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 45,
            attack: 95,
            defense: 50,
            specialAttack: 40,
            specialDefense: 50,
            speed: 75,
        },
    },
    348: {
        id: 348,
        evYield: {
            exp: 200,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 75,
            attack: 125,
            defense: 100,
            specialAttack: 70,
            specialDefense: 80,
            speed: 45,
        },
    },
    349: {
        id: 349,
        evYield: {
            exp: 61,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 20,
            attack: 15,
            defense: 20,
            specialAttack: 10,
            specialDefense: 55,
            speed: 80,
        },
    },
    350: {
        id: 350,
        evYield: {
            exp: 213,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 2,
            speed: 0,
        },
        baseStats: {
            maxHp: 95,
            attack: 60,
            defense: 79,
            specialAttack: 100,
            specialDefense: 125,
            speed: 81,
        },
    },
    351: {
        id: 351,
        evYield: {
            exp: 145,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 70,
            defense: 70,
            specialAttack: 70,
            specialDefense: 70,
            speed: 70,
        },
    },
    352: {
        id: 352,
        evYield: {
            exp: 132,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 90,
            defense: 70,
            specialAttack: 60,
            specialDefense: 120,
            speed: 40,
        },
    },
    353: {
        id: 353,
        evYield: {
            exp: 97,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 44,
            attack: 75,
            defense: 35,
            specialAttack: 63,
            specialDefense: 33,
            speed: 45,
        },
    },
    354: {
        id: 354,
        evYield: {
            exp: 179,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 64,
            attack: 115,
            defense: 65,
            specialAttack: 83,
            specialDefense: 63,
            speed: 65,
        },
    },
    355: {
        id: 355,
        evYield: {
            exp: 97,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 20,
            attack: 40,
            defense: 90,
            specialAttack: 30,
            specialDefense: 90,
            speed: 25,
        },
    },
    356: {
        id: 356,
        evYield: {
            exp: 179,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 2,
            speed: 0,
        },
        baseStats: {
            maxHp: 40,
            attack: 70,
            defense: 130,
            specialAttack: 60,
            specialDefense: 130,
            speed: 25,
        },
    },
    357: {
        id: 357,
        evYield: {
            exp: 169,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 99,
            attack: 68,
            defense: 83,
            specialAttack: 72,
            specialDefense: 87,
            speed: 51,
        },
    },
    358: {
        id: 358,
        evYield: {
            exp: 147,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 50,
            defense: 70,
            specialAttack: 95,
            specialDefense: 80,
            speed: 65,
        },
    },
    359: {
        id: 359,
        evYield: {
            exp: 174,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 130,
            defense: 60,
            specialAttack: 75,
            specialDefense: 60,
            speed: 75,
        },
    },
    360: {
        id: 360,
        evYield: {
            exp: 44,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 95,
            attack: 23,
            defense: 48,
            specialAttack: 23,
            specialDefense: 48,
            speed: 23,
        },
    },
    361: {
        id: 361,
        evYield: {
            exp: 74,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 50,
            attack: 50,
            defense: 50,
            specialAttack: 50,
            specialDefense: 50,
            speed: 50,
        },
    },
    362: {
        id: 362,
        evYield: {
            exp: 187,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 80,
            defense: 80,
            specialAttack: 80,
            specialDefense: 80,
            speed: 80,
        },
    },
    363: {
        id: 363,
        evYield: {
            exp: 75,
            hp: 1,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 70,
            attack: 40,
            defense: 50,
            specialAttack: 55,
            specialDefense: 50,
            speed: 25,
        },
    },
    364: {
        id: 364,
        evYield: {
            exp: 128,
            hp: 2,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 90,
            attack: 60,
            defense: 70,
            specialAttack: 75,
            specialDefense: 70,
            speed: 45,
        },
    },
    365: {
        id: 365,
        evYield: {
            exp: 192,
            hp: 3,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 110,
            attack: 80,
            defense: 90,
            specialAttack: 95,
            specialDefense: 90,
            speed: 65,
        },
    },
    366: {
        id: 366,
        evYield: {
            exp: 142,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 35,
            attack: 64,
            defense: 85,
            specialAttack: 74,
            specialDefense: 55,
            speed: 32,
        },
    },
    367: {
        id: 367,
        evYield: {
            exp: 178,
            hp: 0,
            attack: 1,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 55,
            attack: 104,
            defense: 105,
            specialAttack: 94,
            specialDefense: 75,
            speed: 52,
        },
    },
    368: {
        id: 368,
        evYield: {
            exp: 178,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 2,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 55,
            attack: 84,
            defense: 105,
            specialAttack: 114,
            specialDefense: 75,
            speed: 52,
        },
    },
    369: {
        id: 369,
        evYield: {
            exp: 198,
            hp: 1,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 100,
            attack: 90,
            defense: 130,
            specialAttack: 45,
            specialDefense: 65,
            speed: 55,
        },
    },
    370: {
        id: 370,
        evYield: {
            exp: 110,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 43,
            attack: 30,
            defense: 55,
            specialAttack: 40,
            specialDefense: 65,
            speed: 97,
        },
    },
    371: {
        id: 371,
        evYield: {
            exp: 89,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 45,
            attack: 75,
            defense: 60,
            specialAttack: 40,
            specialDefense: 30,
            speed: 50,
        },
    },
    372: {
        id: 372,
        evYield: {
            exp: 144,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 65,
            attack: 95,
            defense: 100,
            specialAttack: 60,
            specialDefense: 50,
            speed: 50,
        },
    },
    373: {
        id: 373,
        evYield: {
            exp: 218,
            hp: 0,
            attack: 3,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 95,
            attack: 135,
            defense: 80,
            specialAttack: 110,
            specialDefense: 80,
            speed: 100,
        },
    },
    374: {
        id: 374,
        evYield: {
            exp: 103,
            hp: 0,
            attack: 0,
            defense: 1,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 40,
            attack: 55,
            defense: 80,
            specialAttack: 35,
            specialDefense: 60,
            speed: 30,
        },
    },
    375: {
        id: 375,
        evYield: {
            exp: 153,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 60,
            attack: 75,
            defense: 100,
            specialAttack: 55,
            specialDefense: 80,
            speed: 50,
        },
    },
    376: {
        id: 376,
        evYield: {
            exp: 210,
            hp: 0,
            attack: 0,
            defense: 3,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 135,
            defense: 130,
            specialAttack: 95,
            specialDefense: 90,
            speed: 70,
        },
    },
    377: {
        id: 377,
        evYield: {
            exp: 217,
            hp: 0,
            attack: 0,
            defense: 3,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 100,
            defense: 200,
            specialAttack: 50,
            specialDefense: 100,
            speed: 50,
        },
    },
    378: {
        id: 378,
        evYield: {
            exp: 216,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 3,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 50,
            defense: 100,
            specialAttack: 100,
            specialDefense: 200,
            speed: 50,
        },
    },
    379: {
        id: 379,
        evYield: {
            exp: 215,
            hp: 0,
            attack: 0,
            defense: 2,
            specialAttack: 0,
            specialDefense: 1,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 75,
            defense: 150,
            specialAttack: 75,
            specialDefense: 150,
            speed: 50,
        },
    },
    380: {
        id: 380,
        evYield: {
            exp: 211,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 3,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 80,
            defense: 90,
            specialAttack: 110,
            specialDefense: 130,
            speed: 110,
        },
    },
    381: {
        id: 381,
        evYield: {
            exp: 211,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 3,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 90,
            defense: 80,
            specialAttack: 130,
            specialDefense: 110,
            speed: 110,
        },
    },
    382: {
        id: 382,
        evYield: {
            exp: 218,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 3,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 100,
            attack: 100,
            defense: 90,
            specialAttack: 150,
            specialDefense: 140,
            speed: 90,
        },
    },
    383: {
        id: 383,
        evYield: {
            exp: 218,
            hp: 0,
            attack: 3,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 100,
            attack: 150,
            defense: 140,
            specialAttack: 100,
            specialDefense: 90,
            speed: 90,
        },
    },
    384: {
        id: 384,
        evYield: {
            exp: 220,
            hp: 0,
            attack: 2,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 105,
            attack: 150,
            defense: 90,
            specialAttack: 150,
            specialDefense: 90,
            speed: 95,
        },
    },
    385: {
        id: 385,
        evYield: {
            exp: 215,
            hp: 3,
            attack: 0,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 100,
            attack: 100,
            defense: 100,
            specialAttack: 100,
            specialDefense: 100,
            speed: 100,
        },
    },
    386: {
        id: 386,
        evYield: {
            exp: 215,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 1,
        },
        baseStats: {
            maxHp: 50,
            attack: 95,
            defense: 90,
            specialAttack: 95,
            specialDefense: 90,
            speed: 180,
        },
    },
    387: {
        id: 387,
        evYield: {
            exp: 100,
            hp: 0,
            attack: 1,
            defense: 0,
            specialAttack: 0,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 40,
            attack: 45,
            defense: 55,
            specialAttack: 40,
            specialDefense: 50,
            speed: 30,
        },
    },
    388: {
        id: 388,
        evYield: {
            exp: 100,
            hp: 0,
            attack: 0,
            defense: 0,
            specialAttack: 1,
            specialDefense: 0,
            speed: 0,
        },
        baseStats: {
            maxHp: 80,
            attack: 82,
            defense: 70,
            specialAttack: 95,
            specialDefense: 70,
            speed: 86,
        },
    },
};

export const typeDB = {
    1: {
        id: 1,
        type1: 'grass',
        type2: 'poison',
    },
    2: {
        id: 2,
        type1: 'grass',
        type2: 'poison',
    },
    3: {
        id: 3,
        type1: 'grass',
        type2: 'poison',
    },
    4: {
        id: 4,
        type1: 'fire',
        type2: 'fire',
    },
    5: {
        id: 5,
        type1: 'fire',
        type2: 'fire',
    },
    6: {
        id: 6,
        type1: 'fire',
        type2: 'flying',
    },
    7: {
        id: 7,
        type1: 'water',
        type2: 'water',
    },
    8: {
        id: 8,
        type1: 'water',
        type2: 'water',
    },
    9: {
        id: 9,
        type1: 'water',
        type2: 'water',
    },
    10: {
        id: 10,
        type1: 'bug',
        type2: 'bug',
    },
    11: {
        id: 11,
        type1: 'bug',
        type2: 'bug',
    },
    12: {
        id: 12,
        type1: 'bug',
        type2: 'flying',
    },
    13: {
        id: 13,
        type1: 'bug',
        type2: 'poison',
    },
    14: {
        id: 14,
        type1: 'bug',
        type2: 'poison',
    },
    15: {
        id: 15,
        type1: 'bug',
        type2: 'poison',
    },
    16: {
        id: 16,
        type1: 'normal',
        type2: 'flying',
    },
    17: {
        id: 17,
        type1: 'normal',
        type2: 'flying',
    },
    18: {
        id: 18,
        type1: 'normal',
        type2: 'flying',
    },
    19: {
        id: 19,
        type1: 'normal',
        type2: 'normal',
    },
    20: {
        id: 20,
        type1: 'normal',
        type2: 'normal',
    },
    21: {
        id: 21,
        type1: 'normal',
        type2: 'flying',
    },
    22: {
        id: 22,
        type1: 'normal',
        type2: 'flying',
    },
    23: {
        id: 23,
        type1: 'poison',
        type2: 'poison',
    },
    24: {
        id: 24,
        type1: 'poison',
        type2: 'poison',
    },
    25: {
        id: 25,
        type1: 'electric',
        type2: 'electric',
    },
    26: {
        id: 26,
        type1: 'electric',
        type2: 'electric',
    },
    27: {
        id: 27,
        type1: 'ground',
        type2: 'ground',
    },
    28: {
        id: 28,
        type1: 'ground',
        type2: 'ground',
    },
    29: {
        id: 29,
        type1: 'poison',
        type2: 'poison',
    },
    30: {
        id: 30,
        type1: 'poison',
        type2: 'poison',
    },
    31: {
        id: 31,
        type1: 'poison',
        type2: 'ground',
    },
    32: {
        id: 32,
        type1: 'poison',
        type2: 'poison',
    },
    33: {
        id: 33,
        type1: 'poison',
        type2: 'poison',
    },
    34: {
        id: 34,
        type1: 'poison',
        type2: 'ground',
    },
    35: {
        id: 35,
        type1: 'fairy',
        type2: 'fairy',
    },
    36: {
        id: 36,
        type1: 'fairy',
        type2: 'fairy',
    },
    37: {
        id: 37,
        type1: 'fire',
        type2: 'fire',
    },
    38: {
        id: 38,
        type1: 'fire',
        type2: 'fire',
    },
    39: {
        id: 39,
        type1: 'normal',
        type2: 'fairy',
    },
    40: {
        id: 40,
        type1: 'normal',
        type2: 'fairy',
    },
    41: {
        id: 41,
        type1: 'poison',
        type2: 'flying',
    },
    42: {
        id: 42,
        type1: 'poison',
        type2: 'flying',
    },
    43: {
        id: 43,
        type1: 'grass',
        type2: 'poison',
    },
    44: {
        id: 44,
        type1: 'grass',
        type2: 'poison',
    },
    45: {
        id: 45,
        type1: 'grass',
        type2: 'poison',
    },
    46: {
        id: 46,
        type1: 'bug',
        type2: 'grass',
    },
    47: {
        id: 47,
        type1: 'bug',
        type2: 'grass',
    },
    48: {
        id: 48,
        type1: 'bug',
        type2: 'poison',
    },
    49: {
        id: 49,
        type1: 'bug',
        type2: 'poison',
    },
    50: {
        id: 50,
        type1: 'ground',
        type2: 'ground',
    },
    51: {
        id: 51,
        type1: 'ground',
        type2: 'ground',
    },
    52: {
        id: 52,
        type1: 'normal',
        type2: 'normal',
    },
    53: {
        id: 53,
        type1: 'normal',
        type2: 'normal',
    },
    54: {
        id: 54,
        type1: 'water',
        type2: 'water',
    },
    55: {
        id: 55,
        type1: 'water',
        type2: 'water',
    },
    56: {
        id: 56,
        type1: 'fighting',
        type2: 'fighting',
    },
    57: {
        id: 57,
        type1: 'fighting',
        type2: 'fighting',
    },
    58: {
        id: 58,
        type1: 'fire',
        type2: 'fire',
    },
    59: {
        id: 59,
        type1: 'fire',
        type2: 'fire',
    },
    60: {
        id: 60,
        type1: 'water',
        type2: 'water',
    },
    61: {
        id: 61,
        type1: 'water',
        type2: 'water',
    },
    62: {
        id: 62,
        type1: 'water',
        type2: 'fighting',
    },
    63: {
        id: 63,
        type1: 'psychic',
        type2: 'psychic',
    },
    64: {
        id: 64,
        type1: 'psychic',
        type2: 'psychic',
    },
    65: {
        id: 65,
        type1: 'psychic',
        type2: 'psychic',
    },
    66: {
        id: 66,
        type1: 'fighting',
        type2: 'fighting',
    },
    67: {
        id: 67,
        type1: 'fighting',
        type2: 'fighting',
    },
    68: {
        id: 68,
        type1: 'fighting',
        type2: 'fighting',
    },
    69: {
        id: 69,
        type1: 'grass',
        type2: 'poison',
    },
    70: {
        id: 70,
        type1: 'grass',
        type2: 'poison',
    },
    71: {
        id: 71,
        type1: 'grass',
        type2: 'poison',
    },
    72: {
        id: 72,
        type1: 'water',
        type2: 'poison',
    },
    73: {
        id: 73,
        type1: 'water',
        type2: 'poison',
    },
    74: {
        id: 74,
        type1: 'rock',
        type2: 'ground',
    },
    75: {
        id: 75,
        type1: 'rock',
        type2: 'ground',
    },
    76: {
        id: 76,
        type1: 'rock',
        type2: 'ground',
    },
    77: {
        id: 77,
        type1: 'fire',
        type2: 'fire',
    },
    78: {
        id: 78,
        type1: 'fire',
        type2: 'fire',
    },
    79: {
        id: 79,
        type1: 'water',
        type2: 'psychic',
    },
    80: {
        id: 80,
        type1: 'water',
        type2: 'psychic',
    },
    81: {
        id: 81,
        type1: 'electric',
        type2: 'steel',
    },
    82: {
        id: 82,
        type1: 'electric',
        type2: 'steel',
    },
    83: {
        id: 83,
        type1: 'normal',
        type2: 'flying',
    },
    84: {
        id: 84,
        type1: 'normal',
        type2: 'flying',
    },
    85: {
        id: 85,
        type1: 'normal',
        type2: 'flying',
    },
    86: {
        id: 86,
        type1: 'water',
        type2: 'water',
    },
    87: {
        id: 87,
        type1: 'water',
        type2: 'ice',
    },
    88: {
        id: 88,
        type1: 'poison',
        type2: 'poison',
    },
    89: {
        id: 89,
        type1: 'poison',
        type2: 'poison',
    },
    90: {
        id: 90,
        type1: 'water',
        type2: 'water',
    },
    91: {
        id: 91,
        type1: 'water',
        type2: 'ice',
    },
    92: {
        id: 92,
        type1: 'ghost',
        type2: 'poison',
    },
    93: {
        id: 93,
        type1: 'ghost',
        type2: 'poison',
    },
    94: {
        id: 94,
        type1: 'ghost',
        type2: 'poison',
    },
    95: {
        id: 95,
        type1: 'rock',
        type2: 'ground',
    },
    96: {
        id: 96,
        type1: 'psychic',
        type2: 'psychic',
    },
    97: {
        id: 97,
        type1: 'psychic',
        type2: 'psychic',
    },
    98: {
        id: 98,
        type1: 'water',
        type2: 'water',
    },
    99: {
        id: 99,
        type1: 'water',
        type2: 'water',
    },
    100: {
        id: 100,
        type1: 'electric',
        type2: 'electric',
    },
    101: {
        id: 101,
        type1: 'electric',
        type2: 'electric',
    },
    102: {
        id: 102,
        type1: 'grass',
        type2: 'psychic',
    },
    103: {
        id: 103,
        type1: 'grass',
        type2: 'psychic',
    },
    104: {
        id: 104,
        type1: 'ground',
        type2: 'ground',
    },
    105: {
        id: 105,
        type1: 'ground',
        type2: 'ground',
    },
    106: {
        id: 106,
        type1: 'fighting',
        type2: 'fighting',
    },
    107: {
        id: 107,
        type1: 'fighting',
        type2: 'fighting',
    },
    108: {
        id: 108,
        type1: 'normal',
        type2: 'normal',
    },
    109: {
        id: 109,
        type1: 'poison',
        type2: 'poison',
    },
    110: {
        id: 110,
        type1: 'poison',
        type2: 'poison',
    },
    111: {
        id: 111,
        type1: 'ground',
        type2: 'rock',
    },
    112: {
        id: 112,
        type1: 'ground',
        type2: 'rock',
    },
    113: {
        id: 113,
        type1: 'normal',
        type2: 'normal',
    },
    114: {
        id: 114,
        type1: 'grass',
        type2: 'grass',
    },
    115: {
        id: 115,
        type1: 'normal',
        type2: 'normal',
    },
    116: {
        id: 116,
        type1: 'water',
        type2: 'water',
    },
    117: {
        id: 117,
        type1: 'water',
        type2: 'water',
    },
    118: {
        id: 118,
        type1: 'water',
        type2: 'water',
    },
    119: {
        id: 119,
        type1: 'water',
        type2: 'water',
    },
    120: {
        id: 120,
        type1: 'water',
        type2: 'water',
    },
    121: {
        id: 121,
        type1: 'water',
        type2: 'psychic',
    },
    122: {
        id: 122,
        type1: 'psychic',
        type2: 'fairy',
    },
    123: {
        id: 123,
        type1: 'bug',
        type2: 'flying',
    },
    124: {
        id: 124,
        type1: 'ice',
        type2: 'psychic',
    },
    125: {
        id: 125,
        type1: 'electric',
        type2: 'electric',
    },
    126: {
        id: 126,
        type1: 'fire',
        type2: 'fire',
    },
    127: {
        id: 127,
        type1: 'bug',
        type2: 'bug',
    },
    128: {
        id: 128,
        type1: 'normal',
        type2: 'normal',
    },
    129: {
        id: 129,
        type1: 'water',
        type2: 'water',
    },
    130: {
        id: 130,
        type1: 'water',
        type2: 'flying',
    },
    131: {
        id: 131,
        type1: 'water',
        type2: 'ice',
    },
    132: {
        id: 132,
        type1: 'normal',
        type2: 'normal',
    },
    133: {
        id: 133,
        type1: 'normal',
        type2: 'normal',
    },
    134: {
        id: 134,
        type1: 'water',
        type2: 'water',
    },
    135: {
        id: 135,
        type1: 'electric',
        type2: 'electric',
    },
    136: {
        id: 136,
        type1: 'fire',
        type2: 'fire',
    },
    137: {
        id: 137,
        type1: 'normal',
        type2: 'normal',
    },
    138: {
        id: 138,
        type1: 'rock',
        type2: 'water',
    },
    139: {
        id: 139,
        type1: 'rock',
        type2: 'water',
    },
    140: {
        id: 140,
        type1: 'rock',
        type2: 'water',
    },
    141: {
        id: 141,
        type1: 'rock',
        type2: 'water',
    },
    142: {
        id: 142,
        type1: 'rock',
        type2: 'flying',
    },
    143: {
        id: 143,
        type1: 'normal',
        type2: 'normal',
    },
    144: {
        id: 144,
        type1: 'ice',
        type2: 'flying',
    },
    145: {
        id: 145,
        type1: 'electric',
        type2: 'flying',
    },
    146: {
        id: 146,
        type1: 'fire',
        type2: 'flying',
    },
    147: {
        id: 147,
        type1: 'dragon',
        type2: 'dragon',
    },
    148: {
        id: 148,
        type1: 'dragon',
        type2: 'dragon',
    },
    149: {
        id: 149,
        type1: 'dragon',
        type2: 'flying',
    },
    150: {
        id: 150,
        type1: 'psychic',
        type2: 'psychic',
    },
    151: {
        id: 151,
        type1: 'psychic',
        type2: 'psychic',
    },
    152: {
        id: 152,
        type1: 'grass',
        type2: 'grass',
    },
    153: {
        id: 153,
        type1: 'grass',
        type2: 'grass',
    },
    154: {
        id: 154,
        type1: 'grass',
        type2: 'grass',
    },
    155: {
        id: 155,
        type1: 'fire',
        type2: 'fire',
    },
    156: {
        id: 156,
        type1: 'fire',
        type2: 'fire',
    },
    157: {
        id: 157,
        type1: 'fire',
        type2: 'fire',
    },
    158: {
        id: 158,
        type1: 'water',
        type2: 'water',
    },
    159: {
        id: 159,
        type1: 'water',
        type2: 'water',
    },
    160: {
        id: 160,
        type1: 'water',
        type2: 'water',
    },
    161: {
        id: 161,
        type1: 'normal',
        type2: 'normal',
    },
    162: {
        id: 162,
        type1: 'normal',
        type2: 'normal',
    },
    163: {
        id: 163,
        type1: 'normal',
        type2: 'flying',
    },
    164: {
        id: 164,
        type1: 'normal',
        type2: 'flying',
    },
    165: {
        id: 165,
        type1: 'bug',
        type2: 'flying',
    },
    166: {
        id: 166,
        type1: 'bug',
        type2: 'flying',
    },
    167: {
        id: 167,
        type1: 'bug',
        type2: 'poison',
    },
    168: {
        id: 168,
        type1: 'bug',
        type2: 'poison',
    },
    169: {
        id: 169,
        type1: 'poison',
        type2: 'flying',
    },
    170: {
        id: 170,
        type1: 'water',
        type2: 'electric',
    },
    171: {
        id: 171,
        type1: 'water',
        type2: 'electric',
    },
    172: {
        id: 172,
        type1: 'electric',
        type2: 'electric',
    },
    173: {
        id: 173,
        type1: 'fairy',
        type2: 'fairy',
    },
    174: {
        id: 174,
        type1: 'normal',
        type2: 'fairy',
    },
    175: {
        id: 175,
        type1: 'fairy',
        type2: 'fairy',
    },
    176: {
        id: 176,
        type1: 'fairy',
        type2: 'flying',
    },
    177: {
        id: 177,
        type1: 'psychic',
        type2: 'flying',
    },
    178: {
        id: 178,
        type1: 'psychic',
        type2: 'flying',
    },
    179: {
        id: 179,
        type1: 'electric',
        type2: 'electric',
    },
    180: {
        id: 180,
        type1: 'electric',
        type2: 'electric',
    },
    181: {
        id: 181,
        type1: 'electric',
        type2: 'electric',
    },
    182: {
        id: 182,
        type1: 'grass',
        type2: 'grass',
    },
    183: {
        id: 183,
        type1: 'water',
        type2: 'fairy',
    },
    184: {
        id: 184,
        type1: 'water',
        type2: 'fairy',
    },
    185: {
        id: 185,
        type1: 'rock',
        type2: 'rock',
    },
    186: {
        id: 186,
        type1: 'water',
        type2: 'water',
    },
    187: {
        id: 187,
        type1: 'grass',
        type2: 'flying',
    },
    188: {
        id: 188,
        type1: 'grass',
        type2: 'flying',
    },
    189: {
        id: 189,
        type1: 'grass',
        type2: 'flying',
    },
    190: {
        id: 190,
        type1: 'normal',
        type2: 'normal',
    },
    191: {
        id: 191,
        type1: 'grass',
        type2: 'grass',
    },
    192: {
        id: 192,
        type1: 'grass',
        type2: 'grass',
    },
    193: {
        id: 193,
        type1: 'bug',
        type2: 'flying',
    },
    194: {
        id: 194,
        type1: 'water',
        type2: 'ground',
    },
    195: {
        id: 195,
        type1: 'water',
        type2: 'ground',
    },
    196: {
        id: 196,
        type1: 'psychic',
        type2: 'psychic',
    },
    197: {
        id: 197,
        type1: 'dark',
        type2: 'dark',
    },
    198: {
        id: 198,
        type1: 'dark',
        type2: 'flying',
    },
    199: {
        id: 199,
        type1: 'water',
        type2: 'psychic',
    },
    200: {
        id: 200,
        type1: 'ghost',
        type2: 'ghost',
    },
    201: {
        id: 201,
        type1: 'psychic',
        type2: 'psychic',
    },
    202: {
        id: 202,
        type1: 'psychic',
        type2: 'psychic',
    },
    203: {
        id: 203,
        type1: 'normal',
        type2: 'psychic',
    },
    204: {
        id: 204,
        type1: 'bug',
        type2: 'bug',
    },
    205: {
        id: 205,
        type1: 'bug',
        type2: 'steel',
    },
    206: {
        id: 206,
        type1: 'normal',
        type2: 'normal',
    },
    207: {
        id: 207,
        type1: 'ground',
        type2: 'flying',
    },
    208: {
        id: 208,
        type1: 'steel',
        type2: 'ground',
    },
    209: {
        id: 209,
        type1: 'fairy',
        type2: 'fairy',
    },
    210: {
        id: 210,
        type1: 'fairy',
        type2: 'fairy',
    },
    211: {
        id: 211,
        type1: 'water',
        type2: 'poison',
    },
    212: {
        id: 212,
        type1: 'bug',
        type2: 'steel',
    },
    213: {
        id: 213,
        type1: 'bug',
        type2: 'rock',
    },
    214: {
        id: 214,
        type1: 'bug',
        type2: 'fighting',
    },
    215: {
        id: 215,
        type1: 'dark',
        type2: 'ice',
    },
    216: {
        id: 216,
        type1: 'normal',
        type2: 'normal',
    },
    217: {
        id: 217,
        type1: 'normal',
        type2: 'normal',
    },
    218: {
        id: 218,
        type1: 'fire',
        type2: 'fire',
    },
    219: {
        id: 219,
        type1: 'fire',
        type2: 'rock',
    },
    220: {
        id: 220,
        type1: 'ice',
        type2: 'ground',
    },
    221: {
        id: 221,
        type1: 'ice',
        type2: 'ground',
    },
    222: {
        id: 222,
        type1: 'water',
        type2: 'rock',
    },
    223: {
        id: 223,
        type1: 'water',
        type2: 'water',
    },
    224: {
        id: 224,
        type1: 'water',
        type2: 'water',
    },
    225: {
        id: 225,
        type1: 'ice',
        type2: 'flying',
    },
    226: {
        id: 226,
        type1: 'water',
        type2: 'flying',
    },
    227: {
        id: 227,
        type1: 'steel',
        type2: 'flying',
    },
    228: {
        id: 228,
        type1: 'dark',
        type2: 'fire',
    },
    229: {
        id: 229,
        type1: 'dark',
        type2: 'fire',
    },
    230: {
        id: 230,
        type1: 'water',
        type2: 'dragon',
    },
    231: {
        id: 231,
        type1: 'ground',
        type2: 'ground',
    },
    232: {
        id: 232,
        type1: 'ground',
        type2: 'ground',
    },
    233: {
        id: 233,
        type1: 'normal',
        type2: 'normal',
    },
    234: {
        id: 234,
        type1: 'normal',
        type2: 'normal',
    },
    235: {
        id: 235,
        type1: 'normal',
        type2: 'normal',
    },
    236: {
        id: 236,
        type1: 'fighting',
        type2: 'fighting',
    },
    237: {
        id: 237,
        type1: 'fighting',
        type2: 'fighting',
    },
    238: {
        id: 238,
        type1: 'ice',
        type2: 'psychic',
    },
    239: {
        id: 239,
        type1: 'electric',
        type2: 'electric',
    },
    240: {
        id: 240,
        type1: 'fire',
        type2: 'fire',
    },
    241: {
        id: 241,
        type1: 'normal',
        type2: 'normal',
    },
    242: {
        id: 242,
        type1: 'normal',
        type2: 'normal',
    },
    243: {
        id: 243,
        type1: 'electric',
        type2: 'electric',
    },
    244: {
        id: 244,
        type1: 'fire',
        type2: 'fire',
    },
    245: {
        id: 245,
        type1: 'water',
        type2: 'water',
    },
    246: {
        id: 246,
        type1: 'rock',
        type2: 'ground',
    },
    247: {
        id: 247,
        type1: 'rock',
        type2: 'ground',
    },
    248: {
        id: 248,
        type1: 'rock',
        type2: 'dark',
    },
    249: {
        id: 249,
        type1: 'psychic',
        type2: 'flying',
    },
    250: {
        id: 250,
        type1: 'fire',
        type2: 'flying',
    },
    251: {
        id: 251,
        type1: 'psychic',
        type2: 'grass',
    },
    252: {
        id: 252,
        type1: 'grass',
        type2: 'grass',
    },
    253: {
        id: 253,
        type1: 'grass',
        type2: 'grass',
    },
    254: {
        id: 254,
        type1: 'grass',
        type2: 'grass',
    },
    255: {
        id: 255,
        type1: 'fire',
        type2: 'fire',
    },
    256: {
        id: 256,
        type1: 'fire',
        type2: 'fighting',
    },
    257: {
        id: 257,
        type1: 'fire',
        type2: 'fighting',
    },
    258: {
        id: 258,
        type1: 'water',
        type2: 'water',
    },
    259: {
        id: 259,
        type1: 'water',
        type2: 'ground',
    },
    260: {
        id: 260,
        type1: 'water',
        type2: 'ground',
    },
    261: {
        id: 261,
        type1: 'dark',
        type2: 'dark',
    },
    262: {
        id: 262,
        type1: 'dark',
        type2: 'dark',
    },
    263: {
        id: 263,
        type1: 'normal',
        type2: 'normal',
    },
    264: {
        id: 264,
        type1: 'normal',
        type2: 'normal',
    },
    265: {
        id: 265,
        type1: 'bug',
        type2: 'bug',
    },
    266: {
        id: 266,
        type1: 'bug',
        type2: 'bug',
    },
    267: {
        id: 267,
        type1: 'bug',
        type2: 'flying',
    },
    268: {
        id: 268,
        type1: 'bug',
        type2: 'bug',
    },
    269: {
        id: 269,
        type1: 'bug',
        type2: 'poison',
    },
    270: {
        id: 270,
        type1: 'water',
        type2: 'grass',
    },
    271: {
        id: 271,
        type1: 'water',
        type2: 'grass',
    },
    272: {
        id: 272,
        type1: 'water',
        type2: 'grass',
    },
    273: {
        id: 273,
        type1: 'grass',
        type2: 'grass',
    },
    274: {
        id: 274,
        type1: 'grass',
        type2: 'dark',
    },
    275: {
        id: 275,
        type1: 'grass',
        type2: 'dark',
    },
    276: {
        id: 276,
        type1: 'normal',
        type2: 'flying',
    },
    277: {
        id: 277,
        type1: 'normal',
        type2: 'flying',
    },
    278: {
        id: 278,
        type1: 'water',
        type2: 'flying',
    },
    279: {
        id: 279,
        type1: 'water',
        type2: 'flying',
    },
    280: {
        id: 280,
        type1: 'psychic',
        type2: 'fairy',
    },
    281: {
        id: 281,
        type1: 'psychic',
        type2: 'fairy',
    },
    282: {
        id: 282,
        type1: 'psychic',
        type2: 'fairy',
    },
    283: {
        id: 283,
        type1: 'bug',
        type2: 'water',
    },
    284: {
        id: 284,
        type1: 'bug',
        type2: 'flying',
    },
    285: {
        id: 285,
        type1: 'grass',
        type2: 'grass',
    },
    286: {
        id: 286,
        type1: 'grass',
        type2: 'fighting',
    },
    287: {
        id: 287,
        type1: 'normal',
        type2: 'normal',
    },
    288: {
        id: 288,
        type1: 'normal',
        type2: 'normal',
    },
    289: {
        id: 289,
        type1: 'normal',
        type2: 'normal',
    },
    290: {
        id: 290,
        type1: 'bug',
        type2: 'ground',
    },
    291: {
        id: 291,
        type1: 'bug',
        type2: 'flying',
    },
    292: {
        id: 292,
        type1: 'bug',
        type2: 'ghost',
    },
    293: {
        id: 293,
        type1: 'normal',
        type2: 'normal',
    },
    294: {
        id: 294,
        type1: 'normal',
        type2: 'normal',
    },
    295: {
        id: 295,
        type1: 'normal',
        type2: 'normal',
    },
    296: {
        id: 296,
        type1: 'fighting',
        type2: 'fighting',
    },
    297: {
        id: 297,
        type1: 'fighting',
        type2: 'fighting',
    },
    298: {
        id: 298,
        type1: 'normal',
        type2: 'fairy',
    },
    299: {
        id: 299,
        type1: 'rock',
        type2: 'rock',
    },
    300: {
        id: 300,
        type1: 'normal',
        type2: 'normal',
    },
    301: {
        id: 301,
        type1: 'normal',
        type2: 'normal',
    },
    302: {
        id: 302,
        type1: 'dark',
        type2: 'ghost',
    },
    303: {
        id: 303,
        type1: 'steel',
        type2: 'fairy',
    },
    304: {
        id: 304,
        type1: 'steel',
        type2: 'rock',
    },
    305: {
        id: 305,
        type1: 'steel',
        type2: 'rock',
    },
    306: {
        id: 306,
        type1: 'steel',
        type2: 'rock',
    },
    307: {
        id: 307,
        type1: 'fighting',
        type2: 'psychic',
    },
    308: {
        id: 308,
        type1: 'fighting',
        type2: 'psychic',
    },
    309: {
        id: 309,
        type1: 'electric',
        type2: 'electric',
    },
    310: {
        id: 310,
        type1: 'electric',
        type2: 'electric',
    },
    311: {
        id: 311,
        type1: 'electric',
        type2: 'electric',
    },
    312: {
        id: 312,
        type1: 'electric',
        type2: 'electric',
    },
    313: {
        id: 313,
        type1: 'bug',
        type2: 'bug',
    },
    314: {
        id: 314,
        type1: 'bug',
        type2: 'bug',
    },
    315: {
        id: 315,
        type1: 'grass',
        type2: 'poison',
    },
    316: {
        id: 316,
        type1: 'poison',
        type2: 'poison',
    },
    317: {
        id: 317,
        type1: 'poison',
        type2: 'poison',
    },
    318: {
        id: 318,
        type1: 'water',
        type2: 'dark',
    },
    319: {
        id: 319,
        type1: 'water',
        type2: 'dark',
    },
    320: {
        id: 320,
        type1: 'water',
        type2: 'water',
    },
    321: {
        id: 321,
        type1: 'water',
        type2: 'water',
    },
    322: {
        id: 322,
        type1: 'fire',
        type2: 'ground',
    },
    323: {
        id: 323,
        type1: 'fire',
        type2: 'ground',
    },
    324: {
        id: 324,
        type1: 'fire',
        type2: 'fire',
    },
    325: {
        id: 325,
        type1: 'psychic',
        type2: 'psychic',
    },
    326: {
        id: 326,
        type1: 'psychic',
        type2: 'psychic',
    },
    327: {
        id: 327,
        type1: 'normal',
        type2: 'normal',
    },
    328: {
        id: 328,
        type1: 'ground',
        type2: 'ground',
    },
    329: {
        id: 329,
        type1: 'ground',
        type2: 'dragon',
    },
    330: {
        id: 330,
        type1: 'ground',
        type2: 'dragon',
    },
    331: {
        id: 331,
        type1: 'grass',
        type2: 'grass',
    },
    332: {
        id: 332,
        type1: 'grass',
        type2: 'dark',
    },
    333: {
        id: 333,
        type1: 'normal',
        type2: 'flying',
    },
    334: {
        id: 334,
        type1: 'dragon',
        type2: 'flying',
    },
    335: {
        id: 335,
        type1: 'normal',
        type2: 'normal',
    },
    336: {
        id: 336,
        type1: 'poison',
        type2: 'poison',
    },
    337: {
        id: 337,
        type1: 'rock',
        type2: 'psychic',
    },
    338: {
        id: 338,
        type1: 'rock',
        type2: 'psychic',
    },
    339: {
        id: 339,
        type1: 'water',
        type2: 'ground',
    },
    340: {
        id: 340,
        type1: 'water',
        type2: 'ground',
    },
    341: {
        id: 341,
        type1: 'water',
        type2: 'water',
    },
    342: {
        id: 342,
        type1: 'water',
        type2: 'dark',
    },
    343: {
        id: 343,
        type1: 'ground',
        type2: 'psychic',
    },
    344: {
        id: 344,
        type1: 'ground',
        type2: 'psychic',
    },
    345: {
        id: 345,
        type1: 'rock',
        type2: 'grass',
    },
    346: {
        id: 346,
        type1: 'rock',
        type2: 'grass',
    },
    347: {
        id: 347,
        type1: 'rock',
        type2: 'bug',
    },
    348: {
        id: 348,
        type1: 'rock',
        type2: 'bug',
    },
    349: {
        id: 349,
        type1: 'water',
        type2: 'water',
    },
    350: {
        id: 350,
        type1: 'water',
        type2: 'water',
    },
    351: {
        id: 351,
        type1: 'normal',
        type2: 'normal',
    },
    352: {
        id: 352,
        type1: 'normal',
        type2: 'normal',
    },
    353: {
        id: 353,
        type1: 'ghost',
        type2: 'ghost',
    },
    354: {
        id: 354,
        type1: 'ghost',
        type2: 'ghost',
    },
    355: {
        id: 355,
        type1: 'ghost',
        type2: 'ghost',
    },
    356: {
        id: 356,
        type1: 'ghost',
        type2: 'ghost',
    },
    357: {
        id: 357,
        type1: 'grass',
        type2: 'flying',
    },
    358: {
        id: 358,
        type1: 'psychic',
        type2: 'psychic',
    },
    359: {
        id: 359,
        type1: 'dark',
        type2: 'dark',
    },
    360: {
        id: 360,
        type1: 'psychic',
        type2: 'psychic',
    },
    361: {
        id: 361,
        type1: 'ice',
        type2: 'ice',
    },
    362: {
        id: 362,
        type1: 'ice',
        type2: 'ice',
    },
    363: {
        id: 363,
        type1: 'ice',
        type2: 'water',
    },
    364: {
        id: 364,
        type1: 'ice',
        type2: 'water',
    },
    365: {
        id: 365,
        type1: 'ice',
        type2: 'water',
    },
    366: {
        id: 366,
        type1: 'water',
        type2: 'water',
    },
    367: {
        id: 367,
        type1: 'water',
        type2: 'water',
    },
    368: {
        id: 368,
        type1: 'water',
        type2: 'water',
    },
    369: {
        id: 369,
        type1: 'water',
        type2: 'rock',
    },
    370: {
        id: 370,
        type1: 'water',
        type2: 'water',
    },
    371: {
        id: 371,
        type1: 'dragon',
        type2: 'dragon',
    },
    372: {
        id: 372,
        type1: 'dragon',
        type2: 'dragon',
    },
    373: {
        id: 373,
        type1: 'dragon',
        type2: 'flying',
    },
    374: {
        id: 374,
        type1: 'steel',
        type2: 'psychic',
    },
    375: {
        id: 375,
        type1: 'steel',
        type2: 'psychic',
    },
    376: {
        id: 376,
        type1: 'steel',
        type2: 'psychic',
    },
    377: {
        id: 377,
        type1: 'rock',
        type2: 'rock',
    },
    378: {
        id: 378,
        type1: 'ice',
        type2: 'ice',
    },
    379: {
        id: 379,
        type1: 'steel',
        type2: 'steel',
    },
    380: {
        id: 380,
        type1: 'dragon',
        type2: 'psychic',
    },
    381: {
        id: 381,
        type1: 'dragon',
        type2: 'psychic',
    },
    382: {
        id: 382,
        type1: 'water',
        type2: 'water',
    },
    383: {
        id: 383,
        type1: 'ground',
        type2: 'ground',
    },
    384: {
        id: 384,
        type1: 'dragon',
        type2: 'flying',
    },
    385: {
        id: 385,
        type1: 'steel',
        type2: 'psychic',
    },
    386: {
        id: 386,
        type1: 'psychic',
        type2: 'psychic',
    },
    387: {
        id: 387,
        type1: 'normal',
        type2: 'normal',
    },
    388: {
        id: 388,
        type1: 'grass',
        type2: 'poison',
    },
    389: {
        id: 389,
        type1: 'grass',
        type2: 'ground',
    },
    390: {
        id: 390,
        type1: 'fire',
        type2: 'fire',
    },
    391: {
        id: 391,
        type1: 'fire',
        type2: 'fighting',
    },
    392: {
        id: 392,
        type1: 'fire',
        type2: 'fighting',
    },
    393: {
        id: 393,
        type1: 'water',
        type2: 'water',
    },
    394: {
        id: 394,
        type1: 'water',
        type2: 'water',
    },
    395: {
        id: 395,
        type1: 'water',
        type2: 'steel',
    },
    396: {
        id: 396,
        type1: 'normal',
        type2: 'flying',
    },
    397: {
        id: 397,
        type1: 'normal',
        type2: 'flying',
    },
    398: {
        id: 398,
        type1: 'normal',
        type2: 'flying',
    },
    399: {
        id: 399,
        type1: 'normal',
        type2: 'normal',
    },
    400: {
        id: 400,
        type1: 'normal',
        type2: 'water',
    },
    401: {
        id: 401,
        type1: 'bug',
        type2: 'bug',
    },
    402: {
        id: 402,
        type1: 'bug',
        type2: 'bug',
    },
    403: {
        id: 403,
        type1: 'electric',
        type2: 'electric',
    },
    404: {
        id: 404,
        type1: 'electric',
        type2: 'electric',
    },
    405: {
        id: 405,
        type1: 'electric',
        type2: 'electric',
    },
    406: {
        id: 406,
        type1: 'grass',
        type2: 'poison',
    },
    407: {
        id: 407,
        type1: 'grass',
        type2: 'poison',
    },
    408: {
        id: 408,
        type1: 'rock',
        type2: 'rock',
    },
    409: {
        id: 409,
        type1: 'rock',
        type2: 'rock',
    },
    410: {
        id: 410,
        type1: 'rock',
        type2: 'steel',
    },
    411: {
        id: 411,
        type1: 'rock',
        type2: 'steel',
    },
    412: {
        id: 412,
        type1: 'bug',
        type2: 'bug',
    },
    413: {
        id: 413,
        type1: 'bug',
        type2: 'grass',
    },
    414: {
        id: 414,
        type1: 'bug',
        type2: 'flying',
    },
    415: {
        id: 415,
        type1: 'bug',
        type2: 'flying',
    },
    416: {
        id: 416,
        type1: 'bug',
        type2: 'flying',
    },
    417: {
        id: 417,
        type1: 'electric',
        type2: 'electric',
    },
    418: {
        id: 418,
        type1: 'water',
        type2: 'water',
    },
    419: {
        id: 419,
        type1: 'water',
        type2: 'water',
    },
    420: {
        id: 420,
        type1: 'grass',
        type2: 'grass',
    },
    421: {
        id: 421,
        type1: 'grass',
        type2: 'grass',
    },
    422: {
        id: 422,
        type1: 'water',
        type2: 'water',
    },
    423: {
        id: 423,
        type1: 'water',
        type2: 'ground',
    },
    424: {
        id: 424,
        type1: 'normal',
        type2: 'normal',
    },
    425: {
        id: 425,
        type1: 'ghost',
        type2: 'flying',
    },
    426: {
        id: 426,
        type1: 'ghost',
        type2: 'flying',
    },
    427: {
        id: 427,
        type1: 'normal',
        type2: 'normal',
    },
    428: {
        id: 428,
        type1: 'normal',
        type2: 'normal',
    },
    429: {
        id: 429,
        type1: 'ghost',
        type2: 'ghost',
    },
    430: {
        id: 430,
        type1: 'dark',
        type2: 'flying',
    },
    431: {
        id: 431,
        type1: 'normal',
        type2: 'normal',
    },
    432: {
        id: 432,
        type1: 'normal',
        type2: 'normal',
    },
    433: {
        id: 433,
        type1: 'psychic',
        type2: 'psychic',
    },
    434: {
        id: 434,
        type1: 'poison',
        type2: 'dark',
    },
    435: {
        id: 435,
        type1: 'poison',
        type2: 'dark',
    },
    436: {
        id: 436,
        type1: 'steel',
        type2: 'psychic',
    },
    437: {
        id: 437,
        type1: 'steel',
        type2: 'psychic',
    },
    438: {
        id: 438,
        type1: 'rock',
        type2: 'rock',
    },
    439: {
        id: 439,
        type1: 'psychic',
        type2: 'fairy',
    },
    440: {
        id: 440,
        type1: 'normal',
        type2: 'normal',
    },
    441: {
        id: 441,
        type1: 'normal',
        type2: 'flying',
    },
    442: {
        id: 442,
        type1: 'ghost',
        type2: 'dark',
    },
    443: {
        id: 443,
        type1: 'dragon',
        type2: 'ground',
    },
    444: {
        id: 444,
        type1: 'dragon',
        type2: 'ground',
    },
    445: {
        id: 445,
        type1: 'dragon',
        type2: 'ground',
    },
    446: {
        id: 446,
        type1: 'normal',
        type2: 'normal',
    },
    447: {
        id: 447,
        type1: 'fighting',
        type2: 'fighting',
    },
    448: {
        id: 448,
        type1: 'fighting',
        type2: 'steel',
    },
    449: {
        id: 449,
        type1: 'ground',
        type2: 'ground',
    },
    450: {
        id: 450,
        type1: 'ground',
        type2: 'ground',
    },
    451: {
        id: 451,
        type1: 'poison',
        type2: 'bug',
    },
    452: {
        id: 452,
        type1: 'poison',
        type2: 'dark',
    },
    453: {
        id: 453,
        type1: 'poison',
        type2: 'fighting',
    },
    454: {
        id: 454,
        type1: 'poison',
        type2: 'fighting',
    },
    455: {
        id: 455,
        type1: 'grass',
        type2: 'grass',
    },
    456: {
        id: 456,
        type1: 'water',
        type2: 'water',
    },
    457: {
        id: 457,
        type1: 'water',
        type2: 'water',
    },
    458: {
        id: 458,
        type1: 'water',
        type2: 'flying',
    },
    459: {
        id: 459,
        type1: 'grass',
        type2: 'ice',
    },
    460: {
        id: 460,
        type1: 'grass',
        type2: 'ice',
    },
    461: {
        id: 461,
        type1: 'dark',
        type2: 'ice',
    },
    462: {
        id: 462,
        type1: 'electric',
        type2: 'steel',
    },
    463: {
        id: 463,
        type1: 'normal',
        type2: 'normal',
    },
    464: {
        id: 464,
        type1: 'ground',
        type2: 'rock',
    },
    465: {
        id: 465,
        type1: 'grass',
        type2: 'grass',
    },
    466: {
        id: 466,
        type1: 'electric',
        type2: 'electric',
    },
    467: {
        id: 467,
        type1: 'fire',
        type2: 'fire',
    },
    468: {
        id: 468,
        type1: 'fairy',
        type2: 'flying',
    },
    469: {
        id: 469,
        type1: 'bug',
        type2: 'flying',
    },
    470: {
        id: 470,
        type1: 'grass',
        type2: 'grass',
    },
    471: {
        id: 471,
        type1: 'ice',
        type2: 'ice',
    },
    472: {
        id: 472,
        type1: 'ground',
        type2: 'flying',
    },
    473: {
        id: 473,
        type1: 'ice',
        type2: 'ground',
    },
    474: {
        id: 474,
        type1: 'normal',
        type2: 'normal',
    },
    475: {
        id: 475,
        type1: 'psychic',
        type2: 'fighting',
    },
    476: {
        id: 476,
        type1: 'rock',
        type2: 'steel',
    },
    477: {
        id: 477,
        type1: 'ghost',
        type2: 'ghost',
    },
    478: {
        id: 478,
        type1: 'ice',
        type2: 'ghost',
    },
    479: {
        id: 479,
        type1: 'electric',
        type2: 'ghost',
    },
    480: {
        id: 480,
        type1: 'psychic',
        type2: 'psychic',
    },
    481: {
        id: 481,
        type1: 'psychic',
        type2: 'psychic',
    },
    482: {
        id: 482,
        type1: 'psychic',
        type2: 'psychic',
    },
    483: {
        id: 483,
        type1: 'steel',
        type2: 'dragon',
    },
    484: {
        id: 484,
        type1: 'water',
        type2: 'dragon',
    },
    485: {
        id: 485,
        type1: 'fire',
        type2: 'steel',
    },
    486: {
        id: 486,
        type1: 'normal',
        type2: 'normal',
    },
    487: {
        id: 487,
        type1: 'ghost',
        type2: 'dragon',
    },
    488: {
        id: 488,
        type1: 'psychic',
        type2: 'psychic',
    },
    489: {
        id: 489,
        type1: 'water',
        type2: 'water',
    },
    490: {
        id: 490,
        type1: 'water',
        type2: 'water',
    },
    491: {
        id: 491,
        type1: 'dark',
        type2: 'dark',
    },
    492: {
        id: 492,
        type1: 'grass',
        type2: 'grass',
    },
    493: {
        id: 493,
        type1: 'normal',
        type2: 'normal',
    },
    494: {
        id: 494,
        type1: 'psychic',
        type2: 'fire',
    },
    495: {
        id: 495,
        type1: 'grass',
        type2: 'grass',
    },
    496: {
        id: 496,
        type1: 'grass',
        type2: 'grass',
    },
    497: {
        id: 497,
        type1: 'grass',
        type2: 'grass',
    },
    498: {
        id: 498,
        type1: 'fire',
        type2: 'fire',
    },
    499: {
        id: 499,
        type1: 'fire',
        type2: 'fighting',
    },
    500: {
        id: 500,
        type1: 'fire',
        type2: 'fighting',
    },
    501: {
        id: 501,
        type1: 'water',
        type2: 'water',
    },
    502: {
        id: 502,
        type1: 'water',
        type2: 'water',
    },
    503: {
        id: 503,
        type1: 'water',
        type2: 'water',
    },
    504: {
        id: 504,
        type1: 'normal',
        type2: 'normal',
    },
    505: {
        id: 505,
        type1: 'normal',
        type2: 'normal',
    },
    506: {
        id: 506,
        type1: 'normal',
        type2: 'normal',
    },
    507: {
        id: 507,
        type1: 'normal',
        type2: 'normal',
    },
    508: {
        id: 508,
        type1: 'normal',
        type2: 'normal',
    },
    509: {
        id: 509,
        type1: 'dark',
        type2: 'dark',
    },
    510: {
        id: 510,
        type1: 'dark',
        type2: 'dark',
    },
    511: {
        id: 511,
        type1: 'grass',
        type2: 'grass',
    },
    512: {
        id: 512,
        type1: 'grass',
        type2: 'grass',
    },
    513: {
        id: 513,
        type1: 'fire',
        type2: 'fire',
    },
    514: {
        id: 514,
        type1: 'fire',
        type2: 'fire',
    },
    515: {
        id: 515,
        type1: 'water',
        type2: 'water',
    },
    516: {
        id: 516,
        type1: 'water',
        type2: 'water',
    },
    517: {
        id: 517,
        type1: 'psychic',
        type2: 'psychic',
    },
    518: {
        id: 518,
        type1: 'psychic',
        type2: 'psychic',
    },
    519: {
        id: 519,
        type1: 'normal',
        type2: 'flying',
    },
    520: {
        id: 520,
        type1: 'normal',
        type2: 'flying',
    },
    521: {
        id: 521,
        type1: 'normal',
        type2: 'flying',
    },
    522: {
        id: 522,
        type1: 'electric',
        type2: 'electric',
    },
    523: {
        id: 523,
        type1: 'electric',
        type2: 'electric',
    },
    524: {
        id: 524,
        type1: 'rock',
        type2: 'rock',
    },
    525: {
        id: 525,
        type1: 'rock',
        type2: 'rock',
    },
    526: {
        id: 526,
        type1: 'rock',
        type2: 'rock',
    },
    527: {
        id: 527,
        type1: 'psychic',
        type2: 'flying',
    },
    528: {
        id: 528,
        type1: 'psychic',
        type2: 'flying',
    },
    529: {
        id: 529,
        type1: 'ground',
        type2: 'ground',
    },
    530: {
        id: 530,
        type1: 'ground',
        type2: 'steel',
    },
    531: {
        id: 531,
        type1: 'normal',
        type2: 'normal',
    },
    532: {
        id: 532,
        type1: 'fighting',
        type2: 'fighting',
    },
    533: {
        id: 533,
        type1: 'fighting',
        type2: 'fighting',
    },
    534: {
        id: 534,
        type1: 'fighting',
        type2: 'fighting',
    },
    535: {
        id: 535,
        type1: 'water',
        type2: 'water',
    },
    536: {
        id: 536,
        type1: 'water',
        type2: 'ground',
    },
    537: {
        id: 537,
        type1: 'water',
        type2: 'ground',
    },
    538: {
        id: 538,
        type1: 'fighting',
        type2: 'fighting',
    },
    539: {
        id: 539,
        type1: 'fighting',
        type2: 'fighting',
    },
    540: {
        id: 540,
        type1: 'bug',
        type2: 'grass',
    },
    541: {
        id: 541,
        type1: 'bug',
        type2: 'grass',
    },
    542: {
        id: 542,
        type1: 'bug',
        type2: 'grass',
    },
    543: {
        id: 543,
        type1: 'bug',
        type2: 'poison',
    },
    544: {
        id: 544,
        type1: 'bug',
        type2: 'poison',
    },
    545: {
        id: 545,
        type1: 'bug',
        type2: 'poison',
    },
    546: {
        id: 546,
        type1: 'grass',
        type2: 'fairy',
    },
    547: {
        id: 547,
        type1: 'grass',
        type2: 'fairy',
    },
    548: {
        id: 548,
        type1: 'grass',
        type2: 'grass',
    },
    549: {
        id: 549,
        type1: 'grass',
        type2: 'grass',
    },
    550: {
        id: 550,
        type1: 'water',
        type2: 'water',
    },
    551: {
        id: 551,
        type1: 'ground',
        type2: 'dark',
    },
    552: {
        id: 552,
        type1: 'ground',
        type2: 'dark',
    },
    553: {
        id: 553,
        type1: 'ground',
        type2: 'dark',
    },
    554: {
        id: 554,
        type1: 'fire',
        type2: 'fire',
    },
    555: {
        id: 555,
        type1: 'fire',
        type2: 'fire',
    },
    556: {
        id: 556,
        type1: 'grass',
        type2: 'grass',
    },
    557: {
        id: 557,
        type1: 'bug',
        type2: 'rock',
    },
    558: {
        id: 558,
        type1: 'bug',
        type2: 'rock',
    },
    559: {
        id: 559,
        type1: 'dark',
        type2: 'fighting',
    },
    560: {
        id: 560,
        type1: 'dark',
        type2: 'fighting',
    },
    561: {
        id: 561,
        type1: 'psychic',
        type2: 'flying',
    },
    562: {
        id: 562,
        type1: 'ghost',
        type2: 'ghost',
    },
    563: {
        id: 563,
        type1: 'ghost',
        type2: 'ghost',
    },
    564: {
        id: 564,
        type1: 'water',
        type2: 'rock',
    },
    565: {
        id: 565,
        type1: 'water',
        type2: 'rock',
    },
    566: {
        id: 566,
        type1: 'rock',
        type2: 'flying',
    },
    567: {
        id: 567,
        type1: 'rock',
        type2: 'flying',
    },
    568: {
        id: 568,
        type1: 'poison',
        type2: 'poison',
    },
    569: {
        id: 569,
        type1: 'poison',
        type2: 'poison',
    },
    570: {
        id: 570,
        type1: 'dark',
        type2: 'dark',
    },
    571: {
        id: 571,
        type1: 'dark',
        type2: 'dark',
    },
    572: {
        id: 572,
        type1: 'normal',
        type2: 'normal',
    },
    573: {
        id: 573,
        type1: 'normal',
        type2: 'normal',
    },
    574: {
        id: 574,
        type1: 'psychic',
        type2: 'psychic',
    },
    575: {
        id: 575,
        type1: 'psychic',
        type2: 'psychic',
    },
    576: {
        id: 576,
        type1: 'psychic',
        type2: 'psychic',
    },
    577: {
        id: 577,
        type1: 'psychic',
        type2: 'psychic',
    },
    578: {
        id: 578,
        type1: 'psychic',
        type2: 'psychic',
    },
    579: {
        id: 579,
        type1: 'psychic',
        type2: 'psychic',
    },
    580: {
        id: 580,
        type1: 'water',
        type2: 'flying',
    },
    581: {
        id: 581,
        type1: 'water',
        type2: 'flying',
    },
    582: {
        id: 582,
        type1: 'ice',
        type2: 'ice',
    },
    583: {
        id: 583,
        type1: 'ice',
        type2: 'ice',
    },
    584: {
        id: 584,
        type1: 'ice',
        type2: 'ice',
    },
    585: {
        id: 585,
        type1: 'normal',
        type2: 'grass',
    },
    586: {
        id: 586,
        type1: 'normal',
        type2: 'grass',
    },
    587: {
        id: 587,
        type1: 'electric',
        type2: 'flying',
    },
    588: {
        id: 588,
        type1: 'bug',
        type2: 'bug',
    },
    589: {
        id: 589,
        type1: 'bug',
        type2: 'steel',
    },
    590: {
        id: 590,
        type1: 'grass',
        type2: 'poison',
    },
    591: {
        id: 591,
        type1: 'grass',
        type2: 'poison',
    },
    592: {
        id: 592,
        type1: 'water',
        type2: 'ghost',
    },
    593: {
        id: 593,
        type1: 'water',
        type2: 'ghost',
    },
    594: {
        id: 594,
        type1: 'water',
        type2: 'water',
    },
    595: {
        id: 595,
        type1: 'bug',
        type2: 'electric',
    },
    596: {
        id: 596,
        type1: 'bug',
        type2: 'electric',
    },
    597: {
        id: 597,
        type1: 'grass',
        type2: 'steel',
    },
    598: {
        id: 598,
        type1: 'grass',
        type2: 'steel',
    },
    599: {
        id: 599,
        type1: 'steel',
        type2: 'steel',
    },
    600: {
        id: 600,
        type1: 'steel',
        type2: 'steel',
    },
    601: {
        id: 601,
        type1: 'steel',
        type2: 'steel',
    },
    602: {
        id: 602,
        type1: 'electric',
        type2: 'electric',
    },
    603: {
        id: 603,
        type1: 'electric',
        type2: 'electric',
    },
    604: {
        id: 604,
        type1: 'electric',
        type2: 'electric',
    },
    605: {
        id: 605,
        type1: 'psychic',
        type2: 'psychic',
    },
    606: {
        id: 606,
        type1: 'psychic',
        type2: 'psychic',
    },
    607: {
        id: 607,
        type1: 'ghost',
        type2: 'fire',
    },
    608: {
        id: 608,
        type1: 'ghost',
        type2: 'fire',
    },
    609: {
        id: 609,
        type1: 'ghost',
        type2: 'fire',
    },
    610: {
        id: 610,
        type1: 'dragon',
        type2: 'dragon',
    },
    611: {
        id: 611,
        type1: 'dragon',
        type2: 'dragon',
    },
    612: {
        id: 612,
        type1: 'dragon',
        type2: 'dragon',
    },
    613: {
        id: 613,
        type1: 'ice',
        type2: 'ice',
    },
    614: {
        id: 614,
        type1: 'ice',
        type2: 'ice',
    },
    615: {
        id: 615,
        type1: 'ice',
        type2: 'ice',
    },
    616: {
        id: 616,
        type1: 'bug',
        type2: 'bug',
    },
    617: {
        id: 617,
        type1: 'bug',
        type2: 'bug',
    },
    618: {
        id: 618,
        type1: 'ground',
        type2: 'electric',
    },
    619: {
        id: 619,
        type1: 'fighting',
        type2: 'fighting',
    },
    620: {
        id: 620,
        type1: 'fighting',
        type2: 'fighting',
    },
    621: {
        id: 621,
        type1: 'dragon',
        type2: 'dragon',
    },
    622: {
        id: 622,
        type1: 'ground',
        type2: 'ghost',
    },
    623: {
        id: 623,
        type1: 'ground',
        type2: 'ghost',
    },
    624: {
        id: 624,
        type1: 'dark',
        type2: 'steel',
    },
    625: {
        id: 625,
        type1: 'dark',
        type2: 'steel',
    },
    626: {
        id: 626,
        type1: 'normal',
        type2: 'normal',
    },
    627: {
        id: 627,
        type1: 'normal',
        type2: 'flying',
    },
    628: {
        id: 628,
        type1: 'normal',
        type2: 'flying',
    },
    629: {
        id: 629,
        type1: 'dark',
        type2: 'flying',
    },
    630: {
        id: 630,
        type1: 'dark',
        type2: 'flying',
    },
    631: {
        id: 631,
        type1: 'fire',
        type2: 'fire',
    },
    632: {
        id: 632,
        type1: 'bug',
        type2: 'steel',
    },
    633: {
        id: 633,
        type1: 'dark',
        type2: 'dragon',
    },
    634: {
        id: 634,
        type1: 'dark',
        type2: 'dragon',
    },
    635: {
        id: 635,
        type1: 'dark',
        type2: 'dragon',
    },
    636: {
        id: 636,
        type1: 'bug',
        type2: 'fire',
    },
    637: {
        id: 637,
        type1: 'bug',
        type2: 'fire',
    },
    638: {
        id: 638,
        type1: 'steel',
        type2: 'fighting',
    },
    639: {
        id: 639,
        type1: 'rock',
        type2: 'fighting',
    },
    640: {
        id: 640,
        type1: 'grass',
        type2: 'fighting',
    },
    641: {
        id: 641,
        type1: 'flying',
        type2: 'flying',
    },
    642: {
        id: 642,
        type1: 'electric',
        type2: 'flying',
    },
    643: {
        id: 643,
        type1: 'dragon',
        type2: 'fire',
    },
    644: {
        id: 644,
        type1: 'dragon',
        type2: 'electric',
    },
    645: {
        id: 645,
        type1: 'ground',
        type2: 'flying',
    },
    646: {
        id: 646,
        type1: 'dragon',
        type2: 'ice',
    },
    647: {
        id: 647,
        type1: 'water',
        type2: 'fighting',
    },
    648: {
        id: 648,
        type1: 'normal',
        type2: 'psychic',
    },
    649: {
        id: 649,
        type1: 'bug',
        type2: 'steel',
    },
    650: {
        id: 650,
        type1: 'grass',
        type2: 'grass',
    },
    651: {
        id: 651,
        type1: 'grass',
        type2: 'grass',
    },
    652: {
        id: 652,
        type1: 'grass',
        type2: 'fighting',
    },
    653: {
        id: 653,
        type1: 'fire',
        type2: 'fire',
    },
    654: {
        id: 654,
        type1: 'fire',
        type2: 'fire',
    },
    655: {
        id: 655,
        type1: 'fire',
        type2: 'psychic',
    },
    656: {
        id: 656,
        type1: 'water',
        type2: 'water',
    },
    657: {
        id: 657,
        type1: 'water',
        type2: 'water',
    },
    658: {
        id: 658,
        type1: 'water',
        type2: 'dark',
    },
    659: {
        id: 659,
        type1: 'normal',
        type2: 'normal',
    },
    660: {
        id: 660,
        type1: 'normal',
        type2: 'ground',
    },
    661: {
        id: 661,
        type1: 'normal',
        type2: 'flying',
    },
    662: {
        id: 662,
        type1: 'fire',
        type2: 'flying',
    },
    663: {
        id: 663,
        type1: 'fire',
        type2: 'flying',
    },
    664: {
        id: 664,
        type1: 'bug',
        type2: 'bug',
    },
    665: {
        id: 665,
        type1: 'bug',
        type2: 'bug',
    },
    666: {
        id: 666,
        type1: 'bug',
        type2: 'flying',
    },
    667: {
        id: 667,
        type1: 'fire',
        type2: 'normal',
    },
    668: {
        id: 668,
        type1: 'fire',
        type2: 'normal',
    },
    669: {
        id: 669,
        type1: 'fairy',
        type2: 'fairy',
    },
    670: {
        id: 670,
        type1: 'fairy',
        type2: 'fairy',
    },
    671: {
        id: 671,
        type1: 'fairy',
        type2: 'fairy',
    },
    672: {
        id: 672,
        type1: 'grass',
        type2: 'grass',
    },
    673: {
        id: 673,
        type1: 'grass',
        type2: 'grass',
    },
    674: {
        id: 674,
        type1: 'fighting',
        type2: 'fighting',
    },
    675: {
        id: 675,
        type1: 'fighting',
        type2: 'dark',
    },
    676: {
        id: 676,
        type1: 'normal',
        type2: 'normal',
    },
    677: {
        id: 677,
        type1: 'psychic',
        type2: 'psychic',
    },
    678: {
        id: 678,
        type1: 'psychic',
        type2: 'psychic',
    },
    679: {
        id: 679,
        type1: 'steel',
        type2: 'ghost',
    },
    680: {
        id: 680,
        type1: 'steel',
        type2: 'ghost',
    },
    681: {
        id: 681,
        type1: 'steel',
        type2: 'ghost',
    },
    682: {
        id: 682,
        type1: 'fairy',
        type2: 'fairy',
    },
    683: {
        id: 683,
        type1: 'fairy',
        type2: 'fairy',
    },
    684: {
        id: 684,
        type1: 'fairy',
        type2: 'fairy',
    },
    685: {
        id: 685,
        type1: 'fairy',
        type2: 'fairy',
    },
    686: {
        id: 686,
        type1: 'dark',
        type2: 'psychic',
    },
    687: {
        id: 687,
        type1: 'dark',
        type2: 'psychic',
    },
    688: {
        id: 688,
        type1: 'rock',
        type2: 'water',
    },
    689: {
        id: 689,
        type1: 'rock',
        type2: 'water',
    },
    690: {
        id: 690,
        type1: 'poison',
        type2: 'water',
    },
    691: {
        id: 691,
        type1: 'poison',
        type2: 'dragon',
    },
    692: {
        id: 692,
        type1: 'water',
        type2: 'water',
    },
    693: {
        id: 693,
        type1: 'water',
        type2: 'water',
    },
    694: {
        id: 694,
        type1: 'electric',
        type2: 'normal',
    },
    695: {
        id: 695,
        type1: 'electric',
        type2: 'normal',
    },
    696: {
        id: 696,
        type1: 'rock',
        type2: 'dragon',
    },
    697: {
        id: 697,
        type1: 'rock',
        type2: 'dragon',
    },
    698: {
        id: 698,
        type1: 'rock',
        type2: 'ice',
    },
    699: {
        id: 699,
        type1: 'rock',
        type2: 'ice',
    },
    700: {
        id: 700,
        type1: 'fairy',
        type2: 'fairy',
    },
    701: {
        id: 701,
        type1: 'fighting',
        type2: 'flying',
    },
    702: {
        id: 702,
        type1: 'electric',
        type2: 'fairy',
    },
    703: {
        id: 703,
        type1: 'rock',
        type2: 'fairy',
    },
    704: {
        id: 704,
        type1: 'dragon',
        type2: 'dragon',
    },
    705: {
        id: 705,
        type1: 'dragon',
        type2: 'dragon',
    },
    706: {
        id: 706,
        type1: 'dragon',
        type2: 'dragon',
    },
    707: {
        id: 707,
        type1: 'steel',
        type2: 'fairy',
    },
    708: {
        id: 708,
        type1: 'ghost',
        type2: 'grass',
    },
    709: {
        id: 709,
        type1: 'ghost',
        type2: 'grass',
    },
    710: {
        id: 710,
        type1: 'ghost',
        type2: 'grass',
    },
    711: {
        id: 711,
        type1: 'ghost',
        type2: 'grass',
    },
    712: {
        id: 712,
        type1: 'ice',
        type2: 'ice',
    },
    713: {
        id: 713,
        type1: 'ice',
        type2: 'ice',
    },
    714: {
        id: 714,
        type1: 'flying',
        type2: 'dragon',
    },
    715: {
        id: 715,
        type1: 'flying',
        type2: 'dragon',
    },
    716: {
        id: 716,
        type1: 'fairy',
        type2: 'fairy',
    },
    717: {
        id: 717,
        type1: 'dark',
        type2: 'flying',
    },
    718: {
        id: 718,
        type1: 'dragon',
        type2: 'ground',
    },
    719: {
        id: 719,
        type1: 'rock',
        type2: 'fairy',
    },
    720: {
        id: 720,
        type1: 'psychic',
        type2: 'ghost',
    },
    721: {
        id: 721,
        type1: 'fire',
        type2: 'water',
    },
    722: {
        id: 722,
        type1: 'grass',
        type2: 'flying',
    },
    723: {
        id: 723,
        type1: 'grass',
        type2: 'flying',
    },
    724: {
        id: 724,
        type1: 'grass',
        type2: 'ghost',
    },
    725: {
        id: 725,
        type1: 'fire',
        type2: 'fire',
    },
    726: {
        id: 726,
        type1: 'fire',
        type2: 'fire',
    },
    727: {
        id: 727,
        type1: 'fire',
        type2: 'dark',
    },
    728: {
        id: 728,
        type1: 'water',
        type2: 'water',
    },
    729: {
        id: 729,
        type1: 'water',
        type2: 'water',
    },
    730: {
        id: 730,
        type1: 'water',
        type2: 'fairy',
    },
    731: {
        id: 731,
        type1: 'normal',
        type2: 'flying',
    },
    732: {
        id: 732,
        type1: 'normal',
        type2: 'flying',
    },
    733: {
        id: 733,
        type1: 'normal',
        type2: 'flying',
    },
    734: {
        id: 734,
        type1: 'normal',
        type2: 'normal',
    },
    735: {
        id: 735,
        type1: 'normal',
        type2: 'normal',
    },
    736: {
        id: 736,
        type1: 'bug',
        type2: 'bug',
    },
    737: {
        id: 737,
        type1: 'bug',
        type2: 'electric',
    },
    738: {
        id: 738,
        type1: 'bug',
        type2: 'electric',
    },
    739: {
        id: 739,
        type1: 'fighting',
        type2: 'fighting',
    },
    740: {
        id: 740,
        type1: 'fighting',
        type2: 'ice',
    },
    741: {
        id: 741,
        type1: 'fire',
        type2: 'flying',
    },
    742: {
        id: 742,
        type1: 'bug',
        type2: 'fairy',
    },
    743: {
        id: 743,
        type1: 'bug',
        type2: 'fairy',
    },
    744: {
        id: 744,
        type1: 'rock',
        type2: 'rock',
    },
    745: {
        id: 745,
        type1: 'rock',
        type2: 'rock',
    },
    746: {
        id: 746,
        type1: 'water',
        type2: 'water',
    },
    747: {
        id: 747,
        type1: 'poison',
        type2: 'water',
    },
    748: {
        id: 748,
        type1: 'poison',
        type2: 'water',
    },
    749: {
        id: 749,
        type1: 'ground',
        type2: 'ground',
    },
    750: {
        id: 750,
        type1: 'ground',
        type2: 'ground',
    },
    751: {
        id: 751,
        type1: 'water',
        type2: 'bug',
    },
    752: {
        id: 752,
        type1: 'water',
        type2: 'bug',
    },
    753: {
        id: 753,
        type1: 'grass',
        type2: 'grass',
    },
    754: {
        id: 754,
        type1: 'grass',
        type2: 'grass',
    },
    755: {
        id: 755,
        type1: 'grass',
        type2: 'fairy',
    },
    756: {
        id: 756,
        type1: 'grass',
        type2: 'fairy',
    },
    757: {
        id: 757,
        type1: 'poison',
        type2: 'fire',
    },
    758: {
        id: 758,
        type1: 'poison',
        type2: 'fire',
    },
    759: {
        id: 759,
        type1: 'normal',
        type2: 'fighting',
    },
    760: {
        id: 760,
        type1: 'normal',
        type2: 'fighting',
    },
    761: {
        id: 761,
        type1: 'grass',
        type2: 'grass',
    },
    762: {
        id: 762,
        type1: 'grass',
        type2: 'grass',
    },
    763: {
        id: 763,
        type1: 'grass',
        type2: 'grass',
    },
    764: {
        id: 764,
        type1: 'fairy',
        type2: 'fairy',
    },
    765: {
        id: 765,
        type1: 'normal',
        type2: 'psychic',
    },
    766: {
        id: 766,
        type1: 'fighting',
        type2: 'fighting',
    },
    767: {
        id: 767,
        type1: 'bug',
        type2: 'water',
    },
    768: {
        id: 768,
        type1: 'bug',
        type2: 'water',
    },
    769: {
        id: 769,
        type1: 'ghost',
        type2: 'ground',
    },
    770: {
        id: 770,
        type1: 'ghost',
        type2: 'ground',
    },
    771: {
        id: 771,
        type1: 'water',
        type2: 'water',
    },
    772: {
        id: 772,
        type1: 'normal',
        type2: 'normal',
    },
    773: {
        id: 773,
        type1: 'normal',
        type2: 'normal',
    },
    774: {
        id: 774,
        type1: 'rock',
        type2: 'flying',
    },
    775: {
        id: 775,
        type1: 'normal',
        type2: 'normal',
    },
    776: {
        id: 776,
        type1: 'fire',
        type2: 'dragon',
    },
    777: {
        id: 777,
        type1: 'electric',
        type2: 'steel',
    },
    778: {
        id: 778,
        type1: 'ghost',
        type2: 'fairy',
    },
    779: {
        id: 779,
        type1: 'water',
        type2: 'psychic',
    },
    780: {
        id: 780,
        type1: 'normal',
        type2: 'dragon',
    },
    781: {
        id: 781,
        type1: 'ghost',
        type2: 'grass',
    },
    782: {
        id: 782,
        type1: 'dragon',
        type2: 'dragon',
    },
    783: {
        id: 783,
        type1: 'dragon',
        type2: 'fighting',
    },
    784: {
        id: 784,
        type1: 'dragon',
        type2: 'fighting',
    },
    785: {
        id: 785,
        type1: 'electric',
        type2: 'fairy',
    },
    786: {
        id: 786,
        type1: 'psychic',
        type2: 'fairy',
    },
    787: {
        id: 787,
        type1: 'grass',
        type2: 'fairy',
    },
    788: {
        id: 788,
        type1: 'water',
        type2: 'fairy',
    },
    789: {
        id: 789,
        type1: 'psychic',
        type2: 'psychic',
    },
    790: {
        id: 790,
        type1: 'psychic',
        type2: 'psychic',
    },
    791: {
        id: 791,
        type1: 'psychic',
        type2: 'steel',
    },
    792: {
        id: 792,
        type1: 'psychic',
        type2: 'ghost',
    },
    793: {
        id: 793,
        type1: 'rock',
        type2: 'poison',
    },
    794: {
        id: 794,
        type1: 'bug',
        type2: 'fighting',
    },
    795: {
        id: 795,
        type1: 'bug',
        type2: 'fighting',
    },
    796: {
        id: 796,
        type1: 'electric',
        type2: 'electric',
    },
    797: {
        id: 797,
        type1: 'steel',
        type2: 'flying',
    },
    798: {
        id: 798,
        type1: 'grass',
        type2: 'steel',
    },
    799: {
        id: 799,
        type1: 'dark',
        type2: 'dragon',
    },
    800: {
        id: 800,
        type1: 'psychic',
        type2: 'psychic',
    },
    801: {
        id: 801,
        type1: 'steel',
        type2: 'fairy',
    },
    802: {
        id: 802,
        type1: 'fighting',
        type2: 'ghost',
    },
    803: {
        id: 803,
        type1: 'poison',
        type2: 'poison',
    },
    804: {
        id: 804,
        type1: 'poison',
        type2: 'dragon',
    },
    805: {
        id: 805,
        type1: 'rock',
        type2: 'steel',
    },
    806: {
        id: 806,
        type1: 'fire',
        type2: 'ghost',
    },
    807: {
        id: 807,
        type1: 'electric',
        type2: 'electric',
    },
    808: {
        id: 808,
        type1: 'steel',
        type2: 'steel',
    },
    809: {
        id: 809,
        type1: 'steel',
        type2: 'steel',
    },
    810: {
        id: 810,
        type1: 'grass',
        type2: 'grass',
    },
    811: {
        id: 811,
        type1: 'grass',
        type2: 'grass',
    },
    812: {
        id: 812,
        type1: 'grass',
        type2: 'grass',
    },
    813: {
        id: 813,
        type1: 'fire',
        type2: 'fire',
    },
    814: {
        id: 814,
        type1: 'fire',
        type2: 'fire',
    },
    815: {
        id: 815,
        type1: 'fire',
        type2: 'fire',
    },
    816: {
        id: 816,
        type1: 'water',
        type2: 'water',
    },
    817: {
        id: 817,
        type1: 'water',
        type2: 'water',
    },
    818: {
        id: 818,
        type1: 'water',
        type2: 'water',
    },
    819: {
        id: 819,
        type1: 'normal',
        type2: 'normal',
    },
    820: {
        id: 820,
        type1: 'normal',
        type2: 'normal',
    },
    821: {
        id: 821,
        type1: 'flying',
        type2: 'flying',
    },
    822: {
        id: 822,
        type1: 'flying',
        type2: 'flying',
    },
    823: {
        id: 823,
        type1: 'flying',
        type2: 'steel',
    },
    824: {
        id: 824,
        type1: 'bug',
        type2: 'bug',
    },
    825: {
        id: 825,
        type1: 'bug',
        type2: 'psychic',
    },
    826: {
        id: 826,
        type1: 'bug',
        type2: 'psychic',
    },
    827: {
        id: 827,
        type1: 'dark',
        type2: 'dark',
    },
    828: {
        id: 828,
        type1: 'dark',
        type2: 'dark',
    },
    829: {
        id: 829,
        type1: 'grass',
        type2: 'grass',
    },
    830: {
        id: 830,
        type1: 'grass',
        type2: 'grass',
    },
    831: {
        id: 831,
        type1: 'normal',
        type2: 'normal',
    },
    832: {
        id: 832,
        type1: 'normal',
        type2: 'normal',
    },
    833: {
        id: 833,
        type1: 'water',
        type2: 'water',
    },
    834: {
        id: 834,
        type1: 'water',
        type2: 'rock',
    },
    835: {
        id: 835,
        type1: 'electric',
        type2: 'electric',
    },
    836: {
        id: 836,
        type1: 'electric',
        type2: 'electric',
    },
    837: {
        id: 837,
        type1: 'rock',
        type2: 'rock',
    },
    838: {
        id: 838,
        type1: 'rock',
        type2: 'fire',
    },
    839: {
        id: 839,
        type1: 'rock',
        type2: 'fire',
    },
    840: {
        id: 840,
        type1: 'grass',
        type2: 'dragon',
    },
    841: {
        id: 841,
        type1: 'grass',
        type2: 'dragon',
    },
    842: {
        id: 842,
        type1: 'grass',
        type2: 'dragon',
    },
    843: {
        id: 843,
        type1: 'ground',
        type2: 'ground',
    },
    844: {
        id: 844,
        type1: 'ground',
        type2: 'ground',
    },
    845: {
        id: 845,
        type1: 'flying',
        type2: 'water',
    },
    846: {
        id: 846,
        type1: 'water',
        type2: 'water',
    },
    847: {
        id: 847,
        type1: 'water',
        type2: 'water',
    },
    848: {
        id: 848,
        type1: 'electric',
        type2: 'poison',
    },
    849: {
        id: 849,
        type1: 'electric',
        type2: 'poison',
    },
    850: {
        id: 850,
        type1: 'fire',
        type2: 'bug',
    },
    851: {
        id: 851,
        type1: 'fire',
        type2: 'bug',
    },
    852: {
        id: 852,
        type1: 'fighting',
        type2: 'fighting',
    },
    853: {
        id: 853,
        type1: 'fighting',
        type2: 'fighting',
    },
    854: {
        id: 854,
        type1: 'ghost',
        type2: 'ghost',
    },
    855: {
        id: 855,
        type1: 'ghost',
        type2: 'ghost',
    },
    856: {
        id: 856,
        type1: 'psychic',
        type2: 'psychic',
    },
    857: {
        id: 857,
        type1: 'psychic',
        type2: 'psychic',
    },
    858: {
        id: 858,
        type1: 'psychic',
        type2: 'fairy',
    },
    859: {
        id: 859,
        type1: 'dark',
        type2: 'fairy',
    },
    860: {
        id: 860,
        type1: 'dark',
        type2: 'fairy',
    },
    861: {
        id: 861,
        type1: 'dark',
        type2: 'fairy',
    },
    862: {
        id: 862,
        type1: 'dark',
        type2: 'normal',
    },
    863: {
        id: 863,
        type1: 'steel',
        type2: 'steel',
    },
    864: {
        id: 864,
        type1: 'ghost',
        type2: 'ghost',
    },
    865: {
        id: 865,
        type1: 'fighting',
        type2: 'fighting',
    },
    866: {
        id: 866,
        type1: 'ice',
        type2: 'psychic',
    },
    867: {
        id: 867,
        type1: 'ground',
        type2: 'ghost',
    },
    868: {
        id: 868,
        type1: 'fairy',
        type2: 'fairy',
    },
    869: {
        id: 869,
        type1: 'fairy',
        type2: 'fairy',
    },
    870: {
        id: 870,
        type1: 'fighting',
        type2: 'fighting',
    },
    871: {
        id: 871,
        type1: 'electric',
        type2: 'electric',
    },
    872: {
        id: 872,
        type1: 'ice',
        type2: 'bug',
    },
    873: {
        id: 873,
        type1: 'ice',
        type2: 'bug',
    },
    874: {
        id: 874,
        type1: 'rock',
        type2: 'rock',
    },
    875: {
        id: 875,
        type1: 'ice',
        type2: 'ice',
    },
    876: {
        id: 876,
        type1: 'psychic',
        type2: 'normal',
    },
    877: {
        id: 877,
        type1: 'electric',
        type2: 'dark',
    },
    878: {
        id: 878,
        type1: 'steel',
        type2: 'steel',
    },
    879: {
        id: 879,
        type1: 'steel',
        type2: 'steel',
    },
    880: {
        id: 880,
        type1: 'electric',
        type2: 'dragon',
    },
    881: {
        id: 881,
        type1: 'electric',
        type2: 'ice',
    },
    882: {
        id: 882,
        type1: 'water',
        type2: 'dragon',
    },
    883: {
        id: 883,
        type1: 'water',
        type2: 'ice',
    },
    884: {
        id: 884,
        type1: 'steel',
        type2: 'dragon',
    },
    885: {
        id: 885,
        type1: 'dragon',
        type2: 'ghost',
    },
    886: {
        id: 886,
        type1: 'dragon',
        type2: 'ghost',
    },
    887: {
        id: 887,
        type1: 'dragon',
        type2: 'ghost',
    },
    888: {
        id: 888,
        type1: 'fairy',
        type2: 'fairy',
    },
    889: {
        id: 889,
        type1: 'fighting',
        type2: 'fighting',
    },
    890: {
        id: 890,
        type1: 'poison',
        type2: 'dragon',
    },
    891: {
        id: 891,
        type1: 'fighting',
        type2: 'fighting',
    },
    892: {
        id: 892,
        type1: 'fighting',
        type2: 'dark',
    },
    893: {
        id: 893,
        type1: 'dark',
        type2: 'grass',
    },
    894: {
        id: 894,
        type1: 'electric',
        type2: 'electric',
    },
    895: {
        id: 895,
        type1: 'dragon',
        type2: 'dragon',
    },
    896: {
        id: 896,
        type1: 'ice',
        type2: 'ice',
    },
    897: {
        id: 897,
        type1: 'ghost',
        type2: 'ghost',
    },
    898: {
        id: 898,
        type1: 'psychic',
        type2: 'grass',
    },
    899: {
        id: 899,
        type1: 'normal',
        type2: 'psychic',
    },
    900: {
        id: 900,
        type1: 'bug',
        type2: 'rock',
    },
    901: {
        id: 901,
        type1: 'ground',
        type2: 'normal',
    },
    902: {
        id: 902,
        type1: 'water',
        type2: 'ghost',
    },
    903: {
        id: 903,
        type1: 'fighting',
        type2: 'poison',
    },
    904: {
        id: 904,
        type1: 'dark',
        type2: 'poison',
    },
    905: {
        id: 905,
        type1: 'fairy',
        type2: 'flying',
    },
    906: {
        id: 906,
        type1: 'grass',
        type2: 'grass',
    },
    907: {
        id: 907,
        type1: 'grass',
        type2: 'grass',
    },
    908: {
        id: 908,
        type1: 'grass',
        type2: 'dark',
    },
    909: {
        id: 909,
        type1: 'fire',
        type2: 'fire',
    },
    910: {
        id: 910,
        type1: 'fire',
        type2: 'fire',
    },
    911: {
        id: 911,
        type1: 'fire',
        type2: 'ghost',
    },
    912: {
        id: 912,
        type1: 'water',
        type2: 'water',
    },
    913: {
        id: 913,
        type1: 'water',
        type2: 'water',
    },
    914: {
        id: 914,
        type1: 'water',
        type2: 'fighting',
    },
    915: {
        id: 915,
        type1: 'normal',
        type2: 'normal',
    },
    916: {
        id: 916,
        type1: 'normal',
        type2: 'normal',
    },
    917: {
        id: 917,
        type1: 'bug',
        type2: 'bug',
    },
    918: {
        id: 918,
        type1: 'bug',
        type2: 'bug',
    },
    919: {
        id: 919,
        type1: 'bug',
        type2: 'bug',
    },
    920: {
        id: 920,
        type1: 'bug',
        type2: 'dark',
    },
    921: {
        id: 921,
        type1: 'electric',
        type2: 'electric',
    },
    922: {
        id: 922,
        type1: 'electric',
        type2: 'fighting',
    },
    923: {
        id: 923,
        type1: 'electric',
        type2: 'fighting',
    },
    924: {
        id: 924,
        type1: 'normal',
        type2: 'normal',
    },
    925: {
        id: 925,
        type1: 'normal',
        type2: 'normal',
    },
    926: {
        id: 926,
        type1: 'fairy',
        type2: 'fairy',
    },
    927: {
        id: 927,
        type1: 'fairy',
        type2: 'fairy',
    },
    928: {
        id: 928,
        type1: 'grass',
        type2: 'normal',
    },
    929: {
        id: 929,
        type1: 'grass',
        type2: 'normal',
    },
    930: {
        id: 930,
        type1: 'grass',
        type2: 'normal',
    },
    931: {
        id: 931,
        type1: 'normal',
        type2: 'flying',
    },
    932: {
        id: 932,
        type1: 'rock',
        type2: 'rock',
    },
    933: {
        id: 933,
        type1: 'rock',
        type2: 'rock',
    },
    934: {
        id: 934,
        type1: 'rock',
        type2: 'rock',
    },
    935: {
        id: 935,
        type1: 'fire',
        type2: 'fire',
    },
    936: {
        id: 936,
        type1: 'fire',
        type2: 'psychic',
    },
    937: {
        id: 937,
        type1: 'fire',
        type2: 'ghost',
    },
    938: {
        id: 938,
        type1: 'electric',
        type2: 'electric',
    },
    939: {
        id: 939,
        type1: 'electric',
        type2: 'electric',
    },
    940: {
        id: 940,
        type1: 'electric',
        type2: 'flying',
    },
    941: {
        id: 941,
        type1: 'electric',
        type2: 'flying',
    },
    942: {
        id: 942,
        type1: 'dark',
        type2: 'dark',
    },
    943: {
        id: 943,
        type1: 'dark',
        type2: 'dark',
    },
    944: {
        id: 944,
        type1: 'poison',
        type2: 'normal',
    },
    945: {
        id: 945,
        type1: 'poison',
        type2: 'normal',
    },
    946: {
        id: 946,
        type1: 'grass',
        type2: 'ghost',
    },
    947: {
        id: 947,
        type1: 'grass',
        type2: 'ghost',
    },
    948: {
        id: 948,
        type1: 'ground',
        type2: 'grass',
    },
    949: {
        id: 949,
        type1: 'ground',
        type2: 'grass',
    },
    950: {
        id: 950,
        type1: 'rock',
        type2: 'rock',
    },
    951: {
        id: 951,
        type1: 'grass',
        type2: 'grass',
    },
    952: {
        id: 952,
        type1: 'grass',
        type2: 'fire',
    },
    953: {
        id: 953,
        type1: 'bug',
        type2: 'bug',
    },
    954: {
        id: 954,
        type1: 'bug',
        type2: 'psychic',
    },
    955: {
        id: 955,
        type1: 'psychic',
        type2: 'psychic',
    },
    956: {
        id: 956,
        type1: 'psychic',
        type2: 'psychic',
    },
    957: {
        id: 957,
        type1: 'fairy',
        type2: 'steel',
    },
    958: {
        id: 958,
        type1: 'fairy',
        type2: 'steel',
    },
    959: {
        id: 959,
        type1: 'fairy',
        type2: 'steel',
    },
    960: {
        id: 960,
        type1: 'water',
        type2: 'water',
    },
    961: {
        id: 961,
        type1: 'water',
        type2: 'water',
    },
    962: {
        id: 962,
        type1: 'flying',
        type2: 'dark',
    },
    963: {
        id: 963,
        type1: 'water',
        type2: 'water',
    },
    964: {
        id: 964,
        type1: 'water',
        type2: 'water',
    },
    965: {
        id: 965,
        type1: 'steel',
        type2: 'poison',
    },
    966: {
        id: 966,
        type1: 'steel',
        type2: 'poison',
    },
    967: {
        id: 967,
        type1: 'dragon',
        type2: 'normal',
    },
    968: {
        id: 968,
        type1: 'steel',
        type2: 'steel',
    },
    969: {
        id: 969,
        type1: 'rock',
        type2: 'poison',
    },
    970: {
        id: 970,
        type1: 'rock',
        type2: 'poison',
    },
    971: {
        id: 971,
        type1: 'ghost',
        type2: 'ghost',
    },
    972: {
        id: 972,
        type1: 'ghost',
        type2: 'ghost',
    },
    973: {
        id: 973,
        type1: 'flying',
        type2: 'fighting',
    },
    974: {
        id: 974,
        type1: 'ice',
        type2: 'ice',
    },
    975: {
        id: 975,
        type1: 'ice',
        type2: 'ice',
    },
    976: {
        id: 976,
        type1: 'water',
        type2: 'psychic',
    },
    977: {
        id: 977,
        type1: 'water',
        type2: 'water',
    },
    978: {
        id: 978,
        type1: 'dragon',
        type2: 'water',
    },
    979: {
        id: 979,
        type1: 'fighting',
        type2: 'ghost',
    },
    980: {
        id: 980,
        type1: 'poison',
        type2: 'ground',
    },
    981: {
        id: 981,
        type1: 'normal',
        type2: 'psychic',
    },
    982: {
        id: 982,
        type1: 'normal',
        type2: 'normal',
    },
    983: {
        id: 983,
        type1: 'dark',
        type2: 'steel',
    },
    984: {
        id: 984,
        type1: 'ground',
        type2: 'fighting',
    },
    985: {
        id: 985,
        type1: 'fairy',
        type2: 'psychic',
    },
    986: {
        id: 986,
        type1: 'grass',
        type2: 'dark',
    },
    987: {
        id: 987,
        type1: 'ghost',
        type2: 'fairy',
    },
    988: {
        id: 988,
        type1: 'bug',
        type2: 'fighting',
    },
    989: {
        id: 989,
        type1: 'electric',
        type2: 'ground',
    },
    990: {
        id: 990,
        type1: 'ground',
        type2: 'steel',
    },
    991: {
        id: 991,
        type1: 'ice',
        type2: 'water',
    },
    992: {
        id: 992,
        type1: 'fighting',
        type2: 'electric',
    },
    993: {
        id: 993,
        type1: 'dark',
        type2: 'flying',
    },
    994: {
        id: 994,
        type1: 'fire',
        type2: 'poison',
    },
    995: {
        id: 995,
        type1: 'rock',
        type2: 'electric',
    },
    996: {
        id: 996,
        type1: 'dragon',
        type2: 'ice',
    },
    997: {
        id: 997,
        type1: 'dragon',
        type2: 'ice',
    },
    998: {
        id: 998,
        type1: 'dragon',
        type2: 'ice',
    },
    999: {
        id: 999,
        type1: 'ghost',
        type2: 'ghost',
    },
    1000: {
        id: 1000,
        type1: 'steel',
        type2: 'ghost',
    },
    1001: {
        id: 1001,
        type1: 'dark',
        type2: 'grass',
    },
    1002: {
        id: 1002,
        type1: 'dark',
        type2: 'ice',
    },
    1003: {
        id: 1003,
        type1: 'dark',
        type2: 'ground',
    },
    1004: {
        id: 1004,
        type1: 'dark',
        type2: 'fire',
    },
    1005: {
        id: 1005,
        type1: 'dragon',
        type2: 'dark',
    },
    1006: {
        id: 1006,
        type1: 'fairy',
        type2: 'fighting',
    },
    1007: {
        id: 1007,
        type1: 'fighting',
        type2: 'dragon',
    },
    1008: {
        id: 1008,
        type1: 'electric',
        type2: 'dragon',
    },
    1009: {
        id: 1009,
        type1: 'water',
        type2: 'dragon',
    },
    1010: {
        id: 1010,
        type1: 'grass',
        type2: 'psychic',
    },
    1011: {
        id: 1011,
        type1: 'grass',
        type2: 'dragon',
    },
    1012: {
        id: 1012,
        type1: 'grass',
        type2: 'ghost',
    },
    1013: {
        id: 1013,
        type1: 'grass',
        type2: 'ghost',
    },
    1014: {
        id: 1014,
        type1: 'poison',
        type2: 'fighting',
    },
    1015: {
        id: 1015,
        type1: 'poison',
        type2: 'psychic',
    },
    1016: {
        id: 1016,
        type1: 'poison',
        type2: 'fairy',
    },
    1017: {
        id: 1017,
        type1: 'grass',
        type2: 'grass',
    },
    1018: {
        id: 1018,
        type1: 'steel',
        type2: 'dragon',
    },
    1019: {
        id: 1019,
        type1: 'grass',
        type2: 'dragon',
    },
    1020: {
        id: 1020,
        type1: 'fire',
        type2: 'dragon',
    },
    1021: {
        id: 1021,
        type1: 'electric',
        type2: 'dragon',
    },
    1022: {
        id: 1022,
        type1: 'rock',
        type2: 'psychic',
    },
    1023: {
        id: 1023,
        type1: 'steel',
        type2: 'psychic',
    },
    1024: {
        id: 1024,
        type1: 'normal',
        type2: 'normal',
    },
    1025: {
        id: 1025,
        type1: 'poison',
        type2: 'ghost',
    },
};

// Deprecated: items now loaded from API via globalItemDataStore (ItemDataLoader). Kept for reference.
const _itemsDBDeprecated = {
    potion: {
        id: 'potion',
        name: 'Potion',
        description:
            'A spray-type medicine for treating wounds. It can be used to restore 20 HP to an injured Pokemon.',
        price: 200,
        healAmount: 20,
        healStatus: [],
        overworldOptions: ['Use', 'Give', 'Cancel'],
        battleOptions: ['Use', 'Cancel'],
    },
    super_potion: {
        id: 'super_potion',
        name: 'Super Potion',
        description:
            'A spray-type medicine for treating wounds. It can be used to restore 50 HP to an injured Pokemon.',
        price: 500,
        healAmount: 50,
        healStatus: [],
    },
    hyper_potion: {
        id: 'hyper_potion',
        name: 'Hyper Potion',
        description:
            'A spray-type medicine for treating wounds. It can be used to restore 200 HP to an injured Pokemon.',
        price: 1200,
        healAmount: 200,
        healStatus: [],
    },
    max_potion: {
        id: 'max_potion',
        name: 'Max Potion',
        description:
            'A spray-type medicine for treating wounds. It can be used to restore all HP to an injured Pokemon.',
        price: 2500,
        healAmount: 999,
        healStatus: [],
    },
    antidote: {
        id: 'antidote',
        name: 'Antidote',
        description: 'A spray-type medicine for curing poison. It can be used to heal a poisoned Pokemon.',
        price: 100,
        healAmount: 0,
        healStatus: ['poison'],
    },
    paralyze_heal: {
        id: 'paralyze_heal',
        name: 'Paralyze Heal',
        description:
            'A spray-type medicine for curing paralysis. It can be used to heal a paralyzed Pokemon.',
        price: 200,
        healAmount: 0,
        healStatus: ['paralysis'],
    },
    burn_heal: {
        id: 'burn_heal',
        name: 'Burn Heal',
        description: 'A spray-type medicine for curing burns. It can be used to heal a burned Pokemon.',
        price: 250,
        healAmount: 0,
        healStatus: ['burn'],
    },
    ice_heal: {
        id: 'ice_heal',
        name: 'Ice Heal',
        description:
            'A spray-type medicine for thawing out frozen Pokemon. It can be used to heal a frozen Pokemon.',
        price: 250,
        healAmount: 0,
        healStatus: ['freeze'],
    },
    awakening: {
        id: 'awakening',
        name: 'Awakening',
        description:
            'A spray-type medicine for waking up sleeping Pokemon. It can be used to wake up a sleeping Pokemon.',
        price: 200,
        healAmount: 0,
        healStatus: ['sleep'],
    },
    full_restore: {
        id: 'full_restore',
        name: 'Full Restore',
        description:
            'A spray-type medicine for treating wounds. It can be used to restore all HP and heal all status conditions of an injured Pokemon.',
        price: 3000,
        healAmount: 999,
        healStatus: ['poison', 'paralysis', 'burn', 'freeze', 'sleep'],
    },
    full_heal: {
        id: 'full_heal',
        name: 'Full Heal',
        description:
            'A spray-type medicine for healing all status conditions. It can be used to heal any status condition of a Pokemon.',
        price: 600,
        healAmount: 0,
        healStatus: ['poison', 'paralysis', 'burn', 'freeze', 'sleep'],
    },
    revive: {
        id: 'revive',
        name: 'Revive',
        description:
            "A medicine that can revive a fainted Pokemon. It restores half of the Pokemon's maximum HP.",
        price: 1500,
        healAmount: -1, // 50% of pokemon's HP
        healStatus: ['faint'],
        overworldOptions: ['Use', 'Give', 'Cancel'],
        battleOptions: ['Cancel'],
    },
    max_revive: {
        id: 'max_revive',
        name: 'Max Revive',
        description:
            "A medicine that can fully revive a fainted Pokemon. It restores the Pokemon's maximum HP.",
        price: 4000,
        healAmount: 999, // 100% of pokemon's HP
        healStatus: ['faint'],
    },
    pokeball: {
        id: 'pokeball',
        name: 'Poke Ball',
        description:
            'A device for catching wild Pokemon. It is thrown like a ball at a Pokemon, comfortably encapsulating its target.',
        price: 200,
        catchRate: 1,
    },
    great_ball: {
        id: 'great_ball',
        name: 'Great Ball',
        description:
            'A good, high-performance Ball that provides a higher Pokemon catch rate than a standard Poke Ball.',
        price: 600,
        catchRate: 1.5,
    },
    ultra_ball: {
        id: 'ultra_ball',
        name: 'Ultra Ball',
        description:
            'An ultra-high-performance Ball that provides a higher Pokemon catch rate than a Great Ball.',
        price: 1200,
        catchRate: 2,
    },
    master_ball: {
        id: 'master_ball',
        name: 'Master Ball',
        description:
            'The best Ball with the ultimate performance. It will catch any wild Pokemon without fail.',
        price: 1000000,
        catchRate: 999,
    },
    ether: {
        id: 'ether',
        name: 'Ether',
        description:
            'A spray-type medicine for restoring PP to a single selected move. It can be used to restore 10 PP to a move.',
        price: 200,
        restoreAmount: 10,
    },
    elixir: {
        id: 'elixir',
        name: 'Elixir',
        description:
            'A spray-type medicine for restoring PP to all moves. It can be used to restore 10 PP to all moves.',
        price: 300,
        restoreAmount: 10,
    },
    max_ether: {
        id: 'max_ether',
        name: 'Max Ether',
        description:
            'A spray-type medicine for restoring PP to a single selected move. It can be used to restore all PP to a move.',
        price: 500,
        restoreAmount: 999,
    },
    max_elixir: {
        id: 'max_elixir',
        name: 'Max Elixir',
        description:
            'A spray-type medicine for restoring PP to all moves. It can be used to restore all PP to all moves.',
        price: 700,
        restoreAmount: 999,
    },
    hm1: {
        id: 'hm1',
        name: 'HM01 Cut',
        description:
            'A sharp, slicing move that clears away thin trees and obstacles while striking the foe swiftly.',
        moveId: 'cut',
    },
    hm2: {
        id: 'hm2',
        name: 'Fly',
        description:
            'A swift and soaring flight that lets you revisit towns and avoids attacks while airborne in battle.',
        moveId: 'fly',
    },
    hm3: {
        id: 'hm3',
        name: 'Surf',
        description: 'Ride across water to explore new areas while unleashing a massive wave against foes.',
        moveId: 'surf',
    },
    hm4: {
        id: 'hm4',
        name: 'Rock Smash',
        description: 'A powerful physical attack used to move heavy boulders and smash through opponents.',
        moveId: 'rock_smash',
    },
    hm5: {
        id: 'hm5',
        name: 'Flash',
        description:
            "Illuminates the darkest caves, making it easier to see while lowering an opponent's accuracy in battle.",
        moveId: 'flash',
    },
    hm6: {
        id: 'hm6',
        name: 'Strength',
        description: 'A mighty shove that moves large boulders and crushes foes with brute force.',
        moveId: 'strength',
    },
    hm7: {
        id: 'hm7',
        name: 'Waterfall',
        description:
            'Scale rushing waterfalls and unleash a powerful water strike that may cause the opponent to flinch.',
        moveId: 'waterfall',
    },
    hm8: {
        id: 'hm8',
        name: 'Dive',
        description:
            'Submerge into deep water to explore hidden underwater areas, also allowing you to hide briefly in battle.',
        moveId: 'dive',
    },
    hm9: {
        id: 'hm9',
        name: 'Rock Climb',
        description:
            'Ascend steep cliffs while battering opponents with a rugged, climbing strike that may cause confusion.',
        moveId: 'rock_climb',
    },
    hm10: {
        id: 'hm10',
        name: 'Whirlpool',
        description:
            'Create a swirling vortex that clears watery obstacles and traps foes in battle with continuous damage.',
        moveId: 'whirlpool',
    },
    bicycle: {
        id: 'bicycle',
        name: 'Bicycle',
        description: 'Makes you go fast.',
    },
    lunchbox: {
        id: 'lunchbox',
        name: 'Lunch Box',
        description: 'The Professor’s Lunch Box. Take it back to the Lab.',
    },
    charcoal: {
        id: 'charcoal',
        name: 'Charcoal',
        description: 'Boosts fire type moves.',
    },
    miracle_seed: {
        id: 'miracle_seed',
        name: 'Miracle Seed',
        description: 'Boosts grass type moves.',
    },
    poison_barb: {
        id: 'poison_barb',
        name: 'Poison Barb',
        description: 'Boosts poison type moves.',
    },
    mystic_water: {
        id: 'mystic_water',
        name: 'Mystic Water',
        description: 'Boosts water type moves.',
    },
    rare_candy: {
        id: 'rare_candy',
        name: 'Rare Candy',
        description: 'Levels up your pokemon.',
    },
};

export const pokedexEntriesDB = {
    1: 'A strange seed was planted on its back at birth. The plant grows with this Pokemon, sharing a symbiotic bond.',
    2: 'The bulb on its back grows by drawing energy. It gives off a distinct aroma when it is ready to bloom.',
    3: "The flower on its back catches sunlight to convert it into pure energy. The flower's aroma soothes the emotions of people.",
    4: "Born with a flame at the tip of its tail, it is said that a Charmander's life force flickers weakly if its flame ever goes out.",
    5: 'When it swings its burning tail, it elevates the air temperature to unbearably high levels.',
    6: 'Its wings can carry this Pokemon close to an altitude of 4,600 feet. It blows out fire that is hot enough to melt boulders.',
    7: 'Its shell is not just for protection - it helps regulate water flow, allowing Squirtle to swim at impressive speeds.',
    8: 'The jets of water it spouts from its tail fin can punch through thick steel. It is said to live for over 100 years.',
    9: 'The cannons on its shell fire jets of water capable of punching holes through thick steel. It crushes foes under its heavy body.',
    10: 'Despite its small size, its voracious appetite drives it to eat hundreds of leaves daily. It releases a potent powder when threatened.',
    11: 'It hardens its shell to protect against predators. For defense, it releases a noxious powder from its shell.',
    12: 'In battle, it flaps its wings at great speed to release highly toxic dust into the air, disabling its foes.',
    13: 'Its stinger is highly poisonous. Its bright coloring warns others not to step on its territory.',
    14: 'Its shell hardened into a strong cocoon. While in this state, it remains patient, awaiting evolution.',
    15: 'Its best attack involves flying at high speed and striking with its poisonous stingers. It can fly backward.',
    16: 'A common sight in forests and woods. It flaps its wings at ground level to kick up blinding sand.',
    17: 'Very protective of its sprawling territory, this Pokemon will fiercely peck at any intruder.',
    18: 'This Pokemon flies at Mach-2 speed, seeking prey. Its large talons are feared as wicked weapons.',
    19: 'Its fangs are long and very sharp. They grow continuously, so it gnaws on hard things to whittle them down.',
    20: 'Its whiskers help it to maintain balance. Its fangs never stop growing, so it gnaws to pare them down.',
    21: 'It is very protective of its territory. It will peck at any intruder with its sharp beak relentlessly.',
    22: 'A Pokemon that dates back many years. If it senses danger, it flies high and away, instantly.',
    23: 'It can freely detach its jaw to swallow large prey whole. It can become too heavy to move, however.',
    24: 'The pattern on its belly appears to be a frightening face. Weak foes will flee just at the sight of the pattern.',
    25: 'When several of these Pokemon gather, their electricity could build and cause lightning storms.',
    26: 'Its long tail serves as a ground to protect itself from its own high-voltage power.',
    27: 'It burrows deep underground in arid locations far from water. It only emerges to hunt for prey.',
    28: 'It can roll into a ball, causing its spikes to point outward. It can then roll at high speeds.',
    29: 'Although small, its venomous barbs make it dangerous. The female has a smaller horn than the male.',
    30: "The female's horn develops slowly. It prefers physical attacks such as clawing and biting.",
    31: 'Its hard scales provide strong protection. It uses its hefty bulk to execute powerful moves.',
    32: 'Its large ears are always kept upright. It uses them as radar to sense danger.',
    33: 'Its horn is harder than diamond. If it senses a hostile presence, all the barbs on its back bristle up.',
    34: 'It uses its powerful arms to pin prey before jabbing with its poisonous horn. One jab can be lethal.',
    35: 'Under the full moon, this Pokemon likes to dance in a ring. It creates an illusion of extra dancers.',
    36: 'A very intelligent Pokemon. It is said that a home with a Clefable will bring happiness and joy.',
    37: 'While young, it has six gorgeous tails. As it grows, several new tails are said to split from them.',
    38: 'Each of its nine tails is imbued with supernatural power. It can live for a thousand years.',
    39: 'Its magical and cute songs have complex notes that can put listeners to sleep instantly.',
    40: 'When its huge eyes light up, it sings a mysteriously soothing melody that lulls its enemies to sleep.',
    41: 'During the day, it stays in caves. It uses supersonic waves to check its surroundings while flying.',
    42: 'Once it strikes, it will not stop draining energy from the victim even if it gets too heavy to fly.',
    43: 'During the day, it keeps its face buried in the ground. At night, it wanders around sowing its seeds.',
    44: 'The larger its petals, the more toxic pollen it contains. Its big head is heavy and hard to hold up.',
    45: 'The flower on its head releases a powerful scent. In battle, it gives off toxic pollen.',
    46: 'Burrows under hot sand while feeding on plant roots. The mushrooms on its back grow by drawing nutrients.',
    47: 'The bug host is drained of energy by the mushrooms on its back. They appear to do all the thinking.',
    48: 'Its large eyes act as radar. In a bright place, you can see that they are clusters of many tiny eyes.',
    49: 'The dustlike scales covering its wings are color coded to indicate the kinds of poison it has.',
    50: 'A Pokemon that lives underground. Because of its dark habitat, it is repelled by bright sunlight.',
    51: 'Its three heads move independently. While two heads sleep, one head is always monitoring its surroundings.',
    52: 'Adores round objects. It wanders the streets on a nightly basis to look for dropped loose change.',
    53: 'Very smart and very vengeful. Grabbing its tail could result in a nasty scratch from its sharp claws.',
    54: 'While lulling its enemies with its vacant look, this wily Pokemon will use psychokinetic powers.',
    55: 'Often seen swimming elegantly by lake shores. It is often mistaken for a mermaid queen.',
    56: 'Extremely quick to anger. It could be docile one moment then thrashing away the next instant.',
    57: 'It is always outrageously furious. If it gives chase, it will tenaciously track the target no matter how far.',
    58: 'Very protective of its territory. It will bark and bite to repel intruders from its space.',
    59: 'A Pokemon that has long been admired for its beauty. It runs agilely as if on wings.',
    60: 'Its newly grown legs prevent it from running. It appears to prefer swimming over trying to stand.',
    61: 'The spiral pattern on its belly subtly undulates. Staring at it gradually causes drowsiness.',
    62: 'An adept swimmer at both the front crawl and breast stroke. Easily overtakes the best human swimmers.',
    63: 'Using its ability to read minds, it will identify impending danger and teleport to safety.',
    64: 'It emits special alpha waves from its body that induce headaches just by being close by.',
    65: 'Its brain can outperform a supercomputer. Its intelligence quotient is said to be around 5,000.',
    66: 'Loves to build its muscles. It trains in all styles of martial arts to become even stronger.',
    67: 'Its muscular body is so powerful, it must wear a power-save belt to regulate its motions.',
    68: 'Using its heavy muscles, it throws powerful punches that can send the victim clear over the horizon.',
    69: 'A carnivorous Pokemon that traps and eats bugs. It uses its root feet to absorb nutrients from the soil.',
    70: 'When hungry, it swallows anything that moves. Its hapless prey is dissolved by strong acids.',
    71: 'Said to live in huge colonies deep in jungles, although no one has ever returned from there.',
    72: 'Drifts in shallow seas. Anglers who hook them by accident are often punished by its stinging acid.',
    73: 'The tentacles are normally kept short. On hunts, they are extended to ensnare and immobilize prey.',
    74: 'Often seen rolling down mountain trails. Obstacles are just things to roll straight over, not avoid.',
    75: 'Its rock-like body is so durable, dynamite can be harmlessly detonated on it.',
    76: 'Its boulder-like body is extremely hard. It can easily withstand dynamite blasts without damage.',
    77: 'Its hooves are ten times harder than diamonds. It can trample anything completely flat in moments.',
    78: 'Very competitive, this Pokemon will chase anything that moves fast in the hopes of racing it.',
    79: 'Incredibly slow and dopey. It takes 5 seconds for it to feel pain when under attack.',
    80: 'Though slow, it is skilled at fishing with its tail. It does not feel pain if its tail is bitten.',
    81: 'Uses powerful magnetic waves to levitate and move. When tired, its levitation power weakens.',
    82: 'The faster the units on the sides rotate, the greater the magnetic force they generate.',
    83: 'The sprig of green onions it holds is its weapon. It is used much like a sword.',
    84: 'A bird that makes up for its poor flying with its fast foot speed. Leaves giant footprints.',
    85: 'Its three heads represent joy, sorrow, and anger. It runs at over 60 mph when hunting prey.',
    86: 'The protruding horn on its head is very hard. It is used for bashing through thick ice.',
    87: 'Stores thermal energy in its body. Swims at a steady 8 knots even in intensely cold waters.',
    88: 'Appears in filthy areas. Thrives by sucking up polluted sludge that is pumped out of factories.',
    89: 'Thickly covered with a filthy, vile sludge. It is so toxic, even its footprints contain poison.',
    90: 'Its hard shell repels any kind of attack. It is vulnerable only when its shell is open.',
    91: 'When attacked, it launches its spikes, which grow back in 24 hours. Its shell is said to be harder than diamond.',
    92: 'Almost invisible, this gaseous Pokemon cloaks the target and puts it to sleep without notice.',
    93: 'Because of its ability to slip through block walls, it is said to be from another dimension.',
    94: 'Under a full moon, this Pokemon likes to mimic the shadows of people and laugh at their fright.',
    95: 'As it grows, the stone portions of its body harden to become similar to a diamond, but colored black.',
    96: 'When it is very sleepy, it will use its psychic power as a last resort. Its yawns can be contagious.',
    97: 'When its eyes flash red, it can use psychic powers. It often pretends to be asleep while observing foes.',
    98: 'Its pincers are not only powerful weapons, they are used for balance when walking sideways.',
    99: 'The large pincer has 10,000-horsepower crushing force. However, its huge size makes it unwieldy to use.',
    100: 'Usually found in power plants. Easily mistaken for a Poké Ball, they have zapped many people.',
    101: 'It stores an overcharge of electricity in its body. Even a small shock makes it explode.',
    102: 'Often mistaken for eggs. When disturbed, they quickly gather and attack in swarms.',
    103: 'Legend has it that on rare occasions, one of its heads will drop off and continue on as an Exeggcute.',
    104: "Because it never removes its skull helmet, no one has ever seen this Pokemon's real face.",
    105: 'The bone it holds is its key weapon. It throws the bone boomerang-style, then catches it in midair.',
    106: 'When in a hurry, its legs lengthen progressively. It runs smoothly with extra long, loping strides.',
    107: 'While apparently doing nothing, it fires punches in lightning-fast volleys that are impossible to see.',
    108: 'Its tongue spans almost 7 feet and moves more freely than its forelegs. Its licks can cause paralysis.',
    109: 'In hot places, its internal gases could expand and explode without any warning. Be very careful!',
    110: 'Where two kinds of poison gases meet, 2 Koffings can fuse into a Weezing over many years.',
    111: 'Its powerful tackles can destroy anything. However, it is too slow witted to help people work.',
    112: 'Protected by an armor-like hide, it is capable of living in molten lava of 3,600 degrees Fahrenheit.',
    113: 'A kindly Pokemon that lays highly nutritious eggs and shares them with injured Pokemon or people.',
    114: 'The whole body is swathed with wide vines that are similar to seaweed. Its vines shake as it walks.',
    115: "The infant rarely ventures out of its mother's protective pouch until it is 3 years old.",
    116: 'Found in seas with fast-moving tides. It anchors itself by wrapping its tail around rocks or coral.',
    117: 'Known to shoot down flying bugs with precision blasts of ink from the surface of the water.',
    118: 'Its dorsal fin hosts a sharp horn which is prized. It swims in a school during breeding season.',
    119: 'In the autumn spawning season, they can be seen swimming powerfully up rivers and creeks.',
    120: 'An enigmatic Pokemon that may have come from another planet. Its brain emits mysterious radio waves.',
    121: 'It is capable of creating an exact copy of an opponent instantly. It accomplishes this by memorizing light.',
    122: 'If interrupted while it is miming, it will slap around the offender with its broad hands.',
    123: 'With ninja-like agility and speed, it can create the illusion that there is more than one.',
    124: 'It seductively wiggles its hips as it walks. It can cause people to dance in unison with it.',
    125: 'Normally found near power plants, they can wander away and cause major blackouts in cities.',
    126: "Its magma-like blood circulates throughout its body. Its body's heat can reach 1,200 degrees.",
    127: 'If it fails to crush the victim in its pincers, it will swing it around and toss it hard.',
    128: 'When it targets an enemy, it charges furiously while whipping its body with its long tails.',
    129: 'In the distant past, it was somewhat stronger than the horribly weak descendants that exist today.',
    130: 'Rarely seen in the wild. Huge and vicious, it is capable of destroying entire cities in a rage.',
    131: 'A gentle soul that can read the minds of people. It can ferry people across the sea on its back.',
    132: "Capable of copying an enemy's genetic code to instantly transform itself into a duplicate of the enemy.",
    133: 'Its genetic code is irregular. It may mutate if it is exposed to radiation from element stones.',
    134: "Lives close to water. Its long tail is ridged with a fin which is often mistaken for a mermaid's.",
    135: 'It accumulates negative ions in the atmosphere to blast out 10,000-volt lightning bolts.',
    136: 'When storing thermal energy in its body, its temperature can soar to over 1,600 degrees Fahrenheit.',
    137: 'A man-made Pokemon that was created using cutting-edge technology. It can move freely in cyberspace.',
    138: 'Although long extinct, in rare cases, it can be genetically resurrected from fossils.',
    139: 'A prehistoric Pokemon that died out when its heavy shell made it impossible to catch prey.',
    140: 'A Pokemon that was resurrected from a fossil found in what was once the ocean floor eons ago.',
    141: 'Its sleek shape is perfect for swimming. It slashes prey with its claws and drains their fluids.',
    142: 'A savage Pokemon that died out in ancient times. It was resurrected from DNA found in amber.',
    143: 'Very lazy. Just eats and sleeps. As its rotund bulk builds, it becomes steadily more slothful.',
    144: 'A legendary bird Pokemon. It freezes water that is contained in winter air and makes it snow.',
    145: 'This legendary bird Pokemon causes savage thunderstorms by flapping its glittering wings.',
    146: 'This legendary bird Pokemon is said to bring early spring to the wintry lands it visits.',
    147: 'Long considered a mythical Pokemon until recently when a small colony was found living underwater.',
    148: 'According to a witness, its body was surrounded by a strange aura that gave it a mystical look.',
    149: 'An extremely rarely seen marine Pokemon. Its intelligence is said to match that of humans.',
    150: 'A Pokemon created by genetic manipulation. Said to be the most powerful Pokemon ever.',
    151: 'So rare that it is still said to be a mirage by many experts. Only a few people have seen it worldwide.',
    152: 'The leaf on its head catches the sunlight. As a result, it grows more vigorously than other Pokemon.',
    153: 'The scent that wafts from its leaves has a calming effect on fighting Pokemon.',
    154: 'Anyone who stands beside it becomes refreshed, just as if they were relaxing in a sunny forest.',
    155: 'The flame on its back burns hottest when it is angry. The flaring flames intimidate foes.',
    156: 'This Pokemon is easily angered. When fighting, it turns its back on its opponent to demonstrate its strength.',
    157: 'If its rage peaks, it becomes so hot that anything that touches it will instantly go up in flames.',
    158: 'Its powerful jaws are capable of crushing anything. Even its Trainer must be careful.',
    159: 'When it bites with its massive and powerful jaws, it shakes its head and savagely tears its victim up.',
    160: 'When it attacks, it opens its huge jaws wide. It could snap a telephone pole in two with one bite.',
    161: 'It stands on its tail so it can see a long way. If it spots an enemy, it cries loudly to warn its kind.',
    162: 'The mother puts its offspring to sleep by curling up around them. It corners foes with speed.',
    163: 'It always stands on one foot. It changes feet so fast, the movement can rarely be seen.',
    164: 'Silent and swift in the dark night skies, it scares people with its eerie red eyes and howls.',
    165: 'It uses its sweet aroma to attract prey, then spits acid. The fluid can melt even a metal file.',
    166: 'The patterns on its wings help it blend in with flowers where it likes to hide.',
    167: 'It spins silk from its mouth to create a nest. Once a day, it sheds its skin, covering itself in silk.',
    168: 'It attaches silk to tree branches, then swings from them freely. The silk is strong enough to hold an adult.',
    169: 'By fluttering its wings, it can emit ultrasonic waves that can disorient larger Pokemon.',
    170: 'Its two antennae glow strongly at night. They act as a beacon for its school mates.',
    171: 'Its antennae, which evolved from a fin, have both positive and negative charges flowing through them.',
    172: 'It plays with others by touching tails and setting off sparks. This appears to be a test of courage.',
    173: 'Because of its unusual, star-like silhouette, people believe that it came here on a meteor.',
    174: 'It likes to sing but is not yet good at it. It becomes tense when watched, so it should be left alone.',
    175: 'The shell seems to be filled with joy. It is said that it will share good luck when treated kindly.',
    176: 'They say that it rarely appears before people and that it brings them joy and hope.',
    177: "Because its wings aren't yet fully grown, it has to hop to get around. It is always looking up.",
    178: 'It can stay in the air for days by catching updrafts beneath its wings. It folds its wings to rest.',
    179: 'If static electricity builds in its wool, its horn emits bright sparks.',
    180: 'Its fluffy coat swells to double when static electricity builds up. Touching it can be shocking.',
    181: "The tail's tip shines brightly and can be seen from far away. It serves as a beacon for lost people.",
    182: 'Plentiful in the tropics. When it dances, its petals rub together and make a pleasant ringing sound.',
    183: 'The tip of its tail, which contains oil that is sweeter than honey, is highly valued by trainers.',
    184: 'It uses its tail to lure prey close, then rocks its body to hypnotize them before chomping down.',
    185: 'It disguises itself as a tree to avoid attack. It hates water, so it will disappear on rainy days.',
    186: 'The curled hair on its head proves its status as a king. It is said that the longer and curlier the hair, the more respect it earns.',
    187: 'To keep from being blown away by the wind, they gather in clusters. They do enjoy gentle breezes.',
    188: 'Its bloom releases pollen that causes instant hay fever. Harmful if breathed in large quantities.',
    189: 'Once it takes aim at its foe, it makes a spectacular dive. It can fly at speeds of Mach 2 or higher.',
    190: 'Its tail is so powerful that it can use it to grab a tree branch and hold itself up in the air.',
    191: 'It may drop out of the sky suddenly. If attacked, it will violently shake its leaves.',
    192: 'By basking in sunlight, it fills its body with power. This makes its petals warm.',
    193: 'This Pokemon uses its flying ability to quickly chase down targeted prey.',
    194: 'Its body is virtually composed of water. It shoots strange beams from its crystal-like eyes.',
    195: 'It has a penchant for moving rhythmically. It is thought about 300 million years old.',
    196: "It uses the fine hair that covers its body to sense air currents and predict its enemy's actions.",
    197: 'When agitated, it protects itself by spraying poisonous sweat from its pores.',
    198: 'Feared and loathed by many, it is believed to bring misfortune to all those who see it at night.',
    199: 'It has incredible intellect and intuition. Whatever the situation, it remains calm and collected.',
    200: "It loves to bite and yank people's hair from behind without warning, just to see their shocked reactions.",
    201: "Its shapes look like ancient writing. Research is ongoing to determine if there's a connection.",
    202: 'When two or more gather, they constantly try to outdo each other to be more stylish and popular.',
    203: 'Its long neck and legs allow it to run at 30 mph. It has a surprisingly aggressive temperament.',
    204: 'It likes to hide in the shade of tall trees where it eats bugs. It is often mistaken for a tree branch.',
    205: 'It can convert sunlight into energy while asleep. The steel shell protects its body from predators.',
    206: 'A timid and shy Pokemon, it burrows deep into the ground to create its nest and avoid predators.',
    207: 'It soars through the skies at sonic speeds. Its reckless flying often causes accidents with its tail.',
    208: 'Its body has been compressed deep under the ground. As a result, it is harder than any metal.',
    209: 'Although it looks frightening, it is actually kind and will loyally obey its trainer.',
    210: "Its fangs are its most powerful weapons. Once it bites down, it won't let go until it loses consciousness.",
    211: 'It shoots toxic spines with remarkable accuracy. The poison in its spines could be fatal if too strong.',
    212: 'Its pincers contain steel-like strength. In battle, it never backs down from any opponent.',
    213: 'It stores berries in its shell. The berries eventually ferment and become delicious juices.',
    214: 'With its mighty legs, it can knock down trees. It charges at foes horn-first with devastating force.',
    215: 'Its claws are not only razor sharp but also venomous, making it a dangerous predator in the wild.',
    216: 'Before food becomes scarce in winter, its habit is to hoard berries in many hidden locations.',
    217: 'With its powerful muscles, it can hug its opponents to sleep. Its fur is surprisingly soft.',
    218: 'Its body temperature is roughly 2,200 degrees Fahrenheit. It keeps its heat from escaping with its shell.',
    219: 'Its shell is actually its skin that hardened as a result of cooling. Its internal fire never goes out.',
    220: 'During the ice age, it grew fur to endure the cold. Its tusks are made of ice.',
    221: 'Its entire body is covered with fur that is as hard as steel. It can shatter drifting ice with its charges.',
    222: 'Beneath its shell, its body is actually very soft. If attacked, it spews a poisonous fluid.',
    223: 'It has superb accuracy with its water gun. It can shoot down flying bugs from 300 feet away.',
    224: 'Its sticky saliva can decompose anything. It wraps its tentacles around prey and slowly dissolves them.',
    225: 'During freezing seasons, it migrates to the south with Delibird leading the way.',
    226: "As it majestically swims, it doesn't care if Remoraid attach to it for scavenging its leftovers.",
    227: 'Despite being heavy, it can fly at Mach 2 speed by tucking in its wings and streamlining its body.',
    228: 'It uses different kinds of cries for communicating with others of its kind to alert them to danger.',
    229: 'It chases down prey in a pack of up to 30. It defeats foes with perfectly coordinated teamwork.',
    230: 'It is said that it usually hides in deep-sea trenches. It may jump out of the water to attack prey.',
    231: 'For its nest, it digs a vertical hole in the ground. It marks its territory by spraying a bodily fluid.',
    232: 'If it becomes enraged, it loses control of its psychic powers. This results in its forgetting everything.',
    233: 'A programmer created it using cutting-edge technology. It can move freely in cyberspace.',
    234: "Its antlers can be used to gauge humidity and predict the next day's weather.",
    235: 'The fluid it secretes from its tail can be used as paint. Different emotions cause different colors.',
    236: 'It trains tirelessly, hoping to become the most powerful fighter. It has an indomitable spirit.',
    237: 'It launches kicks while spinning. If it spins at high speed, it may bore its way into the ground.',
    238: "It rocks its body rhythmically. It appears to alter the alpha waves in its victims' brains.",
    239: 'A weak electric current flows between its horns. Sticking a hand there will cause a slight shock.',
    240: 'Each breath it takes creates a small ember. It is said its magma-like blood prevents it from cooling.',
    241: 'Its milk is packed with nutrition, making it the ultimate beverage for the sick or weary.',
    242: "Anyone who takes even one bite of Blissey's egg becomes unfailingly caring and pleasant to everyone.",
    243: 'The rain clouds it carries let it fire thunderbolts at will. They say it descended with lightning.',
    244: 'A Pokemon that races across the land. It is said that one of its roars can cause a volcano to erupt.',
    245: 'Said to be the reincarnation of north winds, it can instantly purify filthy, murky water.',
    246: 'Born deep underground, it comes aboveground and becomes a pupa once it has finished eating soil.',
    247: 'Its shell is as hard as sheet rock, and it is also very strong. Its thrashing can topple a mountain.',
    248: "Its body can't be harmed by any sort of attack, so it is very eager to make challenges against enemies.",
    249: 'A Pokemon that has been overly cocky since ancient times. Its feathers are said to glow seven colors.',
    250: 'A legend says that its body glows in seven colors. A rainbow is said to form behind it when it flies.',
    251: 'This Pokemon wanders across time. Grass and trees flourish in the forests in which it has appeared.',
    252: "The leaf growing out of its head is very bitter. Eating it is known to refresh one's mind.",
    253: 'It lives in dense jungles. While closing in on its prey, it leaps from branch to branch.',
    254: 'The leaves growing on its arms can slice down thick trees. It is without peer in jungle combat.',
    255: 'Inside its body is a flame that never goes out. Like a furnace, it can be used to hatch eggs.',
    256: 'It battles using its martial arts skills. The stronger the foe, the more intensely its flames burn.',
    257: 'In battle, it expels intensely hot flames from its wrists. Its fiery punches scorch its foes.',
    258: 'Its highly developed muscles never grow fatigued, however much it exercises.',
    259: 'Its sturdy legs give it sure footing, even in mud. It burrows into dirt to sleep.',
    260: 'It can easily carry a sumo wrestler on its back. It can also shoot out water stored in its body.',
    261: "A smart and sneaky Pokemon. A pair may work together to steal eggs from a Taillow's nest.",
    262: 'It chases down prey in packs. It will never disobey the commands of a skilled trainer.',
    263: 'It has a cowardly nature. If it encounters a strong opponent, it runs away as fast as it can.',
    264: 'When under attack, it stands on its hind legs, points its bristly fur forward and stares down its foe.',
    265: 'Often targeted by bird Pokemon, it desperately resists by releasing poison from its tail spikes.',
    266: 'Its hard shell protects its soft body. It quietly endures hardships while awaiting evolution.',
    267: 'Despite its elegant appearance, it can flap its wings at high speed to release intensely toxic dust.',
    268: 'Its silk contains a special enzyme that can dissolve anything. It wraps silk around its prey.',
    269: 'It violently shakes its wings, releasing highly toxic dust. It is a picky eater.',
    270: 'The leaf on its head is like a radar. It senses what is in the water and what is approaching.',
    271: 'It becomes inactive in cold weather. It is said to use the nutrients from fallen leaves.',
    272: 'The rhythm of bright, festive dancing makes the cells in its body grow increasingly more energetic.',
    273: 'If it remains still, it becomes impossible to distinguish from real acorns. It delights in surprising foragers.',
    274: 'It lives deep in forests. With the leaf on its head, it performs photosynthesis and drinks the rain.',
    275: 'This cunning Pokemon hides in the shadows of trees, waiting to ambush its prey.',
    276: 'It darts around actively, but also can glide silently from branch to branch using its wings.',
    277: 'It circles its territory in the same pattern daily. It marks time using the position of the sun.',
    278: 'It soars high in the sky, riding on updrafts like a glider. It carries food tucked in its bill.',
    279: 'It swallows prey whole. When confronted by an enemy, it spouts water stored in its body.',
    280: 'If its horns capture the warm feelings of people or Pokemon, its body warms up slightly.',
    281: 'It uses the horns on its head to sense the emotions of others. It appears where happy people gather.',
    282: 'To protect its trainer, it can distort space to create a world where nothing can harm them.',
    283: 'Its sensitivity to sound is so acute, it can balance on a single thin hair by focusing on its breathing.',
    284: 'It flies through rain clouds at high speed, releasing jolts of electricity to strike its prey.',
    285: 'The spores released from under the mushroom-like cap can induce drowsiness in an instant.',
    286: 'The seeds scattered from around its body can induce intense drowsiness in a matter of seconds.',
    287: 'There is always a group of Taillow watching it, hoping to steal a morsel of the food it gathers.',
    288: 'When it gets excited, it runs around at high speeds. Unfortunately, this means it often slips and falls.',
    289: 'The languorous movements of its ringlike muscles create undulating waves, producing a hypnotic effect.',
    290: 'It moves while underground. Although small, it is very powerful as it can quickly dig through hard ground.',
    291: 'Its cry leaves a lasting headache if heard for too long. It moves so quickly that it is almost invisible.',
    292: "A discarded bug shell that came to life. Peering into the crack on its back is said to steal one's spirit.",
    293: 'It can barely fly at all. By flapping its wings furiously, it can move up and down, but not very far.',
    294: 'By slamming its well-toned tail against the ground, it can send out shock waves of over 100 feet.',
    295: 'Its roar has enough power to destroy a large building. When it inhales, it can bring down a flying prey.',
    296: "The muscles in its body never cramp however much it exercises. It can withstand a giant's tackle.",
    297: 'It can stop a train with its bare hands. It has enough power to send a truck flying with a single slap.',
    298: 'Its tail bounces like a rubber ball. It uses its tail to perform complex acrobatic moves in battle.',
    299: 'Using its eyes like radar, it can spot and capture prey even in murky waters.',
    300: 'It is said to have the ability to predict the weather. Its fur color changes depending on its mood.',
    301: 'They say that it evolved to become beautiful. It spends a lot of time grooming itself in mirrors.',
    302: 'Dwelling in dark caves, it darts forward to catch prey after staring at its gleaming red eyes.',
    303: 'Its steel-hard fangs can shatter gems. Small Pokemon flee from its intimidating face.',
    304: 'It eats iron to build its steel body. It is a pest that descends from mountains to eat bridges.',
    305: 'It has a body of steel. To make its body, it feeds on iron ore that it digs from mountains.',
    306: 'It is thought its body transformed as a result of iron accumulation. It can crush a car with one blow.',
    307: 'It is said to have the ability to calm raging spirits by hitting them with its third eye.',
    308: "Through meditation, it gained the psychic power to predict its foes' moves. It hates to fight.",
    309: 'The electricity it emits from its body can make jogging shoes comfortable to wear.',
    310: 'It discharges electricity from its mane. It creates a thundercloud overhead to drop lightning bolts.',
    311: 'During cold seasons, it migrates to the equator. It instantly cheers up anyone who sees it dance.',
    312: 'Its body is virtually composed of electricity. It is equally comfortable in and out of water.',
    313: 'With its sweet aroma, it guides Pokemon to flowers with nectar. It itself feeds on the nectar.',
    314: 'It lives in the shadows of tall trees where it eats bugs. It is attracted by light at night.',
    315: 'The sweet fragrance of the flowers on its arms intoxicates its foes and charms them into a deep slumber.',
    316: 'A very glutinous type of Pokemon. Its stomach acid can even digest molten iron ore.',
    317: 'When it finds something that looks like food, it swallows it whole. Its stomach acid never fails.',
    318: "It is dangerous to swim where Carvanha live. One bite, and they'll tear you apart with fangs.",
    319: 'Known as a villain of the sea, its vicious fangs can tear out boat hulls. Many ships have sunk to it.',
    320: 'It swims by bouncing on its inflated belly. The bigger its body gets, the higher it can bounce.',
    321: 'The first spout of water it shoots from its spout can knock down a flying bird from 100 feet up.',
    322: 'Its humped back stores intensely hot magma. When it is dozing, the magma cools and hardens.',
    323: 'It has volcanoes on its back. If magma builds up in its body, it shudders, causing volcanic eruptions.',
    324: 'The shell on its back is hardened soil from long exposure to heat. It guards its soft body from harm.',
    325: 'It bounces around on its tail to move. The more it bounces, the more energetic it gets.',
    326: 'It uses black pearls to amplify its psychic power. It does an odd dance to gain control over foes.',
    327: 'It draws symbols with its tail that look like ancient writing. Scientists study them for their meaning.',
    328: 'It moves quicker in sand than on grass or rocks. It lives in vast desert wastelands.',
    329: 'It can shoot laser beams from its claws. It is born deep in desert wastelands.',
    330: "It whips up sandstorms with powerful flaps of its wings. It is known as 'The Desert Spirit.'",
    331: 'The spikes on its body are filled with venom. If attacked, it uses the spikes to poison its foe.',
    332: 'When it sleeps deeply, the needles on its back catch falling rain, creating a water supply.',
    333: 'It lives in fluffy cotton clouds. It catches updrafts with its light body to float in the sky.',
    334: 'By singing melodies in its crystal-clear voice, it can make its listeners experience dreamy wonderment.',
    335: 'Sharp claws and savage nature make it dangerous. Its distinctive cry leaves the listener uneasy.',
    336: 'Its poison is strong enough to dissolve solid rock. It wraps around its prey and crushes them.',
    337: 'It floats in space on powerful magnetic waves. It appears where auroras are seen.',
    338: 'Solar energy is the source of its power. On sunny days, it floats silently in the sky.',
    339: 'It makes a nest at the bottom of swamps. It will eat anything - if it is alive, Barboach will eat it.',
    340: 'It claims a large swamp to itself. If a foe comes near it, it sets off tremors by thrashing around.',
    341: 'Its hard shell repels any kind of attack. It is vulnerable only when its shell is open.',
    342: "When its pincers grab prey, the victim is gripped so tightly, it can't move. The pincers crush strongly.",
    343: 'It moves while spinning around on its single foot. Some Baltoy have been seen spinning on their heads.',
    344: 'It is said that it emerges from deep under the ground to steal children and their pets.',
    345: 'Lileep clings to rocks on the seabed. When prey comes close, it quickly extends its neck and swallows whole.',
    346: 'It lives in the shallows of warm seas. When the tide goes out, it digs up prey from beaches.',
    347: 'It lived on land before going extinct 100 million years ago. It can sometimes be found in fossils.',
    348: 'Protected by a hard shell, its body is very sturdy. It skewers prey with its claws to feed.',
    349: 'It lives at the bottom of large lakes. Whenever it spots rare prey, it uses its whiskers to catch them.',
    350: 'Its lovely scales are described as rainbow colored. They change color depending on the viewing angle.',
    351: 'Its appearance changes with the weather. Recently, its molecules were found to be just like water.',
    352: 'It changes its appearance depending on its mood. It can also blend in with its surroundings.',
    353: 'It loves vengeful emotions and hangs in rows under the eaves of houses where vengeful people live.',
    354: 'It seeks revenge on its original trainer who abandoned it. It spends its entire life wandering.',
    355: 'It is feared as a messenger of doom. It appears where people will die and waves its cursed flame.',
    356: 'It pulls pranks by turning invisible and poking or shoving people. Old folklore calls it a protector.',
    357: 'It lives deep in tropical jungles. With a delectable fruit grown on its head, it waits for prey.',
    358: 'Legend has it that it lures away people that venture too close to mountains. No one has ever returned.',
    359: 'Every time it uses its psychic power, it creates a small gap in the fabric of space-time.',
    360: 'It tends to move in a pack with others. They cluster in a tight group to sleep in a cave.',
    361: 'It can only survive in cold areas. It bounces happily around, even in environments below -150 degrees.',
    362: 'Its body is hollow. When the wind blows through its holes, it makes eerie sounds that sound like screaming.',
    363: 'Its streamlined body has little water resistance, and it swims by spinning its body like a propeller.',
    364: 'It is protected by its thick blubber. The fur on its face never freezes even at -50 degrees.',
    365: 'Blubber provides buoyancy while swimming. It may cause tidal waves when it breaches.',
    366: 'It lives in warm seas. Its form has remained unchanged for 100 million years, as its ancient shell suggests.',
    367: 'It lives deep in the sea where no light reaches. It lights up the depths with its luminescent scales.',
    368: 'It lives at the bottom of the sea. In the springtime, its pink body turns more vivid for some reason.',
    369: 'It swims backward by opening and closing its rugged shell. It is surprisingly fast.',
    370: 'During breeding season, it gives off a sweet scent that attracts others of its kind.',
    371: 'It grows by molting repeatedly. Its shell is actually skin that grew hard as a result of iron being added.',
    372: 'The cells in its body create energy by being exposed to sunlight. It flies high in the sky.',
    373: 'It hides in the clouds and flies at speeds approaching the speed of sound. Its battle cry shakes mountains.',
    374: 'It is born with a psychic power that lets it distort space around itself. It floats by levitation.',
    375: 'It has four brains that are joined by a complex neural network. Each brain thinks independently.',
    376: 'A magnetic force keeps it airborne. When it collides with others of its kind, its body emits a loud screech.',
    377: 'Research revealed that the rock types of its body formed when expressly high temperatures compressed its cells.',
    378: "Formed by a sudden transformation of Regice's ice, its body is said to be harder than any kind of metal.",
    379: 'It is said to have slept in underground strata for millions of years since ancient times.',
    380: 'It communicates using telepathy. Its body is covered with a down-like glass fiber.',
    381: 'Even in hiding, it can detect the locations of others and sense their emotions since it has telepathy.',
    382: 'It is said to have widened the seas by causing downpours. It had been asleep in a marine trench.',
    383: 'Said to have expanded the lands by evaporating water with its heat. It battled Kyogre long ago.',
    384: 'It flies forever through the ozone layer, consuming meteoroids for sustenance. The many meteoroids on its body provide its energy.',
    385: 'A legend tells of its falling like a shooting star from the night sky. It can take the forms of those it sees.',
    386: 'This Deoxys has transformed into its Attack Forme. Its tentacles have been converted into devastating weapons.',
};

export const pokedexClassificationsDB = {
    1: 'Seed Pokemon',
    2: 'Seed Pokemon',
    3: 'Seed Pokemon',
    4: 'Lizard Pokemon',
    5: 'Flame Pokemon',
    6: 'Flame Pokemon',
    7: 'Tiny Turtle Pokemon',
    8: 'Turtle Pokemon',
    9: 'Shellfish Pokemon',
    10: 'Worm Pokemon',
    11: 'Cocoon Pokemon',
    12: 'Butterfly Pokemon',
    13: 'Hairy Bug Pokemon',
    14: 'Cocoon Pokemon',
    15: 'Poison Bee Pokemon',
    16: 'Tiny Bird Pokemon',
    17: 'Bird Pokemon',
    18: 'Bird Pokemon',
    19: 'Mouse Pokemon',
    20: 'Mouse Pokemon',
    21: 'Tiny Bird Pokemon',
    22: 'Beak Pokemon',
    23: 'Snake Pokemon',
    24: 'Cobra Pokemon',
    25: 'Mouse Pokemon',
    26: 'Mouse Pokemon',
    27: 'Mouse Pokemon',
    28: 'Mouse Pokemon',
    29: 'Poison Pin Pokemon',
    30: 'Poison Pin Pokemon',
    31: 'Drill Pokemon',
    32: 'Poison Pin Pokemon',
    33: 'Poison Pin Pokemon',
    34: 'Drill Pokemon',
    35: 'Fairy Pokemon',
    36: 'Fairy Pokemon',
    37: 'Fox Pokemon',
    38: 'Fox Pokemon',
    39: 'Balloon Pokemon',
    40: 'Balloon Pokemon',
    41: 'Bat Pokemon',
    42: 'Bat Pokemon',
    43: 'Weed Pokemon',
    44: 'Weed Pokemon',
    45: 'Flower Pokemon',
    46: 'Mushroom Pokemon',
    47: 'Mushroom Pokemon',
    48: 'Insect Pokemon',
    49: 'Poison Moth Pokemon',
    50: 'Mole Pokemon',
    51: 'Mole Pokemon',
    52: 'Scratch Cat Pokemon',
    53: 'Classy Cat Pokemon',
    54: 'Duck Pokemon',
    55: 'Duck Pokemon',
    56: 'Pig Monkey Pokemon',
    57: 'Pig Monkey Pokemon',
    58: 'Puppy Pokemon',
    59: 'Legendary Pokemon',
    60: 'Tadpole Pokemon',
    61: 'Tadpole Pokemon',
    62: 'Tadpole Pokemon',
    63: 'Psi Pokemon',
    64: 'Psi Pokemon',
    65: 'Psi Pokemon',
    66: 'Superpower Pokemon',
    67: 'Superpower Pokemon',
    68: 'Superpower Pokemon',
    69: 'Flower Pokemon',
    70: 'Flycatcher Pokemon',
    71: 'Flycatcher Pokemon',
    72: 'Jellyfish Pokemon',
    73: 'Jellyfish Pokemon',
    74: 'Rock Pokemon',
    75: 'Rock Pokemon',
    76: 'Megaton Pokemon',
    77: 'Fire Horse Pokemon',
    78: 'Fire Horse Pokemon',
    79: 'Dopey Pokemon',
    80: 'Hermit Crab Pokemon',
    81: 'Magnet Pokemon',
    82: 'Magnet Pokemon',
    83: 'Wild Duck Pokemon',
    84: 'Twin Bird Pokemon',
    85: 'Triple Bird Pokemon',
    86: 'Sea Lion Pokemon',
    87: 'Sea Lion Pokemon',
    88: 'Sludge Pokemon',
    89: 'Sludge Pokemon',
    90: 'Bivalve Pokemon',
    91: 'Bivalve Pokemon',
    92: 'Gas Pokemon',
    93: 'Gas Pokemon',
    94: 'Shadow Pokemon',
    95: 'Rock Snake Pokemon',
    96: 'Hypnosis Pokemon',
    97: 'Hypnosis Pokemon',
    98: 'River Crab Pokemon',
    99: 'Pincer Pokemon',
    100: 'Ball Pokemon',
    101: 'Ball Pokemon',
    102: 'Egg Pokemon',
    103: 'Coconut Pokemon',
    104: 'Lonely Pokemon',
    105: 'Bone Keeper Pokemon',
    106: 'Kicking Pokemon',
    107: 'Punching Pokemon',
    108: 'Licking Pokemon',
    109: 'Poison Gas Pokemon',
    110: 'Poison Gas Pokemon',
    111: 'Spikes Pokemon',
    112: 'Drill Pokemon',
    113: 'Egg Pokemon',
    114: 'Vine Pokemon',
    115: 'Parent Pokemon',
    116: 'Dragon Pokemon',
    117: 'Dragon Pokemon',
    118: 'Goldfish Pokemon',
    119: 'Goldfish Pokemon',
    120: 'Starshape Pokemon',
    121: 'Mysterious Pokemon',
    122: 'Barrier Pokemon',
    123: 'Mantis Pokemon',
    124: 'Human Shape Pokemon',
    125: 'Electric Pokemon',
    126: 'Spitfire Pokemon',
    127: 'Stag Beetle Pokemon',
    128: 'Wild Bull Pokemon',
    129: 'Fish Pokemon',
    130: 'Atrocious Pokemon',
    131: 'Transport Pokemon',
    132: 'Transform Pokemon',
    133: 'Evolution Pokemon',
    134: 'Bubble Jet Pokemon',
    135: 'Lightning Pokemon',
    136: 'Flame Pokemon',
    137: 'Virtual Pokemon',
    138: 'Spiral Pokemon',
    139: 'Spiral Pokemon',
    140: 'Shellfish Pokemon',
    141: 'Shellfish Pokemon',
    142: 'Fossil Pokemon',
    143: 'Sleeping Pokemon',
    144: 'Freeze Pokemon',
    145: 'Electric Pokemon',
    146: 'Flame Pokemon',
    147: 'Dragon Pokemon',
    148: 'Dragon Pokemon',
    149: 'Dragon Pokemon',
    150: 'Genetic Pokemon',
    151: 'New Species Pokemon',
    152: 'Leaf Pokemon',
    153: 'Leaf Pokemon',
    154: 'Herb Pokemon',
    155: 'Fire Mouse Pokemon',
    156: 'Volcano Pokemon',
    157: 'Volcano Pokemon',
    158: 'Big Jaw Pokemon',
    159: 'Big Jaw Pokemon',
    160: 'Big Jaw Pokemon',
    161: 'Scout Pokemon',
    162: 'Long Body Pokemon',
    163: 'Owl Pokemon',
    164: 'Owl Pokemon',
    165: 'Five Star Pokemon',
    166: 'Five Star Pokemon',
    167: 'String Spit Pokemon',
    168: 'Long Leg Pokemon',
    169: 'Bat Pokemon',
    170: 'Angler Pokemon',
    171: 'Light Pokemon',
    172: 'Tiny Mouse Pokemon',
    173: 'Star Shape Pokemon',
    174: 'Balloon Pokemon',
    175: 'Spike Ball Pokemon',
    176: 'Happiness Pokemon',
    177: 'Tiny Bird Pokemon',
    178: 'Mystic Pokemon',
    179: 'Wool Pokemon',
    180: 'Wool Pokemon',
    181: 'Light Pokemon',
    182: 'Flower Pokemon',
    183: 'Aqua Mouse Pokemon',
    184: 'Aqua Rabbit Pokemon',
    185: 'Imitation Pokemon',
    186: 'Frog Pokemon',
    187: 'Cottonweed Pokemon',
    188: 'Cottonweed Pokemon',
    189: 'Cotton Pokemon',
    190: 'Long Tail Pokemon',
    191: 'Seed Pokemon',
    192: 'Sun Pokemon',
    193: 'Clear Wing Pokemon',
    194: 'Water Fish Pokemon',
    195: 'Water Fish Pokemon',
    196: 'Sun Pokemon',
    197: 'Moonlight Pokemon',
    198: 'Darkness Pokemon',
    199: 'Royal Pokemon',
    200: 'Rendezvous Pokemon',
    201: 'Symbol Pokemon',
    202: 'Patient Pokemon',
    203: 'Long Neck Pokemon',
    204: 'Bagworm Pokemon',
    205: 'Bagworm Pokemon',
    206: 'Land Snake Pokemon',
    207: 'FlyScorpion Pokemon',
    208: 'Iron Snake Pokemon',
    209: 'Fairy Pokemon',
    210: 'Fairy Pokemon',
    211: 'Balloon Pokemon',
    212: 'Pincer Pokemon',
    213: 'Mold Pokemon',
    214: 'Single Horn Pokemon',
    215: 'Sharp Claw Pokemon',
    216: 'Little Bear Pokemon',
    217: 'Hibernator Pokemon',
    218: 'Lava Pokemon',
    219: 'Lava Pokemon',
    220: 'Pig Pokemon',
    221: 'Swine Pokemon',
    222: 'Coral Pokemon',
    223: 'Jet Pokemon',
    224: 'Jet Pokemon',
    225: 'Delivery Pokemon',
    226: 'Kite Pokemon',
    227: 'Armor Bird Pokemon',
    228: 'Dark Pokemon',
    229: 'Dark Pokemon',
    230: 'Dragon Pokemon',
    231: 'Long Nose Pokemon',
    232: 'Armor Pokemon',
    233: 'Virtual Pokemon',
    234: 'Big Horn Pokemon',
    235: 'Painter Pokemon',
    236: 'Scuffle Pokemon',
    237: 'Handstand Pokemon',
    238: 'Kiss Pokemon',
    239: 'Electric Pokemon',
    240: 'Live Coal Pokemon',
    241: 'Milk Cow Pokemon',
    242: 'Happiness Pokemon',
    243: 'Thunder Pokemon',
    244: 'Volcano Pokemon',
    245: 'Aurora Pokemon',
    246: 'Rock Skin Pokemon',
    247: 'Hard Shell Pokemon',
    248: 'Armor Pokemon',
    249: 'Diving Pokemon',
    250: 'Rainbow Pokemon',
    251: 'Time Travel Pokemon',
    252: 'Wood Gecko Pokemon',
    253: 'Wood Gecko Pokemon',
    254: 'Forest Pokemon',
    255: 'Chick Pokemon',
    256: 'Young Fowl Pokemon',
    257: 'Blaze Pokemon',
    258: 'Mud Fish Pokemon',
    259: 'Mud Fish Pokemon',
    260: 'Mud Fish Pokemon',
    261: 'Bite Pokemon',
    262: 'Bite Pokemon',
    263: 'Tiny Raccoon Pokemon',
    264: 'Rushing Pokemon',
    265: 'Worm Pokemon',
    266: 'Cocoon Pokemon',
    267: 'Butterfly Pokemon',
    268: 'Cocoon Pokemon',
    269: 'Poison Moth Pokemon',
    270: 'Water Weed Pokemon',
    271: 'Jolly Pokemon',
    272: 'Carefree Pokemon',
    273: 'Acorn Pokemon',
    274: 'Wily Pokemon',
    275: 'Wicked Pokemon',
    276: 'Tiny Swallow Pokemon',
    277: 'Swallow Pokemon',
    278: 'Seagull Pokemon',
    279: 'Water Bird Pokemon',
    280: 'Feeling Pokemon',
    281: 'Emotion Pokemon',
    282: 'Embrace Pokemon',
    283: 'Pond Skater Pokemon',
    284: 'Eyeball Pokemon',
    285: 'Mushroom Pokemon',
    286: 'Mushroom Pokemon',
    287: 'Slacker Pokemon',
    288: 'Wild Monkey Pokemon',
    289: 'Lazy Pokemon',
    290: 'Trainee Pokemon',
    291: 'Ninja Pokemon',
    292: 'Shed Pokemon',
    293: 'Whisper Pokemon',
    294: 'Big Voice Pokemon',
    295: 'Loud Noise Pokemon',
    296: 'Guts Pokemon',
    297: 'Arm Thrust Pokemon',
    298: 'Polka Dot Pokemon',
    299: 'Compass Pokemon',
    300: 'Kitten Pokemon',
    301: 'Prim Pokemon',
    302: 'Darkness Pokemon',
    303: 'Deceiver Pokemon',
    304: 'Iron Armor Pokemon',
    305: 'Iron Armor Pokemon',
    306: 'Iron Armor Pokemon',
    307: 'Meditate Pokemon',
    308: 'Meditate Pokemon',
    309: 'Lightning Pokemon',
    310: 'Discharge Pokemon',
    311: 'Cheering Pokemon',
    312: 'Cheering Pokemon',
    313: 'Firefly Pokemon',
    314: 'Firefly Pokemon',
    315: 'Thorn Pokemon',
    316: 'Stomach Pokemon',
    317: 'Poison Bag Pokemon',
    318: 'Savage Pokemon',
    319: 'Brutal Pokemon',
    320: 'Ball Whale Pokemon',
    321: 'Float Whale Pokemon',
    322: 'Numb Pokemon',
    323: 'Eruption Pokemon',
    324: 'Coal Pokemon',
    325: 'Bounce Pokemon',
    326: 'Manipulate Pokemon',
    327: 'Spot Panda Pokemon',
    328: 'Ant Pit Pokemon',
    329: 'Vibration Pokemon',
    330: 'Mystic Pokemon',
    331: 'Cactus Pokemon',
    332: 'Scarecrow Pokemon',
    333: 'Cotton Bird Pokemon',
    334: 'Humming Pokemon',
    335: 'Fang Scorpion Pokemon',
    336: 'Fang Snake Pokemon',
    337: 'Meteorite Pokemon',
    338: 'Meteorite Pokemon',
    339: 'Whiskers Pokemon',
    340: 'Whiskers Pokemon',
    341: 'Shellfish Pokemon',
    342: 'Rogue Pokemon',
    343: 'Clay Doll Pokemon',
    344: 'Clay Doll Pokemon',
    345: 'Sea Lily Pokemon',
    346: 'Barnacle Pokemon',
    347: 'Old Shrimp Pokemon',
    348: 'Plate Pokemon',
    349: 'Fish Pokemon',
    350: 'Tender Pokemon',
    351: 'Weather Pokemon',
    352: 'Color Swap Pokemon',
    353: 'Puppet Pokemon',
    354: 'Marionette Pokemon',
    355: 'Requiem Pokemon',
    356: 'Beckon Pokemon',
    357: 'Fruit Pokemon',
    358: 'Wind Chime Pokemon',
    359: 'Disaster Pokemon',
    360: 'Bright Pokemon',
    361: 'Snow Hat Pokemon',
    362: 'Face Pokemon',
    363: 'Clap Pokemon',
    364: 'Ball Roll Pokemon',
    365: 'Ice Break Pokemon',
    366: 'Bivalve Pokemon',
    367: 'Deep Sea Pokemon',
    368: 'South Sea Pokemon',
    369: 'Longevity Pokemon',
    370: 'Rendezvous Pokemon',
    371: 'Rock Head Pokemon',
    372: 'Endurance Pokemon',
    373: 'Dragon Pokemon',
    374: 'Iron Ball Pokemon',
    375: 'Iron Claw Pokemon',
    376: 'Iron Leg Pokemon',
    377: 'Rock Peak Pokemon',
    378: 'Iceberg Pokemon',
    379: 'Iron Pokemon',
    380: 'Eon Pokemon',
    381: 'Eon Pokemon',
    382: 'Sea Basin Pokemon',
    383: 'Continent Pokemon',
    384: 'Sky High Pokemon',
    385: 'Wish Pokemon',
    386: 'DNA Pokemon',
};

export const pokemonEvolutions = {
    1: {
        evolution: {
            id: 2,
            level: 16,
            item: null,
            trade: false,
        },
    },
    2: {
        evolution: {
            id: 3,
            level: 32,
            item: null,
            trade: false,
        },
    },
    3: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    4: {
        evolution: {
            id: 5,
            level: 16,
            item: null,
            trade: false,
        },
    },
    5: {
        evolution: {
            id: 6,
            level: 36,
            item: null,
            trade: false,
        },
    },
    6: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    7: {
        evolution: {
            id: 8,
            level: 16,
            item: null,
            trade: false,
        },
    },
    8: {
        evolution: {
            id: 9,
            level: 36,
            item: null,
            trade: false,
        },
    },
    9: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    10: {
        evolution: {
            id: 11,
            level: 7,
            item: null,
            trade: false,
        },
    },
    11: {
        evolution: {
            id: 12,
            level: 10,
            item: null,
            trade: false,
        },
    },
    12: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    13: {
        evolution: {
            id: 14,
            level: 7,
            item: null,
            trade: false,
        },
    },
    14: {
        evolution: {
            id: 15,
            level: 10,
            item: null,
            trade: false,
        },
    },
    15: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    16: {
        evolution: {
            id: 17,
            level: 18,
            item: null,
            trade: false,
        },
    },
    17: {
        evolution: {
            id: 18,
            level: 36,
            item: null,
            trade: false,
        },
    },
    18: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    19: {
        evolution: {
            id: 20,
            level: 20,
            item: null,
            trade: false,
        },
    },
    20: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    21: {
        evolution: {
            id: 22,
            level: 20,
            item: null,
            trade: false,
        },
    },
    22: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    23: {
        evolution: {
            id: 24,
            level: 22,
            item: null,
            trade: false,
        },
    },
    24: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    25: {
        evolution: {
            id: 26,
            level: null,
            item: 'thunder_stone',
            trade: false,
        },
    },
    26: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    27: {
        evolution: {
            id: 28,
            level: 22,
            item: null,
            trade: false,
        },
    },
    28: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    29: {
        evolution: {
            id: 30,
            level: 16,
            item: null,
            trade: false,
        },
    },
    30: {
        evolution: {
            id: 31,
            level: null,
            item: 'moon_stone',
            trade: false,
        },
    },
    31: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    32: {
        evolution: {
            id: 33,
            level: 16,
            item: null,
            trade: false,
        },
    },
    33: {
        evolution: {
            id: 34,
            level: null,
            item: 'moon_stone',
            trade: false,
        },
    },
    34: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    35: {
        evolution: {
            id: 36,
            level: null,
            item: 'moon_stone',
            trade: false,
        },
    },
    36: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    37: {
        evolution: {
            id: 38,
            level: null,
            item: 'fire_stone',
            trade: false,
        },
    },
    38: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    39: {
        evolution: {
            id: 40,
            level: null,
            item: 'moon_stone',
            trade: false,
        },
    },
    40: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    41: {
        evolution: {
            id: 42,
            level: 22,
            item: null,
            trade: false,
        },
    },
    42: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    43: {
        evolution: {
            id: 44,
            level: 21,
            item: null,
            trade: false,
        },
    },
    44: {
        evolution: {
            id: 45,
            level: null,
            item: 'leaf_stone',
            trade: false,
        },
    },
    45: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    46: {
        evolution: {
            id: 47,
            level: 24,
            item: null,
            trade: false,
        },
    },
    47: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    48: {
        evolution: {
            id: 49,
            level: 31,
            item: null,
            trade: false,
        },
    },
    49: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    50: {
        evolution: {
            id: 51,
            level: 26,
            item: null,
            trade: false,
        },
    },
    51: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    52: {
        evolution: {
            id: 53,
            level: 28,
            item: null,
            trade: false,
        },
    },
    53: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    54: {
        evolution: {
            id: 55,
            level: 33,
            item: null,
            trade: false,
        },
    },
    55: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    56: {
        evolution: {
            id: 57,
            level: 28,
            item: null,
            trade: false,
        },
    },
    57: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    58: {
        evolution: {
            id: 59,
            level: null,
            item: 'fire_stone',
            trade: false,
        },
    },
    59: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    60: {
        evolution: {
            id: 61,
            level: 25,
            item: null,
            trade: false,
        },
    },
    61: {
        evolution: {
            id: 62,
            level: null,
            item: 'water_stone',
            trade: false,
        },
    },
    62: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    63: {
        evolution: {
            id: 64,
            level: 16,
            item: null,
            trade: false,
        },
    },
    64: {
        evolution: {
            id: 65,
            level: 42,
            item: null,
            trade: true,
        },
    },
    65: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    66: {
        evolution: {
            id: 67,
            level: 28,
            item: null,
            trade: false,
        },
    },
    67: {
        evolution: {
            id: 68,
            level: 40,
            item: null,
            trade: true,
        },
    },
    68: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    69: {
        evolution: {
            id: 70,
            level: 21,
            item: null,
            trade: false,
        },
    },
    70: {
        evolution: {
            id: 71,
            level: null,
            item: 'leaf_stone',
            trade: false,
        },
    },
    71: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    72: {
        evolution: {
            id: 73,
            level: 30,
            item: null,
            trade: false,
        },
    },
    73: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    74: {
        evolution: {
            id: 75,
            level: 25,
            item: null,
            trade: false,
        },
    },
    75: {
        evolution: {
            id: 76,
            level: 45,
            item: null,
            trade: true,
        },
    },
    76: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    77: {
        evolution: {
            id: 78,
            level: 40,
            item: null,
            trade: false,
        },
    },
    78: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    79: {
        evolution: {
            id: 80,
            level: 37,
            item: null,
            trade: false,
        },
    },
    80: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    81: {
        evolution: {
            id: 82,
            level: 30,
            item: null,
            trade: false,
        },
    },
    82: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    83: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    84: {
        evolution: {
            id: 85,
            level: 31,
            item: null,
            trade: false,
        },
    },
    85: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    86: {
        evolution: {
            id: 87,
            level: 34,
            item: null,
            trade: false,
        },
    },
    87: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    88: {
        evolution: {
            id: 89,
            level: 38,
            item: null,
            trade: false,
        },
    },
    89: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    90: {
        evolution: {
            id: 91,
            level: null,
            item: 'water_stone',
            trade: false,
        },
    },
    91: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    92: {
        evolution: {
            id: 93,
            level: 25,
            item: null,
            trade: false,
        },
    },
    93: {
        evolution: {
            id: 94,
            level: 45,
            item: null,
            trade: true,
        },
    },
    94: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    95: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    96: {
        evolution: {
            id: 97,
            level: 26,
            item: null,
            trade: false,
        },
    },

    97: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    98: {
        evolution: {
            id: 99,
            level: 28,
            item: null,
            trade: false,
        },
    },
    99: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    100: {
        evolution: {
            id: 101,
            level: 30,
            item: null,
            trade: false,
        },
    },
    101: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    102: {
        evolution: {
            id: 103,
            level: null,
            item: 'leaf_stone',
            trade: false,
        },
    },
    103: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    104: {
        evolution: {
            id: 105,
            level: 28,
            item: null,
            trade: false,
        },
    },
    105: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    106: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    107: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    108: {
        evolution: {
            id: 463,
            level: null,
            item: null,
            trade: false,
        },
    },
    109: {
        evolution: {
            id: 110,
            level: 35,
            item: null,
            trade: false,
        },
    },
    110: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    111: {
        evolution: {
            id: 112,
            level: 42,
            item: null,
            trade: false,
        },
    },
    112: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    113: {
        evolution: {
            id: 242,
            level: null,
            item: null,
            trade: false,
        },
    },
    114: {
        evolution: {
            id: 465,
            level: null,
            item: null,
            trade: false,
        },
    },
    115: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    116: {
        evolution: {
            id: 117,
            level: 32,
            item: null,
            trade: false,
        },
    },
    117: {
        evolution: {
            id: 230,
            level: 45,
            item: 'dragon_scale',
            trade: true,
        },
    },
    118: {
        evolution: {
            id: 119,
            level: 33,
            item: null,
            trade: false,
        },
    },
    119: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    120: {
        evolution: {
            id: 121,
            level: null,
            item: 'water_stone',
            trade: false,
        },
    },
    121: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    122: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    123: {
        evolution: {
            id: 212,
            level: 45,
            item: 'metal_coat',
            trade: true,
        },
    },
    124: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    125: {
        evolution: {
            id: 466,
            level: 42,
            item: 'electirizer',
            trade: true,
        },
    },
    126: {
        evolution: {
            id: 467,
            level: 42,
            item: 'magmarizer',
            trade: true,
        },
    },
    127: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    128: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    129: {
        evolution: {
            id: 130,
            level: 20,
            item: null,
            trade: false,
        },
    },
    130: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    131: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    132: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    133: {
        evolution: {
            id: 134,
            level: null,
            item: 'water_stone',
            trade: false,
        },
    },
    134: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    135: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    136: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    137: {
        evolution: {
            id: 233,
            level: 40,
            item: 'up_grade',
            trade: true,
        },
    },
    138: {
        evolution: {
            id: 139,
            level: 40,
            item: null,
            trade: false,
        },
    },
    139: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    140: {
        evolution: {
            id: 141,
            level: 40,
            item: null,
            trade: false,
        },
    },
    141: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    142: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    143: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    144: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    145: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    146: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    147: {
        evolution: {
            id: 148,
            level: 30,
            item: null,
            trade: false,
        },
    },
    148: {
        evolution: {
            id: 149,
            level: 55,
            item: null,
            trade: false,
        },
    },
    149: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    150: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    151: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    152: {
        evolution: {
            id: 153,
            level: 16,
            item: null,
            trade: false,
        },
    },
    153: {
        evolution: {
            id: 154,
            level: 32,
            item: null,
            trade: false,
        },
    },
    154: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    155: {
        evolution: {
            id: 156,
            level: 14,
            item: null,
            trade: false,
        },
    },
    156: {
        evolution: {
            id: 157,
            level: 36,
            item: null,
            trade: false,
        },
    },
    157: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    158: {
        evolution: {
            id: 159,
            level: 18,
            item: null,
            trade: false,
        },
    },
    159: {
        evolution: {
            id: 160,
            level: 30,
            item: null,
            trade: false,
        },
    },
    160: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    161: {
        evolution: {
            id: 162,
            level: 15,
            item: null,
            trade: false,
        },
    },
    162: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    163: {
        evolution: {
            id: 164,
            level: 20,
            item: null,
            trade: false,
        },
    },
    164: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    165: {
        evolution: {
            id: 166,
            level: 18,
            item: null,
            trade: false,
        },
    },
    166: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    167: {
        evolution: {
            id: 168,
            level: 22,
            item: null,
            trade: false,
        },
    },
    168: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    169: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    170: {
        evolution: {
            id: 171,
            level: 27,
            item: null,
            trade: false,
        },
    },
    171: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    172: {
        evolution: {
            id: 25,
            level: null,
            item: 'happiness',
            trade: false,
        },
    },
    173: {
        evolution: {
            id: 35,
            level: null,
            item: 'happiness',
            trade: false,
        },
    },
    174: {
        evolution: {
            id: 39,
            level: null,
            item: 'happiness',
            trade: false,
        },
    },
    175: {
        evolution: {
            id: 176,
            level: null,
            item: 'happiness',
            trade: false,
        },
    },
    176: {
        evolution: {
            id: 468,
            level: null,
            item: 'shiny_stone',
            trade: false,
        },
    },
    177: {
        evolution: {
            id: 178,
            level: 25,
            item: null,
            trade: false,
        },
    },
    178: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    179: {
        evolution: {
            id: 180,
            level: 15,
            item: null,
            trade: false,
        },
    },
    180: {
        evolution: {
            id: 181,
            level: 30,
            item: null,
            trade: false,
        },
    },
    181: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    182: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    183: {
        evolution: {
            id: 184,
            level: 18,
            item: null,
            trade: false,
        },
    },
    184: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    185: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    186: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    187: {
        evolution: {
            id: 188,
            level: 18,
            item: null,
            trade: false,
        },
    },
    188: {
        evolution: {
            id: 189,
            level: 27,
            item: null,
            trade: false,
        },
    },
    189: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    190: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    191: {
        evolution: {
            id: 192,
            level: null,
            item: 'sun_stone',
            trade: false,
        },
    },
    192: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    193: {
        evolution: {
            id: 469,
            level: 45,
            item: null,
            trade: false,
        },
    },
    194: {
        evolution: {
            id: 195,
            level: 20,
            item: null,
            trade: false,
        },
    },
    195: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    196: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    197: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    198: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    199: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    200: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    201: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    202: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    203: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    204: {
        evolution: {
            id: 205,
            level: 31,
            item: null,
            trade: false,
        },
    },
    205: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    206: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    207: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    208: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    209: {
        evolution: {
            id: 210,
            level: 23,
            item: null,
            trade: false,
        },
    },
    210: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    211: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    212: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    213: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    214: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    215: {
        evolution: {
            id: 461,
            level: null,
            item: 'razor_claw',
            trade: false,
        },
    },
    216: {
        evolution: {
            id: 217,
            level: 30,
            item: null,
            trade: false,
        },
    },
    217: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    218: {
        evolution: {
            id: 219,
            level: 38,
            item: null,
            trade: false,
        },
    },
    219: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    220: {
        evolution: {
            id: 221,
            level: 33,
            item: null,
            trade: false,
        },
    },
    221: {
        evolution: {
            id: 473,
            level: null,
            item: 'ancient_power',
            trade: false,
        },
    },
    222: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    223: {
        evolution: {
            id: 224,
            level: 25,
            item: null,
            trade: false,
        },
    },
    224: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    225: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    226: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    227: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    228: {
        evolution: {
            id: 229,
            level: 24,
            item: null,
            trade: false,
        },
    },
    229: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    230: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    231: {
        evolution: {
            id: 232,
            level: 25,
            item: null,
            trade: false,
        },
    },
    232: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    233: {
        evolution: {
            id: 474,
            level: null,
            item: 'dubious_disc',
            trade: true,
        },
    },
    234: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    235: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    236: {
        evolution: {
            id: 107,
            level: 20,
            item: null,
            trade: false,
        },
    },
    237: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    238: {
        evolution: {
            id: 124,
            level: 30,
            item: null,
            trade: false,
        },
    },
    239: {
        evolution: {
            id: 125,
            level: 30,
            item: null,
            trade: false,
        },
    },
    240: {
        evolution: {
            id: 126,
            level: 30,
            item: null,
            trade: false,
        },
    },
    241: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    242: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    243: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    244: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    245: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    246: {
        evolution: {
            id: 247,
            level: 30,
            item: null,
            trade: false,
        },
    },
    247: {
        evolution: {
            id: 248,
            level: 55,
            item: null,
            trade: false,
        },
    },
    248: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    249: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    250: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    251: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    252: {
        evolution: {
            id: 253,
            level: 16,
            item: null,
            trade: false,
        },
    },
    253: {
        evolution: {
            id: 254,
            level: 36,
            item: null,
            trade: false,
        },
    },
    254: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    255: {
        evolution: {
            id: 256,
            level: 16,
            item: null,
            trade: false,
        },
    },
    256: {
        evolution: {
            id: 257,
            level: 36,
            item: null,
            trade: false,
        },
    },
    257: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    258: {
        evolution: {
            id: 259,
            level: 16,
            item: null,
            trade: false,
        },
    },
    259: {
        evolution: {
            id: 260,
            level: 36,
            item: null,
            trade: false,
        },
    },
    260: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    261: {
        evolution: {
            id: 262,
            level: 18,
            item: null,
            trade: false,
        },
    },
    262: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    263: {
        evolution: {
            id: 264,
            level: 20,
            item: null,
            trade: false,
        },
    },
    264: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    265: {
        evolution: {
            id: 266,
            level: 7,
            item: null,
            trade: false,
        },
    },
    266: {
        evolution: {
            id: 267,
            level: 10,
            item: null,
            trade: false,
        },
    },
    267: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    268: {
        evolution: {
            id: 269,
            level: 10,
            item: null,
            trade: false,
        },
    },
    269: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    270: {
        evolution: {
            id: 271,
            level: 14,
            item: null,
            trade: false,
        },
    },
    271: {
        evolution: {
            id: 272,
            level: 30,
            item: null,
            trade: false,
        },
    },
    272: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    273: {
        evolution: {
            id: 274,
            level: 14,
            item: null,
            trade: false,
        },
    },
    274: {
        evolution: {
            id: 275,
            level: 35,
            item: null,
            trade: false,
        },
    },
    275: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    276: {
        evolution: {
            id: 277,
            level: 22,
            item: null,
            trade: false,
        },
    },
    277: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    278: {
        evolution: {
            id: 279,
            level: 25,
            item: null,
            trade: false,
        },
    },
    279: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    280: {
        evolution: {
            id: 281,
            level: 20,
            item: null,
            trade: false,
        },
    },
    281: {
        evolution: {
            id: 282,
            level: 30,
            item: null,
            trade: false,
        },
    },
    282: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    283: {
        evolution: {
            id: 284,
            level: 22,
            item: null,
            trade: false,
        },
    },
    284: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    285: {
        evolution: {
            id: 286,
            level: 23,
            item: null,
            trade: false,
        },
    },
    286: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    287: {
        evolution: {
            id: 288,
            level: 18,
            item: null,
            trade: false,
        },
    },
    288: {
        evolution: {
            id: 289,
            level: 36,
            item: null,
            trade: false,
        },
    },
    289: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    290: {
        evolution: {
            id: 291,
            level: 20,
            item: null,
            trade: false,
        },
    },
    291: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    292: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    293: {
        evolution: {
            id: 294,
            level: 20,
            item: null,
            trade: false,
        },
    },
    294: {
        evolution: {
            id: 295,
            level: 40,
            item: null,
            trade: false,
        },
    },
    295: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    296: {
        evolution: {
            id: 297,
            level: 24,
            item: null,
            trade: false,
        },
    },
    297: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    298: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    299: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    300: {
        evolution: {
            id: 301,
            level: null,
            item: 'moon_stone',
            trade: false,
        },
    },
    301: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    302: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    303: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    304: {
        evolution: {
            id: 305,
            level: 32,
            item: null,
            trade: false,
        },
    },
    305: {
        evolution: {
            id: 306,
            level: 42,
            item: null,
            trade: false,
        },
    },
    306: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    307: {
        evolution: {
            id: 308,
            level: 37,
            item: null,
            trade: false,
        },
    },
    308: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    309: {
        evolution: {
            id: 310,
            level: 26,
            item: null,
            trade: false,
        },
    },
    310: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    311: {
        evolution: {
            id: 312,
            level: 26,
            item: null,
            trade: false,
        },
    },
    312: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    313: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    314: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    315: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    316: {
        evolution: {
            id: 317,
            level: 26,
            item: null,
            trade: false,
        },
    },
    317: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    318: {
        evolution: {
            id: 319,
            level: 30,
            item: null,
            trade: false,
        },
    },
    319: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    320: {
        evolution: {
            id: 321,
            level: 40,
            item: null,
            trade: false,
        },
    },
    321: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    322: {
        evolution: {
            id: 323,
            level: 33,
            item: null,
            trade: false,
        },
    },
    323: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    324: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    325: {
        evolution: {
            id: 326,
            level: 32,
            item: null,
            trade: false,
        },
    },
    326: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    327: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    328: {
        evolution: {
            id: 329,
            level: 35,
            item: null,
            trade: false,
        },
    },
    329: {
        evolution: {
            id: 330,
            level: 45,
            item: null,
            trade: false,
        },
    },
    330: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    331: {
        evolution: {
            id: 332,
            level: 32,
            item: null,
            trade: false,
        },
    },
    332: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    333: {
        evolution: {
            id: 334,
            level: 35,
            item: null,
            trade: false,
        },
    },
    334: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    335: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    336: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    337: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    338: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    339: {
        evolution: {
            id: 340,
            level: 30,
            item: null,
            trade: false,
        },
    },
    340: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    341: {
        evolution: {
            id: 342,
            level: 30,
            item: null,
            trade: false,
        },
    },
    342: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    343: {
        evolution: {
            id: 344,
            level: 36,
            item: null,
            trade: false,
        },
    },
    344: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    345: {
        evolution: {
            id: 346,
            level: 40,
            item: null,
            trade: false,
        },
    },
    346: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    347: {
        evolution: {
            id: 348,
            level: 40,
            item: null,
            trade: false,
        },
    },
    348: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    349: {
        evolution: {
            id: 350,
            level: null,
            item: 'prism_scale',
            trade: true,
        },
    },
    350: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    351: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    352: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    353: {
        evolution: {
            id: 354,
            level: 37,
            item: null,
            trade: false,
        },
    },
    354: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    355: {
        evolution: {
            id: 356,
            level: 37,
            item: null,
            trade: false,
        },
    },
    356: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    357: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    358: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    359: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    360: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    361: {
        evolution: {
            id: 362,
            level: 42,
            item: null,
            trade: false,
        },
    },
    362: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    363: {
        evolution: {
            id: 364,
            level: 32,
            item: null,
            trade: false,
        },
    },
    364: {
        evolution: {
            id: 365,
            level: 44,
            item: null,
            trade: false,
        },
    },
    365: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    366: {
        evolution: {
            id: 367,
            level: 30,
            item: null,
            trade: false,
        },
    },
    367: {
        evolution: {
            id: 368,
            level: 50,
            item: null,
            trade: false,
        },
    },
    368: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    369: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    370: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    371: {
        evolution: {
            id: 372,
            level: 30,
            item: null,
            trade: false,
        },
    },
    372: {
        evolution: {
            id: 373,
            level: 50,
            item: null,
            trade: false,
        },
    },
    373: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    374: {
        evolution: {
            id: 375,
            level: 20,
            item: null,
            trade: false,
        },
    },
    375: {
        evolution: {
            id: 376,
            level: 45,
            item: null,
            trade: false,
        },
    },
    376: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    377: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    378: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    379: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    380: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    381: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    382: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    383: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    384: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    385: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    386: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    387: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
    388: {
        evolution: {
            id: null,
            level: null,
            item: null,
            trade: false,
        },
    },
};
